import * as i1 from '@angular/common/http';
import { HttpResponse, HttpErrorResponse, HTTP_INTERCEPTORS, HttpParams, HttpClientModule, HttpClient } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Optional, Inject, EventEmitter, Component, ViewChild, Input, Output, NgModule, Directive, Pipe, HostListener } from '@angular/core';
import * as i1$1 from '@ngx-translate/core';
import { TranslateModule, TranslatePipe, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as i2$2 from 'ngx-cookie-service';
import { CookieService } from 'ngx-cookie-service';
import { of, forkJoin, Subject, Subscription, BehaviorSubject, interval, combineLatest, throwError, AsyncSubject } from 'rxjs';
import * as i1$3 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import * as i4 from '@angular/common';
import { CommonModule as CommonModule$1, DatePipe, CurrencyPipe } from '@angular/common';
import * as i2$1 from '@angular/forms';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import * as i5 from '@bento/bento-ng';
import { BentoModule } from '@bento/bento-ng';
import * as i2$3 from '@bento/bfm-ng';
import { BfmModule } from '@bento/bfm-ng';
import * as i1$2 from '@ng-bootstrap/ng-bootstrap';
import { NgbModule, NgbDateParserFormatter, NgbDateAdapter, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { distinctUntilChanged, debounceTime, first, take, switchMap, map, exhaustMap, catchError, tap } from 'rxjs/operators';
import * as wjcGrid from '@grapecity/wijmo.grid';
import * as i2 from '@grapecity/wijmo.angular2.grid';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { __awaiter, __rest } from 'tslib';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i10 from 'ng2-currency-mask';
import { CurrencyMaskModule, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';
import * as i1$4 from 'ngx-mask';
import { NgxMaskModule } from 'ngx-mask';
import { BentoFlexGridControlModule } from '@bento/bento-ng-flexgrid-control';
import * as i11 from '@grapecity/wijmo.angular2.grid.filter';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { WjGridGrouppanelModule } from '@grapecity/wijmo.angular2.grid.grouppanel';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { parse, format } from 'date-fns';
import * as wjcCore from '@grapecity/wijmo';
import * as wjcGridXlsx from '@grapecity/wijmo.grid.xlsx';
import * as i2$4 from '@bento/bento-ng-d3';
import { BentoD3ArcGaugeComponent, BentoD3ColumnChartComponent, BentoD3Module } from '@bento/bento-ng-d3';
import * as i1$5 from '@angular/router';
import { RouterModule as RouterModule$1 } from '@angular/router';

const API_URL = '/api/accountant-cost/v1/';
const API_ACCOUNTANT_COST = '/api/accountant-cost/v1/';
const API_COSTS_CALCULATION = '/api/add-costs-calculation/v1/';
const API_PREFERENCES = '/api/profiles/v1/preferences';
const ENV_SETTINGS = 'ENV_SETTINGS';

class FakeBackendHttpInterceptor {
    constructor(environment) {
        this.environment = environment;
    }
    isMockInterceptorEnabled() {
        return this.environment && this.environment.enableMockInterceptor;
    }
    intercept(request, next) {
        const { url, method } = request;
        switch (true) {
            case url.endsWith('/api/accountant-cost/v1/calculation-model-result/cost') &&
                method === 'GET' &&
                this.isMockInterceptorEnabled():
                console.log('/api/accountant-cost/v1/calculation-model-result/cost');
                return getWidgetCosts();
            case url.endsWith('/api/accountant-cost/v1/calculation-model-result/revenue') &&
                method === 'GET' &&
                this.isMockInterceptorEnabled():
                console.log('/api/accountant-cost/v1/calculation-model-result/revenue');
                return getWidgetRevenue();
            case url.endsWith('/api/accountant-cost/v1/costs/widget-revenue-costs') &&
                method === 'GET':
                return getWidegetRevenueCosts();
            case url.endsWith('/api/accountant-cost/v1/costs/widget-revenue-costs-client') && method === 'GET':
                return getWidegetRevenueCostsPerClient();
            case url.endsWith('/api/accountant-cost/v1/costs/widget-clients') &&
                method === 'GET':
                return getWidgetClients();
            case url.endsWith('/api/add-costs-calculation/v1/clients') &&
                method === 'GET':
                return getAddCostsCalculationClients();
            case url.endsWith('/api/accountant-cost/v1/calculation-model/') &&
                method === 'GET' && this.isMockInterceptorEnabled():
                return getAllCalculationModels();
            case url.endsWith('/api/accountant-cost/v1/calculation-spreadsheet') &&
                method === 'GET':
                return getCalculationSpreadsheet();
            default:
                return next.handle(request);
        }
        function fireCalculation() {
            if (Math.random() > 0.5) {
                return of(new HttpResponse({ status: 200 }));
            }
            else {
                throw new HttpErrorResponse({ status: 500 });
            }
        }
        function getSingleTemplate() {
            const template = {
                id: url.split('/').pop(),
                clients: [{ id: '1', name: 'Client 1' }, { id: '2', name: 'Client 2' }]
            };
            return ok(template);
        }
        function getProfitSpreadsheet() {
            const data = [
                {
                    name: 'MockName',
                    cnpj: '20.771.509/0001-45',
                    columnInfo: [
                        {
                            columnName: 'Custo Mensal',
                            // tslint:disable-next-line: max-line-length
                            formula: '[{"type": "column", "columnId": "18443aad-d20c-4983-9c68-19e5380816ef", "description": "Receitas do Cliente"}, {"type": "operator", "operator": "-"}, {"type": "column", "columnId": "931ca9f1-bccf-4801-aa8c-93e276615a6d", "description": "Custo Mensal do Cliente com Margem de Lucro"}]',
                            value: 1392
                        }
                    ]
                }
            ];
            return ok(data);
        }
        function getAllCalculationModels() {
            const data = {
                items: [
                    {
                        type: 'calculationModelGridDto',
                        changed: '2019-06-27T14:05:30.067133',
                        id: '4',
                        code: '100',
                        name: 'Modelo 4'
                    },
                    {
                        type: 'calculationModelGridDto',
                        changed: '2019-06-27T14:05:43.645090',
                        code: '200',
                        id: '3',
                        name: 'Modelo 3'
                    },
                    {
                        type: 'calculationModelGridDto',
                        changed: '2019-06-27T14:05:47.361661',
                        id: '2',
                        code: '300',
                        name: 'Modelo 2'
                    },
                    {
                        type: 'calculationModelGridDto',
                        changed: '2019-06-27T14:05:51.723225',
                        id: '1',
                        code: '400',
                        name: 'Modelo 1'
                    }
                ],
                apiVersion: 'V1',
                itemsPerPage: 25,
                pageIndex: 0,
                startIndex: 0,
                totalItems: 5,
                totalPages: 1
            };
            return ok(data);
        }
        function getWidgetCosts() {
            const data = [
                { cost: 20, competence: '2017-11' },
                { cost: 800, competence: '2017-12' },
                { cost: 250, competence: '2018-01' },
                { cost: 1250, competence: '2018-02' },
                { cost: 550, competence: '2018-03' },
                { cost: 540, competence: '2018-04' }
            ];
            return ok(data);
        }
        function getWidgetRevenue() {
            const data = [
                { revenue: 20, competence: '2017-11' },
                { revenue: 800, competence: '2017-12' },
                { revenue: 250, competence: '2018-01' },
                { revenue: 1250, competence: '2018-02' },
                { revenue: 550, competence: '2018-03' },
                { revenue: 540, competence: '2018-04' }
            ];
            return ok(data);
        }
        function getWidegetRevenueCosts() {
            const data = {
                amount: [
                    [200, 500],
                    [500, 700],
                    [1000, 1500],
                    [1500, 500],
                    [500, 2000],
                    [2000, 800]
                ],
                competence: ['11/17', '12/17', '01/18', '02/18', '03/18', '04/18']
            };
            return ok(data);
        }
        function getWidegetRevenueCostsPerClient() {
            const data = [
                {
                    revenue: 1000,
                    cost: 500,
                    client: 'Y1',
                    competence: '2017-11'
                },
                {
                    revenue: 500,
                    cost: 200,
                    client: 'Y2',
                    competence: '2017-11'
                },
                {
                    revenue: 2000,
                    cost: 3000,
                    client: 'Y3',
                    competence: '2017-11'
                },
                {
                    revenue: 700,
                    cost: 700,
                    client: 'Y4',
                    competence: '2017-11'
                },
                {
                    revenue: 820,
                    cost: 340,
                    client: 'Y5',
                    competence: '2017-11'
                },
                {
                    revenue: 5000,
                    cost: 10000,
                    client: 'Y6',
                    competence: '2017-11'
                }
            ];
            return ok(data);
        }
        function getWidgetClients() {
            const data = {
                deficit: 500,
                superavit: 1000,
                total: 1500
            };
            return ok(data);
        }
        function getAddCostsCalculationClients() {
            const data = {
                clients: [
                    'Supermercados Rosso',
                    'Academia WellFit',
                    'Mecânica Criciúma',
                    'Backup Informática',
                    'Auto Posto Dagostin',
                    'Estofaria Premium',
                    'Transportadora Soares'
                ]
            };
            return ok(data);
        }
        function getCalculationSpreadsheet() {
            const data = {
                office: [
                    'Funcionários Ativos Escritório',
                    'Folha Mensal Escritório',
                    'Adiantamento Escritório',
                    'Folha Complementar Menos Alteração Salarial Escritório',
                    'Folha Complementar Menos Lançamentos Funcionários Escritório',
                    'Folha Semanal Escritório',
                    'Participação de Lucros Escritório',
                    '13º Adiantamento Escritório',
                    '13º Integral Escritório',
                    'Férias Escritório',
                    'Valor Rescisão Escritório',
                    'Encargos Escritório',
                    'Impostos Escritório',
                    'INSS Mensal Escritório',
                    'INSS Complementar Escritório',
                    'INSS Complementar CCT Escritório',
                    'INSS 13º Escritório',
                    'IRRF Escritório',
                    'IRRF Participação de Lucros Escritório',
                    'GRRF Complementar Escritório',
                    'GRRF Complementar CCT Escritório',
                    'GRCS Patronal Escritório',
                    'GRCS Funcionários Escritório',
                    'GRCS Complementar Funcionários Escritório',
                    'FGTS Escritório',
                    'FGTS Complementar Escritório',
                    'FGTS Complementar CCT Escritório',
                    'Contribuição Confederativa Escritório',
                    'Contribuição Confederativa Complementar Escritório',
                    'Contribuição Confederativa 13º Escritório',
                    'Quantidade Rescisão Escritório'
                ],
                clients: [
                    'Horas Lalur Cliente',
                    'Horas Atualizar Cliente',
                    'Horas Registro Cliente',
                    'Horas Patrimônio Cliente',
                    'Valor Contratos Cliente',
                    'Valor Faturado Cliente',
                    'Valor Desconto Cliente',
                    'Valor Lançado Sem Desconto Cliente',
                    'Funcionários Ativos Cliente',
                    'Funcionários Admitidos Cliente',
                    'Rubricas Cliente',
                    'Horas Folha Cliente',
                    'Lançamentos Contábeis Cliente',
                    'Horas Contabilidade Cliente',
                    'Notas de Entrada Cliente',
                    'Notas de Saída Cliente',
                    'Notas de Serviço Cliente',
                    'Cupons Fiscais Cliente',
                    'Horas Escrita Fiscal Cliente',
                    'Faturamento Escrita Fiscal Cliente',
                    'Horas Trabalhadas para Cliente',
                    'Horas Trabalhadas para Todos Clientes',
                    'Lançamentos para Cliente',
                    'Lançamentos para Todos Clientes',
                    'Cupons Fiscais Eletrônicos Cliente',
                    'Reduções Z Modelo 2D Cliente',
                    'Reduções Z Bilhetes de Passagem Cliente',
                    'Bilhetes de Passagem Cliente',
                    'Resumo do Movimento Diário Modelo 18 Cliente'
                ]
            };
            return ok(data);
        }
        function ok(body) {
            return of(new HttpResponse({ status: 200, body }));
        }
    }
}
FakeBackendHttpInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FakeBackendHttpInterceptor, deps: [{ token: ENV_SETTINGS, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
FakeBackendHttpInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FakeBackendHttpInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FakeBackendHttpInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Optional
                    }, {
                        type: Inject,
                        args: [ENV_SETTINGS]
                    }] }];
    } });
const fakeBackendProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: FakeBackendHttpInterceptor,
    multi: true
};

class PagingInfo$1 {
    constructor(startIndex, pageIndex, itemsPerPage) {
        this.startIndex = startIndex;
        this.pageIndex = pageIndex;
        this.itemsPerPage = itemsPerPage;
    }
}

class TableClientsService {
    constructor(http) {
        this.http = http;
    }
    getSearchClients(pagingInfo, filters, customFilters) {
        const customFilter = !!customFilters ? customFilters.filter : null;
        const searchBody = {
            filterSearchSort: Object.assign(Object.assign({}, filters), { filter: customFilter }),
            pagingDataRequest: pagingInfo
        };
        return this.http.post(`/api/core/v3/companies/${this.getCompanyId()}/clients/search`, searchBody);
    }
    getCompanyId() {
        try {
            const [companyCookieObject] = document.cookie.split(';').filter(cookie => cookie.includes('bmTheme'));
            const [companyCookieKey, companyCookie] = companyCookieObject.split('=');
            return companyCookie;
        }
        catch (err) {
            console.log(err.message);
        }
    }
    mountCustomFilter(by, op, values) {
        return {
            by,
            op,
            values
        };
    }
    setCustomFilter(useOr, items) {
        return {
            filter: JSON.stringify({
                useOr,
                items
            })
        };
    }
}
TableClientsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TableClientsService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
TableClientsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TableClientsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TableClientsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class BusyLoaderState {
    constructor() {
        this.state = false;
    }
    display(state) {
        this.state = state;
    }
    show() {
        this.state = true;
    }
    hide() {
        this.state = false;
    }
}
class LoaderService {
    constructor() {
        this.templatesLoader = new BusyLoaderState();
        this.scrollLoader = new BusyLoaderState();
        this.clientsLoader = new BusyLoaderState();
        this.modalClientsLoader = new BusyLoaderState();
        this.widgetsLoader = new BusyLoaderState();
        this.actionsLoader = new BusyLoaderState();
        this.editLoader = new BusyLoaderState();
        this.calculationLoader = new BusyLoaderState();
    }
}
LoaderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LoaderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
LoaderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LoaderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class AccountingCostsFlexGridServices {
    constructor() {
        this.DEFAULT_FLEX_GRID_ROWS_HEIGHT = 36;
    }
    updateFlexGridRows(flexGrid) {
        if (!flexGrid ||
            !flexGrid.rows ||
            !flexGrid.columnHeaders ||
            !flexGrid.columnHeaders.rows) {
            return;
        }
        const rows = flexGrid.rows;
        const rowHeaders = flexGrid.columnHeaders.rows;
        this.setRowsHeight(rows);
        this.setRowsHeight(rowHeaders);
        if (rows[0] && rows[0].dataItem) {
            rows.forEach(item => {
                if (item.dataItem[Object.keys(item.dataItem)[Object.keys(item.dataItem).length - 1]] > 0) {
                    item.cssClass = 'i-success';
                }
                else if (item.dataItem[Object.keys(item.dataItem)[Object.keys(item.dataItem).length - 1]] < 0) {
                    item.cssClass = 'i-error';
                }
            });
        }
        return flexGrid;
    }
    setRowsHeight(rowsList) {
        for (const row of rowsList) {
            row.height = this.DEFAULT_FLEX_GRID_ROWS_HEIGHT;
        }
        return rowsList;
    }
}
AccountingCostsFlexGridServices.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsFlexGridServices, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AccountingCostsFlexGridServices.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsFlexGridServices, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsFlexGridServices, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class ClientsTableComponent {
    constructor(flexGridService) {
        this.flexGridService = flexGridService;
        this.changeButtonStatus = new EventEmitter();
        this.endOfScroll = new EventEmitter();
        this.allowResizing = wjcGrid.AllowResizing.None;
        this.allClients = [];
        this.pageOfClientsFormatted = [];
        this.columns = [
            {
                header: 'ID',
                binding: 'code',
                width: 100,
                filter: false
            },
            {
                header: 'Client',
                binding: 'name',
                width: '*',
                filter: false
            }
        ];
        this.isAllChecked = false;
        this.isIndetermined = false;
        this.columnsWidth = 36;
        this.itemsPerPage = 30;
    }
    ngOnInit() {
        this.columnDefinitionsByBinding = this.columns.reduce((result, item) => {
            result[item.binding] = item;
            return result;
        }, {});
        this.formatClients();
        this.flexGrid = this.flexGridService.updateFlexGridRows(this.flexGrid);
    }
    updateFlexGridRows(flexGrid) {
        flexGrid = this.flexGridService.updateFlexGridRows(this.flexGrid);
    }
    ngOnChanges(changes) {
        if (!changes.listClient ||
            changes.listClient.firstChange ||
            !changes.listClient.previousValue ||
            !changes.listClient.currentValue) {
            return;
        }
        if (changes.listClient.previousValue.clients &&
            changes.listClient.currentValue.clients &&
            changes.listClient.previousValue.clients.length > changes.listClient.currentValue.clients.length) {
            this.isAllChecked = false;
            this.isIndetermined = false;
        }
        else if (changes.listClient.previousValue.clients &&
            changes.listClient.currentValue.clients &&
            changes.listClient.previousValue.clients.length < changes.listClient.currentValue.clients.length) {
            this.onCheckboxChange();
            this.flexGrid.refresh();
        }
        this.formatClients();
        this.refreshFlexGrid();
        this.preservePosition();
    }
    refreshFlexGrid() {
        this.flexGrid.collectionView.refresh();
    }
    preservePosition() {
        const position = this.flexGrid.scrollPosition;
        let handler;
        let removeHandler;
        handler = () => {
            this.flexGrid.scrollPosition = position;
            removeHandler();
        };
        removeHandler = () => {
            this.flexGrid.scrollPositionChanged.removeHandler(handler);
        };
        this.flexGrid.scrollPositionChanged.addHandler(handler);
    }
    formatClients() {
        if (!this.listClient) {
            return;
        }
        if (!this.listClient.clients || this.listClient.clients.length === 0) {
            this.allClients.length = 0;
            return;
        }
        this.pageOfClientsFormatted = this.listClient.clients.map(client => {
            const id = parseInt(`${client.code}`, 10);
            client.code = id ? id : client.code;
            return client;
        });
        if (this.listClient.deleteOperation) {
            this.allClients = this.pageOfClientsFormatted;
            if (this.allClients.length < this.itemsPerPage) {
                this.endOfScroll.emit();
            }
        }
        else {
            if (!this.pageOfClientsFormatted ||
                !this.allClients ||
                this.pageOfClientsFormatted.length === 0 ||
                this.allClients.length === 0 ||
                this.pageOfClientsFormatted[0].id !==
                    this.allClients[this.allClients.length - 1].id) {
                this.allClients.push(...this.pageOfClientsFormatted);
                this.allClients = this.removeDuplicates(this.allClients, 'id');
            }
        }
    }
    i18n(node) {
        return `Onvio.AccountingCosts.SelectClients.TableClients.${node}`;
    }
    initializeHeaders(flex) {
        if (this.flexGrid &&
            this.flexGrid.rowHeaders &&
            this.flexGrid.rowHeaders.columns) {
            const hc = new wjcGrid.Column();
            this.flexGrid.rowHeaders.columns.push(hc);
            this.flexGrid.rowHeaders.columns[1].width = this.columnsWidth;
            this.flexGrid.columns.getColumn('code').format = 'f0';
            this.flexGrid.refresh();
        }
        flex.scrollPositionChanged.addHandler((grid) => {
            if (grid.viewRange.bottomRow >= grid.rows.length - 1 &&
                this.allClients.length < this.totalItems) {
                this.endOfScroll.emit();
            }
        });
    }
    removeDuplicates(array, key) {
        const lookup = {};
        return array.filter(obj => {
            if (!lookup[obj[key]]) {
                lookup[obj[key]] = true;
                return lookup[obj[key]];
            }
            return false;
        });
    }
    onHeaderCheckboxChange() {
        if (this.allClients && this.allClients.length) {
            this.allClients.forEach(client => client.state = this.isAllChecked);
            this.changeButtonStatus.emit(this.isAllChecked);
        }
    }
    onCheckboxChange() {
        if (this.allClients && this.allClients.length) {
            this.isAllChecked = this.allClients.every(client => client.state);
            this.isIndetermined = this.allClients.some(client => client.state) && !this.allClients.every(client => client.state);
            this.changeButtonStatus.emit(this.isAllChecked || this.isIndetermined);
        }
    }
}
ClientsTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientsTableComponent, deps: [{ token: AccountingCostsFlexGridServices }], target: i0.ɵɵFactoryTarget.Component });
ClientsTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ClientsTableComponent, selector: "acc-clients-table", inputs: { listClient: "listClient", totalItems: "totalItems", allClients: "allClients" }, outputs: { changeButtonStatus: "changeButtonStatus", endOfScroll: "endOfScroll" }, viewQueries: [{ propertyName: "flexGrid", first: true, predicate: ["flexGrid"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"ng-bento\"\n  [ngStyle]=\"{ 'height' : allClients.length === 0 ? '36px' : '100%' }\">\n    <wj-flex-grid #flexGrid\n    class=\"bento-flex-grid has-row-hover clients-table\"\n    [itemsSource]=\"allClients\"\n    [stickyHeaders]=\"false\"\n    [showMarquee]=\"false\"\n    [showSort]=\"false\"\n    [allowResizing]=\"allowResizing\"\n    [isReadOnly]=\"true\"\n    (initialized)=\"initializeHeaders(flexGrid)\"\n    [autoScroll]=\"true\"\n    (loadedRows)=\"updateFlexGridRows(flexGrid)\"\n    [ngClass]=\"{ 'flex-grid-root-styles': allClients.length === 0 }\">\n        <div class=\"table-body\">\n            <ng-template wjFlexGridCellTemplate [cellType]=\"'TopLeft'\" let-col=\"col\">\n                <div *ngIf=\"col.index === 1\">\n                    <bento-checkbox [(ngModel)]=\"isAllChecked\" [indeterminate]=\"isIndetermined\"\n                        (change)=\"onHeaderCheckboxChange()\"></bento-checkbox>\n                </div>\n            </ng-template>\n\n            <ng-template wjFlexGridCellTemplate [cellType]=\"'RowHeader'\" let-col=\"col\" let-row=\"row\" let-item=\"item\">\n                <div class=\"line-count\" *ngIf=\"col.index === 0\">{{ row.index+1 }}</div>\n                <div *ngIf=\"col.index === 1\">\n                    <bento-checkbox class=\"table-checkbox\" [(ngModel)]=\"item.state\" (change)=\"onCheckboxChange()\">\n                    </bento-checkbox>\n                </div>\n            </ng-template>\n\n            <wj-flex-grid-column [header]=\"i18n('Id') | translate\" [binding]=\"'code'\"\n                [width]=\"columnDefinitionsByBinding['code'].width\">\n            </wj-flex-grid-column>\n\n            <wj-flex-grid-column [header]=\"i18n('Client') | translate\" [binding]=\"'name'\"\n                [width]=\"columnDefinitionsByBinding['name'].width\">\n            </wj-flex-grid-column>\n        </div>\n\n    </wj-flex-grid>\n</div>\n", styles: [":host{height:calc(100% - 45px);display:block}:host>.ng-bento,:host>.ng-bento .wj-flexgrid{height:100%}:host ::ng-deep .wj-cell{display:flex;align-items:center}:host ::ng-deep .wj-cell.wj-align-right{justify-content:flex-end}::ng-deep [wj-part=ch]{height:36px!important}::ng-deep .wj-cell{height:36px!important}.flex-grid-root-styles ::ng-deep [wj-part=root]{overflow:hidden!important}\n"], components: [{ type: i2.WjFlexGrid, selector: "wj-flex-grid", inputs: ["wjModelProperty", "isDisabled", "tabOrder", "newRowAtTop", "allowAddNew", "allowDelete", "allowDragging", "allowMerging", "allowResizing", "allowSorting", "allowPinning", "autoScroll", "autoRowHeights", "autoSizeMode", "autoGenerateColumns", "autoSearch", "caseSensitiveSearch", "quickAutoSize", "bigCheckboxes", "childItemsPath", "groupHeaderFormat", "headersVisibility", "showSelectedHeaders", "showMarquee", "showPlaceholders", "itemFormatter", "isReadOnly", "imeEnabled", "mergeManager", "selectionMode", "showGroups", "showSort", "showDropDown", "showAlternatingRows", "showErrors", "alternatingRowStep", "itemValidator", "validateEdits", "treeIndent", "itemsSource", "autoClipboard", "expandSelectionOnCopyPaste", "frozenCells", "frozenRows", "frozenColumns", "cloneFrozenCells", "deferResizing", "sortRowIndex", "editColumnIndex", "stickyHeaders", "preserveSelectedState", "preserveOutlineState", "preserveWhiteSpace", "keyActionTab", "keyActionEnter", "rowHeaderPath", "virtualizationThreshold", "anchorCursor", "lazyRender", "refreshOnEdit", "copyHeaders", "columnGroups", "commitEmptyEdits", "headersFocusability", "ariaLabel", "skipMerged", "pasteEmptyCells", "groupSummaryPosition"], outputs: ["initialized", "gotFocus", "lostFocus", "refreshing", "refreshed", "invalidInput", "beginningEdit", "cellEditEnded", "cellEditEnding", "prepareCellForEdit", "formatItem", "resizingColumn", "resizedColumn", "autoSizingColumn", "autoSizedColumn", "draggingColumn", "draggingColumnOver", "draggedColumn", "sortingColumn", "sortedColumn", "pinningColumn", "pinnedColumn", "resizingRow", "resizedRow", "autoSizingRow", "autoSizedRow", "draggingRow", "draggingRowOver", "draggedRow", "deletingRow", "deletedRow", "loadingRows", "loadedRows", "rowEditStarting", "rowEditStarted", "rowEditEnding", "rowEditEnded", "rowAdded", "groupCollapsedChanging", "groupCollapsedChanged", "columnGroupCollapsedChanging", "columnGroupCollapsedChanged", "itemsSourceChanging", "itemsSourceChanged", "selectionChanging", "selectionChanged", "scrollPositionChanged", "updatingView", "updatedView", "updatingLayout", "updatedLayout", "pasting", "pasted", "pastingCell", "pastedCell", "copying", "copied"] }, { type: i5.BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }, { type: i2.WjFlexGridColumn, selector: "wj-flex-grid-column", inputs: ["asyncBindings", "wjProperty", "name", "dataMap", "dataType", "binding", "sortMemberPath", "format", "cellTemplate", "header", "width", "maxLength", "minWidth", "maxWidth", "align", "allowDragging", "allowSorting", "allowResizing", "allowMerging", "aggregate", "isReadOnly", "cssClass", "cssClassAll", "isContentHtml", "isSelected", "visible", "wordWrap", "multiLine", "mask", "inputType", "isRequired", "showDropDown", "dataMapEditor", "dropDownCssClass", "quickAutoSize", "editor", "placeholder"], outputs: ["initialized", "isSelectedChange"] }], directives: [{ type: i4.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.WjFlexGridCellTemplate, selector: "[wjFlexGridCellTemplate]", inputs: ["wjFlexGridCellTemplate", "cellOverflow", "valuePaths", "autoSizeRows", "forceFullEdit", "cellType"], exportAs: ["wjFlexGridCellTemplate"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientsTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-clients-table', template: "<div class=\"ng-bento\"\n  [ngStyle]=\"{ 'height' : allClients.length === 0 ? '36px' : '100%' }\">\n    <wj-flex-grid #flexGrid\n    class=\"bento-flex-grid has-row-hover clients-table\"\n    [itemsSource]=\"allClients\"\n    [stickyHeaders]=\"false\"\n    [showMarquee]=\"false\"\n    [showSort]=\"false\"\n    [allowResizing]=\"allowResizing\"\n    [isReadOnly]=\"true\"\n    (initialized)=\"initializeHeaders(flexGrid)\"\n    [autoScroll]=\"true\"\n    (loadedRows)=\"updateFlexGridRows(flexGrid)\"\n    [ngClass]=\"{ 'flex-grid-root-styles': allClients.length === 0 }\">\n        <div class=\"table-body\">\n            <ng-template wjFlexGridCellTemplate [cellType]=\"'TopLeft'\" let-col=\"col\">\n                <div *ngIf=\"col.index === 1\">\n                    <bento-checkbox [(ngModel)]=\"isAllChecked\" [indeterminate]=\"isIndetermined\"\n                        (change)=\"onHeaderCheckboxChange()\"></bento-checkbox>\n                </div>\n            </ng-template>\n\n            <ng-template wjFlexGridCellTemplate [cellType]=\"'RowHeader'\" let-col=\"col\" let-row=\"row\" let-item=\"item\">\n                <div class=\"line-count\" *ngIf=\"col.index === 0\">{{ row.index+1 }}</div>\n                <div *ngIf=\"col.index === 1\">\n                    <bento-checkbox class=\"table-checkbox\" [(ngModel)]=\"item.state\" (change)=\"onCheckboxChange()\">\n                    </bento-checkbox>\n                </div>\n            </ng-template>\n\n            <wj-flex-grid-column [header]=\"i18n('Id') | translate\" [binding]=\"'code'\"\n                [width]=\"columnDefinitionsByBinding['code'].width\">\n            </wj-flex-grid-column>\n\n            <wj-flex-grid-column [header]=\"i18n('Client') | translate\" [binding]=\"'name'\"\n                [width]=\"columnDefinitionsByBinding['name'].width\">\n            </wj-flex-grid-column>\n        </div>\n\n    </wj-flex-grid>\n</div>\n", styles: [":host{height:calc(100% - 45px);display:block}:host>.ng-bento,:host>.ng-bento .wj-flexgrid{height:100%}:host ::ng-deep .wj-cell{display:flex;align-items:center}:host ::ng-deep .wj-cell.wj-align-right{justify-content:flex-end}::ng-deep [wj-part=ch]{height:36px!important}::ng-deep .wj-cell{height:36px!important}.flex-grid-root-styles ::ng-deep [wj-part=root]{overflow:hidden!important}\n"] }]
        }], ctorParameters: function () { return [{ type: AccountingCostsFlexGridServices }]; }, propDecorators: { flexGrid: [{
                type: ViewChild,
                args: ['flexGrid']
            }], listClient: [{
                type: Input
            }], changeButtonStatus: [{
                type: Output
            }], endOfScroll: [{
                type: Output
            }], totalItems: [{
                type: Input
            }], allClients: [{
                type: Input
            }] } });

class AddClientsModalComponent {
    constructor(activeModal, tableClientsService, fb, loaderService) {
        this.activeModal = activeModal;
        this.tableClientsService = tableClientsService;
        this.fb = fb;
        this.selectedClientsIds = [];
        this.modalClients = [];
        this.saveDisabled = true;
        this.pagingInfo = new PagingInfo$1(1, 1, 30);
        this.listClient = {};
        this.filters = {};
        this.itemsPerPage = 30;
        this.loadingModalClientsBusyLoader = loaderService.modalClientsLoader;
    }
    ngOnInit() {
        this.searchForEmpty();
    }
    i18n(node) {
        return `Onvio.AccountingCosts.SelectClients.${node}`;
    }
    getSelectedData() {
        return this.modalClients.filter(client => client.state).map(client => {
            return Object.assign(Object.assign({}, client), { state: false });
        });
    }
    onChangeButtonStatus(buttonStatus) {
        this.saveDisabled = !buttonStatus;
    }
    searchClient(search = '') {
        this.listClient = {
            clients: []
        };
        if (search) {
            search = search.trim();
            this.filters = {
                orderBy: '',
                search,
                searchBy: 'name,code'
            };
            this.modalClients = [];
            this.pagingInfo.startIndex = 1;
            this.setClients(this.filters);
        }
        else {
            this.modalClients = [];
            this.searchForEmpty();
        }
    }
    searchForEmpty() {
        this.searchForm = this.fb.group({
            search: ''
        });
        this.filters = {};
        this.pagingInfo.startIndex = 1;
        this.setClients(this.filters);
        this.searchForm.valueChanges
            .pipe(distinctUntilChanged(), debounceTime(1000)).subscribe(value => {
            this.searchClient(value.search);
        });
    }
    onEndScroll() {
        if (!this.loadingModalClientsBusyLoader.state) {
            this.pagingInfo.startIndex += this.itemsPerPage;
            this.setClients(this.filters);
        }
    }
    setClients(filters) {
        {
            this.loadingModalClientsBusyLoader.show();
            const customFilters = [this.tableClientsService.mountCustomFilter('code', '!IN', ['FIRM'])];
            if (this.selectedClientsIds.length > 0) {
                customFilters.push(this.tableClientsService.mountCustomFilter('id', '!IN', this.selectedClientsIds));
            }
            const customFilter = this.tableClientsService.setCustomFilter(false, customFilters);
            this.tableClientsService.getSearchClients(this.pagingInfo, filters, customFilter)
                .pipe(first())
                .subscribe(res => {
                this.totalItems = res.totalItems;
                this.listClient = {
                    clients: res.items
                };
                this.loadingModalClientsBusyLoader.hide();
            });
        }
    }
}
AddClientsModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AddClientsModalComponent, deps: [{ token: i1$2.NgbActiveModal }, { token: TableClientsService }, { token: i2$1.FormBuilder }, { token: LoaderService }], target: i0.ɵɵFactoryTarget.Component });
AddClientsModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: AddClientsModalComponent, selector: "acc-add-clients-modal", inputs: { selectedClientsIds: "selectedClientsIds" }, ngImport: i0, template: "<div class=\"ng-bento\">\n    <button *ngIf=\"activeModal\" type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss()\">\n        <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n    </button>\n    <h4 id=\"modal-title\" class=\"modal-header\">\n        {{ i18n('Modal.SelectClients') | translate }}\n    </h4>\n    <hr>\n    <div class=\"modal-body\">\n        <div class=\"d-flex flex-column\">\n            <bento-toolbar class=\"bento-toolbar\" [formGroup]=\"searchForm\">\n                <div class=\"navbar-right\">\n                    <span class=\"bento-search\">\n                        <input bentoReset formControlName=\"search\" type=\"text\" class=\"form-control\"\n                            [placeholder]=\"i18n('Modal.Search') | translate\">\n                    </span>\n                </div>\n            </bento-toolbar>\n        </div>\n        <acc-clients-table class=\"busy-loader-container\" [bentoBusyLoader]=\"loadingModalClientsBusyLoader.state\" (endOfScroll)=\"onEndScroll()\"\n         [listClient]=\"listClient\" [(allClients)]=\"modalClients\" [totalItems]=\"totalItems\"\n            (changeButtonStatus)=\"onChangeButtonStatus($event)\"></acc-clients-table>\n    </div>\n    <div class=\"modal-footer\">\n        <button data-testid = \"save-btn\" type=\"button\" class=\"btn btn-primary\" (click)=\"activeModal.close(getSelectedData())\"\n            [disabled]=\"saveDisabled\"> {{ i18n('Modal.Save') | translate }} </button>\n        <button data-testid = \"cancel-btn\" type=\"button\" class=\"btn btn-outline-primary\" (click)=\"activeModal.dismiss()\">\n            {{ i18n('Modal.Cancel') | translate }} </button>\n    </div>\n</div>\n", styles: [".ng-bento .bento-toolbar .navbar-right{top:auto}::ng-deep .ng-bento .modal-scroll .modal-content{height:100%}::ng-deep .modal-scroll .modal-content{height:auto;height:initial;min-height:70%}.d-flex{height:36px}.busy-loader-container ::ng-deep .bento-busyloader-front-blocker{background:0}\n"], components: [{ type: i5.BentoToolbarComponent, selector: "bento-toolbar", inputs: ["items", "moreText"] }, { type: ClientsTableComponent, selector: "acc-clients-table", inputs: ["listClient", "totalItems", "allClients"], outputs: ["changeButtonStatus", "endOfScroll"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i5.BentoResetDirective, selector: "input:not([type=checkbox])[formControlName][bentoReset],input:not([type=checkbox])[formControl][bentoReset],input:not([type=checkbox])[ngModel][bentoReset]" }, { type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["size", "showDelay", "hideDelay", "bentoBusyLoader"], outputs: ["show", "hide"] }, { type: i5.BentoFooterTabHelper, selector: "[class=\"modal-footer\"]" }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AddClientsModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-add-clients-modal', template: "<div class=\"ng-bento\">\n    <button *ngIf=\"activeModal\" type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss()\">\n        <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n    </button>\n    <h4 id=\"modal-title\" class=\"modal-header\">\n        {{ i18n('Modal.SelectClients') | translate }}\n    </h4>\n    <hr>\n    <div class=\"modal-body\">\n        <div class=\"d-flex flex-column\">\n            <bento-toolbar class=\"bento-toolbar\" [formGroup]=\"searchForm\">\n                <div class=\"navbar-right\">\n                    <span class=\"bento-search\">\n                        <input bentoReset formControlName=\"search\" type=\"text\" class=\"form-control\"\n                            [placeholder]=\"i18n('Modal.Search') | translate\">\n                    </span>\n                </div>\n            </bento-toolbar>\n        </div>\n        <acc-clients-table class=\"busy-loader-container\" [bentoBusyLoader]=\"loadingModalClientsBusyLoader.state\" (endOfScroll)=\"onEndScroll()\"\n         [listClient]=\"listClient\" [(allClients)]=\"modalClients\" [totalItems]=\"totalItems\"\n            (changeButtonStatus)=\"onChangeButtonStatus($event)\"></acc-clients-table>\n    </div>\n    <div class=\"modal-footer\">\n        <button data-testid = \"save-btn\" type=\"button\" class=\"btn btn-primary\" (click)=\"activeModal.close(getSelectedData())\"\n            [disabled]=\"saveDisabled\"> {{ i18n('Modal.Save') | translate }} </button>\n        <button data-testid = \"cancel-btn\" type=\"button\" class=\"btn btn-outline-primary\" (click)=\"activeModal.dismiss()\">\n            {{ i18n('Modal.Cancel') | translate }} </button>\n    </div>\n</div>\n", styles: [".ng-bento .bento-toolbar .navbar-right{top:auto}::ng-deep .ng-bento .modal-scroll .modal-content{height:100%}::ng-deep .modal-scroll .modal-content{height:auto;height:initial;min-height:70%}.d-flex{height:36px}.busy-loader-container ::ng-deep .bento-busyloader-front-blocker{background:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }, { type: TableClientsService }, { type: i2$1.FormBuilder }, { type: LoaderService }]; }, propDecorators: { selectedClientsIds: [{
                type: Input
            }] } });

var ActionTypes;
(function (ActionTypes) {
    ActionTypes["ADD"] = "Add";
    ActionTypes["DUPLICATE"] = "Duplicate";
    ActionTypes["REMOVE"] = "Remove";
    ActionTypes["EXCLUDE"] = "Excluir";
})(ActionTypes || (ActionTypes = {}));

class ClientsToolbarComponent {
    constructor(translateService, fb) {
        this.translateService = translateService;
        this.fb = fb;
        this.actions = [];
        this.searchClient = new EventEmitter();
        this.actionsButtons = [];
    }
    ngOnInit() {
        this.setActionsButtons().then(actionButtons => this.actionsButtons = actionButtons);
        this.searchForm = this.fb.group({
            search: ''
        });
        this.searchForm.valueChanges
            .pipe(distinctUntilChanged(), debounceTime(1000)).subscribe(value => {
            this.searchClient.emit(value.search);
        });
    }
    ngAfterViewInit() {
    }
    ngOnChanges(changes) {
        changes.actions.currentValue.forEach((element, index) => {
            if (!!this.actionsButtons[index]) {
                this.actionsButtons[index].disabled = element.disabled;
                this.toolbar.refresh();
            }
        });
    }
    setActionsButtons() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield Promise.all(this.actions.map((_a) => __awaiter(this, void 0, void 0, function* () {
                var { type } = _a, config = __rest(_a, ["type"]);
                return (Object.assign({ label: yield this.getTranslate(type).toPromise(), icon: this.getActionIcon(type), static: true }, config));
            })));
        });
    }
    getActionIcon(type) {
        switch (type) {
            case ActionTypes.ADD:
                return 'bento-icon-add';
            case ActionTypes.DUPLICATE:
                return 'bento-icon-copy';
            case ActionTypes.REMOVE:
                return 'bento-icon-remove';
        }
    }
    getTranslate(node) {
        return this.translateService.get(this.i18n(node));
    }
    i18n(node) {
        return `Onvio.AccountingCosts.ClientsToolbar.${node}`;
    }
}
ClientsToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientsToolbarComponent, deps: [{ token: i1$1.TranslateService }, { token: i2$1.FormBuilder }], target: i0.ɵɵFactoryTarget.Component });
ClientsToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ClientsToolbarComponent, selector: "acc-clients-toolbar", inputs: { actions: "actions" }, outputs: { searchClient: "searchClient" }, viewQueries: [{ propertyName: "toolbar", first: true, predicate: ["toolbar"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<main class=\"d-flex flex-column ng-bento\">\n  <bento-toolbar #toolbar *ngIf=\"actionsButtons.length\" class=\"bento-toolbar\" [items]=\"actionsButtons\" [formGroup]=\"searchForm\" >\n    <div class=\"navbar-right\">\n      <span class=\"bento-search\">\n        <input bentoReset formControlName=\"search\" type=\"text\" class=\"form-control\" [placeholder]=\"i18n('Search') | translate\">\n      </span>\n    </div>\n  </bento-toolbar>\n</main>\n", styles: [".ng-bento .bento-toolbar .navbar-right{top:auto}:host ::ng-deep .ng-bento .bento-toolbar .navbar-nav .more-button{display:none!important}.d-flex{height:36px}\n"], components: [{ type: i5.BentoToolbarComponent, selector: "bento-toolbar", inputs: ["items", "moreText"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i5.BentoResetDirective, selector: "input:not([type=checkbox])[formControlName][bentoReset],input:not([type=checkbox])[formControl][bentoReset],input:not([type=checkbox])[ngModel][bentoReset]" }, { type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientsToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-clients-toolbar', template: "<main class=\"d-flex flex-column ng-bento\">\n  <bento-toolbar #toolbar *ngIf=\"actionsButtons.length\" class=\"bento-toolbar\" [items]=\"actionsButtons\" [formGroup]=\"searchForm\" >\n    <div class=\"navbar-right\">\n      <span class=\"bento-search\">\n        <input bentoReset formControlName=\"search\" type=\"text\" class=\"form-control\" [placeholder]=\"i18n('Search') | translate\">\n      </span>\n    </div>\n  </bento-toolbar>\n</main>\n", styles: [".ng-bento .bento-toolbar .navbar-right{top:auto}:host ::ng-deep .ng-bento .bento-toolbar .navbar-nav .more-button{display:none!important}.d-flex{height:36px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }, { type: i2$1.FormBuilder }]; }, propDecorators: { actions: [{
                type: Input
            }], searchClient: [{
                type: Output
            }], toolbar: [{
                type: ViewChild,
                args: ['toolbar']
            }] } });

class SelectClientsComponent {
    constructor(modalService, tableClientsService, loaderService) {
        this.modalService = modalService;
        this.tableClientsService = tableClientsService;
        this.actions = [
            {
                type: ActionTypes.ADD,
                action: () => this.open()
            },
            {
                type: ActionTypes.REMOVE,
                action: () => this.removeRows(),
                disabled: true
            }
        ];
        this.templateSelectedClients = [];
        this.addClients = new EventEmitter();
        this.removeClients = new EventEmitter();
        this.listClient = {};
        this.selectedClients = [];
        this.selectedClientsIds = [];
        this.pagingInfo = new PagingInfo$1(1, 1, 30);
        this.filters = {};
        this.itemsPerPage = 30;
        this.totalItems = 0;
        this.loadingClientsBusyLoader = loaderService.clientsLoader;
    }
    ngOnChanges(changes) {
        if (!!changes.templateSelectedClients &&
            !!changes.templateSelectedClients.currentValue &&
            this.templateSelectedClients.length > 0) {
            const clientIds = this.templateSelectedClients.map(client => this.formatClientIdUpperCase(client.id));
            this.selectedClientsIds = clientIds;
            this.selectedClients = [];
            this.listClient = {};
            this.searchForEmpty();
            this.clearItems();
        }
    }
    clearItems() {
        const ids = [];
        if (!!this.listClient && !!this.listClient.clients) {
            this.listClient.clients.forEach((client) => ids.push(client.id));
            this.listClient = {
                clients: this.listClient.clients.filter(item => ids.filter(id => item.id === id).length === 1)
            };
        }
    }
    setClients() {
        this.loadingClientsBusyLoader.show();
        const customFilters = [this.tableClientsService.mountCustomFilter('id', 'IN', this.selectedClientsIds)];
        const customFilter = this.tableClientsService.setCustomFilter(true, customFilters);
        this.tableClientsService
            .getSearchClients(this.pagingInfo, this.filters, customFilter)
            .pipe(first())
            .subscribe({
            next: (res) => {
                this.listClient = {
                    clients: res.items
                };
                this.totalItems = res.totalItems;
                this.loadingClientsBusyLoader.hide();
            },
            error: () => {
                this.loadingClientsBusyLoader.hide();
            }
        });
    }
    refreshFlexGrid() {
        this.clientsTable.refreshFlexGrid();
    }
    onEndOfScroll() {
        if (!this.loadingClientsBusyLoader.state) {
            this.pagingInfo.startIndex += this.itemsPerPage;
            this.setClients();
        }
    }
    open() {
        const options = {
            windowClass: 'modal-scroll',
            ariaLabelledBy: 'modal-clients-title',
            container: '#bentoNGModalContainer'
        };
        const modalRef = this.modalService.open(AddClientsModalComponent, options);
        modalRef.componentInstance.selectedClientsIds = this.selectedClientsIds;
        modalRef.result.then((clientsToAdd) => {
            if (this.selectedClients.length >= this.totalItems) {
                this.listClient = {
                    clients: clientsToAdd,
                    deleteOperation: false
                };
            }
            this.totalItems += clientsToAdd.length;
            this.selectedClients = [...clientsToAdd, ...this.selectedClients];
            this.selectedClientsIds = [...this.selectedClientsIds, ...clientsToAdd.map(item => item.id)];
            this.addClients.emit(this.selectedClientsIds);
        }, reason => { });
    }
    removeRows() {
        const removedClients = this.selectedClients.filter(client => client.state);
        const removedClientsIds = removedClients.map(client => client.id);
        this.clientsTable.preservePosition();
        this.listClient = {
            clients: this.selectedClients.filter(client => !client.state),
            deleteOperation: true
        };
        this.pagingInfo.startIndex -= removedClients.length;
        this.selectedClients = this.listClient.clients;
        this.selectedClientsIds = this.selectedClientsIds.filter(id => !removedClientsIds.includes(id));
        this.removeClients.emit(this.selectedClientsIds);
        this.onChangeButtonStatus(false);
    }
    onChangeButtonStatus(isEnabled) {
        const [add, remove] = this.actions;
        this.actions = [Object.assign({}, add), Object.assign(Object.assign({}, remove), { disabled: !isEnabled })];
    }
    searchForEmpty() {
        this.pagingInfo.startIndex = 1;
        this.filters = {};
        this.setClients();
    }
    onSearchClient(search) {
        this.listClient = {
            clients: []
        };
        if (search) {
            search = search.trim();
            this.filters = {
                orderBy: '',
                search,
                searchBy: 'name,code'
            };
            this.pagingInfo.startIndex = 1;
            this.selectedClients = [];
            this.setClients();
        }
        else {
            this.selectedClients = [];
            this.searchForEmpty();
        }
    }
    i18n(node) {
        return `Onvio.AccountingCosts.Costs.CostsCalculation.${node}`;
    }
    formatClientIdUpperCase(clientId) {
        return clientId
            .split('-')
            .join('')
            .toUpperCase();
    }
}
SelectClientsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SelectClientsComponent, deps: [{ token: i1$2.NgbModal }, { token: TableClientsService }, { token: LoaderService }], target: i0.ɵɵFactoryTarget.Component });
SelectClientsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: SelectClientsComponent, selector: "acc-select-clients", inputs: { templateSelectedClients: "templateSelectedClients" }, outputs: { addClients: "addClients", removeClients: "removeClients" }, viewQueries: [{ propertyName: "clientsTable", first: true, predicate: ["tableClients"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<acc-clients-toolbar\n  [actions]=\"actions\"\n  (searchClient)=\"onSearchClient($event)\"\n></acc-clients-toolbar>\n<div class=\"table-container\" [bentoBusyLoader]=\"loadingClientsBusyLoader.state\">\n  <acc-clients-table\n    #tableClients\n    [listClient]=\"listClient\"\n    [(allClients)]=\"selectedClients\"\n    (endOfScroll)=\"onEndOfScroll()\"\n    (changeButtonStatus)=\"onChangeButtonStatus($event)\"\n    [ngClass]=\"loadingClientsBusyLoader.state ? 'container-loading' : ''\"\n    [totalItems]=\"totalItems\"\n  >\n  </acc-clients-table>\n</div>\n", styles: [".table-container ::ng-deep .clients-table{max-height:60vh}.table-container .container-loading{min-height:60vh}@media (min-height: 800px){.table-container ::ng-deep .clients-table{max-height:69vh}.table-container .container-loading{min-height:69vh}}@media (min-height: 1024px){.table-container ::ng-deep .clients-table{max-height:72vh}.table-container .container-loading{min-height:72vh}}@media (min-height: 1366px){.table-container ::ng-deep .clients-table{max-height:77vh}.table-container .container-loading{min-height:77vh}}::ng-deep .modal-scroll .modal-dialog{height:200px;min-height:70%;margin:100px 0}.table-container ::ng-deep .bento-busyloader-front-blocker{background:0}\n"], components: [{ type: ClientsToolbarComponent, selector: "acc-clients-toolbar", inputs: ["actions"], outputs: ["searchClient"] }, { type: ClientsTableComponent, selector: "acc-clients-table", inputs: ["listClient", "totalItems", "allClients"], outputs: ["changeButtonStatus", "endOfScroll"] }], directives: [{ type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["size", "showDelay", "hideDelay", "bentoBusyLoader"], outputs: ["show", "hide"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SelectClientsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-select-clients', template: "<acc-clients-toolbar\n  [actions]=\"actions\"\n  (searchClient)=\"onSearchClient($event)\"\n></acc-clients-toolbar>\n<div class=\"table-container\" [bentoBusyLoader]=\"loadingClientsBusyLoader.state\">\n  <acc-clients-table\n    #tableClients\n    [listClient]=\"listClient\"\n    [(allClients)]=\"selectedClients\"\n    (endOfScroll)=\"onEndOfScroll()\"\n    (changeButtonStatus)=\"onChangeButtonStatus($event)\"\n    [ngClass]=\"loadingClientsBusyLoader.state ? 'container-loading' : ''\"\n    [totalItems]=\"totalItems\"\n  >\n  </acc-clients-table>\n</div>\n", styles: [".table-container ::ng-deep .clients-table{max-height:60vh}.table-container .container-loading{min-height:60vh}@media (min-height: 800px){.table-container ::ng-deep .clients-table{max-height:69vh}.table-container .container-loading{min-height:69vh}}@media (min-height: 1024px){.table-container ::ng-deep .clients-table{max-height:72vh}.table-container .container-loading{min-height:72vh}}@media (min-height: 1366px){.table-container ::ng-deep .clients-table{max-height:77vh}.table-container .container-loading{min-height:77vh}}::ng-deep .modal-scroll .modal-dialog{height:200px;min-height:70%;margin:100px 0}.table-container ::ng-deep .bento-busyloader-front-blocker{background:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }, { type: TableClientsService }, { type: LoaderService }]; }, propDecorators: { clientsTable: [{
                type: ViewChild,
                args: ['tableClients']
            }], templateSelectedClients: [{
                type: Input
            }], addClients: [{
                type: Output
            }], removeClients: [{
                type: Output
            }] } });

class TableClientsComponent {
    constructor(flexGridService, fb) {
        this.flexGridService = flexGridService;
        this.actions = [];
        this.endScroll = new EventEmitter();
        this.select = new EventEmitter();
        this.selectAll = new EventEmitter();
        this.search = new EventEmitter();
        this.isIndeterminate = false;
        this.isAllSelected = false;
        this._clients = [];
        this.isRemoving = false;
        this.COLUMN_HEADER_WIDTH = 36;
        this.searchForm = fb.group({
            search: ['']
        });
        this.searchForm.get('search').valueChanges.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((value) => this.search.emit(value || ''));
    }
    set clients(value) {
        if (!value) {
            return;
        }
        if (value && value.length < this._clients.length) {
            this.isIndeterminate = false;
            this.isAllSelected = false;
        }
        else {
            this.checkHeaderStatus();
        }
        this._clients.length = 0;
        this._clients.push(...value);
        if (this.flexGrid && this.flexGrid.collectionView) {
            this.flexGrid.collectionView.refresh();
        }
    }
    get clients() {
        return this._clients;
    }
    ngOnInit() {
        this.flexGrid.onRefreshed = () => {
            this.flexGrid = this.flexGridService.updateFlexGridRows(this.flexGrid);
        };
    }
    initializeHeaders() {
        if (this.flexGrid) {
            const hc = new wjcGrid.Column();
            this.flexGrid.rowHeaders.columns.push(hc);
            this.flexGrid.rowHeaders.columns[1].width = this.COLUMN_HEADER_WIDTH;
            this.flexGrid = this.flexGridService.updateFlexGridRows(this.flexGrid);
            this.initializeHandler();
        }
    }
    initializeHandler() {
        if (this.flexGrid) {
            this.flexGrid.scrollPositionChanged.addHandler((grid) => {
                if (grid.viewRange.bottomRow >= grid.rows.length - 1) {
                    this.endScroll.emit();
                }
            });
        }
    }
    onHeaderCheckBoxChange() {
        if (this.clients && this.clients.length) {
            this.isIndeterminate = false;
            this.isAllSelected = !this.isAllSelected;
            this.clients.forEach(client => client.state = this.isAllSelected);
            this.selectAll.emit(this.isAllSelected);
        }
    }
    onCheckBoxChange(item) {
        this.checkHeaderStatus();
        this.select.emit(item);
    }
    checkHeaderStatus() {
        if (this.clients && this.clients.length) {
            this.isIndeterminate = this.clients.some(client => client.state);
            this.isAllSelected = false;
        }
    }
}
TableClientsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TableClientsComponent, deps: [{ token: AccountingCostsFlexGridServices }, { token: i2$1.FormBuilder }], target: i0.ɵɵFactoryTarget.Component });
TableClientsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: TableClientsComponent, selector: "acc-table-clients", inputs: { actions: "actions", clients: "clients" }, outputs: { endScroll: "endScroll", select: "select", selectAll: "selectAll", search: "search" }, viewQueries: [{ propertyName: "flexGrid", first: true, predicate: ["flexGrid"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"ng-bento\">\n  <bento-toolbar #toolbar class=\"bento-toolbar\" [items]=\"actions\" [formGroup]=\"searchForm\">\n  <div class=\"navbar navbar-right\">\n    <span class=\"bento-search\">\n      <input bentoReset formControlName=\"search\" type=\"text\" class=\"form-control\" [placeholder]=\"'Onvio.AccountingCosts.ClientsToolbar.Search' | translate\">\n    </span>\n  </div>\n</bento-toolbar>\n\n<wj-flex-grid\n#flexGrid\nclass=\"bento-flex-grid\"\n[itemsSource]=\"clients\"\n[stickyHeaders]=\"false\"\n[showMarquee]=\"false\"\n[allowSorting]=\"false\"\n[autoRowHeights]=\"false\"\n[isReadOnly]=\"true\"\n(initialized)=\"initializeHeaders()\"\n>\n  <ng-template wjFlexGridCellTemplate [cellType]=\"'TopLeft'\" let-col=\"col\">\n    <div *ngIf=\"col.index === 1\">\n      <bento-checkbox\n      [ngModel]=\"isAllSelected\"\n      (change)=\"onHeaderCheckBoxChange()\"\n      [indeterminate]=\"isIndeterminate\"\n      ></bento-checkbox>\n    </div>\n  </ng-template>\n  <ng-template\n  wjFlexGridCellTemplate\n  [cellType]=\"'RowHeader'\"\n  let-col=\"col\"\n  let-row=\"row\"\n  let-item=\"item\"\n  >\n  <div *ngIf=\"col.index === 0\">{{ row.index + 1 }}</div>\n  <div *ngIf=\"col.index === 1\">\n    <bento-checkbox\n    [(ngModel)]=\"item.state\"\n    (change)=\"onCheckBoxChange(item)\"\n    ></bento-checkbox>\n  </div>\n</ng-template>\n<wj-flex-grid-column [dataType]=\"2\" [header]=\"'Onvio.AccountingCosts.SelectClients.TableClients.Id' | translate\" [binding]=\"'code'\" [width]=\"100\">\n</wj-flex-grid-column>\n\n<wj-flex-grid-column [header]=\"'Onvio.AccountingCosts.SelectClients.TableClients.Client' | translate\" [binding]=\"'name'\" [width]=\"'*'\">\n</wj-flex-grid-column>\n</wj-flex-grid>\n\n</div>", styles: ["::ng-deep .ng-bento .wj-cells .wj-cell.wj-state-selected,::ng-deep .ng-bento .wj-cells .wj-cell.wj-state-multi-selected{background-color:#fff;color:#000}::ng-deep .ng-bento .bento-toolbar .navbar-right{top:-5px;height:20px}::ng-deep .ng-bento .wj-cell.wj-header{text-align:left}.navbar{min-height:0;margin-bottom:0}\n"], components: [{ type: i5.BentoToolbarComponent, selector: "bento-toolbar", inputs: ["items", "moreText"] }, { type: i2.WjFlexGrid, selector: "wj-flex-grid", inputs: ["wjModelProperty", "isDisabled", "tabOrder", "newRowAtTop", "allowAddNew", "allowDelete", "allowDragging", "allowMerging", "allowResizing", "allowSorting", "allowPinning", "autoScroll", "autoRowHeights", "autoSizeMode", "autoGenerateColumns", "autoSearch", "caseSensitiveSearch", "quickAutoSize", "bigCheckboxes", "childItemsPath", "groupHeaderFormat", "headersVisibility", "showSelectedHeaders", "showMarquee", "showPlaceholders", "itemFormatter", "isReadOnly", "imeEnabled", "mergeManager", "selectionMode", "showGroups", "showSort", "showDropDown", "showAlternatingRows", "showErrors", "alternatingRowStep", "itemValidator", "validateEdits", "treeIndent", "itemsSource", "autoClipboard", "expandSelectionOnCopyPaste", "frozenCells", "frozenRows", "frozenColumns", "cloneFrozenCells", "deferResizing", "sortRowIndex", "editColumnIndex", "stickyHeaders", "preserveSelectedState", "preserveOutlineState", "preserveWhiteSpace", "keyActionTab", "keyActionEnter", "rowHeaderPath", "virtualizationThreshold", "anchorCursor", "lazyRender", "refreshOnEdit", "copyHeaders", "columnGroups", "commitEmptyEdits", "headersFocusability", "ariaLabel", "skipMerged", "pasteEmptyCells", "groupSummaryPosition"], outputs: ["initialized", "gotFocus", "lostFocus", "refreshing", "refreshed", "invalidInput", "beginningEdit", "cellEditEnded", "cellEditEnding", "prepareCellForEdit", "formatItem", "resizingColumn", "resizedColumn", "autoSizingColumn", "autoSizedColumn", "draggingColumn", "draggingColumnOver", "draggedColumn", "sortingColumn", "sortedColumn", "pinningColumn", "pinnedColumn", "resizingRow", "resizedRow", "autoSizingRow", "autoSizedRow", "draggingRow", "draggingRowOver", "draggedRow", "deletingRow", "deletedRow", "loadingRows", "loadedRows", "rowEditStarting", "rowEditStarted", "rowEditEnding", "rowEditEnded", "rowAdded", "groupCollapsedChanging", "groupCollapsedChanged", "columnGroupCollapsedChanging", "columnGroupCollapsedChanged", "itemsSourceChanging", "itemsSourceChanged", "selectionChanging", "selectionChanged", "scrollPositionChanged", "updatingView", "updatedView", "updatingLayout", "updatedLayout", "pasting", "pasted", "pastingCell", "pastedCell", "copying", "copied"] }, { type: i5.BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }, { type: i2.WjFlexGridColumn, selector: "wj-flex-grid-column", inputs: ["asyncBindings", "wjProperty", "name", "dataMap", "dataType", "binding", "sortMemberPath", "format", "cellTemplate", "header", "width", "maxLength", "minWidth", "maxWidth", "align", "allowDragging", "allowSorting", "allowResizing", "allowMerging", "aggregate", "isReadOnly", "cssClass", "cssClassAll", "isContentHtml", "isSelected", "visible", "wordWrap", "multiLine", "mask", "inputType", "isRequired", "showDropDown", "dataMapEditor", "dropDownCssClass", "quickAutoSize", "editor", "placeholder"], outputs: ["initialized", "isSelectedChange"] }], directives: [{ type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$2.NgbNavbar, selector: ".navbar" }, { type: i2$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i5.BentoResetDirective, selector: "input:not([type=checkbox])[formControlName][bentoReset],input:not([type=checkbox])[formControl][bentoReset],input:not([type=checkbox])[ngModel][bentoReset]" }, { type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i2.WjFlexGridCellTemplate, selector: "[wjFlexGridCellTemplate]", inputs: ["wjFlexGridCellTemplate", "cellOverflow", "valuePaths", "autoSizeRows", "forceFullEdit", "cellType"], exportAs: ["wjFlexGridCellTemplate"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TableClientsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-table-clients', template: "<div class=\"ng-bento\">\n  <bento-toolbar #toolbar class=\"bento-toolbar\" [items]=\"actions\" [formGroup]=\"searchForm\">\n  <div class=\"navbar navbar-right\">\n    <span class=\"bento-search\">\n      <input bentoReset formControlName=\"search\" type=\"text\" class=\"form-control\" [placeholder]=\"'Onvio.AccountingCosts.ClientsToolbar.Search' | translate\">\n    </span>\n  </div>\n</bento-toolbar>\n\n<wj-flex-grid\n#flexGrid\nclass=\"bento-flex-grid\"\n[itemsSource]=\"clients\"\n[stickyHeaders]=\"false\"\n[showMarquee]=\"false\"\n[allowSorting]=\"false\"\n[autoRowHeights]=\"false\"\n[isReadOnly]=\"true\"\n(initialized)=\"initializeHeaders()\"\n>\n  <ng-template wjFlexGridCellTemplate [cellType]=\"'TopLeft'\" let-col=\"col\">\n    <div *ngIf=\"col.index === 1\">\n      <bento-checkbox\n      [ngModel]=\"isAllSelected\"\n      (change)=\"onHeaderCheckBoxChange()\"\n      [indeterminate]=\"isIndeterminate\"\n      ></bento-checkbox>\n    </div>\n  </ng-template>\n  <ng-template\n  wjFlexGridCellTemplate\n  [cellType]=\"'RowHeader'\"\n  let-col=\"col\"\n  let-row=\"row\"\n  let-item=\"item\"\n  >\n  <div *ngIf=\"col.index === 0\">{{ row.index + 1 }}</div>\n  <div *ngIf=\"col.index === 1\">\n    <bento-checkbox\n    [(ngModel)]=\"item.state\"\n    (change)=\"onCheckBoxChange(item)\"\n    ></bento-checkbox>\n  </div>\n</ng-template>\n<wj-flex-grid-column [dataType]=\"2\" [header]=\"'Onvio.AccountingCosts.SelectClients.TableClients.Id' | translate\" [binding]=\"'code'\" [width]=\"100\">\n</wj-flex-grid-column>\n\n<wj-flex-grid-column [header]=\"'Onvio.AccountingCosts.SelectClients.TableClients.Client' | translate\" [binding]=\"'name'\" [width]=\"'*'\">\n</wj-flex-grid-column>\n</wj-flex-grid>\n\n</div>", styles: ["::ng-deep .ng-bento .wj-cells .wj-cell.wj-state-selected,::ng-deep .ng-bento .wj-cells .wj-cell.wj-state-multi-selected{background-color:#fff;color:#000}::ng-deep .ng-bento .bento-toolbar .navbar-right{top:-5px;height:20px}::ng-deep .ng-bento .wj-cell.wj-header{text-align:left}.navbar{min-height:0;margin-bottom:0}\n"] }]
        }], ctorParameters: function () { return [{ type: AccountingCostsFlexGridServices }, { type: i2$1.FormBuilder }]; }, propDecorators: { flexGrid: [{
                type: ViewChild,
                args: ['flexGrid', { static: true }]
            }], actions: [{
                type: Input
            }], endScroll: [{
                type: Output
            }], select: [{
                type: Output
            }], selectAll: [{
                type: Output
            }], search: [{
                type: Output
            }], clients: [{
                type: Input
            }] } });

class ClientsService {
    constructor(http) {
        this.http = http;
        this.maxClients = 1000;
    }
    findClientsPage(clientsIds, page, filter) {
        const clientsFilter = this.mountCustomFilter('id', 'IN', clientsIds);
        const firmFilter = this.mountCustomFilter('code', '!IN', ['FIRM']);
        const customFilter = this.setCustomFilter(false, [
            clientsFilter,
            firmFilter
        ]);
        const searchBody = {
            filterSearchSort: {
                filter: customFilter,
                orderBy: 'code asc'
            },
            pagingDataRequest: page
        };
        if (filter && filter.search) {
            searchBody.filterSearchSort.search = filter.search;
        }
        return this.http
            .post(`/api/core/v3/companies/${this.getCompanyId()}/clients/search`, searchBody)
            .pipe(first());
    }
    findClientsExcluding(clientsIds, page, filter) {
        let customFilter;
        const firmFilter = this.mountCustomFilter('code', '!IN', ['FIRM']);
        if (clientsIds && clientsIds.length) {
            const clientsFilter = this.mountCustomFilter('id', '!IN', clientsIds);
            customFilter = this.setCustomFilter(false, [clientsFilter, firmFilter]);
        }
        else {
            customFilter = this.setCustomFilter(false, [firmFilter]);
        }
        const searchBody = {
            filterSearchSort: {
                filter: customFilter,
                orderBy: 'code asc'
            },
            pagingDataRequest: page
        };
        if (filter && filter.search) {
            searchBody.filterSearchSort.search = filter.search;
        }
        return this.http
            .post(`/api/core/v3/companies/${this.getCompanyId()}/clients/search`, searchBody)
            .pipe(first());
    }
    findAllClients() {
        return this.http
            .get(`/api/core/v3/companies/${this.getCompanyId()}/clients`)
            .pipe(take(1), switchMap(res => {
            const totalItems = res.totalItems;
            const batches = this.getClientsBatches(totalItems);
            return forkJoin(batches);
        }));
    }
    getCompanyId() {
        try {
            const [companyCookieObject] = document.cookie
                .split(';')
                .filter(cookie => cookie.includes('bmTheme'));
            const [companyCookieKey, companyCookie] = companyCookieObject.split('=');
            return companyCookie;
        }
        catch (err) {
            console.log(err.message);
        }
    }
    getClientsBatches(totalItems) {
        const batches = [];
        for (let i = 0; i < Math.ceil(totalItems / this.maxClients); i++) {
            const params = new HttpParams()
                .append('startIndex', `${i * this.maxClients + 1}`)
                .append('itemsPerPage', `${this.maxClients}`);
            batches.push(this.http
                .get(`/api/core/v3/companies/${this.getCompanyId()}/clients`, { params })
                .pipe(take(1)));
        }
        return batches;
    }
    mountCustomFilter(by, op, values) {
        return {
            by,
            op,
            values
        };
    }
    setCustomFilter(useOr, items) {
        return JSON.stringify({
            useOr,
            items
        });
    }
}
ClientsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientsService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
ClientsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class ClientsModalComponent {
    constructor(activeModal, clientsService, loaderService) {
        this.activeModal = activeModal;
        this.clientsService = clientsService;
        this.loaderService = loaderService;
        this.clients = [];
        this.isAllSelected = false;
        this.disableSave = true;
        this.endScroll = new Subject();
        this.endScrollObs = this.endScroll.asObservable();
        this.search = new Subject();
        this.searchObs = this.search.asObservable();
        this.select = new Subject();
        this.selectObs = this.select.asObservable();
        this.selectAll = new Subject();
        this.selectAllObs = this.selectAll.asObservable();
        this.modalClientsLoader = this.loaderService.modalClientsLoader;
    }
    onEndScroll() {
        if (this.clients && this.clients.length < this.totalItems && !this.modalClientsLoader.state) {
            this.endScroll.next();
        }
    }
    onSearch(value) {
        this.search.next(value);
    }
    onSelect() {
        this.disableSave = this.clients.every(client => !client.state);
        this.isAllSelected = false;
    }
    onSelectAll() {
        this.isAllSelected = !this.isAllSelected;
        this.disableSave = this.clients.every(client => !client.state);
        this.selectAll.next(this.isAllSelected);
    }
    onSave() {
        this.modalClientsLoader.show();
        const selectedClients = this.clients
            .filter(client => client.state)
            .map(client => {
            return Object.assign(Object.assign({}, client), { state: false });
        });
        this.activeModal.close(selectedClients);
        this.modalClientsLoader.hide();
    }
}
ClientsModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientsModalComponent, deps: [{ token: i1$2.NgbActiveModal }, { token: ClientsService }, { token: LoaderService }], target: i0.ɵɵFactoryTarget.Component });
ClientsModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ClientsModalComponent, selector: "acc-clients-modal", inputs: { clients: "clients", totalItems: "totalItems" }, ngImport: i0, template: "<div class=\"ng-bento\">\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss('')\">\n        <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n    </button>\n    <h4 id=\"modal-title\" class=\"modal-header\">\n       {{'Onvio.AccountingCosts.SelectClients.Modal.SelectClients' | translate}}\n    </h4>\n    <div class=\"modal-body\">\n        <div class=\"d-flex flex-column\">\n            <acc-table-clients class=\"table-clients\" [bentoBusyLoader]=\"modalClientsLoader.state\" [clients]=\"clients\" (endScroll)=\"onEndScroll()\"\n            (selectAll)=\"onSelectAll()\" (select)=\"onSelect()\" (search)=\"onSearch($event)\"></acc-table-clients>\n    </div>\n    <div class=\"modal-footer\">\n        <button data-testid = \"save-btn\" type=\"button\" class=\"btn btn-primary\" (click)=\"onSave()\"\n           [disabled]=\"disableSave\" > {{'Onvio.AccountingCosts.SelectClients.Modal.Save' | translate}} </button>\n        <button data-testid = \"cancel-btn\" type=\"button\" class=\"btn btn-outline-primary\" \n        (click)=\"activeModal.dismiss('')\">\n            {{'Onvio.AccountingCosts.SelectClients.Modal.Cancel' | translate}} </button>\n    </div>\n</div>", styles: [".table-clients ::ng-deep .ng-bento .wj-content{height:calc(100vh - 255px)}.table-clients ::ng-deep .bento-busyloader-front-blocker{background:0}\n"], components: [{ type: TableClientsComponent, selector: "acc-table-clients", inputs: ["actions", "clients"], outputs: ["endScroll", "select", "selectAll", "search"] }], directives: [{ type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["size", "showDelay", "hideDelay", "bentoBusyLoader"], outputs: ["show", "hide"] }, { type: i5.BentoFooterTabHelper, selector: "[class=\"modal-footer\"]" }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientsModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-clients-modal', template: "<div class=\"ng-bento\">\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss('')\">\n        <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n    </button>\n    <h4 id=\"modal-title\" class=\"modal-header\">\n       {{'Onvio.AccountingCosts.SelectClients.Modal.SelectClients' | translate}}\n    </h4>\n    <div class=\"modal-body\">\n        <div class=\"d-flex flex-column\">\n            <acc-table-clients class=\"table-clients\" [bentoBusyLoader]=\"modalClientsLoader.state\" [clients]=\"clients\" (endScroll)=\"onEndScroll()\"\n            (selectAll)=\"onSelectAll()\" (select)=\"onSelect()\" (search)=\"onSearch($event)\"></acc-table-clients>\n    </div>\n    <div class=\"modal-footer\">\n        <button data-testid = \"save-btn\" type=\"button\" class=\"btn btn-primary\" (click)=\"onSave()\"\n           [disabled]=\"disableSave\" > {{'Onvio.AccountingCosts.SelectClients.Modal.Save' | translate}} </button>\n        <button data-testid = \"cancel-btn\" type=\"button\" class=\"btn btn-outline-primary\" \n        (click)=\"activeModal.dismiss('')\">\n            {{'Onvio.AccountingCosts.SelectClients.Modal.Cancel' | translate}} </button>\n    </div>\n</div>", styles: [".table-clients ::ng-deep .ng-bento .wj-content{height:calc(100vh - 255px)}.table-clients ::ng-deep .bento-busyloader-front-blocker{background:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }, { type: ClientsService }, { type: LoaderService }]; }, propDecorators: { clients: [{
                type: Input
            }], totalItems: [{
                type: Input
            }] } });

class SharedModule {
}
SharedModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SharedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SharedModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SharedModule, declarations: [SelectClientsComponent,
        ClientsTableComponent,
        AddClientsModalComponent,
        ClientsToolbarComponent,
        TableClientsComponent,
        ClientsModalComponent], imports: [CommonModule$1,
        WjGridModule,
        BentoModule,
        FormsModule,
        NgbModule,
        ReactiveFormsModule,
        TranslateModule], exports: [SelectClientsComponent,
        TableClientsComponent] });
SharedModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SharedModule, imports: [[
            CommonModule$1,
            WjGridModule,
            BentoModule,
            FormsModule,
            NgbModule,
            ReactiveFormsModule,
            TranslateModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SharedModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SelectClientsComponent,
                        ClientsTableComponent,
                        AddClientsModalComponent,
                        ClientsToolbarComponent,
                        TableClientsComponent,
                        ClientsModalComponent
                    ],
                    imports: [
                        CommonModule$1,
                        WjGridModule,
                        BentoModule,
                        FormsModule,
                        NgbModule,
                        ReactiveFormsModule,
                        TranslateModule
                    ],
                    exports: [
                        SelectClientsComponent,
                        TableClientsComponent
                    ]
                }]
        }] });

class AlertService {
    constructor() {
        this.alerts = [];
    }
    addAlert(alert) {
        this.alerts.push(alert);
        return alert;
    }
    removeAlert(alert) {
        const index = this.findAlert(alert);
        if (index >= 0) {
            this.alerts.splice(index, 1);
        }
    }
    getAlerts() {
        return this.alerts;
    }
    cleanAlerts() {
        this.alerts.length = 0;
    }
    findAlert(alert) {
        return this.alerts.findIndex(item => item === alert);
    }
}
AlertService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AlertService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class AlertComponent {
    constructor(alertService) {
        this.alerts = alertService.getAlerts();
    }
}
AlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertComponent, deps: [{ token: AlertService }], target: i0.ɵɵFactoryTarget.Component });
AlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: AlertComponent, selector: "acc-alert", ngImport: i0, template: "<div class=\"filter-alerts ng-bento\">\n  <bento-alert id=\"alerts\" [inline]=\"true\" [items]=\"alerts\"></bento-alert>\n</div>\n", styles: [".filter-alerts{position:fixed;z-index:100000!important}::ng-deep bento-alert .alert .close i.bui-alert-close-indicator:before{content:\"\\e64a\"}:host{display:flex;width:100%;justify-content:center}\n"], components: [{ type: i5.BentoAlertComponent, selector: "bento-alert", inputs: ["inline", "grabFocus", "items"], outputs: ["close"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-alert', template: "<div class=\"filter-alerts ng-bento\">\n  <bento-alert id=\"alerts\" [inline]=\"true\" [items]=\"alerts\"></bento-alert>\n</div>\n", styles: [".filter-alerts{position:fixed;z-index:100000!important}::ng-deep bento-alert .alert .close i.bui-alert-close-indicator:before{content:\"\\e64a\"}:host{display:flex;width:100%;justify-content:center}\n"] }]
        }], ctorParameters: function () { return [{ type: AlertService }]; } });

class AlertFixedService {
    constructor() {
        this.alerts = [];
    }
    addAlert(alert) {
        this.alerts.push(alert);
        return alert;
    }
    removeAlert(alert) {
        const index = this.findAlert(alert);
        if (index >= 0) {
            this.alerts.splice(index, 1);
        }
    }
    getAlerts() {
        return this.alerts;
    }
    cleanAlerts() {
        this.alerts.length = 0;
    }
    findAlert(alert) {
        return this.alerts.findIndex(item => item === alert);
    }
}
AlertFixedService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertFixedService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AlertFixedService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertFixedService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertFixedService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class AlertFixedComponent {
    constructor(alertService) {
        this.alerts = alertService.getAlerts();
    }
}
AlertFixedComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertFixedComponent, deps: [{ token: AlertFixedService }], target: i0.ɵɵFactoryTarget.Component });
AlertFixedComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: AlertFixedComponent, selector: "acc-alert-fixed", ngImport: i0, template: "<div class=\"filter-alerts alert-fixed ng-bento\">\n    <bento-alert id=\"alertsFixed\" [inline]=\"true\" [items]=\"alerts\"></bento-alert>\n  </div>\n", styles: [".filter-alerts.filter-alerts{position:relative;z-index:95!important;top:0;width:100%}::ng-deep bento-alert .alert .close i.bui-alert-close-indicator:before{content:\"\\e64a\"}\n"], components: [{ type: i5.BentoAlertComponent, selector: "bento-alert", inputs: ["inline", "grabFocus", "items"], outputs: ["close"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertFixedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-alert-fixed', template: "<div class=\"filter-alerts alert-fixed ng-bento\">\n    <bento-alert id=\"alertsFixed\" [inline]=\"true\" [items]=\"alerts\"></bento-alert>\n  </div>\n", styles: [".filter-alerts.filter-alerts{position:relative;z-index:95!important;top:0;width:100%}::ng-deep bento-alert .alert .close i.bui-alert-close-indicator:before{content:\"\\e64a\"}\n"] }]
        }], ctorParameters: function () { return [{ type: AlertFixedService }]; } });

class CommonModule {
}
CommonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CommonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommonModule, declarations: [AlertComponent, AlertFixedComponent], imports: [CommonModule$1,
        BentoModule,
        NgbModule,
        BrowserAnimationsModule], exports: [AlertComponent, AlertFixedComponent] });
CommonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommonModule, imports: [[
            CommonModule$1,
            BentoModule,
            NgbModule,
            BrowserAnimationsModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule$1,
                        BentoModule,
                        NgbModule,
                        BrowserAnimationsModule
                    ],
                    declarations: [AlertComponent, AlertFixedComponent],
                    exports: [AlertComponent, AlertFixedComponent]
                }]
        }] });
function HttpLoaderFactory$1(http) {
    return new TranslateHttpLoader(http, '/i18n/');
}

var ErrorType;
(function (ErrorType) {
    ErrorType["NO_CLIENTS"] = "NO_CLIENTS";
    ErrorType["INVALID_FORMULA"] = "INVALID_FORMULA";
})(ErrorType || (ErrorType = {}));

class RouterService {
    constructor() {
        // visible for testing
        this.router = new Subject();
        this.routerChange$ = this.router.asObservable();
    }
    getRouterChangeObservable() {
        return this.routerChange$;
    }
    setRoute(route) {
        this.router.next(route);
    }
}
RouterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RouterService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
RouterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RouterService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RouterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * This Component must be extended by top level components that will be directly accessed by nucleus-staff routes.
 * It enables our hybrid routing solution to work.
 *
 * This is how the routing between our library (Angular) and nucleus-staff (AngularJS) works:
 * - When a component in our lib has to navigate to another view, it will request it to the RouterService.
 * - The RouterService will publish the new route to an Observable within the service.
 * - A top level component that is being currently being displayed by nucleus-staff and is subscribed to
 *   the RouterService observable will publish a 'routerChanged' event that AngularJS is capable of handling.
 *   That's the reason why the top level component must extend the HybridRouterComponent.
 * - The controller of the view currently displayed by the AngularJS app (e.g. accounting-costs-controller)
 *   will respond to the "router-changed" event and change the application's route.
 * - In our lib, the component targeted by the route will receive any data via input parameters.
 */
class HybridRouterComponent {
    constructor(routerService) {
        this.routerService = routerService;
        this.routerChanged = new EventEmitter();
    }
    ngOnInit() {
        this.routesSubscription = this.routerService
            .getRouterChangeObservable()
            .subscribe((route) => {
            if (route) {
                this.routerChanged.emit(route);
            }
        });
    }
    ngOnDestroy() {
        if (this.routesSubscription) {
            this.routesSubscription.unsubscribe();
        }
    }
}
HybridRouterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: HybridRouterComponent, deps: [{ token: RouterService }], target: i0.ɵɵFactoryTarget.Directive });
HybridRouterComponent.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: HybridRouterComponent, outputs: { routerChanged: "routerChanged" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: HybridRouterComponent, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: RouterService }]; }, propDecorators: { routerChanged: [{
                type: Output
            }] } });

class Route {
    constructor(path, data) {
        this.path = path;
        this.data = data;
    }
}
class AddCostsCalculationRoute extends Route {
    constructor(data) {
        super('add-costs-calculation', data);
    }
}
class CostsCalculationTemplateListRoute extends Route {
    constructor() {
        super('setup-models');
    }
}

class AccountingCostsCalculationTemplateService {
    constructor(http) {
        this.http = http;
    }
    getAll(pagingInfo, filters) {
        const uri = '/api/accountant-cost/v1/calculation-model/';
        const urlParams = this.mapToHttpParams(pagingInfo, filters);
        return this.http.get(uri, { params: urlParams });
    }
    get(calculationTemplateId) {
        const uuid = this.formatToLowerCase(calculationTemplateId);
        const uri = `/api/accountant-cost/v1/calculation-model/${encodeURIComponent(uuid)}`;
        return this.http.get(uri);
    }
    mapToHttpParams(pagingInfo, filters) {
        return Object.entries(Object.assign(Object.assign({}, pagingInfo), filters))
            .filter(([_, value]) => value !== undefined && value !== null)
            .reduce((httpParams, [key, value]) => httpParams.append(key, value.toString()), new HttpParams());
    }
    post(model) {
        return this.http.post('/api/accountant-cost/v1/calculation-model', model, { responseType: 'text' });
    }
    put(model) {
        return this.http.put(`/api/accountant-cost/v1/calculation-model/${model.id}`, model, { responseType: 'text' });
    }
    getNextCalculationModelCode() {
        return this.http.get(`${API_URL}calculation-model/next`)
            .pipe(first(), map((model => {
            if (!model || !model.code) {
                throw new Error();
            }
            else {
                return model;
            }
        })));
    }
    getCalculationModelByCode(code) {
        return this.http.get(`${API_URL}calculation-model/calculationModelCode/${code}`);
    }
    formatToLowerCase(str) {
        if (str.length === 36) {
            const stringMatch = str.match('^(.{8})(.{4})(.{4})(.{4})(.{12})$');
            return `${stringMatch[1]}-${stringMatch[2]}-${stringMatch[3]}-${stringMatch[4]}-${stringMatch[5]}`.toLowerCase();
        }
        return str;
    }
}
AccountingCostsCalculationTemplateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsCalculationTemplateService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
AccountingCostsCalculationTemplateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsCalculationTemplateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsCalculationTemplateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class TranslationService {
    constructor(translate) {
        this.translate = translate;
    }
    getTranslations(keys, baseKey) {
        const fullPathKeys = keys.map(key => this.composeKey(baseKey, key));
        return this.translate.get(fullPathKeys).pipe(take(1), map(obj => fullPathKeys.map((key) => obj[key])));
    }
    getTranslation(key, baseKey) {
        return this.translate.get(this.composeKey(baseKey, key)).pipe(take(1));
    }
    composeKey(baseKey, key) {
        return !!baseKey ? `${baseKey}.${key}` : key;
    }
}
TranslationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TranslationService, deps: [{ token: i1$1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
TranslationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TranslationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TranslationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }]; } });

class LocalStorageService {
    constructor() {
        this.localStorage = window.localStorage;
    }
    set(key, value) {
        this.localStorage.setItem(key, JSON.stringify(value));
    }
    get(key) {
        return JSON.parse(this.localStorage.getItem(key));
    }
    unset(key) {
        this.localStorage.removeItem(key);
    }
}
LocalStorageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LocalStorageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
LocalStorageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LocalStorageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LocalStorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class AddCostsCalculationTemplateService {
    constructor(localStorageService) {
        this.localStorageService = localStorageService;
        this.COST_CALCULATION_STATE = 'COST_CALCULATION_STATE';
        this.SPREADSHEET_PROPERTIES = [
            'calculation',
            'dataGrid',
            'formSelectedItems',
            'formulaCalculation'
        ];
        this.state = {
            id: null,
            code: null,
            name: null,
            calculation: '',
            dataGrid: [],
            formSelectedItems: '',
            formulaCalculation: '',
            clientsIds: [],
            columns: [],
            editCode: null,
            defaultModel: false
        };
    }
    getSelectedClientsId() {
        return this.state.clientsIds;
    }
    setSelectedClientsId(clientsIds) {
        this.state.clientsIds = clientsIds;
        this.saveState();
    }
    getCode() {
        return this.state.code;
    }
    setCode(code) {
        this.state.code = code;
        this.saveState();
    }
    setId(id) {
        this.state.id = id;
        this.saveState();
    }
    getId() {
        return this.state.id;
    }
    getColumnsState() {
        return this.state.columns;
    }
    getName() {
        return this.state.name;
    }
    setName(name) {
        this.state.name = name.substring(0, 200);
        this.saveState();
    }
    getEditCode() {
        return this.state.editCode;
    }
    setEditCode(editCode) {
        this.state.editCode = editCode;
        this.saveState();
    }
    setSpreadsheetValue(key, value) {
        if (this.SPREADSHEET_PROPERTIES.some(property => key === property)) {
            this.state[key] = value;
        }
        this.saveState();
    }
    getSpreadsheetValue(key) {
        if (this.SPREADSHEET_PROPERTIES.some(property => key === property)) {
            return this.state[key];
        }
        return null;
    }
    setStateFromTemplate(template) {
        this.state.id = template.id;
        this.state.code = template.code;
        this.state.name = template.name;
        this.state.clientsIds =
            template.clients && template.clients.length > 0
                ? template.clients.map(client => client.clientId)
                : [];
        this.setColumns(template.columns);
        this.state.defaultModel = template.defaultModel;
    }
    clearCostCalculationState() {
        localStorage.removeItem(this.COST_CALCULATION_STATE);
    }
    resetState() {
        this.state = {
            id: null,
            code: null,
            name: null,
            calculation: '',
            dataGrid: [],
            formSelectedItems: '',
            formulaCalculation: '',
            clientsIds: [],
            columns: [],
            editCode: null,
            defaultModel: false
        };
        this.saveState();
    }
    loadState() {
        this.state = this.localStorageService.get(this.COST_CALCULATION_STATE);
        if (!this.state) {
            this.resetState();
        }
    }
    saveState() {
        this.localStorageService.set(this.COST_CALCULATION_STATE, this.state);
    }
    setFormula(formula) {
        if (!formula || formula.length === 0) {
            return [];
        }
        const mappedFormulas = formula.map(formulaItem => {
            return {
                item: {
                    formulaId: formulaItem.id,
                    order: formulaItem.type === 'COLUMN'
                        ? formulaItem.nestedColumnOrder
                        : null,
                    type: formulaItem.type,
                    description: this.setDescription(formulaItem.type, formulaItem),
                    value: formulaItem.type === 'FIXED' ? formulaItem.value : null,
                    operator: formulaItem.operator,
                    percentage: formulaItem.percentage,
                    id: formulaItem.costItemId,
                    origin: formulaItem.origin
                }
            };
        });
        return mappedFormulas;
    }
    setNumberFormatter(value) {
        return value.replace('.', ',');
    }
    setDescription(type, item) {
        switch (type) {
            case 'OPERATOR':
                return item.operator.replace('*', 'X').replace('/', '÷');
            case 'FIXED':
                return item.percentage
                    ? `${this.setNumberFormatter(item.value.toString())}%`
                    : `${this.setNumberFormatter(item.value.toString())}`;
            case 'LIMITER':
                return item.limiter;
            case 'COLUMN':
                return item.nestedColumnName;
            case 'COST_ITEM':
                return item.description;
            default:
                return '';
        }
    }
    getFormula(column) {
        return column && column.calculations
            ? column.calculations.map(formula => {
                return {
                    id: formula.item.formulaId,
                    nestedColumnOrder: formula.item.type === 'COLUMN' ? formula.item.order : null,
                    type: formula.item.type,
                    nestedColumnName: formula.item.type === 'COLUMN' ? formula.item.description : null,
                    description: formula.item.description,
                    limiter: formula.item.type === 'LIMITER' ? formula.item.description : null,
                    operator: formula.item.type === 'OPERATOR' ? formula.item.operator : null,
                    percentage: formula.item.type === 'FIXED' ? formula.item.percentage : null,
                    value: formula.item.type === 'FIXED'
                        ? this.getValueAsNumber(formula.item.description)
                        : null,
                    costItemId: formula.item.type === 'COST_ITEM' ? formula.item.id : null,
                    origin: formula.item.type === 'COST_ITEM' ? formula.item.origin : null
                };
            })
            : [];
    }
    getColumns() {
        const dataGrid = this.getSpreadsheetValue('dataGrid');
        return dataGrid
            ? dataGrid.map((item, index) => {
                return {
                    id: item.id,
                    name: item.label,
                    type: item.classification,
                    unitType: item.type,
                    order: index,
                    formula: this.getFormula(item)
                };
            })
            : [];
    }
    setColumns(columns) {
        const dataGrid = columns.map(column => {
            return {
                id: column.id,
                label: column.name,
                classification: column.type,
                type: column.unitType,
                calculations: this.setFormula(column.formula)
            };
        });
        this.setSpreadsheetValue('dataGrid', dataGrid);
    }
    getValueAsNumber(value) {
        return +value.replace(/[.%]+/g, '').replace(',', '.');
    }
    getCalculationModel() {
        return {
            id: this.getId(),
            name: this.getName(),
            code: this.getCode(),
            clientsIds: this.getSelectedClientsId(),
            columns: this.getColumns()
        };
    }
}
AddCostsCalculationTemplateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AddCostsCalculationTemplateService, deps: [{ token: LocalStorageService }], target: i0.ɵɵFactoryTarget.Injectable });
AddCostsCalculationTemplateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AddCostsCalculationTemplateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AddCostsCalculationTemplateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: LocalStorageService }]; } });

class AccountingCostsService {
    constructor(translate, cookieService) {
        this.translate = translate;
        this.cookieService = cookieService;
    }
    setLanguage() {
        const cookieLang = this.cookieService.get('BMLanguageCode');
        if (cookieLang) {
            this.translate.setDefaultLang(cookieLang);
        }
        else {
            const browserLang = this.translate.getBrowserCultureLang();
            const lang = browserLang.match(/(en|es|fr|nl|pt|xx).*/)
                ? browserLang
                : 'en-US';
            this.cookieService.set('BMLanguageCode', lang);
            this.translate.setDefaultLang(lang);
        }
    }
}
AccountingCostsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsService, deps: [{ token: i1$1.TranslateService }, { token: i2$2.CookieService }], target: i0.ɵɵFactoryTarget.Injectable });
AccountingCostsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }, { type: i2$2.CookieService }]; } });

class GeneralComponent {
    constructor(service, translationService, addCostsCalculationTemplateService, alertService, loaderService) {
        this.service = service;
        this.translationService = translationService;
        this.addCostsCalculationTemplateService = addCostsCalculationTemplateService;
        this.alertService = alertService;
        this.alerts = [];
        this.validations = {
            required: ''
        };
        this.i18nBaseKey = 'Onvio.AccountingCosts.AddCostsCalculation';
        this.maxLengthCode = 10;
        this.loadingEditBusyLoader = loaderService.editLoader;
    }
    ngOnInit() {
        const code = this.addCostsCalculationTemplateService.getCode() || '';
        const name = this.addCostsCalculationTemplateService.getName() || '';
        this.editCode =
            this.addCostsCalculationTemplateService.getEditCode() || code;
        this.codeField.nativeElement.focus();
        this.generalForm.get('code').setValue(code);
        this.generalForm.get('name').setValue(name);
        if (!!this.templateId) {
            this.service
                .get(this.templateId)
                .pipe(first())
                .subscribe(template => {
                this.editCode = template.code;
                this.addCostsCalculationTemplateService.setEditCode(this.editCode);
            });
        }
        else if (!code) {
            this.generalForm.get('code').enable();
            this.fetchNextCode();
        }
    }
    i18n(node) {
        return `${this.i18nBaseKey}.${node}`;
    }
    onCodeKeypress(event) {
        if (!this.isNumber(event.key)) {
            event.preventDefault();
            return;
        }
        const value = this.generalForm.get('code').value;
        this.validateCodeValue(event, value);
    }
    onCodePaste(event) {
        const clipboardData = event.clipboardData.getData('text');
        if (!this.isNumber(clipboardData)) {
            event.preventDefault();
            return;
        }
        const value = this.generalForm.get('code').value + clipboardData;
        this.validateCodeValue(event, value);
    }
    validateCodeValue(event, value) {
        if (!value) {
            return;
        }
        value = value.toString();
        if (value && value.length >= this.maxLengthCode) {
            event.preventDefault();
        }
    }
    isNumber(value) {
        return !!value ? !!value.match('^[0-9]*$') : false;
    }
    saveState() {
        const code = this.generalForm.get('code').value;
        const name = this.generalForm.get('name').value;
        this.addCostsCalculationTemplateService.setCode(code);
        this.addCostsCalculationTemplateService.setName(name);
    }
    fetchNextCode() {
        this.loadingEditBusyLoader.show();
        this.service
            .getNextCalculationModelCode()
            .pipe(first())
            .subscribe({
            next: model => {
                this.setNextCode(model);
                this.loadingEditBusyLoader.hide();
            },
            error: () => {
                this.translationService
                    .getTranslation('LoadTemplateError', this.i18nBaseKey)
                    .pipe(first())
                    .subscribe(errorMessage => {
                    this.showError(errorMessage);
                });
                this.loadingEditBusyLoader.hide();
            }
        });
    }
    shouldShowRequiredError(formControlKey) {
        if (!this.generalForm) {
            return false;
        }
        return (this.generalForm.controls[formControlKey].hasError('required') &&
            this.generalForm.controls[formControlKey].touched);
    }
    shouldShowError(formControlKey) {
        if (!this.generalForm) {
            return false;
        }
        return (!this.generalForm.controls[formControlKey].valid &&
            !this.generalForm.controls[formControlKey].pristine);
    }
    validateId() {
        const code = parseInt(this.generalForm.get('code').value, 10);
        if (code) {
            this.service.getCalculationModelByCode(code).subscribe(res => {
                this.isIdInvalid = this.editCode !== code;
                this.param = { code };
            }, err => {
                this.isIdInvalid = false;
            });
        }
    }
    setNextCode(model) {
        this.generalForm.get('code').setValue(model.code);
        this.addCostsCalculationTemplateService.setCode(this.generalForm.get('code').value);
    }
    showError(errorMessage) {
        this.alertService.addAlert({
            msg: errorMessage,
            type: 'danger',
            timeout: 3000
        });
    }
}
GeneralComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GeneralComponent, deps: [{ token: AccountingCostsCalculationTemplateService }, { token: TranslationService }, { token: AddCostsCalculationTemplateService }, { token: AlertService }, { token: LoaderService }], target: i0.ɵɵFactoryTarget.Component });
GeneralComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: GeneralComponent, selector: "acc-general", inputs: { templateId: "templateId", generalForm: "generalForm" }, viewQueries: [{ propertyName: "codeField", first: true, predicate: ["code"], descendants: true, static: true }], ngImport: i0, template: "<form [formGroup]=\"generalForm\">\n  <h3 class=\"tab-title\">{{ i18n(\"GeneralTab.Title\") | translate }}</h3>\n  <div class=\"row\">\n    <div class=\"col-md-5\">\n      <div class=\"ng-bento form-group\">\n        <label class=\"bento-label-required\" for=\"id\">\n          {{ i18n(\"GeneralTab.Id\") | translate }}\n        </label>\n        <input\n          #code\n          class=\"bento-input form-control\"\n          [ngClass]=\"{\n            'border-danger': shouldShowRequiredError('code') || isIdInvalid\n          }\"\n          id=\"id\"\n          name=\"id\"\n          formControlName=\"code\"\n          required\n          type=\"text\"\n          (keypress)=\"onCodeKeypress($event)\"\n          (keyup)=\"saveState()\"\n          (paste)=\"onCodePaste($event)\"\n          (blur)=\"validateId()\"\n        />\n        <div *ngIf=\"shouldShowRequiredError('code')\" class=\"bfm-error-message\">\n          <span class=\"ng-star-inserted\">\n            {{ i18n(\"Form.Errors.Required.ID\") | translate }}\n          </span>\n        </div>\n        <div *ngIf=\"isIdInvalid\" class=\"bfm-error-message\">\n          <span class=\"ng-star-inserted\">\n            {{ i18n(\"Form.Errors.Unique\") | translate: param }}\n          </span>\n        </div>\n    </div>\n  </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-5\">\n      <div class=\"ng-bento form-group\">\n        <label class=\"bento-label-required\" for=\"name\">\n          {{ i18n(\"GeneralTab.Name\") | translate }}\n        </label>\n        <input\n        [ngClass]=\"{ 'border-danger': shouldShowRequiredError('name') }\"\n        class=\"bento-input form-control\"\n        id=\"name\"\n        name=\"name\"\n        formControlName=\"name\"\n        required\n        type=\"text\"\n        maxlength=\"200\"\n        (keyup)=\"saveState()\"\n      />\n        <div *ngIf=\"shouldShowRequiredError('name')\" class=\"bfm-error-message\">\n          <span class=\"ng-star-inserted\">\n            {{ i18n(\"Form.Errors.Required.Name\") | translate }}\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n</form>\n", styles: [".tab-title{margin-top:0}\n"], directives: [{ type: i2$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i2$1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GeneralComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-general', template: "<form [formGroup]=\"generalForm\">\n  <h3 class=\"tab-title\">{{ i18n(\"GeneralTab.Title\") | translate }}</h3>\n  <div class=\"row\">\n    <div class=\"col-md-5\">\n      <div class=\"ng-bento form-group\">\n        <label class=\"bento-label-required\" for=\"id\">\n          {{ i18n(\"GeneralTab.Id\") | translate }}\n        </label>\n        <input\n          #code\n          class=\"bento-input form-control\"\n          [ngClass]=\"{\n            'border-danger': shouldShowRequiredError('code') || isIdInvalid\n          }\"\n          id=\"id\"\n          name=\"id\"\n          formControlName=\"code\"\n          required\n          type=\"text\"\n          (keypress)=\"onCodeKeypress($event)\"\n          (keyup)=\"saveState()\"\n          (paste)=\"onCodePaste($event)\"\n          (blur)=\"validateId()\"\n        />\n        <div *ngIf=\"shouldShowRequiredError('code')\" class=\"bfm-error-message\">\n          <span class=\"ng-star-inserted\">\n            {{ i18n(\"Form.Errors.Required.ID\") | translate }}\n          </span>\n        </div>\n        <div *ngIf=\"isIdInvalid\" class=\"bfm-error-message\">\n          <span class=\"ng-star-inserted\">\n            {{ i18n(\"Form.Errors.Unique\") | translate: param }}\n          </span>\n        </div>\n    </div>\n  </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-5\">\n      <div class=\"ng-bento form-group\">\n        <label class=\"bento-label-required\" for=\"name\">\n          {{ i18n(\"GeneralTab.Name\") | translate }}\n        </label>\n        <input\n        [ngClass]=\"{ 'border-danger': shouldShowRequiredError('name') }\"\n        class=\"bento-input form-control\"\n        id=\"name\"\n        name=\"name\"\n        formControlName=\"name\"\n        required\n        type=\"text\"\n        maxlength=\"200\"\n        (keyup)=\"saveState()\"\n      />\n        <div *ngIf=\"shouldShowRequiredError('name')\" class=\"bfm-error-message\">\n          <span class=\"ng-star-inserted\">\n            {{ i18n(\"Form.Errors.Required.Name\") | translate }}\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n</form>\n", styles: [".tab-title{margin-top:0}\n"] }]
        }], ctorParameters: function () { return [{ type: AccountingCostsCalculationTemplateService }, { type: TranslationService }, { type: AddCostsCalculationTemplateService }, { type: AlertService }, { type: LoaderService }]; }, propDecorators: { templateId: [{
                type: Input
            }], generalForm: [{
                type: Input
            }], codeField: [{
                type: ViewChild,
                args: ['code', { static: true }]
            }] } });

var CompanyType;
(function (CompanyType) {
    CompanyType[CompanyType["OFFICE"] = 1] = "OFFICE";
    CompanyType[CompanyType["CLIENT"] = 2] = "CLIENT";
})(CompanyType || (CompanyType = {}));

class SpreadsheetService {
    constructor(http) {
        this.http = http;
        this.calculationEndpoint = `${API_URL}cost-item`;
        this.calculationModelEndpoint = `${API_URL}calculation-model/`;
    }
    getCalculation(type) {
        const params = new HttpParams().set('companyType', type.toString());
        return this.http.get(this.calculationEndpoint, {
            params
        });
    }
    getCalculationModel(id) {
        const endPoint = this.calculationModelEndpoint + `/${id}`;
        return this.http.get(endPoint);
    }
}
SpreadsheetService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SpreadsheetService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
SpreadsheetService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SpreadsheetService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SpreadsheetService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class DroplistComponent {
    constructor(iterableDiffers, changesDetect) {
        this.iterableDiffers = iterableDiffers;
        this.changesDetect = changesDetect;
        this.remove = new EventEmitter();
        this.brazilianNumberFormatter = new Intl.NumberFormat('pt-BR', {
            currency: 'BRL',
            minimumFractionDigits: 2
        });
        this.iterableDiffer = iterableDiffers.find([]).create(null);
    }
    ngDoCheck() {
        const changes = this.iterableDiffer.diff(this.bullets);
        if (changes) {
            changes.forEachAddedItem(item => {
                if (item) {
                    this.changesDetect.detectChanges();
                    this.moveScrollToEnd(document.querySelector('.items-list').scrollWidth);
                }
            });
        }
    }
    drop(event) {
        moveItemInArray(this.bullets, event.previousIndex, event.currentIndex);
    }
    removeItem(item) {
        const index = this.bullets.indexOf(item);
        if (item && index > -1) {
            this.remove.emit(index);
        }
    }
    maskBullet(value, isPercent = false) {
        if (isNaN(value)) {
            if (value.includes(',')) {
                const parseFloat = value.replaceAll('.', '').replace(',', '.').replaceAll('%', '');
                const format = this.brazilianNumberFormatter.format(parseFloat);
                if (isPercent) {
                    return `${format}%`;
                }
                return format;
            }
            else {
                return value;
            }
        }
        else {
            const format = this.brazilianNumberFormatter.format(value);
            if (isPercent) {
                return `${format}%`;
            }
            return format;
        }
    }
    moveScrollToEnd(scrollWidth) {
        document.querySelector('.items-list').scrollTo(scrollWidth, 0);
    }
}
DroplistComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DroplistComponent, deps: [{ token: i0.IterableDiffers }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
DroplistComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DroplistComponent, selector: "acc-droplist", inputs: { bullets: "bullets" }, outputs: { remove: "remove" }, ngImport: i0, template: "<div cdkDropList cdkDropListOrientation=\"horizontal\" class=\"items-list\" (cdkDropListDropped)=\"drop($event)\">\n    <div class=\"items-box\" *ngFor=\"let bullet of bullets\" cdkDrag>\n        <div class=\"bullet-wrapper\">\n            <span class=\"bullet\" [ngClass]=\"bullet.class\">\n                {{ maskBullet(bullet.item.description, bullet.item.percentage) }}\n            </span>\n            <span class=\"del\" (click)=\"removeItem(bullet)\"> X </span>\n        </div>\n    </div>\n</div>\n", styles: [".items-list{max-width:100%;border:1px solid #b2b2b8;min-height:100px;display:flex;align-items:center;background:white;overflow:auto}.items-box{color:#000000de;padding:0 10px;cursor:move}.bullet{display:inline-block;padding:4px 10px;font-size:11px;text-transform:uppercase;border-radius:4px;border-right:solid 1px #ccc;white-space:nowrap}.bullet-office-data{background-color:#387c2b;color:#fff}.bullet-clients-data{background-color:#0072a8;color:#fff}.bullet-column{background-color:#5d1893;color:#fff}.bullet-operations,.bullet-parentheses{background-color:#ffb400;color:#000!important}.bullet-value{background-color:#d4ebf4;color:#000!important}.del{text-align:center;vertical-align:middle;color:#fff!important;font-size:10px;max-width:20px;max-height:20px;min-width:20px;min-height:20px;padding:0;cursor:pointer;border-radius:50%;background-color:#000;font-weight:700;display:flex;align-items:center;justify-content:center;margin-top:-10px;margin-left:-10px}.cdk-drag-preview{box-sizing:border-box;z-index:9999!important;border-radius:4px}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.bullet-wrapper{display:flex;flex-direction:row}\n"], directives: [{ type: i1$3.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "id", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListAutoScrollDisabled", "cdkDropListOrientation", "cdkDropListLockAxis", "cdkDropListData", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$3.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragDisabled", "cdkDragStartDelay", "cdkDragLockAxis", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragBoundary", "cdkDragRootElement", "cdkDragData", "cdkDragFreeDragPosition"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DroplistComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-droplist', template: "<div cdkDropList cdkDropListOrientation=\"horizontal\" class=\"items-list\" (cdkDropListDropped)=\"drop($event)\">\n    <div class=\"items-box\" *ngFor=\"let bullet of bullets\" cdkDrag>\n        <div class=\"bullet-wrapper\">\n            <span class=\"bullet\" [ngClass]=\"bullet.class\">\n                {{ maskBullet(bullet.item.description, bullet.item.percentage) }}\n            </span>\n            <span class=\"del\" (click)=\"removeItem(bullet)\"> X </span>\n        </div>\n    </div>\n</div>\n", styles: [".items-list{max-width:100%;border:1px solid #b2b2b8;min-height:100px;display:flex;align-items:center;background:white;overflow:auto}.items-box{color:#000000de;padding:0 10px;cursor:move}.bullet{display:inline-block;padding:4px 10px;font-size:11px;text-transform:uppercase;border-radius:4px;border-right:solid 1px #ccc;white-space:nowrap}.bullet-office-data{background-color:#387c2b;color:#fff}.bullet-clients-data{background-color:#0072a8;color:#fff}.bullet-column{background-color:#5d1893;color:#fff}.bullet-operations,.bullet-parentheses{background-color:#ffb400;color:#000!important}.bullet-value{background-color:#d4ebf4;color:#000!important}.del{text-align:center;vertical-align:middle;color:#fff!important;font-size:10px;max-width:20px;max-height:20px;min-width:20px;min-height:20px;padding:0;cursor:pointer;border-radius:50%;background-color:#000;font-weight:700;display:flex;align-items:center;justify-content:center;margin-top:-10px;margin-left:-10px}.cdk-drag-preview{box-sizing:border-box;z-index:9999!important;border-radius:4px}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.bullet-wrapper{display:flex;flex-direction:row}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.IterableDiffers }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { bullets: [{
                type: Input
            }], remove: [{
                type: Output
            }] } });

class FilterPipe {
    transform(items, value) {
        if (!items) {
            return [];
        }
        if (!value) {
            return items;
        }
        if (value === '' || value === null) {
            return [];
        }
        return items.filter(e => {
            e = e && e.description ? e.description.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '') : '';
            value = value.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '');
            return e.toLowerCase().indexOf(value.toLowerCase()) > -1;
        });
    }
}
FilterPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FilterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
FilterPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FilterPipe, name: "filter" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FilterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'filter'
                }]
        }] });

class SpreadsheetComponent {
    constructor(translate, modalService, fb, service, alertService, addCostsCalculationTemplateService) {
        this.translate = translate;
        this.modalService = modalService;
        this.fb = fb;
        this.service = service;
        this.alertService = alertService;
        this.addCostsCalculationTemplateService = addCostsCalculationTemplateService;
        this.addWidth = 400;
        this.bullet = 'bullet';
        this.calculation = [];
        this.data = [];
        this.dataClients = [];
        this.dataOffice = [];
        this.isBtnActive = 1;
        this.isDisabledDel = true;
        this.isDisabledNav = true;
        this.isDisabledLeft = true;
        this.isDisabledRight = true;
        this.isDisabledFirst = true;
        this.isDisabledLast = true;
        this.insertColumnForm = this.fb.group({
            columnName: ['']
        });
        this.groupColumn = 'EXPENSE';
        this.groupResultType = 'AMOUNT';
        this.operators = [];
        this.parentheses = [];
        this.resultEditCalculation = [];
        this.searchFilter = '';
        this.dataGrid = [];
        this.dataTable = [];
        this.tempName = '';
        this.editTitle = '';
        this.editIndex = 0;
        this.tbWidth = 0;
        this.validateColumnName = false;
        this.validateColumnNameDuplicity = false;
        this.contentType = 'content-office-data';
        this.typeParentheses = [['{', '}'], ['[', ']'], ['(', ')']];
        this.isFinalResultDisabled = false;
        this.subscription = new Subscription();
        this.brazilianNumberFormatter = new Intl.NumberFormat('pt-BR', {
            currency: 'BRL',
            minimumFractionDigits: 2
        });
        this.originalCalculations = [];
        this.originalGroupColumn = '';
        this.originalType = '';
    }
    get formSelectedItems() {
        return this.checkedForm.get('selectedItems');
    }
    onKeydownHandler(event) {
        switch (event.key) {
            case 'ArrowLeft':
                if (!this.isDisabledLeft) {
                    this.prevColumn();
                }
                break;
            case 'ArrowRight':
                if (!this.isDisabledRight) {
                    this.nextColumn();
                }
                break;
            case 'Delete':
                if (!this.isDisabledDel) {
                    this.delete();
                }
                break;
            case 'Escape':
                this.cancelEditCalculation();
                break;
        }
    }
    ngOnInit() {
        this.checkedForm = this.fb.group({
            selectedItems: this.fb.array([])
        });
        this.groupValueInsert = this.fb.group({
            type: 'false',
            insertValue: ''
        });
        this.getEditCostingModel();
        this.onChanges();
        this.validateStorage();
        this.getOfficeData();
        this.getClientsData();
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    addCheckboxes(val) {
        this.formSelectedItems.push(this.fb.control(val));
    }
    getEditCostingModel() {
        this.dataGrid = [];
        this.dataGrid = this.addCostsCalculationTemplateService.getSpreadsheetValue('dataGrid');
        this.dataTable = this.dataGrid;
        this.dataGrid.forEach(item => {
            if (item.calculations) {
                item.calculations.forEach(calc => {
                    calc.class = this.setBullet(calc.item.type, calc.item.origin);
                    calc.type =
                        calc.item.type === 'COST_ITEM' ? 'variable' : 'operations';
                });
            }
            if (item.classification === 'FINAL_RESULT') {
                this.isFinalResultDisabled = true;
            }
            this.sumWidthTb();
            this.addCheckboxes(null);
        });
        this.validateDataGrid();
    }
    setBullet(type, origin) {
        switch (type) {
            case 'COST_ITEM':
                if (origin === 'OFFICE') {
                    return 'bullet-office-data';
                }
                if (origin === 'CUSTOMER') {
                    return 'bullet-clients-data';
                }
                break;
            case 'COLUMN':
                return 'bullet-column';
            case 'OPERATOR':
                return 'bullet-operations';
            case 'LIMITER':
                return 'bullet-parentheses';
            case 'FIXED':
                return 'bullet-value';
        }
    }
    clearEdit() {
        this.addCostsCalculationTemplateService.setSpreadsheetValue('calculation', null);
        this.addCostsCalculationTemplateService.setSpreadsheetValue('formulaCalculation', null);
        this.calculation = [];
        this.groupColumn = 'EXPENSE';
        this.groupResultType = 'AMOUNT';
        this.setButtonActive(1);
    }
    clearInsertValue() {
        this.groupValueInsert.controls.type.setValue('false');
    }
    clearSearch() {
        this.searchFilter = '';
    }
    delete() {
        const indexDelete = [];
        for (let i = 0; i < this.formSelectedItems.controls.length; i++) {
            const control = this.formSelectedItems.controls[i];
            if (control.value) {
                if (this.isReferenced(i)) {
                    const msg = this.insideI18n('SpreadsheetTab.Errors.ReferenceColumn');
                    this.displayAlert(msg, 'danger');
                    this.modalReference.close();
                    return;
                }
                else {
                    indexDelete.push(i);
                    if (this.dataGrid[i].classification === 'FINAL_RESULT') {
                        this.isFinalResultDisabled = false;
                    }
                }
            }
        }
        indexDelete.reverse().forEach(val => {
            this.dataGrid.splice(val, 1);
            this.saveState('dataGrid', this.dataGrid);
            this.dataTable = this.dataGrid;
            this.formSelectedItems.removeAt(val);
            this.subWidthTb();
        });
        if (this.dataGrid.length === 1) {
            this.isDisabledNav = true;
        }
        this.validateDataGrid();
        this.modalReference.close();
    }
    isReferenced(index) {
        const colName = this.dataGrid[index].label;
        return this.dataGrid.some(column => {
            if (column.calculations instanceof Array) {
                return column.calculations.some(calc => {
                    return calc.item.type === 'COLUMN' && calc.item.description === colName;
                });
            }
            return false;
        });
    }
    updateColumnIndexReferences() {
        const colOrder = {};
        this.dataGrid.forEach((column, index) => {
            colOrder[column.label] = index;
        });
        this.dataGrid
            .filter(column => column.calculations instanceof Array)
            .forEach(column => {
            column.calculations
                .filter(calc => calc.item.type === 'COLUMN')
                .forEach(calc => {
                calc.item.order = colOrder[calc.item.description];
            });
        });
    }
    updateColumnReferences(index, label) {
        const originalColInfo = this.dataGrid[index];
        this.dataGrid
            .filter(column => column.calculations instanceof Array)
            .forEach(column => {
            column.calculations
                .filter(calc => calc.item.type === 'COLUMN' && calc.item.description === originalColInfo.label)
                .forEach(calc => {
                calc.item.description = label;
            });
        });
    }
    drop(event) {
        moveItemInArray(this.calculation, event.previousIndex, event.currentIndex);
    }
    getTranslation(key) {
        return this.translate.get(this.i18n(key)).toPromise();
    }
    saveState(key, value) {
        this.addCostsCalculationTemplateService.setSpreadsheetValue(key, value);
    }
    loadState(key) {
        return this.addCostsCalculationTemplateService.getSpreadsheetValue(key);
    }
    getOperators() {
        this.operators = [
            { description: '+', type: 'OPERATOR', operator: '+' },
            { description: '-', type: 'OPERATOR', operator: '-' },
            { description: 'x', type: 'OPERATOR', operator: '*' },
            { description: '÷', type: 'OPERATOR', operator: '/' }
        ];
        this.parentheses = [
            { description: '(', type: 'LIMITER' },
            { description: ')', type: 'LIMITER' },
            { description: '[', type: 'LIMITER' },
            { description: ']', type: 'LIMITER' },
            { description: '{', type: 'LIMITER' },
            { description: '}', type: 'LIMITER' }
        ];
    }
    getOfficeData() {
        this.service
            .getCalculation(CompanyType.OFFICE)
            .pipe(take(1))
            .subscribe(res => {
            res.forEach(item => {
                this.dataOffice.push(Object.assign(Object.assign({}, item), { type: 'COST_ITEM' }));
            });
        });
    }
    setOfficeData() {
        this.contentType = 'content-office-data';
        this.bullet = 'bullet-office-data';
        this.data = this.dataOffice;
        this.isBtnActive = 1;
        this.clearSearch();
    }
    getCalculationFormula(i) {
        this.dataGrid = this.loadState('dataGrid');
        if (!!this.dataGrid &&
            !!this.dataGrid[i].calculations &&
            !!this.dataGrid[i].calculations.length) {
            this.calculation = this.dataGrid[i].calculations;
            this.originalCalculations = [...this.calculation];
            this.saveState('calculation', this.calculation);
        }
        if (!!this.dataGrid && !!this.dataGrid[i].classification) {
            this.groupColumn = this.dataGrid[i].classification;
            this.originalGroupColumn = this.groupColumn;
            if (this.groupColumn === 'FINAL_RESULT') {
                this.isFinalResultDisabled = false;
            }
        }
        if (!!this.dataGrid && !!this.dataGrid[i].type) {
            this.groupResultType = this.dataGrid[i].type;
            this.originalType = this.groupResultType;
        }
    }
    getColumnData() {
        this.contentType = 'content-column';
        this.bullet = 'bullet-column';
        this.isBtnActive = 3;
        this.dataGrid = this.loadState('dataGrid');
        this.filterColumns();
        this.clearSearch();
    }
    filterColumns() {
        this.data = this.dataGrid
            .filter(item => item.label !== this.tempName)
            .map(item => {
            return {
                description: item.label,
                type: 'COLUMN',
                order: this.dataGrid.indexOf(item)
            };
        });
    }
    getClientsData() {
        this.service
            .getCalculation(CompanyType.CLIENT)
            .pipe(take(1))
            .subscribe(res => {
            res.forEach(item => this.dataClients.push(Object.assign(Object.assign({}, item), { type: 'COST_ITEM' })));
        });
    }
    setClientsData() {
        this.contentType = 'content-clients-data';
        this.bullet = 'bullet-clients-data';
        this.data = this.dataClients;
        this.isBtnActive = 2;
        this.clearSearch();
    }
    i18n(node) {
        return `Onvio.AccountingCosts.AddCostsCalculation.${node}`;
    }
    insideI18n(node) {
        return this.translate.instant(`Onvio.AccountingCosts.AddCostsCalculation.${node}`);
    }
    joinCalculation() {
        let res;
        const bullet = 'bullet-value';
        const type = this.groupValueInsert.controls.type.value;
        const val = this.brazilianNumberFormatter.format(this.groupValueInsert.controls.insertValue.value);
        type === 'true' ? (res = `${val}%`) : (res = val);
        const item = {
            description: res,
            type: 'FIXED',
            percentage: type === 'true',
            value: this.groupValueInsert.controls.insertValue.value
        };
        this.saveCalculation(item, bullet);
        this.groupValueInsert.controls.insertValue.setValue('');
    }
    keyDown(event) {
        this.validateColumnName = false;
        if (event.key === 'Enter') {
            this.save();
        }
    }
    keyDownInsertValue(event) {
        if (event.key === 'Enter') {
            this.joinCalculation();
        }
    }
    move(from, to) {
        const labels = this.dataGrid;
        to = ((to % labels.length) + labels.length) % labels.length;
        labels.splice(to, 0, labels.splice(from, 1)[0]);
        this.dataGrid = labels;
        this.dataTable = labels;
        this.updateColumnIndexReferences();
        this.saveState('dataGrid', this.dataGrid);
        this.formSelectedItems.controls[from].setValue(null);
        this.formSelectedItems.controls[to].setValue(true);
    }
    nextColumn() {
        const from = this.formSelectedItems.value.indexOf(true);
        const to = from + 1;
        this.move(from, to);
    }
    lastColumn() {
        const from = this.formSelectedItems.value.indexOf(true);
        const to = this.formSelectedItems.value.length - 1;
        this.move(from, to);
    }
    onChanges() {
        this.subscription.add(this.formSelectedItems.valueChanges.subscribe(value => {
            this.saveState('formSelectedItems', value);
            if (value.length > 1) {
                const items = value.filter(item => !!item);
                if (items.length === 1) {
                    if (value.indexOf(true) === 0) {
                        this.isDisabledFirstLeft(true);
                    }
                    else {
                        this.isDisabledFirstLeft(false);
                    }
                    if (value.indexOf(true) ===
                        this.formSelectedItems.value.length - 1) {
                        this.isDisabledLastRight(true);
                    }
                    else {
                        this.isDisabledLastRight(false);
                    }
                    if (this.isDisabledFirst && this.isDisabledLast) {
                        this.isDisabledLeft = false;
                        this.isDisabledRight = false;
                    }
                }
                if (items.length === 0 || items.length > 1) {
                    this.isDisabledLastRight(true);
                    this.isDisabledFirstLeft(true);
                }
            }
            this.isDisabledDel = !value.find(item => {
                return !!item;
            });
        }));
    }
    open(content) {
        this.modalReference = this.modalService.open(content, {
            container: '#bentoNGModalContainer',
            size: 'lg'
        });
    }
    prevColumn() {
        const from = this.formSelectedItems.value.indexOf(true);
        const to = from - 1;
        this.move(from, to);
    }
    firstColumn() {
        const from = this.formSelectedItems.value.indexOf(true);
        const to = 0;
        this.move(from, to);
    }
    removeItemCalculation(index) {
        this.calculation.splice(index, 1);
        this.createStringFormula();
        this.saveState('calculation', this.calculation);
    }
    save() {
        const column = this.insertColumnForm.value.columnName;
        this.validateColumnName = false;
        this.validateColumnNameDuplicity = false;
        if (!!column && this.isColumnNameValid(column)) {
            this.dataGrid.push({
                label: column,
                classification: '',
                type: '',
                calculations: []
            });
            this.addCheckboxes(null);
            this.sumWidthTb();
            this.validateDataGrid();
            this.saveState('dataGrid', this.dataGrid);
            this.dataTable = this.dataGrid;
            this.insertColumnForm.controls.columnName.setValue('');
            this.modalReference.close();
        }
        else if (!this.isColumnNameValid(column)) {
            this.validateColumnNameDuplicity = true;
        }
        else {
            this.validateColumnName = true;
        }
    }
    cancel() {
        this.validateColumnName = false;
        this.validateColumnNameDuplicity = false;
        this.modalReference.close();
    }
    isColumnNameValid(columnName, ignoreIndex = null) {
        if (columnName === undefined || columnName === null) {
            return false;
        }
        if (columnName.trim().length <= 0) {
            return false;
        }
        return !this.dataGrid.some((column, index) => {
            if (index === ignoreIndex) {
                return false;
            }
            const columnLabelUpperCaseString = column.label.toUpperCase().trim();
            const columnsNameUpperCaseString = columnName.toUpperCase().trim();
            return columnLabelUpperCaseString.replace(/\s+/g, ' ') === columnsNameUpperCaseString.replace(/\s+/g, ' ');
        });
    }
    saveCalculation(item, bullet) {
        const type = this.isOperatorOrparentheses(bullet)
            ? 'operations'
            : 'variable';
        this.calculation.push({
            item,
            class: bullet,
            type
        });
        this.saveState('calculation', this.calculation);
    }
    saveEditCalculation() {
        if (this.validEditName(this.editTitle, this.editIndex) && this.validateSaveEditCalculation()) {
            this.dataGrid[this.editIndex].calculations = this.calculation;
            if (this.dataGrid[this.editIndex].calculations.length === 0) {
                this.groupColumn = '';
                this.groupResultType = '';
            }
            else if (this.groupColumn === 'FINAL_RESULT') {
                this.isFinalResultDisabled = true;
            }
            this.updateColumnReferences(this.editIndex, this.editTitle);
            this.dataGrid[this.editIndex].classification = this.groupColumn;
            this.dataGrid[this.editIndex].type = this.groupResultType;
            this.dataGrid[this.editIndex].label = this.editTitle;
            this.saveState('dataGrid', this.dataGrid);
            this.dataTable = this.dataGrid;
            this.validateDataGrid();
            this.modalReference.close();
        }
    }
    validEditName(columnName, colIndex) {
        if (columnName.length === 0) {
            const msg = this.insideI18n('SpreadsheetTab.Errors.ColumnName');
            this.displayAlert(msg, 'danger');
            return false;
        }
        else if (!this.isColumnNameValid(columnName, colIndex)) {
            const msg = this.insideI18n('SpreadsheetTab.Errors.ColumnNameDuplicity');
            this.displayAlert(msg, 'danger');
            return false;
        }
        return true;
    }
    cancelEditCalculation() {
        if (!this.dataGrid || !this.dataGrid[this.editIndex]) {
            return;
        }
        this.dataGrid[this.editIndex].calculations = this.originalCalculations;
        this.saveState('calculation', this.originalCalculations);
        this.calculation = this.originalCalculations;
        this.dataGrid[this.editIndex].classification = this.originalGroupColumn;
        this.groupColumn = this.originalGroupColumn;
        if (this.groupColumn === 'FINAL_RESULT') {
            this.isFinalResultDisabled = true;
        }
        this.dataGrid[this.editIndex].type = this.originalType;
        this.groupResultType = this.originalType;
        this.saveState('dataGrid', this.dataGrid);
        this.dataTable = this.dataGrid;
        this.modalReference.close();
    }
    createStringFormula() {
        const formula = this.calculation
            .map(elem => {
            if (elem && elem.item) {
                return elem.item.description;
            }
            else {
                return '';
            }
        })
            .join(',');
        this.saveState('formulaCalculation', formula);
    }
    validateSaveEditCalculation() {
        this.createStringFormula();
        const regexNotFirstOp = /^[,+x÷-]+/;
        const regexNotLastOp = /[,+x÷-]+$/;
        const regexNotGroupedOp = /[,+x÷-]{4,}/;
        const regexEmptyLimiter = /[{\[(][,][}\])]/;
        const formula = this.loadState('formulaCalculation');
        let res = formula.replace(regexNotFirstOp, '');
        res = res.replace(regexNotLastOp, '');
        if (regexNotGroupedOp.test(res) ||
            !this.isBalanced(res) ||
            this.interleavedVariables() ||
            regexEmptyLimiter.test(res)) {
            const msg = this.insideI18n('SpreadsheetTab.Alert.Danger');
            this.displayAlert(msg, 'danger');
            return false;
        }
        else {
            this.trimCalculation();
            this.saveState('formulaCalculation', res);
            return true;
        }
    }
    isDisabledFirstLeft(isDisabled) {
        if (isDisabled === '' || isDisabled === null || isDisabled === undefined) {
            isDisabled = true;
        }
        this.isDisabledFirst = isDisabled;
        this.isDisabledLeft = isDisabled;
    }
    isDisabledLastRight(isDisabled) {
        if (isDisabled === '' || isDisabled === null || isDisabled === undefined) {
            isDisabled = true;
        }
        this.isDisabledLast = isDisabled;
        this.isDisabledRight = isDisabled;
    }
    isOperator(calculationItem) {
        return calculationItem && calculationItem.class === 'bullet-operations';
    }
    isOperatorOrparentheses(type) {
        if (type === 'bullet-operations' || type === 'bullet-parentheses') {
            return true;
        }
        else {
            return false;
        }
    }
    isTypeVariable(calculationItem) {
        return calculationItem.type === 'variable';
    }
    trimCalculation() {
        while (this.isOperator(this.calculation[0])) {
            this.calculation[0] = null;
            this.calculation = this.calculation.filter(item => item !== null);
        }
        while (this.isOperator(this.calculation[this.calculation.length - 1])) {
            this.calculation[this.calculation.length - 1] = null;
            this.calculation = this.calculation.filter(item => item !== null);
        }
    }
    interleavedVariables() {
        let flag = false;
        this.calculation.forEach((item, i) => {
            if (this.calculation[i + 1]) {
                if (this.isTypeVariable(this.calculation[i]) &&
                    this.isTypeVariable(this.calculation[i + 1])) {
                    flag = true;
                }
            }
        });
        return flag;
    }
    displayAlert(msg, type) {
        if (this.lastAlert) {
            this.alertService.removeAlert(this.lastAlert);
        }
        this.lastAlert = this.alertService.addAlert({
            type,
            msg,
            closeable: true
        });
    }
    isBalanced(expression) {
        const stack = [];
        for (const value of expression) {
            if (this.isParantheses(value)) {
                if (this.isOpenParentheses(value)) {
                    stack.push(value);
                }
                else {
                    if (stack.length === 0) {
                        return false;
                    }
                    const top = stack.pop();
                    if (!this.matches(top, value)) {
                        return false;
                    }
                }
            }
        }
        const returnValue = stack.length === 0 ? true : false;
        return returnValue;
    }
    isParantheses(char) {
        const str = '{}[]()';
        if (str.indexOf(char) > -1) {
            return true;
        }
        else {
            return false;
        }
    }
    isOpenParentheses(parenthesisChar) {
        for (const value of this.typeParentheses) {
            if (value[0] === parenthesisChar) {
                return true;
            }
        }
        return false;
    }
    matches(topOfStack, closedParenthesis) {
        for (const value of this.typeParentheses) {
            if (value[0] === topOfStack && value[1] === closedParenthesis) {
                return true;
            }
        }
        return false;
    }
    setButtonActive(index) {
        this.isBtnActive = index;
    }
    sumWidthTb() {
        this.tbWidth += this.addWidth;
    }
    subWidthTb() {
        this.tbWidth -= this.addWidth;
    }
    toEdit(content, column, id) {
        this.tempName = column.label;
        this.editTitle = column.label;
        this.editIndex = id;
        this.modalReference = this.modalService.open(content, {
            container: '#bentoNGModalContainer',
            windowClass: 'modal-edit',
            size: 'lg',
            backdrop: 'static'
        });
        this.clearOriginals();
        this.validateModalEdit(id);
        this.clearInsertValue();
    }
    validateDataGrid() {
        this.tableCalculation = false;
        this.dataGrid.forEach(item => {
            if (item.calculations.length || item.classification.length) {
                this.tableCalculation = true;
            }
        });
    }
    validateStorage() {
        if (this.loadState('dataGrid') && this.loadState('formSelectedItems')) {
            this.tableCalculation = false;
            this.dataGrid = this.loadState('dataGrid');
            this.dataTable = this.loadState('dataGrid');
            this.dataGrid.forEach(() => {
                this.sumWidthTb();
            });
            this.validateDataGrid();
        }
    }
    validateModalEdit(id) {
        this.clearEdit();
        this.getCalculationFormula(id);
        this.getOperators();
        this.setOfficeData();
    }
    getLabelTranslated(constant) {
        switch (constant) {
            case 'EXPENSE':
                return this.i18n('SpreadsheetTab.Cost');
            case 'REVENUE':
                return this.i18n('SpreadsheetTab.Revenue');
            case 'OTHERS':
                return this.i18n('SpreadsheetTab.Others');
            case 'FINAL_RESULT':
                return this.i18n('SpreadsheetTab.FinalResult');
        }
    }
    getTableWidth(amountOfSelectedControls) {
        return `${amountOfSelectedControls * 418}px`;
    }
    clearOriginals() {
        this.originalCalculations = [];
        this.originalGroupColumn = '';
        this.originalType = '';
    }
    maskBullet(value, isPercent = false) {
        if (isNaN(value)) {
            if (value.includes(',')) {
                const parseFloat = value.replaceAll('.', '').replace(',', '.').replaceAll('%', '');
                const format = this.brazilianNumberFormatter.format(parseFloat);
                if (isPercent) {
                    return `${format}%`;
                }
                return format;
            }
            else {
                return value;
            }
        }
        else {
            const format = this.brazilianNumberFormatter.format(value);
            if (isPercent) {
                return `${format}%`;
            }
            return format;
        }
    }
}
SpreadsheetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SpreadsheetComponent, deps: [{ token: i1$1.TranslateService }, { token: i1$2.NgbModal }, { token: i2$1.FormBuilder }, { token: SpreadsheetService }, { token: AlertService }, { token: AddCostsCalculationTemplateService }], target: i0.ɵɵFactoryTarget.Component });
SpreadsheetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: SpreadsheetComponent, selector: "acc-spreadsheet", inputs: { templateId: "templateId" }, host: { listeners: { "window:keydown": "onKeydownHandler($event)" } }, ngImport: i0, template: "<h3 class=\"tab-title\">{{ i18n(\"SpreadsheetTab.Title\") | translate }}</h3>\n<p>{{ i18n(\"SpreadsheetTab.Instructions\") | translate }}</p>\n\n<button type=\"button\" class=\"btn btn-link btn-icon btn-lg add-button mb10\" (click)=\"open(content)\">\n  <i class=\"bento-icon-add\"></i>\n  <span class=\"btn-text\">\n    {{ i18n(\"SpreadsheetTab.InsertColumn\") | translate }}\n  </span>\n</button>\n\n<!-- modal - insert column -->\n<ng-template #content let-modal>\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"modal.dismiss()\">\n    <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n  </button>\n\n  <div class=\"modal-body\">\n    <div class=\"form-group\" [formGroup]=\"insertColumnForm\">\n      <label class=\"bento-label-required\" for=\"id\">\n        {{ i18n(\"SpreadsheetTab.Modal.ColumnName\") | translate }}\n      </label>\n      <input ngbAutofocus (keydown)=\"keyDown($event)\" [className]=\"\n          validateColumnName || validateColumnNameDuplicity\n            ? 'bento-input form-control bfm-invalid mb6'\n            : 'bento-input form-control bfm-valid mb6'\n        \" formControlName=\"columnName\" type=\"text\" maxlength=\"50\"/>\n\n      <div *ngIf=\"validateColumnName\" class=\"ng-star-inserted\">\n        <div class=\"ng-star-inserted\">\n          <div class=\"bfm-error-message\">\n            <span class=\"ng-star-inserted\">\n              {{ i18n(\"SpreadsheetTab.Errors.ColumnName\") | translate }}\n            </span>\n          </div>\n        </div>\n      </div>\n      <div *ngIf=\"validateColumnNameDuplicity\" class=\"ng-star-inserted\">\n        <div class=\"ng-star-inserted\">\n          <div class=\"bfm-error-message\">\n            <span class=\"ng-star-inserted\">\n              {{ i18n(\"SpreadsheetTab.Errors.ColumnNameDuplicity\") | translate }}\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-primary\" (click)=\"save()\">\n      {{ i18n(\"Form.Button.Save\") | translate }}\n    </button>\n    <button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"cancel()\">\n      {{ i18n(\"Form.Button.Cancel\") | translate }}\n    </button>\n  </div>\n</ng-template>\n\n<!-- Modal - Confirm-->\n<ng-template #modalConfirm let-modal>\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"modal.dismiss()\">\n    <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"modal-header\">\n    {{ i18n(\"SpreadsheetTab.Modal.Confirm.Title\") | translate }}\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-primary\" (click)=\"delete()\">\n      {{ i18n(\"SpreadsheetTab.Remove\") | translate }}\n    </button>\n    <button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"modal.close()\">\n      {{ i18n(\"SpreadsheetTab.Cancel\") | translate }}\n    </button>\n  </div>\n</ng-template>\n\n<!-- Modal - Edit -->\n<ng-template #modalEdit>\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"cancelEditCalculation()\">\n    <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"modalEdit\">\n    <div class=\"modal-header\">\n      <div class=\"row row-first line\">\n        <div class=\"col\">\n          <label class=\"lbl\"> {{ i18n(\"SpreadsheetTab.Modal.Edit.Name\") | translate }} </label>\n          <input\n          id=\"columnNameEdit\"\n          type=\"text\"\n          [(ngModel)]=\"editTitle\"\n          class=\"form-control ng-valid ng-dirty ng-touched\"\n          maxlength=\"50\"/>\n\n        </div>\n        <div class=\"col col-center\">\n          <!-- Column type -->\n          <p>\n            {{\n              i18n(\"SpreadsheetTab.Modal.Edit.Instructions.ColumnType\") | translate\n            }}\n          </p>\n          <div [(ngModel)]=\"groupColumn\" ngbRadioGroup class=\"btn-group btn-group-toggle\" name=\"radioBasicColumn\">\n            <label for=\"radioBasicColumn-Cost\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle\">\n              <input id=\"radioBasicColumn-Cost\" ngbButton type=\"radio\" value=\"EXPENSE\" />\n              {{ i18n(\"SpreadsheetTab.Cost\") | translate }}\n            </label>\n            <label for=\"radioBasicColumn-Revenue\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle\">\n              <input id=\"radioBasicColumn-Revenue\" ngbButton type=\"radio\" value=\"REVENUE\" />\n              {{ i18n(\"SpreadsheetTab.Revenue\") | translate }}\n            </label>\n            <label for=\"radioBasicColumn-Others\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle\">\n              <input id=\"radioBasicColumn-Others\" ngbButton type=\"radio\" value=\"OTHERS\" />\n              {{ i18n(\"SpreadsheetTab.Others\") | translate }}\n            </label>\n            <label for=\"radioBasicColumn-FinalResult\" ngbButtonLabel\n              class=\"btn btn-outline-primary btn-toggle final-result\">\n              <input id=\"radioBasicColumn-FinalResult\" ngbButton type=\"radio\" value=\"FINAL_RESULT\"\n                [disabled]=\"isFinalResultDisabled\" />\n              {{ i18n(\"SpreadsheetTab.FinalResult\") | translate }}\n            </label>\n          </div>\n        </div>\n        <div class=\"col\">\n          <!-- Result type -->\n          <p>\n            {{\n              i18n(\"SpreadsheetTab.Modal.Edit.Instructions.ResultType\") | translate\n            }}\n          </p>\n\n          <div [(ngModel)]=\"groupResultType\" ngbRadioGroup class=\"btn-group btn-group-toggle\"\n            name=\"radioBasicResultType\">\n            <label for=\"radioBasicResultType-left\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle\">\n              <input id=\"radioBasicResultType-left\" ngbButton type=\"radio\" value=\"AMOUNT\" />\n              {{ i18n(\"SpreadsheetTab.Value\") | translate }}\n            </label>\n            <label for=\"radioBasicResultType-middle\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle\">\n              <input id=\"radioBasicResultType-middle\" ngbButton type=\"radio\" value=\"HOUR\" />\n              {{ i18n(\"SpreadsheetTab.Hours\") | translate }}\n            </label>\n            <label for=\"radioBasicResultType-right\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle quantity\">\n              <input id=\"radioBasicResultType-right\" ngbButton type=\"radio\" value=\"QUANTITY\" />\n              {{ i18n(\"SpreadsheetTab.Quantity\") | translate }}\n            </label>\n          </div>\n\n        </div>\n      </div>\n\n      <div class=\"row secondLine\">\n        <button type=\"button\" class=\"btn btn-primary\" [className]=\"\n            isBtnActive === 1 ? 'btn btn-primary' : 'btn btn-outline-primary'\n          \" (click)=\"setOfficeData();\">\n          {{ i18n(\"SpreadsheetTab.Modal.Edit.FirmData\") | translate }}\n        </button>\n        <button type=\"button\" [className]=\"\n            isBtnActive === 2 ? 'btn btn-primary' : 'btn btn-outline-primary'\n          \" (click)=\"setClientsData();\">\n          {{ i18n(\"SpreadsheetTab.Modal.Edit.ClientData\") | translate }}\n        </button>\n        <button type=\"button\" [className]=\"\n            isBtnActive === 3 ? 'btn btn-primary' : 'btn btn-outline-primary'\n          \" (click)=\"getColumnData();\">\n          {{ i18n(\"SpreadsheetTab.Modal.Edit.Columns\") | translate }}\n        </button>\n\n        <p class=\"align-between instructions\">\n          {{ i18n(\"SpreadsheetTab.Modal.Edit.Instructions.Drag\") | translate }}\n        </p>\n\n        <span class=\"bento-search\">\n          <input bentoReset class=\"form-control mt17\" [(ngModel)]=\"searchFilter\" type=\"text\"\n            placeholder=\" {{ i18n('SpreadsheetTab.Modal.Edit.Search') | translate }}\" />\n        </span>\n      </div>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div [ngClass]=\"['content-labels content-variable scroll', contentType]\">\n          <span *ngFor=\"let item of data | filter: searchFilter; let i = index\" (click)=\"saveCalculation(item, bullet)\">\n            {{ item.description }}\n          </span>\n        </div>\n\n        <form class=\"content-labels content-right d-flex flex-column mg-0\" [formGroup]=\"groupValueInsert\">\n          <div class=\"content-value-insert\">\n            <div class=\"inner-content\">\n              <label class=\"lbl-insert-value\" for=\"insertValue\">{{\n                  i18n(\"SpreadsheetTab.Modal.Edit.InsertValue\") | translate\n                }}</label>\n              <input id=\"insertValue\" type=\"text\" class=\"form-control input-insert-value\" formControlName=\"insertValue\"\n                     (keydown)=\"keyDownInsertValue($event)\" currencyMask maxlength=\"15\"/>\n\n              <div class=\"btn-group-footer\">\n                <div formControlName=\"type\" ngbRadioGroup class=\"btn-group btn-group-toggle\"\n                  name=\"radioBasicResultType\">\n                  <label for=\"radioBasicResultType-val\" ngbButtonLabel\n                    class=\"btn btn-outline-primary btn-toggle value-button\">\n                    <input id=\"radioBasicResultType-val\" ngbButton type=\"radio\" value=\"false\" />\n                    {{ i18n(\"SpreadsheetTab.Value\") | translate }}\n                  </label>\n                  <label for=\"radioBasicResultType-porcent\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle\">\n                    <input id=\"radioBasicResultType-porcent\" ngbButton type=\"radio\" value=\"true\" />\n                    {{ i18n(\"SpreadsheetTab.Percentage\") | translate }}\n                  </label>\n                </div>\n                <button type=\"button\" class=\"btn btn-primary btn-insert ml20\" (click)=\"joinCalculation()\">\n                  {{ i18n(\"Form.Button.Insert\") | translate }}\n                </button>\n              </div>\n            </div>\n          </div>\n          <div class=\"content-operations\">\n            <div class=\"content\">\n              <label class=\"lbl-operators\">\n                {{ i18n(\"SpreadsheetTab.Modal.Edit.Instructions.Operators\") | translate }}\n              </label>\n              <div class=\"all-operators\">\n                <span *ngFor=\"let item of operators; let i = index\"\n                  (click)=\"saveCalculation(item, 'bullet-operations')\">\n                  {{ item.description }}\n                </span>\n                <span *ngFor=\"let parenthese of parentheses; let j = index\"\n                  (click)=\"saveCalculation(parenthese, 'bullet-parentheses')\">\n                  {{ parenthese.description }}\n                </span>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n\n      <div class=\"row\">\n        <div style=\"width: 100%;\">\n          <acc-droplist [bullets]=\"calculation\" (remove)=\"removeItemCalculation($event)\"></acc-droplist>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer pd-0\">\n      <!-- Footer Button -->\n      <div class=\"footer-btn\">\n        <button type=\"button\" class=\"btn btn-primary mr10\" (click)=\"saveEditCalculation()\">\n          {{ i18n(\"Form.Button.Save\") | translate }}\n        </button>\n        <button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"cancelEditCalculation()\">\n          {{ i18n(\"Form.Button.Cancel\") | translate }}\n        </button>\n      </div>\n    </div>\n  </div>\n</ng-template>\n\n<!-- Tabel - Selected items-->\n<div class=\"div-main\" [ngStyle]=\"{width: getTableWidth(formSelectedItems.controls.length)}\">\n  <div [ngClass]=\"[\n      'container-table no-overflow',\n      dataTable.length > 4 ? 'container-table active-container' : ''\n    ]\">\n    <div *ngIf=\"dataTable.length > 0\" class=\"actions-header\">\n      <button [disabled]=\"isDisabledDel\" class=\"btn btn-outline-primary\"\n        ngbTooltip=\"{{ i18n('SpreadsheetTab.Remove') | translate }}\" placement=\"top\" type=\"button\"\n        (click)=\"open(modalConfirm)\">\n        <i class=\"bento-icon-remove\"></i>\n      </button>\n\n      <button [disabled]=\"isDisabledFirst\" class=\"btn btn-outline-primary\"\n        ngbTooltip=\"{{ i18n('SpreadsheetTab.MoveFirst') | translate }}\" placement=\"top\" type=\"button\"\n        (click)=\"firstColumn()\">\n        <i class=\"bento-icon-chevron-first-left\"></i>\n      </button>\n\n      <button [disabled]=\"isDisabledLeft\" class=\"btn btn-outline-primary\"\n        ngbTooltip=\"{{ i18n('SpreadsheetTab.MoveLeft') | translate }}\" placement=\"top\" type=\"button\"\n        (click)=\"prevColumn()\">\n        <i class=\"bento-icon-chevron-left\"></i>\n      </button>\n\n      <button [disabled]=\"isDisabledRight\" class=\"btn btn-outline-primary\"\n        ngbTooltip=\"{{ i18n('SpreadsheetTab.MoveRight') | translate }}\" placement=\"top\" type=\"button\"\n        (click)=\"nextColumn()\">\n        <i class=\"bento-icon-chevron-right\"></i>\n      </button>\n\n      <button [disabled]=\"isDisabledLast\" class=\"btn btn-outline-primary\"\n        ngbTooltip=\"{{ i18n('SpreadsheetTab.MoveLast') | translate }}\" placement=\"top\" type=\"button\"\n        (click)=\"lastColumn()\">\n        <i class=\"bento-icon-chevron-last-right\"></i>\n      </button>\n    </div>\n  </div>\n  <div [ngClass]=\"[\n      'container-table',\n      dataTable.length > 4 ? 'container-table active-container' : ''\n    ]\">\n    <table *ngIf=\"dataTable.length > 0\" class=\"table table-selected-items\">\n      <tbody>\n        <tr [formGroup]=\"checkedForm\" [ngClass]=\"[dataTable.length > 10 ? 'active-row' : '']\">\n          <td class=\"classification-and-name-row\" formArrayName=\"selectedItems\" *ngFor=\"let item of formSelectedItems.controls; let i = index\">\n            <div class=\"column-wrapper\">\n              <label [for]=\"i\" class=\"chk\" [title]=\"dataTable[i].label\">\n                <input class=\"bento-input\" type=\"checkbox\" [id]=\"i\" [formControl]=\"item\" />\n                <span>{{ dataTable[i].label }}</span>\n              </label>\n              <a href=\"javascript:void(0)\" (click)=\"toEdit(modalEdit, dataTable[i], i)\" class=\"link-edit\">\n                <i class=\"bento-icon-edit\"></i>\n                {{ i18n(\"SpreadsheetTab.Edit\") | translate }}\n              </a>\n            </div>\n          </td>\n        </tr>\n        <tr *ngIf=\"tableCalculation; else emptyTable\" [ngClass]=\"[dataTable.length > 10 ? 'active-row' : '']\">\n          <td *ngFor=\"let item of dataTable; let i = index\">\n            <div>\n              <span *ngFor=\"let elem of dataTable[i].calculations; let x = index\" [ngClass]=\"['bullet', elem.class]\">\n                {{ maskBullet(elem.item.description, elem.item.percentage) }}\n              </span>\n            </div>\n          </td>\n        </tr>\n        <tr *ngIf=\"tableCalculation\" [ngClass]=\"[dataTable.length > 10 ? 'active-row' : '']\">\n          <td *ngFor=\"let item of dataTable; let i = index\" class=\"classification classification-and-name-row\">\n            {{ getLabelTranslated(item.classification) | translate }}\n          </td>\n        </tr>\n        <ng-template #emptyTable>\n          <tr>\n            <td [attr.colspan]=\"formSelectedItems.controls.length\" class=\"emptyTd\"></td>\n          </tr>\n        </ng-template>\n      </tbody>\n    </table>\n  </div>\n</div>\n", styles: [".modalEdit h3,.modalEdit p{width:100%;font-weight:400}.modalEdit h3{font-size:18px;margin-bottom:0;width:90%}.modalEdit p,.modalEdit .lbl{font-size:16px!important;width:100%}.modalEdit .row{margin:0;justify-content:space-between}.modalEdit .col-center{padding:0 15px!important}@media (max-width: 768px){.modalEdit .col-center{padding-top:14px!important}}.modalEdit .col{margin-right:20px}.modalEdit .col input[type=text]{width:89%;height:32px}@media (max-width: 768px){.modalEdit .col.txt-center{text-align:inherit}.modalEdit .col.txt-center .title{padding-left:0}}.modalEdit .btn-group{margin-bottom:14px;margin-top:4px}.modalEdit .bento-search{width:100%}.modalEdit .bento-search input{border-color:#b2b2b8;padding:0 10px 0 27px;width:100%}.modalEdit .bento-search:before{color:#b2b2b8;left:11px;top:69%;font-size:14px}.modalEdit .modal-content{width:90%!important}.modalEdit .modal-header{flex-flow:wrap;padding:0;border-bottom:0!important}.modalEdit .modal-header .btn{width:27%;padding:0 21px!important}.modalEdit .modal-header .final-result{padding:0 42px!important}.modalEdit .modal-header .row{width:100%}.modalEdit .modal-header .row .col-center div .final-result{width:220px}.modalEdit .modal-header .row .col .btn-group .quantity{padding:0 35px!important;width:155px}.modalEdit .modal-header .row-first{margin:0 0 25px}@media (max-width: 768px){.modalEdit .modal-header .row-first{display:block!important}.modalEdit .modal-header .row-first .btn{max-width:165px;font-size:11px}}.modalEdit .modal-body{margin:10px 0}.modalEdit .modal-body p{margin:0;font-family:BentoLight,arial,helvetica,sans-serif}.modalEdit .modal-footer{border-top:1px solid #fff;padding:0;flex-flow:wrap;justify-content:left}.modalEdit .modal-footer p{margin:0;font-family:BentoLight,arial,helvetica,sans-serif}.modalEdit .modal-footer .footer-btn{display:block;width:100%;margin:0;padding:0;text-align:right}.modalEdit .pd-0{padding:0!important}.modalEdit .mg-0{margin:0!important}.modalEdit .content-labels.content-variable{border:1px solid #b2b2b8;padding:5px;margin:0 0 16px}.modalEdit .content-labels.content-variable span{cursor:pointer}.modalEdit .content-labels.scroll{overflow-x:auto;width:68%;height:240px}@media (max-width: 929px){.modalEdit .content-labels.scroll{height:343px}}@media (min-width: 930px) and (max-width: 1227px){.modalEdit .content-labels.scroll{height:309px}}@media (min-width: 1228px) and (max-width: 1366px){.modalEdit .content-labels.scroll{height:273px}}.modalEdit .content-labels .box-item{display:inline-block;position:relative}.modalEdit .content-labels .box-item .del-new{text-align:center;position:absolute;right:-8px;color:#fff!important;font-size:10px;width:20px;height:20px;padding:0;line-height:22px;top:-10px;cursor:pointer;border-radius:50%;background-color:#000;font-weight:700}@-moz-document url-prefix(){.modalEdit .content-labels .box-item .del-new{height:20px}}.modalEdit .content-labels .box-item .del{text-align:center;position:absolute;right:-13px;color:#fff;font-size:10px;width:17px;height:23px;padding:0;line-height:23px;top:0;cursor:pointer;border-top-left-radius:0;border-bottom-left-radius:0}@-moz-document url-prefix(){.modalEdit .content-labels .box-item .del{height:24px}}.modalEdit .content-labels span{color:#fff;display:inline-block;margin:5px;padding:4px 10px;font-size:11px;text-transform:uppercase;border-radius:4px;border-right:solid 1px #ccc}.modalEdit .content-labels span.default{background-color:#606169;color:#fff}.modalEdit .content-labels span:last-child{border:none}.modalEdit .content-labels span:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.modalEdit .content-labels.cdk-drop-list-dragging span:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.modalEdit .content-labels.content-office-data span{background-color:#387c2b}.modalEdit .content-labels.content-clients-data span{background-color:#0072a8}.modalEdit .content-labels.content-column span{background-color:#5d1893}.modalEdit .content-labels.content-left{width:100%;border:1px solid #b2b2b8;padding:10px 5px;height:64px;white-space:nowrap}.modalEdit .content-labels.content-left span{margin:5px 15px}.modalEdit .content-labels.content-right{width:30%}.modalEdit .content-labels .content-value-insert{border:1px solid #b2b2b8;padding:0 22px}.modalEdit .content-labels .content-value-insert .form-control{margin:auto;width:100%}.modalEdit .content-labels .content-value-insert .btn-group-footer{margin:14px 0 0;display:flex;justify-content:space-between}@media (max-width: 1227px){.modalEdit .content-labels .content-value-insert .btn-group-footer{margin:14px 0;display:block}.modalEdit .content-labels .content-value-insert .btn-group-footer .btn-group-toggle{margin-right:10px}.modalEdit .content-labels .content-value-insert .btn-group-footer .ml20{margin-left:0}}@media (max-width: 1227px) and (max-width: 929px){.modalEdit .content-labels .content-value-insert .btn-group-footer .value-button{margin-bottom:10px}.modalEdit .content-labels .content-value-insert .btn-group-footer .btn-group-toggle{width:100%;display:grid}.modalEdit .content-labels .content-value-insert .btn-group-footer .btn-group-toggle .btn-outline-primary{border-radius:4px}.modalEdit .content-labels .content-value-insert .btn-group-footer .btn{width:100%}}.modalEdit .content-labels .content-value-insert span{border-right:0 solid #fff}.modalEdit .content-labels .content-value-insert .input-insert-value{width:100%;text-align:right}.modalEdit .content-labels .content-value-insert .lbl-insert-value{margin-top:10px;text-align:left;text-transform:none;color:#212121;font-family:BentoLight,arial,helvetica,sans-serif;font-size:16px;width:85%}.modalEdit .content-labels .content-operations{border:1px solid #b2b2b8;margin-top:17px;padding:0 22px}.modalEdit .content-labels .content-operations .content{width:100%;padding:15px 0}@media (max-width: 768px){.modalEdit .content-labels .content-operations .content{width:170px;margin:auto}}@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2){.modalEdit .content-labels .content-operations .content{margin:auto}}.modalEdit .content-labels .content-operations .all-operators{width:100%}@media (min-width: 1367px){.modalEdit .content-labels .content-operations .all-operators{width:300px}}.modalEdit .content-labels .content-operations .all-operators span{background-color:#ffb400;color:#000;cursor:pointer;padding:4px 10px 4px 8px;margin-right:10px;margin-left:0!important;width:20px;font-weight:700}.modalEdit .content-labels .content-operations .all-operators .lbl-operators{text-align:left;text-transform:none;color:#212121;font-family:BentoLight,arial,helvetica,sans-serif;font-size:16px;width:100%}.modalEdit .content-labels .cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.modalEdit .content-labels:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.div-main{max-width:100%}.div-main .container-table{overflow-x:auto;max-width:100%;page-break-inside:auto}.div-main .container-table.active-container{border-right:1px solid #d5d4d9}.div-main .container-table:first-child{height:36px}.div-main .container-table .actions-header{background-color:#f4f5f7;border:1px solid #d5d4d9}.div-main .container-table .actions-header button{min-width:2rem;margin:4px}.div-main .container-table .actions-header button:first-child{margin-left:8px}.div-main .container-table .table-selected-items{display:table;margin:0;border:1px solid #d5d4d9;max-width:none;max-width:initial;white-space:pre-wrap}.div-main .container-table .table-selected-items tbody,.div-main .container-table .table-selected-items tbody tr{background-color:#fff}@-moz-document url-prefix(){.div-main .container-table .table-selected-items tbody tr.active-row{display:inline-flex;width:100%}}.div-main .container-table .table-selected-items tbody tr .classification-and-name-row{height:36px}.div-main .container-table .table-selected-items tbody td{padding:0 8px;min-height:36px;border:1px solid #d5d4d9;white-space:pre-line;min-width:330px;max-width:330px;vertical-align:middle}@-moz-document url-prefix(){.div-main .container-table .table-selected-items tbody td{align-items:center}}.div-main .container-table .table-selected-items tbody td .column-wrapper{display:flex;align-items:center;justify-content:space-between;width:100%;height:100%}.div-main .container-table .table-selected-items tbody td label{cursor:pointer;font-weight:600;white-space:nowrap;margin:0;display:flex;align-items:center;width:80%}.div-main .container-table .table-selected-items tbody td label span{margin-left:5px;display:block;width:calc(100% - 100px);text-overflow:ellipsis;overflow:hidden}.div-main .container-table .table-selected-items tbody td .link-edit{color:#212121}.emptyTd{height:36px}.breakafter{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.scroll{overflow-x:auto;width:100%}.no-overflow{overflow:hidden!important}.row .content-labels{margin:0 0 16px}.row .content-calculation{display:table}.align-between{justify-content:space-between;display:flex;padding-bottom:14px}.ml20{margin-left:20px}.mr10{margin-right:10px}.mt15{margin-top:15px!important}.mt17{margin-top:17px}.mb10{margin-bottom:10px}.mb6{margin-bottom:6px}.mt10{margin-top:10px}.tab-title{margin-top:0}.classification{color:#666;font-weight:700;font-size:14px;font-family:Arial,Helvetica,sans-serif}.container-alert{position:fixed;left:0;top:35px;width:100%;display:flex;justify-content:center;z-index:9999}.btn-insert{margin-top:4px}@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2){.btn-insert{margin-left:10px}}@media (max-width: 1227px){.btn-insert{margin-top:-5px}}.bullet{color:#fff;display:inline-block;padding:4px 10px;margin:3px;font-size:11px;text-transform:uppercase;border-radius:4px;border-right:solid 1px #ccc}.bullet-office-data{background-color:#387c2b;color:#fff}.bullet-clients-data{background-color:#0072a8;color:#fff}.bullet-column{background-color:#5d1893;color:#fff}.bullet-operations,.bullet-parentheses{background-color:#ffb400;color:#000!important}.bullet-value{background-color:#d4ebf4;color:#000!important}.cdk-drag{cursor:move}.cdk-drag-placeholder{background:#ccc;border:dotted 1px #000;border-right:dotted 1px #000!important;border-left:dotted 1px #000!important;color:#000!important;opacity:.5;transition:transform .25s cubic-bezier(0,0,.2,1)}.cdk-drag-preview{z-index:9999!important;box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-preview .del{opacity:0}.line{border-bottom:.5px solid #707070;padding-bottom:16px}.instructions{margin:29px 0 0;padding:0}::ng-deep .ng-bento .modal.modal-edit .modal-dialog.modal-lg .modal-content{width:90%}@media (max-width: 768px){::ng-deep .ng-bento .modal.modal-edit .modal-dialog.modal-lg .modal-content{width:100%}}.secondLine:before{content:none}\n"], components: [{ type: DroplistComponent, selector: "acc-droplist", inputs: ["bullets"], outputs: ["remove"] }], directives: [{ type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i2$1.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.BentoFooterTabHelper, selector: "[class=\"modal-footer\"]" }, { type: i2$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i1$2.NgbRadioGroup, selector: "[ngbRadioGroup]", inputs: ["name"] }, { type: i1$2.NgbButtonLabel, selector: "[ngbButtonLabel]" }, { type: i1$2.NgbRadio, selector: "[ngbButton][type=radio]", inputs: ["value", "disabled", "name"] }, { type: i5.BentoResetDirective, selector: "input:not([type=checkbox])[formControlName][bentoReset],input:not([type=checkbox])[formControl][bentoReset],input:not([type=checkbox])[ngModel][bentoReset]" }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i10.CurrencyMaskDirective, selector: "[currencyMask]", inputs: ["options", "max", "min"] }, { type: i4.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i5.BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i1$2.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i2$1.FormArrayName, selector: "[formArrayName]", inputs: ["formArrayName"] }, { type: i2$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i2$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }], pipes: { "translate": i1$1.TranslatePipe, "filter": FilterPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SpreadsheetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-spreadsheet', template: "<h3 class=\"tab-title\">{{ i18n(\"SpreadsheetTab.Title\") | translate }}</h3>\n<p>{{ i18n(\"SpreadsheetTab.Instructions\") | translate }}</p>\n\n<button type=\"button\" class=\"btn btn-link btn-icon btn-lg add-button mb10\" (click)=\"open(content)\">\n  <i class=\"bento-icon-add\"></i>\n  <span class=\"btn-text\">\n    {{ i18n(\"SpreadsheetTab.InsertColumn\") | translate }}\n  </span>\n</button>\n\n<!-- modal - insert column -->\n<ng-template #content let-modal>\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"modal.dismiss()\">\n    <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n  </button>\n\n  <div class=\"modal-body\">\n    <div class=\"form-group\" [formGroup]=\"insertColumnForm\">\n      <label class=\"bento-label-required\" for=\"id\">\n        {{ i18n(\"SpreadsheetTab.Modal.ColumnName\") | translate }}\n      </label>\n      <input ngbAutofocus (keydown)=\"keyDown($event)\" [className]=\"\n          validateColumnName || validateColumnNameDuplicity\n            ? 'bento-input form-control bfm-invalid mb6'\n            : 'bento-input form-control bfm-valid mb6'\n        \" formControlName=\"columnName\" type=\"text\" maxlength=\"50\"/>\n\n      <div *ngIf=\"validateColumnName\" class=\"ng-star-inserted\">\n        <div class=\"ng-star-inserted\">\n          <div class=\"bfm-error-message\">\n            <span class=\"ng-star-inserted\">\n              {{ i18n(\"SpreadsheetTab.Errors.ColumnName\") | translate }}\n            </span>\n          </div>\n        </div>\n      </div>\n      <div *ngIf=\"validateColumnNameDuplicity\" class=\"ng-star-inserted\">\n        <div class=\"ng-star-inserted\">\n          <div class=\"bfm-error-message\">\n            <span class=\"ng-star-inserted\">\n              {{ i18n(\"SpreadsheetTab.Errors.ColumnNameDuplicity\") | translate }}\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-primary\" (click)=\"save()\">\n      {{ i18n(\"Form.Button.Save\") | translate }}\n    </button>\n    <button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"cancel()\">\n      {{ i18n(\"Form.Button.Cancel\") | translate }}\n    </button>\n  </div>\n</ng-template>\n\n<!-- Modal - Confirm-->\n<ng-template #modalConfirm let-modal>\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"modal.dismiss()\">\n    <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"modal-header\">\n    {{ i18n(\"SpreadsheetTab.Modal.Confirm.Title\") | translate }}\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-primary\" (click)=\"delete()\">\n      {{ i18n(\"SpreadsheetTab.Remove\") | translate }}\n    </button>\n    <button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"modal.close()\">\n      {{ i18n(\"SpreadsheetTab.Cancel\") | translate }}\n    </button>\n  </div>\n</ng-template>\n\n<!-- Modal - Edit -->\n<ng-template #modalEdit>\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"cancelEditCalculation()\">\n    <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"modalEdit\">\n    <div class=\"modal-header\">\n      <div class=\"row row-first line\">\n        <div class=\"col\">\n          <label class=\"lbl\"> {{ i18n(\"SpreadsheetTab.Modal.Edit.Name\") | translate }} </label>\n          <input\n          id=\"columnNameEdit\"\n          type=\"text\"\n          [(ngModel)]=\"editTitle\"\n          class=\"form-control ng-valid ng-dirty ng-touched\"\n          maxlength=\"50\"/>\n\n        </div>\n        <div class=\"col col-center\">\n          <!-- Column type -->\n          <p>\n            {{\n              i18n(\"SpreadsheetTab.Modal.Edit.Instructions.ColumnType\") | translate\n            }}\n          </p>\n          <div [(ngModel)]=\"groupColumn\" ngbRadioGroup class=\"btn-group btn-group-toggle\" name=\"radioBasicColumn\">\n            <label for=\"radioBasicColumn-Cost\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle\">\n              <input id=\"radioBasicColumn-Cost\" ngbButton type=\"radio\" value=\"EXPENSE\" />\n              {{ i18n(\"SpreadsheetTab.Cost\") | translate }}\n            </label>\n            <label for=\"radioBasicColumn-Revenue\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle\">\n              <input id=\"radioBasicColumn-Revenue\" ngbButton type=\"radio\" value=\"REVENUE\" />\n              {{ i18n(\"SpreadsheetTab.Revenue\") | translate }}\n            </label>\n            <label for=\"radioBasicColumn-Others\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle\">\n              <input id=\"radioBasicColumn-Others\" ngbButton type=\"radio\" value=\"OTHERS\" />\n              {{ i18n(\"SpreadsheetTab.Others\") | translate }}\n            </label>\n            <label for=\"radioBasicColumn-FinalResult\" ngbButtonLabel\n              class=\"btn btn-outline-primary btn-toggle final-result\">\n              <input id=\"radioBasicColumn-FinalResult\" ngbButton type=\"radio\" value=\"FINAL_RESULT\"\n                [disabled]=\"isFinalResultDisabled\" />\n              {{ i18n(\"SpreadsheetTab.FinalResult\") | translate }}\n            </label>\n          </div>\n        </div>\n        <div class=\"col\">\n          <!-- Result type -->\n          <p>\n            {{\n              i18n(\"SpreadsheetTab.Modal.Edit.Instructions.ResultType\") | translate\n            }}\n          </p>\n\n          <div [(ngModel)]=\"groupResultType\" ngbRadioGroup class=\"btn-group btn-group-toggle\"\n            name=\"radioBasicResultType\">\n            <label for=\"radioBasicResultType-left\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle\">\n              <input id=\"radioBasicResultType-left\" ngbButton type=\"radio\" value=\"AMOUNT\" />\n              {{ i18n(\"SpreadsheetTab.Value\") | translate }}\n            </label>\n            <label for=\"radioBasicResultType-middle\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle\">\n              <input id=\"radioBasicResultType-middle\" ngbButton type=\"radio\" value=\"HOUR\" />\n              {{ i18n(\"SpreadsheetTab.Hours\") | translate }}\n            </label>\n            <label for=\"radioBasicResultType-right\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle quantity\">\n              <input id=\"radioBasicResultType-right\" ngbButton type=\"radio\" value=\"QUANTITY\" />\n              {{ i18n(\"SpreadsheetTab.Quantity\") | translate }}\n            </label>\n          </div>\n\n        </div>\n      </div>\n\n      <div class=\"row secondLine\">\n        <button type=\"button\" class=\"btn btn-primary\" [className]=\"\n            isBtnActive === 1 ? 'btn btn-primary' : 'btn btn-outline-primary'\n          \" (click)=\"setOfficeData();\">\n          {{ i18n(\"SpreadsheetTab.Modal.Edit.FirmData\") | translate }}\n        </button>\n        <button type=\"button\" [className]=\"\n            isBtnActive === 2 ? 'btn btn-primary' : 'btn btn-outline-primary'\n          \" (click)=\"setClientsData();\">\n          {{ i18n(\"SpreadsheetTab.Modal.Edit.ClientData\") | translate }}\n        </button>\n        <button type=\"button\" [className]=\"\n            isBtnActive === 3 ? 'btn btn-primary' : 'btn btn-outline-primary'\n          \" (click)=\"getColumnData();\">\n          {{ i18n(\"SpreadsheetTab.Modal.Edit.Columns\") | translate }}\n        </button>\n\n        <p class=\"align-between instructions\">\n          {{ i18n(\"SpreadsheetTab.Modal.Edit.Instructions.Drag\") | translate }}\n        </p>\n\n        <span class=\"bento-search\">\n          <input bentoReset class=\"form-control mt17\" [(ngModel)]=\"searchFilter\" type=\"text\"\n            placeholder=\" {{ i18n('SpreadsheetTab.Modal.Edit.Search') | translate }}\" />\n        </span>\n      </div>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div [ngClass]=\"['content-labels content-variable scroll', contentType]\">\n          <span *ngFor=\"let item of data | filter: searchFilter; let i = index\" (click)=\"saveCalculation(item, bullet)\">\n            {{ item.description }}\n          </span>\n        </div>\n\n        <form class=\"content-labels content-right d-flex flex-column mg-0\" [formGroup]=\"groupValueInsert\">\n          <div class=\"content-value-insert\">\n            <div class=\"inner-content\">\n              <label class=\"lbl-insert-value\" for=\"insertValue\">{{\n                  i18n(\"SpreadsheetTab.Modal.Edit.InsertValue\") | translate\n                }}</label>\n              <input id=\"insertValue\" type=\"text\" class=\"form-control input-insert-value\" formControlName=\"insertValue\"\n                     (keydown)=\"keyDownInsertValue($event)\" currencyMask maxlength=\"15\"/>\n\n              <div class=\"btn-group-footer\">\n                <div formControlName=\"type\" ngbRadioGroup class=\"btn-group btn-group-toggle\"\n                  name=\"radioBasicResultType\">\n                  <label for=\"radioBasicResultType-val\" ngbButtonLabel\n                    class=\"btn btn-outline-primary btn-toggle value-button\">\n                    <input id=\"radioBasicResultType-val\" ngbButton type=\"radio\" value=\"false\" />\n                    {{ i18n(\"SpreadsheetTab.Value\") | translate }}\n                  </label>\n                  <label for=\"radioBasicResultType-porcent\" ngbButtonLabel class=\"btn btn-outline-primary btn-toggle\">\n                    <input id=\"radioBasicResultType-porcent\" ngbButton type=\"radio\" value=\"true\" />\n                    {{ i18n(\"SpreadsheetTab.Percentage\") | translate }}\n                  </label>\n                </div>\n                <button type=\"button\" class=\"btn btn-primary btn-insert ml20\" (click)=\"joinCalculation()\">\n                  {{ i18n(\"Form.Button.Insert\") | translate }}\n                </button>\n              </div>\n            </div>\n          </div>\n          <div class=\"content-operations\">\n            <div class=\"content\">\n              <label class=\"lbl-operators\">\n                {{ i18n(\"SpreadsheetTab.Modal.Edit.Instructions.Operators\") | translate }}\n              </label>\n              <div class=\"all-operators\">\n                <span *ngFor=\"let item of operators; let i = index\"\n                  (click)=\"saveCalculation(item, 'bullet-operations')\">\n                  {{ item.description }}\n                </span>\n                <span *ngFor=\"let parenthese of parentheses; let j = index\"\n                  (click)=\"saveCalculation(parenthese, 'bullet-parentheses')\">\n                  {{ parenthese.description }}\n                </span>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n\n      <div class=\"row\">\n        <div style=\"width: 100%;\">\n          <acc-droplist [bullets]=\"calculation\" (remove)=\"removeItemCalculation($event)\"></acc-droplist>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer pd-0\">\n      <!-- Footer Button -->\n      <div class=\"footer-btn\">\n        <button type=\"button\" class=\"btn btn-primary mr10\" (click)=\"saveEditCalculation()\">\n          {{ i18n(\"Form.Button.Save\") | translate }}\n        </button>\n        <button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"cancelEditCalculation()\">\n          {{ i18n(\"Form.Button.Cancel\") | translate }}\n        </button>\n      </div>\n    </div>\n  </div>\n</ng-template>\n\n<!-- Tabel - Selected items-->\n<div class=\"div-main\" [ngStyle]=\"{width: getTableWidth(formSelectedItems.controls.length)}\">\n  <div [ngClass]=\"[\n      'container-table no-overflow',\n      dataTable.length > 4 ? 'container-table active-container' : ''\n    ]\">\n    <div *ngIf=\"dataTable.length > 0\" class=\"actions-header\">\n      <button [disabled]=\"isDisabledDel\" class=\"btn btn-outline-primary\"\n        ngbTooltip=\"{{ i18n('SpreadsheetTab.Remove') | translate }}\" placement=\"top\" type=\"button\"\n        (click)=\"open(modalConfirm)\">\n        <i class=\"bento-icon-remove\"></i>\n      </button>\n\n      <button [disabled]=\"isDisabledFirst\" class=\"btn btn-outline-primary\"\n        ngbTooltip=\"{{ i18n('SpreadsheetTab.MoveFirst') | translate }}\" placement=\"top\" type=\"button\"\n        (click)=\"firstColumn()\">\n        <i class=\"bento-icon-chevron-first-left\"></i>\n      </button>\n\n      <button [disabled]=\"isDisabledLeft\" class=\"btn btn-outline-primary\"\n        ngbTooltip=\"{{ i18n('SpreadsheetTab.MoveLeft') | translate }}\" placement=\"top\" type=\"button\"\n        (click)=\"prevColumn()\">\n        <i class=\"bento-icon-chevron-left\"></i>\n      </button>\n\n      <button [disabled]=\"isDisabledRight\" class=\"btn btn-outline-primary\"\n        ngbTooltip=\"{{ i18n('SpreadsheetTab.MoveRight') | translate }}\" placement=\"top\" type=\"button\"\n        (click)=\"nextColumn()\">\n        <i class=\"bento-icon-chevron-right\"></i>\n      </button>\n\n      <button [disabled]=\"isDisabledLast\" class=\"btn btn-outline-primary\"\n        ngbTooltip=\"{{ i18n('SpreadsheetTab.MoveLast') | translate }}\" placement=\"top\" type=\"button\"\n        (click)=\"lastColumn()\">\n        <i class=\"bento-icon-chevron-last-right\"></i>\n      </button>\n    </div>\n  </div>\n  <div [ngClass]=\"[\n      'container-table',\n      dataTable.length > 4 ? 'container-table active-container' : ''\n    ]\">\n    <table *ngIf=\"dataTable.length > 0\" class=\"table table-selected-items\">\n      <tbody>\n        <tr [formGroup]=\"checkedForm\" [ngClass]=\"[dataTable.length > 10 ? 'active-row' : '']\">\n          <td class=\"classification-and-name-row\" formArrayName=\"selectedItems\" *ngFor=\"let item of formSelectedItems.controls; let i = index\">\n            <div class=\"column-wrapper\">\n              <label [for]=\"i\" class=\"chk\" [title]=\"dataTable[i].label\">\n                <input class=\"bento-input\" type=\"checkbox\" [id]=\"i\" [formControl]=\"item\" />\n                <span>{{ dataTable[i].label }}</span>\n              </label>\n              <a href=\"javascript:void(0)\" (click)=\"toEdit(modalEdit, dataTable[i], i)\" class=\"link-edit\">\n                <i class=\"bento-icon-edit\"></i>\n                {{ i18n(\"SpreadsheetTab.Edit\") | translate }}\n              </a>\n            </div>\n          </td>\n        </tr>\n        <tr *ngIf=\"tableCalculation; else emptyTable\" [ngClass]=\"[dataTable.length > 10 ? 'active-row' : '']\">\n          <td *ngFor=\"let item of dataTable; let i = index\">\n            <div>\n              <span *ngFor=\"let elem of dataTable[i].calculations; let x = index\" [ngClass]=\"['bullet', elem.class]\">\n                {{ maskBullet(elem.item.description, elem.item.percentage) }}\n              </span>\n            </div>\n          </td>\n        </tr>\n        <tr *ngIf=\"tableCalculation\" [ngClass]=\"[dataTable.length > 10 ? 'active-row' : '']\">\n          <td *ngFor=\"let item of dataTable; let i = index\" class=\"classification classification-and-name-row\">\n            {{ getLabelTranslated(item.classification) | translate }}\n          </td>\n        </tr>\n        <ng-template #emptyTable>\n          <tr>\n            <td [attr.colspan]=\"formSelectedItems.controls.length\" class=\"emptyTd\"></td>\n          </tr>\n        </ng-template>\n      </tbody>\n    </table>\n  </div>\n</div>\n", styles: [".modalEdit h3,.modalEdit p{width:100%;font-weight:400}.modalEdit h3{font-size:18px;margin-bottom:0;width:90%}.modalEdit p,.modalEdit .lbl{font-size:16px!important;width:100%}.modalEdit .row{margin:0;justify-content:space-between}.modalEdit .col-center{padding:0 15px!important}@media (max-width: 768px){.modalEdit .col-center{padding-top:14px!important}}.modalEdit .col{margin-right:20px}.modalEdit .col input[type=text]{width:89%;height:32px}@media (max-width: 768px){.modalEdit .col.txt-center{text-align:inherit}.modalEdit .col.txt-center .title{padding-left:0}}.modalEdit .btn-group{margin-bottom:14px;margin-top:4px}.modalEdit .bento-search{width:100%}.modalEdit .bento-search input{border-color:#b2b2b8;padding:0 10px 0 27px;width:100%}.modalEdit .bento-search:before{color:#b2b2b8;left:11px;top:69%;font-size:14px}.modalEdit .modal-content{width:90%!important}.modalEdit .modal-header{flex-flow:wrap;padding:0;border-bottom:0!important}.modalEdit .modal-header .btn{width:27%;padding:0 21px!important}.modalEdit .modal-header .final-result{padding:0 42px!important}.modalEdit .modal-header .row{width:100%}.modalEdit .modal-header .row .col-center div .final-result{width:220px}.modalEdit .modal-header .row .col .btn-group .quantity{padding:0 35px!important;width:155px}.modalEdit .modal-header .row-first{margin:0 0 25px}@media (max-width: 768px){.modalEdit .modal-header .row-first{display:block!important}.modalEdit .modal-header .row-first .btn{max-width:165px;font-size:11px}}.modalEdit .modal-body{margin:10px 0}.modalEdit .modal-body p{margin:0;font-family:BentoLight,arial,helvetica,sans-serif}.modalEdit .modal-footer{border-top:1px solid #fff;padding:0;flex-flow:wrap;justify-content:left}.modalEdit .modal-footer p{margin:0;font-family:BentoLight,arial,helvetica,sans-serif}.modalEdit .modal-footer .footer-btn{display:block;width:100%;margin:0;padding:0;text-align:right}.modalEdit .pd-0{padding:0!important}.modalEdit .mg-0{margin:0!important}.modalEdit .content-labels.content-variable{border:1px solid #b2b2b8;padding:5px;margin:0 0 16px}.modalEdit .content-labels.content-variable span{cursor:pointer}.modalEdit .content-labels.scroll{overflow-x:auto;width:68%;height:240px}@media (max-width: 929px){.modalEdit .content-labels.scroll{height:343px}}@media (min-width: 930px) and (max-width: 1227px){.modalEdit .content-labels.scroll{height:309px}}@media (min-width: 1228px) and (max-width: 1366px){.modalEdit .content-labels.scroll{height:273px}}.modalEdit .content-labels .box-item{display:inline-block;position:relative}.modalEdit .content-labels .box-item .del-new{text-align:center;position:absolute;right:-8px;color:#fff!important;font-size:10px;width:20px;height:20px;padding:0;line-height:22px;top:-10px;cursor:pointer;border-radius:50%;background-color:#000;font-weight:700}@-moz-document url-prefix(){.modalEdit .content-labels .box-item .del-new{height:20px}}.modalEdit .content-labels .box-item .del{text-align:center;position:absolute;right:-13px;color:#fff;font-size:10px;width:17px;height:23px;padding:0;line-height:23px;top:0;cursor:pointer;border-top-left-radius:0;border-bottom-left-radius:0}@-moz-document url-prefix(){.modalEdit .content-labels .box-item .del{height:24px}}.modalEdit .content-labels span{color:#fff;display:inline-block;margin:5px;padding:4px 10px;font-size:11px;text-transform:uppercase;border-radius:4px;border-right:solid 1px #ccc}.modalEdit .content-labels span.default{background-color:#606169;color:#fff}.modalEdit .content-labels span:last-child{border:none}.modalEdit .content-labels span:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.modalEdit .content-labels.cdk-drop-list-dragging span:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.modalEdit .content-labels.content-office-data span{background-color:#387c2b}.modalEdit .content-labels.content-clients-data span{background-color:#0072a8}.modalEdit .content-labels.content-column span{background-color:#5d1893}.modalEdit .content-labels.content-left{width:100%;border:1px solid #b2b2b8;padding:10px 5px;height:64px;white-space:nowrap}.modalEdit .content-labels.content-left span{margin:5px 15px}.modalEdit .content-labels.content-right{width:30%}.modalEdit .content-labels .content-value-insert{border:1px solid #b2b2b8;padding:0 22px}.modalEdit .content-labels .content-value-insert .form-control{margin:auto;width:100%}.modalEdit .content-labels .content-value-insert .btn-group-footer{margin:14px 0 0;display:flex;justify-content:space-between}@media (max-width: 1227px){.modalEdit .content-labels .content-value-insert .btn-group-footer{margin:14px 0;display:block}.modalEdit .content-labels .content-value-insert .btn-group-footer .btn-group-toggle{margin-right:10px}.modalEdit .content-labels .content-value-insert .btn-group-footer .ml20{margin-left:0}}@media (max-width: 1227px) and (max-width: 929px){.modalEdit .content-labels .content-value-insert .btn-group-footer .value-button{margin-bottom:10px}.modalEdit .content-labels .content-value-insert .btn-group-footer .btn-group-toggle{width:100%;display:grid}.modalEdit .content-labels .content-value-insert .btn-group-footer .btn-group-toggle .btn-outline-primary{border-radius:4px}.modalEdit .content-labels .content-value-insert .btn-group-footer .btn{width:100%}}.modalEdit .content-labels .content-value-insert span{border-right:0 solid #fff}.modalEdit .content-labels .content-value-insert .input-insert-value{width:100%;text-align:right}.modalEdit .content-labels .content-value-insert .lbl-insert-value{margin-top:10px;text-align:left;text-transform:none;color:#212121;font-family:BentoLight,arial,helvetica,sans-serif;font-size:16px;width:85%}.modalEdit .content-labels .content-operations{border:1px solid #b2b2b8;margin-top:17px;padding:0 22px}.modalEdit .content-labels .content-operations .content{width:100%;padding:15px 0}@media (max-width: 768px){.modalEdit .content-labels .content-operations .content{width:170px;margin:auto}}@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2){.modalEdit .content-labels .content-operations .content{margin:auto}}.modalEdit .content-labels .content-operations .all-operators{width:100%}@media (min-width: 1367px){.modalEdit .content-labels .content-operations .all-operators{width:300px}}.modalEdit .content-labels .content-operations .all-operators span{background-color:#ffb400;color:#000;cursor:pointer;padding:4px 10px 4px 8px;margin-right:10px;margin-left:0!important;width:20px;font-weight:700}.modalEdit .content-labels .content-operations .all-operators .lbl-operators{text-align:left;text-transform:none;color:#212121;font-family:BentoLight,arial,helvetica,sans-serif;font-size:16px;width:100%}.modalEdit .content-labels .cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.modalEdit .content-labels:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.div-main{max-width:100%}.div-main .container-table{overflow-x:auto;max-width:100%;page-break-inside:auto}.div-main .container-table.active-container{border-right:1px solid #d5d4d9}.div-main .container-table:first-child{height:36px}.div-main .container-table .actions-header{background-color:#f4f5f7;border:1px solid #d5d4d9}.div-main .container-table .actions-header button{min-width:2rem;margin:4px}.div-main .container-table .actions-header button:first-child{margin-left:8px}.div-main .container-table .table-selected-items{display:table;margin:0;border:1px solid #d5d4d9;max-width:none;max-width:initial;white-space:pre-wrap}.div-main .container-table .table-selected-items tbody,.div-main .container-table .table-selected-items tbody tr{background-color:#fff}@-moz-document url-prefix(){.div-main .container-table .table-selected-items tbody tr.active-row{display:inline-flex;width:100%}}.div-main .container-table .table-selected-items tbody tr .classification-and-name-row{height:36px}.div-main .container-table .table-selected-items tbody td{padding:0 8px;min-height:36px;border:1px solid #d5d4d9;white-space:pre-line;min-width:330px;max-width:330px;vertical-align:middle}@-moz-document url-prefix(){.div-main .container-table .table-selected-items tbody td{align-items:center}}.div-main .container-table .table-selected-items tbody td .column-wrapper{display:flex;align-items:center;justify-content:space-between;width:100%;height:100%}.div-main .container-table .table-selected-items tbody td label{cursor:pointer;font-weight:600;white-space:nowrap;margin:0;display:flex;align-items:center;width:80%}.div-main .container-table .table-selected-items tbody td label span{margin-left:5px;display:block;width:calc(100% - 100px);text-overflow:ellipsis;overflow:hidden}.div-main .container-table .table-selected-items tbody td .link-edit{color:#212121}.emptyTd{height:36px}.breakafter{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.scroll{overflow-x:auto;width:100%}.no-overflow{overflow:hidden!important}.row .content-labels{margin:0 0 16px}.row .content-calculation{display:table}.align-between{justify-content:space-between;display:flex;padding-bottom:14px}.ml20{margin-left:20px}.mr10{margin-right:10px}.mt15{margin-top:15px!important}.mt17{margin-top:17px}.mb10{margin-bottom:10px}.mb6{margin-bottom:6px}.mt10{margin-top:10px}.tab-title{margin-top:0}.classification{color:#666;font-weight:700;font-size:14px;font-family:Arial,Helvetica,sans-serif}.container-alert{position:fixed;left:0;top:35px;width:100%;display:flex;justify-content:center;z-index:9999}.btn-insert{margin-top:4px}@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2){.btn-insert{margin-left:10px}}@media (max-width: 1227px){.btn-insert{margin-top:-5px}}.bullet{color:#fff;display:inline-block;padding:4px 10px;margin:3px;font-size:11px;text-transform:uppercase;border-radius:4px;border-right:solid 1px #ccc}.bullet-office-data{background-color:#387c2b;color:#fff}.bullet-clients-data{background-color:#0072a8;color:#fff}.bullet-column{background-color:#5d1893;color:#fff}.bullet-operations,.bullet-parentheses{background-color:#ffb400;color:#000!important}.bullet-value{background-color:#d4ebf4;color:#000!important}.cdk-drag{cursor:move}.cdk-drag-placeholder{background:#ccc;border:dotted 1px #000;border-right:dotted 1px #000!important;border-left:dotted 1px #000!important;color:#000!important;opacity:.5;transition:transform .25s cubic-bezier(0,0,.2,1)}.cdk-drag-preview{z-index:9999!important;box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-preview .del{opacity:0}.line{border-bottom:.5px solid #707070;padding-bottom:16px}.instructions{margin:29px 0 0;padding:0}::ng-deep .ng-bento .modal.modal-edit .modal-dialog.modal-lg .modal-content{width:90%}@media (max-width: 768px){::ng-deep .ng-bento .modal.modal-edit .modal-dialog.modal-lg .modal-content{width:100%}}.secondLine:before{content:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }, { type: i1$2.NgbModal }, { type: i2$1.FormBuilder }, { type: SpreadsheetService }, { type: AlertService }, { type: AddCostsCalculationTemplateService }]; }, propDecorators: { templateId: [{
                type: Input
            }], onKeydownHandler: [{
                type: HostListener,
                args: ['window:keydown', ['$event']]
            }] } });

class PagedItems {
    constructor(startIndex, totalItems, totalPages, items, currentItemCount, itemsPerPage, pageIndex) {
        this.startIndex = startIndex;
        this.totalItems = totalItems;
        this.totalPages = totalPages;
        this.items = items;
        this.currentItemCount = currentItemCount;
        this.itemsPerPage = itemsPerPage;
        this.pageIndex = pageIndex;
    }
}
class PagingInfo {
    constructor(startIndex, pageIndex, itemsPerPage) {
        this.startIndex = startIndex;
        this.pageIndex = pageIndex;
        this.itemsPerPage = itemsPerPage;
    }
}
class Filters {
}

class ClientsComponent {
    constructor(modalService, clientsService, addCostsCalculationTemplateService, loaderService, translateService) {
        this.modalService = modalService;
        this.clientsService = clientsService;
        this.addCostsCalculationTemplateService = addCostsCalculationTemplateService;
        this.loaderService = loaderService;
        this.translateService = translateService;
        this.clients = [];
        this.clientsChange = new EventEmitter();
        this.actions = [];
        this.ITEMS_PAGE = 30;
        this.clientsInfo = {
            filter: {},
            isAllSelected: false,
            pagingInfo: new PagingInfo(1, 1, this.ITEMS_PAGE),
            totalItems: 0
        };
        this.clientsModalInfo = {
            filter: {},
            isAllSelected: false,
            pagingInfo: new PagingInfo(1, 1, this.ITEMS_PAGE),
            totalItems: 0
        };
        this.subscriptions = new Subscription();
        this.loaderClientsModal = this.loaderService.modalClientsLoader;
        this.loaderClients = this.loaderService.clientsLoader;
    }
    i18n(node) {
        return `Onvio.AccountingCosts.AddCostsCalculation.ClientsTab.${node}`;
    }
    ngOnInit() {
        forkJoin([this.translateService.get('Onvio.AccountingCosts.Toolbar.Add'),
            this.translateService.get('Onvio.AccountingCosts.Toolbar.Remove')])
            .subscribe(([add, remove]) => {
            this.actions = [{
                    action: () => this.openModalAndRegisterEvents(),
                    icon: 'bento-icon-add',
                    label: add
                }, {
                    action: () => this.removeClients(),
                    icon: 'bento-icon-remove',
                    label: remove,
                    disabled: true
                }];
        });
        if (this.clients.length === 0) {
            this.loadSelectedClients();
        }
    }
    onSearch(value) {
        this.clients = [];
        this.clientsInfo.filter.search = value;
        this.clientsInfo.pagingInfo.startIndex = 1;
        this.loadSelectedClients();
    }
    onSelectAll(isAllSelected) {
        this.clientsInfo.isAllSelected = isAllSelected;
        this.changeRemoveButtonStatus(!isAllSelected);
    }
    onEndScroll() {
        if (this.clientsInfo.totalItems > this.clients.length && !this.loaderClients.state) {
            this.clientsInfo.pagingInfo.startIndex += this.ITEMS_PAGE;
            this.loadSelectedClients();
        }
    }
    onSelect() {
        this.changeRemoveButtonStatus(this.clients.every(client => !client.state));
        this.clientsInfo.isAllSelected = false;
    }
    removeClients() {
        const selectedIds = this.addCostsCalculationTemplateService.getSelectedClientsId();
        const idsToRemove = this.clients.filter(client => client.state).map(client => client.id);
        idsToRemove.forEach(id => {
            selectedIds.splice(selectedIds.indexOf(id), 1);
        });
        this.addCostsCalculationTemplateService.setSelectedClientsId(selectedIds);
        this.changeRemoveButtonStatus(true);
        this.reset();
        this.loadSelectedClients();
        this.clientsChange.emit(this.clients);
    }
    loadSelectedClients() {
        const clientsIds = this.addCostsCalculationTemplateService.getSelectedClientsId();
        this.loaderClients.show();
        this.clientsService.findClientsPage(clientsIds, this.clientsInfo.pagingInfo, this.clientsInfo.filter)
            .subscribe((companyClients) => {
            this.clientsInfo.totalItems = companyClients.totalItems;
            this.clients = [...this.clients, ...this.formatCompanyClients(companyClients.items)];
            if (!this.clientsInfo.filter.search) {
                this.clientsChange.emit(this.clients);
            }
            this.loaderClients.hide();
        }, () => this.loaderClients.hide());
    }
    openModalAndRegisterEvents() {
        this.subscriptions = new Subscription();
        this.loaderClientsModal.show();
        this.modalRef = this.modalService.open(ClientsModalComponent, {
            container: '#bentoNGModalContainer'
        });
        this.resetModal();
        this.populateModal();
        this.registerModalEndScrollEvent();
        this.registerModalSearchEvent();
        this.registerModalSelectAllEvent();
        this.registerModalSelectEvent();
        this.modalRef.result.then(result => {
            this.populateTable(result);
        }, () => this.subscriptions.unsubscribe());
    }
    resetModal() {
        this.clientsModalInfo.pagingInfo.startIndex = 1;
        this.clientsModalInfo.filter = {};
    }
    reset() {
        this.clients = [];
        this.clientsInfo.isAllSelected = false;
        this.clientsInfo.pagingInfo.startIndex = 1;
        this.clientsInfo.filter = {};
    }
    populateTable(result) {
        if (!result) {
            return;
        }
        this.reset();
        let clientsIds = this.addCostsCalculationTemplateService.getSelectedClientsId();
        const formattedResult = this.formatCompanyClients(result);
        this.clients = [];
        clientsIds = [...clientsIds, ...formattedResult.map(client => client.id)];
        this.addCostsCalculationTemplateService.setSelectedClientsId(clientsIds);
        this.loadSelectedClients();
        this.subscriptions.unsubscribe();
    }
    registerModalSelectEvent() {
        this.subscriptions.add(this.modalRef.componentInstance.selectObs.subscribe((allSelected) => {
            this.clientsModalInfo.isAllSelected = allSelected;
        }));
    }
    populateModal() {
        const clientsIds = this.addCostsCalculationTemplateService.getSelectedClientsId();
        this.subscriptions.add(this.clientsService.findClientsExcluding(clientsIds, this.clientsModalInfo.pagingInfo)
            .subscribe((companyClients) => {
            this.modalRef.componentInstance.totalItems = companyClients.totalItems;
            this.modalRef.componentInstance.clients = this.formatCompanyClients(companyClients.items);
            this.loaderClientsModal.hide();
        }, () => this.loaderClientsModal.hide()));
    }
    registerModalSearchEvent() {
        const clientsIds = this.addCostsCalculationTemplateService.getSelectedClientsId();
        this.subscriptions.add(this.modalRef.componentInstance.searchObs.pipe(switchMap((value) => {
            this.loaderClientsModal.show();
            this.clientsModalInfo.filter = {
                search: value
            };
            this.clientsModalInfo.pagingInfo.startIndex = 1;
            this.modalRef.componentInstance.clients = [];
            return this.clientsService
                .findClientsExcluding(clientsIds, this.clientsModalInfo.pagingInfo, this.clientsModalInfo.filter);
        })).subscribe((companyClients) => {
            this.modalRef.componentInstance.clients =
                this.formatCompanyClients(companyClients.items);
            this.loaderClientsModal.hide();
        }, () => this.loaderClientsModal.hide()));
    }
    registerModalSelectAllEvent() {
        this.subscriptions.add(this.modalRef.componentInstance.selectAllObs.
            subscribe((isAllSelected) => this.clientsModalInfo.isAllSelected = isAllSelected));
    }
    registerModalEndScrollEvent() {
        const clientsIds = this.addCostsCalculationTemplateService.getSelectedClientsId();
        this.subscriptions.add(this.modalRef.componentInstance.endScrollObs.pipe(switchMap(() => {
            this.loaderClientsModal.show();
            this.clientsModalInfo.pagingInfo.startIndex += this.ITEMS_PAGE;
            return this.clientsService
                .findClientsExcluding(clientsIds, this.clientsModalInfo.pagingInfo, this.clientsModalInfo.filter);
        })).subscribe((companyClients) => {
            this.modalRef.componentInstance.clients =
                [...this.modalRef.componentInstance.clients,
                    ...this.formatCompanyClients(companyClients.items)];
            this.loaderClientsModal.hide();
        }, () => this.loaderClientsModal.hide()));
    }
    changeRemoveButtonStatus(isDisabled) {
        const [add, remove] = this.actions;
        this.actions = [Object.assign({}, add), Object.assign(Object.assign({}, remove), { disabled: isDisabled })];
    }
    formatCompanyClients(clients) {
        if (!clients) {
            return [];
        }
        return clients.map(item => {
            return {
                code: item.code,
                id: item.id,
                name: item.name,
                state: false
            };
        });
    }
    get getClientsInfo() {
        return this.clientsInfo;
    }
}
ClientsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientsComponent, deps: [{ token: i1$2.NgbModal }, { token: ClientsService }, { token: AddCostsCalculationTemplateService }, { token: LoaderService }, { token: i1$1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
ClientsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ClientsComponent, selector: "acc-clients", inputs: { clients: "clients" }, outputs: { clientsChange: "clientsChange" }, ngImport: i0, template: "<h3 class=\"tab-title\">{{ i18n('ClientsTitle') | translate }}</h3>\n<p>{{ i18n('SelectWhichClients') | translate }}</p>\n<div class=\"client-table\">\n  <acc-table-clients class=\"clients-table\" [bentoBusyLoader]=\"loaderClients.state\" [clients]=\"clients\" [actions]=\"actions\" (endScroll)=\"onEndScroll()\"\n    (search)=\"onSearch($event)\" (select)=\"onSelect()\" (selectAll)=\"onSelectAll($event)\"></acc-table-clients>\n</div>\n", styles: [".tab-title{margin-top:0}.clients-table{display:block}.clients-table ::ng-deep .bento-busyloader-front-blocker{background:0}.clients-table ::ng-deep .ng-bento .wj-content{height:calc(100vh - 320px)}\n"], components: [{ type: TableClientsComponent, selector: "acc-table-clients", inputs: ["actions", "clients"], outputs: ["endScroll", "select", "selectAll", "search"] }], directives: [{ type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["size", "showDelay", "hideDelay", "bentoBusyLoader"], outputs: ["show", "hide"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-clients', template: "<h3 class=\"tab-title\">{{ i18n('ClientsTitle') | translate }}</h3>\n<p>{{ i18n('SelectWhichClients') | translate }}</p>\n<div class=\"client-table\">\n  <acc-table-clients class=\"clients-table\" [bentoBusyLoader]=\"loaderClients.state\" [clients]=\"clients\" [actions]=\"actions\" (endScroll)=\"onEndScroll()\"\n    (search)=\"onSearch($event)\" (select)=\"onSelect()\" (selectAll)=\"onSelectAll($event)\"></acc-table-clients>\n</div>\n", styles: [".tab-title{margin-top:0}.clients-table{display:block}.clients-table ::ng-deep .bento-busyloader-front-blocker{background:0}.clients-table ::ng-deep .ng-bento .wj-content{height:calc(100vh - 320px)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }, { type: ClientsService }, { type: AddCostsCalculationTemplateService }, { type: LoaderService }, { type: i1$1.TranslateService }]; }, propDecorators: { clients: [{
                type: Input
            }], clientsChange: [{
                type: Output
            }] } });

class AddCostsCalculationTemplateComponent extends HybridRouterComponent {
    constructor(accountingCostsTemplateService, translationService, alertService, addCostsCalculationTemplateService, fb, clientsService, loaderService, routerService, accountingCostsService) {
        super(routerService);
        this.accountingCostsTemplateService = accountingCostsTemplateService;
        this.translationService = translationService;
        this.alertService = alertService;
        this.addCostsCalculationTemplateService = addCostsCalculationTemplateService;
        this.fb = fb;
        this.clientsService = clientsService;
        this.clients = [];
        this.i18nBaseKey = 'Onvio.AccountingCosts.AddCostsCalculation';
        this.saveTemplate$ = new Subject();
        accountingCostsService.setLanguage();
        this.loadingEditBusyLoader = loaderService.editLoader;
        this.saveSubscription = this.saveTemplate$.pipe(debounceTime(500), exhaustMap(() => {
            this.save();
            return of();
        })).subscribe();
    }
    ngOnInit() {
        super.ngOnInit();
        this.translationService
            .getTranslation('LoadTemplateError', this.i18nBaseKey)
            .pipe(first())
            .subscribe(errorMessage => {
            this.errorMessage = errorMessage;
        });
        this.initTemplate();
        this.generalForm = this.fb.group({
            code: ['', [Validators.required, Validators.maxLength(10)]],
            name: ['', [Validators.required, Validators.maxLength(200)]]
        });
    }
    i18n(node) {
        return `${this.i18nBaseKey}.${node}`;
    }
    onItemsSelected(v) {
        this.selectedItems = v;
    }
    requestSave() {
        this.saveTemplate$.next();
    }
    save() {
        if (this.isValidCalculationModel()) {
            this.loadingEditBusyLoader.show();
            const model = this.addCostsCalculationTemplateService.getCalculationModel();
            const subscribable = !model.id ?
                this.accountingCostsTemplateService
                    .post(model) :
                this.accountingCostsTemplateService
                    .put(model);
            subscribable
                .pipe(first())
                .subscribe({
                next: () => {
                    this.addCostsCalculationTemplateService.resetState();
                    this.routerService.setRoute(new CostsCalculationTemplateListRoute());
                    this.loadingEditBusyLoader.hide();
                },
                error: err => {
                    if (err && err.error) {
                        const exceptionType = JSON.parse(err.error).exceptionType;
                        this.showError(this.getErrorByExceptionType(exceptionType));
                    }
                    this.loadingEditBusyLoader.hide();
                }
            });
        }
    }
    cancel() {
        this.alertService.cleanAlerts();
        this.addCostsCalculationTemplateService.resetState();
        this.routerService.setRoute(new CostsCalculationTemplateListRoute());
    }
    getErrorByExceptionType(exceptionType) {
        return (!!exceptionType && exceptionType === ErrorType.INVALID_FORMULA) ?
            'SpreadsheetTab.Errors.InvalidFormula' :
            'SaveTemplateError';
    }
    hasName() {
        return !!this.addCostsCalculationTemplateService.getName();
    }
    hasCode() {
        return !!this.addCostsCalculationTemplateService.getCode();
    }
    columnHasFomula(column) {
        return column.calculations && column.calculations.length > 0;
    }
    classificationIs(column, classificationType) {
        return column.classification === classificationType;
    }
    hasColumnWithoutFormula() {
        const dataGrid = this.addCostsCalculationTemplateService.getSpreadsheetValue('dataGrid');
        return dataGrid && !dataGrid.every(this.columnHasFomula);
    }
    hasOneFinalResult() {
        const dataGrid = this.addCostsCalculationTemplateService.getSpreadsheetValue('dataGrid');
        return (dataGrid &&
            dataGrid.filter(column => this.classificationIs(column, 'FINAL_RESULT'))
                .length === 1);
    }
    isValidCalculationModel() {
        this.alertService.cleanAlerts();
        if (!this.hasCode()) {
            this.showPersistentError('Form.Errors.Required.ID');
        }
        if (!this.hasName()) {
            this.generalForm.get('name').markAsTouched();
            this.generalForm.get('name').markAsDirty();
            this.showPersistentError('Form.Errors.Required.Name');
        }
        if (!this.hasSelectedClients()) {
            this.showPersistentError('ClientsTab.NoClientsSelected');
        }
        if (this.hasColumnWithoutFormula()) {
            this.showPersistentError('SpreadsheetTab.Errors.RequiredFormula');
        }
        if (!this.hasOneFinalResult()) {
            this.showPersistentError('SpreadsheetTab.Errors.RequiredFinalResult');
        }
        if (this.alertService.getAlerts().length > 0) {
            return false;
        }
        else {
            return true;
        }
    }
    showError(errorMessage) {
        this.translationService
            .getTranslation(errorMessage, this.i18nBaseKey)
            .pipe(first())
            .subscribe(message => {
            this.addError(message);
        });
    }
    showPersistentError(errorMessage) {
        this.translationService
            .getTranslation(errorMessage, this.i18nBaseKey)
            .pipe(first())
            .subscribe(message => {
            this.addPersistentError(message);
        });
    }
    hasIdAndName() {
        return (this.addCostsCalculationTemplateService.getCode() &&
            this.addCostsCalculationTemplateService.getName());
    }
    hasSelectedClients() {
        return (this.addCostsCalculationTemplateService.getSelectedClientsId() &&
            this.addCostsCalculationTemplateService.getSelectedClientsId().length > 0);
    }
    initTemplate() {
        if (this.templateId) {
            this.loadingEditBusyLoader.show();
            this.accountingCostsTemplateService
                .get(this.templateId)
                .pipe(take(1))
                .subscribe({
                next: template => {
                    this.addCostsCalculationTemplateService.setStateFromTemplate(template);
                    this.generalForm.get('code').setValue(template.code);
                    this.generalForm.get('name').setValue(template.name);
                    this.loadingEditBusyLoader.hide();
                },
                error: () => {
                    this.addError(this.errorMessage);
                    this.routerService.setRoute(new CostsCalculationTemplateListRoute());
                }
            });
        }
        else {
            this.addCostsCalculationTemplateService.loadState();
        }
    }
    onClientsChange(clients) {
        this.clients = clients;
    }
    addError(msg) {
        this.alertService.addAlert({
            type: 'danger',
            closeable: true,
            timeout: 5000,
            msg
        });
    }
    addPersistentError(msg) {
        this.alertService.addAlert({
            type: 'danger',
            closeable: true,
            msg
        });
    }
    ngOnDestroy() {
        this.saveSubscription.unsubscribe();
    }
}
AddCostsCalculationTemplateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AddCostsCalculationTemplateComponent, deps: [{ token: AccountingCostsCalculationTemplateService }, { token: TranslationService }, { token: AlertService }, { token: AddCostsCalculationTemplateService }, { token: i2$1.FormBuilder }, { token: ClientsService }, { token: LoaderService }, { token: RouterService }, { token: AccountingCostsService }], target: i0.ɵɵFactoryTarget.Component });
AddCostsCalculationTemplateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: AddCostsCalculationTemplateComponent, selector: "acc-add-costs-calculation-template", inputs: { templateId: "templateId" }, usesInheritance: true, ngImport: i0, template: "<acc-alert></acc-alert>\n<div class=\"ng-bento main-container\">\n  <div class=\"setup-page-header\">\n    <h1>{{ i18n(\"AddTemplate\") | translate }}</h1>\n    <nav>\n      <button type=\"button\" class=\"btn btn-primary\" (click)=\"requestSave()\"\n        [disabled]=\"this.loadingEditBusyLoader.state\">\n        {{ i18n(\"Save\") | translate }}\n      </button>\n      <button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"cancel()\">\n        {{ i18n(\"Cancel\") | translate }}\n      </button>\n    </nav>\n  </div>\n\n  <section class=\"content ng-bento\" [bentoBusyLoader]=\"loadingEditBusyLoader.state\"\n    [ngStyle]=\"{'height': loadingEditBusyLoader.state ? 'calc(100vh - 180px)' : ''}\">\n    <div class=\"bento-tabset tabs-left\">\n      <ul ngbNav #myNav=\"ngbNav\" class=\"nav nav-tabs\">\n        <li [ngbNavItem]=\"1\"><a ngbNavLink>{{ i18n(\"General\") | translate }}</a>\n          <ng-template ngbNavContent>\n            <div class=\"general\">\n              <acc-general [templateId]=\"templateId\" [generalForm]=\"generalForm\"></acc-general>\n            </div>\n          </ng-template>\n        </li>\n        <li [ngbNavItem]=\"2\"><a ngbNavLink>{{ i18n(\"Spreadsheet\") | translate }}</a>\n          <ng-template ngbNavContent>\n            <div class=\"spreadsheet\">\n              <acc-spreadsheet [templateId]=\"templateId\"></acc-spreadsheet>\n            </div>\n          </ng-template>\n        </li>\n        <li [ngbNavItem]=\"3\"><a ngbNavLink>{{ i18n(\"Clients\") | translate }}</a>\n          <ng-template ngbNavContent>\n            <div class=\"clients\">\n              <acc-clients (clientsChange)=\"onClientsChange($event)\" [clients]=\"clients\"></acc-clients>\n            </div>\n          </ng-template>\n        </li>\n      </ul>\n      <div [ngbNavOutlet]=\"myNav\" class=\"tab-content\"></div>\n    </div>\n  </section>\n</div>", styles: [".setup-page-header{background:#f4f5f7;height:60px;display:flex;justify-content:space-between;padding:0 20px;align-items:center}.setup-page-header .btn-primary{margin-right:10px}.tabset>ul{height:100vh}.main-container section{overflow:hidden}.main-container ::ng-deep .nav-tabs>li{width:120px}.content{padding:30px}.content .spreadsheet .add-button{margin:0;padding-left:4px}.content .general h3,.content .spreadsheet h3,.content .clients h3{margin-top:0}.content .spreadsheet,.content .clients{width:calc(100vw - 177px)}\n"], components: [{ type: AlertComponent, selector: "acc-alert" }, { type: GeneralComponent, selector: "acc-general", inputs: ["templateId", "generalForm"] }, { type: SpreadsheetComponent, selector: "acc-spreadsheet", inputs: ["templateId"] }, { type: ClientsComponent, selector: "acc-clients", inputs: ["clients"], outputs: ["clientsChange"] }, { type: i1$2.NgbNavOutlet, selector: "[ngbNavOutlet]", inputs: ["paneRole", "ngbNavOutlet"] }], directives: [{ type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["size", "showDelay", "hideDelay", "bentoBusyLoader"], outputs: ["show", "hide"] }, { type: i4.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i1$2.NgbNav, selector: "[ngbNav]", inputs: ["animation", "destroyOnHide", "orientation", "roles", "keyboard", "activeId"], outputs: ["activeIdChange", "shown", "hidden", "navChange"], exportAs: ["ngbNav"] }, { type: i1$2.NgbNavItem, selector: "[ngbNavItem]", inputs: ["disabled", "domId", "destroyOnHide", "ngbNavItem"], outputs: ["shown", "hidden"], exportAs: ["ngbNavItem"] }, { type: i1$2.NgbNavLink, selector: "a[ngbNavLink]" }, { type: i1$2.NgbNavContent, selector: "ng-template[ngbNavContent]" }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AddCostsCalculationTemplateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-add-costs-calculation-template', template: "<acc-alert></acc-alert>\n<div class=\"ng-bento main-container\">\n  <div class=\"setup-page-header\">\n    <h1>{{ i18n(\"AddTemplate\") | translate }}</h1>\n    <nav>\n      <button type=\"button\" class=\"btn btn-primary\" (click)=\"requestSave()\"\n        [disabled]=\"this.loadingEditBusyLoader.state\">\n        {{ i18n(\"Save\") | translate }}\n      </button>\n      <button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"cancel()\">\n        {{ i18n(\"Cancel\") | translate }}\n      </button>\n    </nav>\n  </div>\n\n  <section class=\"content ng-bento\" [bentoBusyLoader]=\"loadingEditBusyLoader.state\"\n    [ngStyle]=\"{'height': loadingEditBusyLoader.state ? 'calc(100vh - 180px)' : ''}\">\n    <div class=\"bento-tabset tabs-left\">\n      <ul ngbNav #myNav=\"ngbNav\" class=\"nav nav-tabs\">\n        <li [ngbNavItem]=\"1\"><a ngbNavLink>{{ i18n(\"General\") | translate }}</a>\n          <ng-template ngbNavContent>\n            <div class=\"general\">\n              <acc-general [templateId]=\"templateId\" [generalForm]=\"generalForm\"></acc-general>\n            </div>\n          </ng-template>\n        </li>\n        <li [ngbNavItem]=\"2\"><a ngbNavLink>{{ i18n(\"Spreadsheet\") | translate }}</a>\n          <ng-template ngbNavContent>\n            <div class=\"spreadsheet\">\n              <acc-spreadsheet [templateId]=\"templateId\"></acc-spreadsheet>\n            </div>\n          </ng-template>\n        </li>\n        <li [ngbNavItem]=\"3\"><a ngbNavLink>{{ i18n(\"Clients\") | translate }}</a>\n          <ng-template ngbNavContent>\n            <div class=\"clients\">\n              <acc-clients (clientsChange)=\"onClientsChange($event)\" [clients]=\"clients\"></acc-clients>\n            </div>\n          </ng-template>\n        </li>\n      </ul>\n      <div [ngbNavOutlet]=\"myNav\" class=\"tab-content\"></div>\n    </div>\n  </section>\n</div>", styles: [".setup-page-header{background:#f4f5f7;height:60px;display:flex;justify-content:space-between;padding:0 20px;align-items:center}.setup-page-header .btn-primary{margin-right:10px}.tabset>ul{height:100vh}.main-container section{overflow:hidden}.main-container ::ng-deep .nav-tabs>li{width:120px}.content{padding:30px}.content .spreadsheet .add-button{margin:0;padding-left:4px}.content .general h3,.content .spreadsheet h3,.content .clients h3{margin-top:0}.content .spreadsheet,.content .clients{width:calc(100vw - 177px)}\n"] }]
        }], ctorParameters: function () { return [{ type: AccountingCostsCalculationTemplateService }, { type: TranslationService }, { type: AlertService }, { type: AddCostsCalculationTemplateService }, { type: i2$1.FormBuilder }, { type: ClientsService }, { type: LoaderService }, { type: RouterService }, { type: AccountingCostsService }]; }, propDecorators: { templateId: [{
                type: Input
            }] } });

class EllipsisPipe {
    transform(val, args) {
        if (args === undefined || args === null || !args) {
            return val;
        }
        if (val === undefined || val === null) {
            return (val = '');
        }
        if (val.length > args) {
            return val.substring(0, args) + '...';
        }
        else {
            return val;
        }
    }
}
EllipsisPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EllipsisPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
EllipsisPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EllipsisPipe, name: "ellipsis" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EllipsisPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'ellipsis'
                }]
        }] });

const customCurrencyMaskConfig = {
    align: 'right',
    allowNegative: false,
    decimal: ',',
    precision: 2,
    prefix: '',
    suffix: '',
    thousands: '.',
};
class AddCostsCalculationTemplateModule {
}
AddCostsCalculationTemplateModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AddCostsCalculationTemplateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AddCostsCalculationTemplateModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AddCostsCalculationTemplateModule, declarations: [ClientsComponent,
        AddCostsCalculationTemplateComponent,
        GeneralComponent,
        SpreadsheetComponent,
        FilterPipe,
        EllipsisPipe,
        DroplistComponent], imports: [CommonModule$1,
        BentoModule,
        NgbModule,
        DragDropModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        BfmModule, i1$4.NgxMaskModule, SharedModule,
        CommonModule,
        CurrencyMaskModule], exports: [AddCostsCalculationTemplateComponent, DragDropModule] });
AddCostsCalculationTemplateModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AddCostsCalculationTemplateModule, providers: [
        { provide: CURRENCY_MASK_CONFIG, useValue: customCurrencyMaskConfig },
    ], imports: [[
            CommonModule$1,
            BentoModule,
            NgbModule,
            DragDropModule,
            TranslateModule,
            FormsModule,
            ReactiveFormsModule,
            BfmModule,
            NgxMaskModule.forChild(),
            SharedModule,
            CommonModule,
            CurrencyMaskModule,
        ], DragDropModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AddCostsCalculationTemplateModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ClientsComponent,
                        AddCostsCalculationTemplateComponent,
                        GeneralComponent,
                        SpreadsheetComponent,
                        FilterPipe,
                        EllipsisPipe,
                        DroplistComponent,
                    ],
                    imports: [
                        CommonModule$1,
                        BentoModule,
                        NgbModule,
                        DragDropModule,
                        TranslateModule,
                        FormsModule,
                        ReactiveFormsModule,
                        BfmModule,
                        NgxMaskModule.forChild(),
                        SharedModule,
                        CommonModule,
                        CurrencyMaskModule,
                    ],
                    providers: [
                        { provide: CURRENCY_MASK_CONFIG, useValue: customCurrencyMaskConfig },
                    ],
                    exports: [AddCostsCalculationTemplateComponent, DragDropModule]
                }]
        }] });

const dateValidator = (datePattern) => {
    return (control) => {
        const parsedDate = parse(control.value, datePattern, new Date());
        const isValid = !isNaN(parsedDate.getTime());
        if (isValid) {
            return null;
        }
        else {
            return { date: true };
        }
    };
};

class BasisInputComponent {
    constructor(translationService) {
        this.translationService = translationService;
        this.validations = {
            date: '',
            required: ''
        };
        this.i18nBaseKey = 'Onvio.AccountingCosts.BasisInput';
    }
    ngOnInit() {
        this.translationService.getTranslations(['Placeholder', 'Mask', 'DatePattern', 'Errors.Invalid', 'Errors.Required'], this.i18nBaseKey)
            .subscribe(([placeholder, mask, datePattern, date, required]) => {
            this.placeholder = placeholder;
            this.mask = mask;
            this.datePattern = datePattern;
            this.validations.date = date;
            this.validations.required = required;
            const validators = this.control.validator ? [this.control.validator] : [];
            validators.push(dateValidator(this.datePattern));
            this.control.setValidators(validators);
        });
    }
    i18n(relativeKey) {
        return this.translationService.composeKey(this.i18nBaseKey, relativeKey);
    }
    isLoaded() {
        return !!this.control && !!this.control.value;
    }
}
BasisInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BasisInputComponent, deps: [{ token: TranslationService }], target: i0.ɵɵFactoryTarget.Component });
BasisInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: BasisInputComponent, selector: "acc-basis-input", inputs: { control: "control" }, ngImport: i0, template: "<div class=\"ng-bento form-group\" *ngIf=\"!!control\">\n  <label for=\"basis-input\">{{i18n('Label') | translate}}</label>\n\n  <!-- [validation]=\"false\" disables ngx-mask validation-->\n\n  <input *ngIf=\"mask\"\n    bfmField\n    [bfmLabel]=\"i18n('Label') | translate\"\n    class=\"bento-input form-control\"\n    id=\"basis-input\"\n    name=\"basis-input\"\n    [placeholder]=\"placeholder\"\n    type=\"text\"\n    [errorContainer]=\"basisErrorContainer\"\n    [validations]=\"validations\"\n    [formControl]=\"control\"\n    [value]=\"control.value\"\n    [mask]=\"mask\"\n    [validation]=\"false\"\n    [dropSpecialCharacters]=\"false\">\n  <bfm-error-container #basisErrorContainer></bfm-error-container>\n</div>\n\n", styles: [".form-control{width:120px}\n"], components: [{ type: i2$3.BfmErrorContainerComponent, selector: "bfm-error-container", inputs: ["errors"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i2$3.BfmFieldDirective, selector: "[bfmField]", inputs: ["muteAutoLabel", "setAutoGenerateId", "validations", "errorTemplate", "errorContainerTemplate", "errorContainer", "validateOnBlurOnly", "instantValidation", "showFieldLevelErrorContainer", "muteError", "showErrorIndicator", "bfmLabel", "resetToDefaultErrorTemplate", "resetToDefaultErrorContainerTemplate"], outputs: ["errorHandler", "fieldValidate"] }, { type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i1$4.MaskDirective, selector: "[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BasisInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-basis-input', template: "<div class=\"ng-bento form-group\" *ngIf=\"!!control\">\n  <label for=\"basis-input\">{{i18n('Label') | translate}}</label>\n\n  <!-- [validation]=\"false\" disables ngx-mask validation-->\n\n  <input *ngIf=\"mask\"\n    bfmField\n    [bfmLabel]=\"i18n('Label') | translate\"\n    class=\"bento-input form-control\"\n    id=\"basis-input\"\n    name=\"basis-input\"\n    [placeholder]=\"placeholder\"\n    type=\"text\"\n    [errorContainer]=\"basisErrorContainer\"\n    [validations]=\"validations\"\n    [formControl]=\"control\"\n    [value]=\"control.value\"\n    [mask]=\"mask\"\n    [validation]=\"false\"\n    [dropSpecialCharacters]=\"false\">\n  <bfm-error-container #basisErrorContainer></bfm-error-container>\n</div>\n\n", styles: [".form-control{width:120px}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslationService }]; }, propDecorators: { control: [{
                type: Input
            }] } });

class AccountingCostsCalculationService {
    constructor(http) {
        this.http = http;
    }
    calculate(calculationTemplateId, clientsIds, basis) {
        const uri = `/api/accountant-cost/v1/calculation-model/${calculationTemplateId}/request-calculation`;
        const body = {
            clientsIds,
            basis: format(basis, 'yyyy-MM')
        };
        return this.http.post(uri, body);
    }
}
AccountingCostsCalculationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsCalculationService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
AccountingCostsCalculationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsCalculationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsCalculationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class DateFormatterService {
    constructor(translationService) {
        this.translationService = translationService;
    }
    parseYearMonth(dateStr) {
        return this.translationService.getTranslation('Onvio.AccountingCosts.BasisInput.DatePattern')
            .pipe(map((value) => {
            return parse(dateStr, value, new Date());
        }));
    }
    formatYearMonth(date) {
        return this.translationService.getTranslation('Onvio.AccountingCosts.BasisInput.DatePattern')
            .pipe(map((value) => {
            return format(date, value);
        }));
    }
    formatDateTime(date) {
        return this.translationService.getTranslation('Onvio.AccountingCosts.DateTimePattern')
            .pipe(map((value) => format(date, value)));
    }
    formatUtcDate(dateStr) {
        return this.formatDateTime(new Date(dateStr.replace('-', '/').replace('T', ' ') + ' UTC'));
    }
    formatYearMonthIso(date) {
        return format(date, 'MM-yyyy');
    }
}
DateFormatterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DateFormatterService, deps: [{ token: TranslationService }], target: i0.ɵɵFactoryTarget.Injectable });
DateFormatterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DateFormatterService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DateFormatterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: TranslationService }]; } });

class UserPreferenceService {
    constructor(http) {
        this.http = http;
    }
    getPreferences(application, category) {
        const params = new HttpParams()
            .append('application', application)
            .append('category', category);
        return this.http.get(`${API_PREFERENCES}`, { params });
    }
    postPreference(application, category, value) {
        const newPreference = {
            application,
            category,
            value
        };
        return this.http.post(`${API_PREFERENCES}`, newPreference);
    }
    patchPreference(id, value) {
        const body = { value };
        return this.http.patch(`${API_PREFERENCES}/${id}`, body);
    }
}
UserPreferenceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: UserPreferenceService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
UserPreferenceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: UserPreferenceService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: UserPreferenceService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class AccountingCostsUserPreferencesService {
    constructor(userPreferenceService, dateService, templateService) {
        this.userPreferenceService = userPreferenceService;
        this.dateService = dateService;
        this.templateService = templateService;
    }
    getFilters(category) {
        return this.userPreferenceService.getPreferences('accounting-costs', category);
    }
    postFilters(category) {
        return forkJoin([
            this.getCurrentDateObs(),
            this.getFirstModelObs()
        ]).pipe(take(1), switchMap(([date, model]) => {
            const filters = {
                selectedBasisDate: date,
                selectedTemplate: model.items[0]
            };
            return this.userPreferenceService.postPreference('accounting-costs', category, filters);
        }));
    }
    patchFilters(filters, id) {
        this.userPreferenceService.patchPreference(id, filters).subscribe();
    }
    getCurrentDateObs() {
        return this.dateService.formatYearMonth(new Date());
    }
    getFirstModelObs() {
        const paging = new PagingInfo(0, 0, 1);
        const orderFilter = new Filters();
        orderFilter.orderBy = 'code asc';
        return this.templateService.getAll(paging, orderFilter);
    }
}
AccountingCostsUserPreferencesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsUserPreferencesService, deps: [{ token: UserPreferenceService }, { token: DateFormatterService }, { token: AccountingCostsCalculationTemplateService }], target: i0.ɵɵFactoryTarget.Injectable });
AccountingCostsUserPreferencesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsUserPreferencesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsUserPreferencesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: UserPreferenceService }, { type: DateFormatterService }, { type: AccountingCostsCalculationTemplateService }]; } });

class CalculationTemplateComboboxComponent {
    constructor(service, routerService, translateService) {
        this.service = service;
        this.routerService = routerService;
        this.translateService = translateService;
        this.comboboxOptions = {
            columns: [
                { name: 'code' },
                { name: 'name' }
            ],
            headerTranslation: {
                code: this.translateService.instant('Onvio.AccountingCosts.Costs.Combobox.ID'),
                name: this.translateService.instant('Onvio.AccountingCosts.Costs.Combobox.Template'),
            },
            searchable: true,
            useServerSearch: true,
            debounceTime: 300,
            labelFormatter: (template) => {
                return `${template.code}, ${template.name}`;
            }
        };
        this.filteredData = [];
        /**
         * Block size for each data return
         */
        this.blockSize = 25;
    }
    ngOnInit() {
        this.reset();
    }
    i18n(node) {
        return `Onvio.AccountingCosts.CalculationTemplateCombobox.${node}`;
    }
    getData({ search, index, size }) {
        const pagingInfo = new PagingInfo(index, null, this.blockSize);
        const filters = new Filters();
        filters.orderBy = 'code asc';
        return this.service.getAll(pagingInfo, filters);
    }
    /**
     * Callback called to search items using the backend service,
     * triggered when text is typed in the combobox.
     */
    searchDataOnType(e) {
        this.filterDataStream(e.search);
    }
    filterDataStream(value = '') {
        if (!!this.data && !!this.data.items) {
            this.filteredData = this.data.items.filter(element => element.name.toUpperCase().includes(value.toUpperCase()) ||
                element.code.toString().toUpperCase().includes(value.toUpperCase()));
            this.dataStream = new BehaviorSubject(this.filteredData);
        }
    }
    /**
     * Callback called when end of scroll is reached in the dropdown list.
     * The Bento combobox will add the nex page of items to the end of the currently displayed list.
     * The former items are kept until the "text search" or "reset" callbacks are triggered.
     */
    onEndOfScroll(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const pageInfo = {
                search: e.search,
                index: e.currentIndex,
                size: this.blockSize
            };
            let nextBlock;
            this.getData(pageInfo)
                .pipe(first())
                .subscribe({
                next: data => {
                    nextBlock = data;
                    if (!!nextBlock && !!nextBlock.items && !!nextBlock.items.length) {
                        this.dataStream.next(nextBlock.items);
                    }
                }
            });
        });
    }
    /**
     * Callback that resets the data in the combobox to its initial state.
     */
    reset() {
        const pageInfo = {
            search: null,
            index: 0,
            size: this.blockSize
        };
        this.getData(pageInfo).subscribe(data => {
            this.data = data;
            this.dataStream = new BehaviorSubject(this.data.items);
        });
    }
    openEditTemplatePage() {
        if (this.control.valid) {
            this.routerService.setRoute(new AddCostsCalculationRoute({
                templateId: this.control.value.id
            }));
        }
    }
}
CalculationTemplateComboboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CalculationTemplateComboboxComponent, deps: [{ token: AccountingCostsCalculationTemplateService }, { token: RouterService }, { token: i1$1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
CalculationTemplateComboboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: CalculationTemplateComboboxComponent, selector: "acc-calculation-template-combobox", inputs: { control: "control" }, ngImport: i0, template: "<div class=\"ng-bento form-group alignment-fisrt\" *ngIf=\"!!control\">\n  <label>\n    {{ i18n(\"Label\") | translate }}\n  </label>\n  <div class=\"input-group\">\n    <bento-combobox bfmField\n                    id=\"calculation-template-combobox\"\n                    name=\"calculation-template-combobox\"\n                    [setAutoGenerateId]=\"false\"\n                    bfmLabel=\"{{ i18n('Label') | translate }}\"\n                    autocomplete=\"off\"\n                    [itemsObservable]=\"dataStream\"\n                    [options]=\"comboboxOptions\"\n                    (endOfScroll)=\"onEndOfScroll($event)\"\n                    (search)=\"searchDataOnType($event)\"\n                    (click)=\"filterDataStream()\"\n                    [revertOnInvalidInput]=\"true\"\n                    (resetItems)=\"reset()\"\n                    required\n                    [errorContainer]=\"calculationTemplateErrorContainer\"\n                    [formControl]=\"control\">\n    </bento-combobox>\n    <button id=\"edit-template-btn\"\n            class=\"input-group-append input-group-action\"\n            type=\"button\"\n            (click)=\"openEditTemplatePage()\"\n            [disabled]=\"!control || control.invalid\">\n      <i class=\"bento-icon-edit\"></i>\n    </button>\n  </div>\n  <bfm-error-container #calculationTemplateErrorContainer\n                       class=\"d-block\">\n  </bfm-error-container>\n</div>\n", styles: [".input-group-action{cursor:pointer;font-size:16px;border:none;background:none;outline:none}.input-group-action[disabled]{cursor:default!important;color:\"graytext\"!important}::ng-deep .ng-bento.alignment-fisrt .bento-combobox-container-header .bui-bento-combobox-container-header-label:first-child{text-align:right;width:30%}::ng-deep .ng-bento.alignment-fisrt .bui-bento-combobox-container-item.bento-list-row>div:first-child{text-align:right;width:30%}\n"], components: [{ type: i5.BentoComboboxComponent, selector: "bento-combobox", inputs: ["appendTo", "options", "up", "readonly", "required", "revertOnInvalidInput", "inputLabelText", "open", "itemsObservable", "id", "inputLabelClass", "rowTemplate"], outputs: ["search", "resetItems", "endOfScroll", "openChange"] }, { type: i2$3.BfmErrorContainerComponent, selector: "bfm-error-container", inputs: ["errors"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$3.BfmFieldDirective, selector: "[bfmField]", inputs: ["muteAutoLabel", "setAutoGenerateId", "validations", "errorTemplate", "errorContainerTemplate", "errorContainer", "validateOnBlurOnly", "instantValidation", "showFieldLevelErrorContainer", "muteError", "showErrorIndicator", "bfmLabel", "resetToDefaultErrorTemplate", "resetToDefaultErrorContainerTemplate"], outputs: ["errorHandler", "fieldValidate"] }, { type: i2$1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CalculationTemplateComboboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-calculation-template-combobox', template: "<div class=\"ng-bento form-group alignment-fisrt\" *ngIf=\"!!control\">\n  <label>\n    {{ i18n(\"Label\") | translate }}\n  </label>\n  <div class=\"input-group\">\n    <bento-combobox bfmField\n                    id=\"calculation-template-combobox\"\n                    name=\"calculation-template-combobox\"\n                    [setAutoGenerateId]=\"false\"\n                    bfmLabel=\"{{ i18n('Label') | translate }}\"\n                    autocomplete=\"off\"\n                    [itemsObservable]=\"dataStream\"\n                    [options]=\"comboboxOptions\"\n                    (endOfScroll)=\"onEndOfScroll($event)\"\n                    (search)=\"searchDataOnType($event)\"\n                    (click)=\"filterDataStream()\"\n                    [revertOnInvalidInput]=\"true\"\n                    (resetItems)=\"reset()\"\n                    required\n                    [errorContainer]=\"calculationTemplateErrorContainer\"\n                    [formControl]=\"control\">\n    </bento-combobox>\n    <button id=\"edit-template-btn\"\n            class=\"input-group-append input-group-action\"\n            type=\"button\"\n            (click)=\"openEditTemplatePage()\"\n            [disabled]=\"!control || control.invalid\">\n      <i class=\"bento-icon-edit\"></i>\n    </button>\n  </div>\n  <bfm-error-container #calculationTemplateErrorContainer\n                       class=\"d-block\">\n  </bfm-error-container>\n</div>\n", styles: [".input-group-action{cursor:pointer;font-size:16px;border:none;background:none;outline:none}.input-group-action[disabled]{cursor:default!important;color:\"graytext\"!important}::ng-deep .ng-bento.alignment-fisrt .bento-combobox-container-header .bui-bento-combobox-container-header-label:first-child{text-align:right;width:30%}::ng-deep .ng-bento.alignment-fisrt .bui-bento-combobox-container-item.bento-list-row>div:first-child{text-align:right;width:30%}\n"] }]
        }], ctorParameters: function () { return [{ type: AccountingCostsCalculationTemplateService }, { type: RouterService }, { type: i1$1.TranslateService }]; }, propDecorators: { control: [{
                type: Input
            }] } });

class CalculationFormComponent {
    constructor(translationService, fb, accCostsCalculationService, accCostsCalculationTemplateService, dateFormatterService, alertService, preferencesService, loaderService) {
        this.translationService = translationService;
        this.fb = fb;
        this.accCostsCalculationService = accCostsCalculationService;
        this.accCostsCalculationTemplateService = accCostsCalculationTemplateService;
        this.dateFormatterService = dateFormatterService;
        this.alertService = alertService;
        this.preferencesService = preferencesService;
        this.selectedClientsIds = [];
        this.selectClients = new EventEmitter();
        this.bindClients = new EventEmitter();
        this.submitSubject = new Subject();
        this.i18nBaseKey = 'Onvio.AccountingCosts.Filters';
        this.validations = {
            required: ''
        };
        this.formFilter = this.fb.group({
            calculationTemplate: ['', Validators.required],
            basis: ['', [Validators.required]]
        });
        this.loadingClientsBusyLoader = loaderService.clientsLoader;
        this.loadingCalculationBusyLoader = loaderService.calculationLoader;
    }
    ngOnInit() {
        this.registerSubmitListener();
        this.translationService.getTranslations([
            'Errors.Required', 'CalculationForm.PerformingCalculation', 'CalculationForm.ErrorOccurred'
        ], this.i18nBaseKey)
            .subscribe(([required, performingCalculationMessage, calculationErrorMessage]) => {
            this.validations.required = required;
            this.performingCalculationMessage = performingCalculationMessage;
            this.calculationErrorMessage = calculationErrorMessage;
        });
        this.getPreferences();
        this.formSubscription = this.formFilter.get('calculationTemplate').valueChanges.pipe(distinctUntilChanged(), switchMap(value => {
            if (value) {
                this.loadingClientsBusyLoader.show();
                return this.accCostsCalculationTemplateService.get(value.id).pipe(take(1));
            }
        })).subscribe(template => {
            this.bindClients.emit(template);
        });
    }
    i18n(key) {
        return this.translationService.composeKey(this.i18nBaseKey, key);
    }
    submit() {
        this.loadingCalculationBusyLoader.show();
        this.submitSubject.next('');
    }
    registerSubmitListener() {
        this.submitSubject
            .pipe(exhaustMap(_ => interval(2000)
            .pipe(first())))
            .subscribe(() => this.calculate());
    }
    calculate() {
        if (!this.formFilter.get('calculationTemplate') &&
            !this.formFilter.get('calculationTemplate').value
            && !this.formFilter.get('calculationTemplate').value.id) {
            return;
        }
        this.preferencesService.patchFilters({
            selectedBasisDate: this.formFilter.get('basis').value,
            selectedTemplate: this.formFilter.get('calculationTemplate').value
        }, this.preferenceId);
        const calculationTemplateObs = this.accCostsCalculationTemplateService
            .get(this.formFilter.get('calculationTemplate').value.id)
            .pipe(first());
        const basisDateObs = this.dateFormatterService
            .parseYearMonth(this.formFilter.get('basis').value)
            .pipe(first());
        combineLatest([calculationTemplateObs, basisDateObs])
            .pipe(switchMap((responses) => {
            const [calculationTemplate, basisDate] = responses;
            return this.accCostsCalculationService.calculate(this.formatToLowerCase(calculationTemplate.id), this.formatArraytoLowerCase(this.selectedClientsIds), basisDate);
        }), first())
            .subscribe({
            next: () => {
                this.onSucessCalculation();
                this.loadingCalculationBusyLoader.hide();
            },
            error: (err) => {
                this.onErrorCalculation(err);
                this.loadingCalculationBusyLoader.hide();
            }
        });
    }
    onSucessCalculation() {
        this.displayAlert({
            type: 'warning',
            msg: this.performingCalculationMessage,
            closeable: true
        });
    }
    onErrorCalculation(err) {
        const httpErrorCode = err.status;
        if (httpErrorCode === 202 || httpErrorCode === 409) {
            this.onSucessCalculation();
            return;
        }
        this.displayAlert({
            type: 'danger',
            msg: this.calculationErrorMessage,
            closeable: true,
        });
    }
    formatToLowerCase(str) {
        const stringMatch = str.match('^(.{8})(.{4})(.{4})(.{4})(.{12})$');
        return `${stringMatch[1]}-${stringMatch[2]}-${stringMatch[3]}-${stringMatch[4]}-${stringMatch[5]}`.toLowerCase();
    }
    formatArraytoLowerCase(array) {
        if (array && array.length) {
            return array.map(this.formatToLowerCase);
        }
        return [];
    }
    displayAlert(alert) {
        if (this.lastAlert) {
            this.alertService.removeAlert(this.lastAlert);
        }
        this.lastAlert = this.alertService.addAlert(alert);
    }
    openSelectClients() {
        this.selectClients.emit();
    }
    getPreferences() {
        this.preferencesService.getFilters('calculate-profit')
            .subscribe({
            next: (preferences) => {
                const preference = preferences[0];
                if (preference
                    && preference.id
                    && preference.value
                    && preference.value.selectedTemplate
                    && preference.value.selectedBasisDate) {
                    this.preferenceId = preference.id;
                    this.formFilter.patchValue({ calculationTemplate: preference.value.selectedTemplate });
                    this.formFilter.patchValue({ basis: preference.value.selectedBasisDate });
                }
                else {
                    this.createPreference();
                }
            }
        });
    }
    createPreference() {
        this.preferencesService.postFilters('calculate-profit')
            .pipe(switchMap(() => {
            this.getPreferences();
            return of({});
        }))
            .subscribe();
    }
    ngOnDestroy() {
        this.formSubscription.unsubscribe();
    }
}
CalculationFormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CalculationFormComponent, deps: [{ token: TranslationService }, { token: i2$1.FormBuilder }, { token: AccountingCostsCalculationService }, { token: AccountingCostsCalculationTemplateService }, { token: DateFormatterService }, { token: AlertService }, { token: AccountingCostsUserPreferencesService }, { token: LoaderService }], target: i0.ɵɵFactoryTarget.Component });
CalculationFormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: CalculationFormComponent, selector: "acc-calculation-form", inputs: { isLateralOpen: "isLateralOpen", selectedClientsIds: "selectedClientsIds" }, outputs: { selectClients: "selectClients", bindClients: "bindClients" }, ngImport: i0, template: "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <h1>{{ i18n('CalculationForm.CalculateProfit') | translate }}</h1>\n  </div>\n  <form autocomplete=\"off\" *ngIf=\"!!formFilter\" [formGroup]=\"formFilter\" bfmForm id=\"filtersForm\" name=\"filtersForm\"\n    [validations]=\"validations\" (ngSubmit)=\"submit()\" class=\"row\">\n    <div class=\"col\">\n      <div class=\"calculation-model-filter\">\n        <acc-calculation-template-combobox  name=\"calculation-template\" [control]=\"formFilter.get('calculationTemplate')\">\n        </acc-calculation-template-combobox>\n      </div>\n      <acc-basis-input name=\"basis\" [control]=\"formFilter.get('basis')\"></acc-basis-input>\n      <div [ngClass]=\"{'hidden': isLateralOpen}\">\n        <a data-testid=\"select-clients\" class=\"text-info pointer\"\n          (click)=\"openSelectClients()\" >{{ i18n('CalculationForm.SelectClients') | translate }}</a>\n      </div>\n      <div class=\"mt-3\">\n        <button id=\"calculate-btn\" type=\"submit\" class=\"btn btn-primary\" [bentoBusyLoader]=\"loadingCalculationBusyLoader.state\" \n        [disabled]=\"formFilter.invalid || loadingCalculationBusyLoader.state\">{{ i18n('Calculate') | translate }}</button>\n      </div>\n    </div>\n  </form>\n</div>\n", styles: [".pointer{cursor:pointer}.calculation-model-filter{max-width:340px;width:340px}:host ::ng-deep acc-basis-input input{max-width:120px;width:120px}.hidden{visibility:hidden}\n"], components: [{ type: CalculationTemplateComboboxComponent, selector: "acc-calculation-template-combobox", inputs: ["control"] }, { type: BasisInputComponent, selector: "acc-basis-input", inputs: ["control"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$3.BfmFormDirective, selector: "[bfmForm]", inputs: ["showServerError", "formSubmitted", "resetErrors", "serverErrorContainer", "muteError", "errorContainer", "errorTemplate", "errorContainerTemplate", "resetToDefaultErrorContainerTemplate", "validations", "validateOnBlurOnly", "showFieldLevelErrorContainer", "showErrorIndicator", "instantValidation"], outputs: ["errorHandler"] }, { type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["size", "showDelay", "hideDelay", "bentoBusyLoader"], outputs: ["show", "hide"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CalculationFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-calculation-form', template: "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <h1>{{ i18n('CalculationForm.CalculateProfit') | translate }}</h1>\n  </div>\n  <form autocomplete=\"off\" *ngIf=\"!!formFilter\" [formGroup]=\"formFilter\" bfmForm id=\"filtersForm\" name=\"filtersForm\"\n    [validations]=\"validations\" (ngSubmit)=\"submit()\" class=\"row\">\n    <div class=\"col\">\n      <div class=\"calculation-model-filter\">\n        <acc-calculation-template-combobox  name=\"calculation-template\" [control]=\"formFilter.get('calculationTemplate')\">\n        </acc-calculation-template-combobox>\n      </div>\n      <acc-basis-input name=\"basis\" [control]=\"formFilter.get('basis')\"></acc-basis-input>\n      <div [ngClass]=\"{'hidden': isLateralOpen}\">\n        <a data-testid=\"select-clients\" class=\"text-info pointer\"\n          (click)=\"openSelectClients()\" >{{ i18n('CalculationForm.SelectClients') | translate }}</a>\n      </div>\n      <div class=\"mt-3\">\n        <button id=\"calculate-btn\" type=\"submit\" class=\"btn btn-primary\" [bentoBusyLoader]=\"loadingCalculationBusyLoader.state\" \n        [disabled]=\"formFilter.invalid || loadingCalculationBusyLoader.state\">{{ i18n('Calculate') | translate }}</button>\n      </div>\n    </div>\n  </form>\n</div>\n", styles: [".pointer{cursor:pointer}.calculation-model-filter{max-width:340px;width:340px}:host ::ng-deep acc-basis-input input{max-width:120px;width:120px}.hidden{visibility:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslationService }, { type: i2$1.FormBuilder }, { type: AccountingCostsCalculationService }, { type: AccountingCostsCalculationTemplateService }, { type: DateFormatterService }, { type: AlertService }, { type: AccountingCostsUserPreferencesService }, { type: LoaderService }]; }, propDecorators: { isLateralOpen: [{
                type: Input
            }], selectedClientsIds: [{
                type: Input
            }], selectClients: [{
                type: Output
            }], bindClients: [{
                type: Output
            }] } });

class AccountingCostsFilters {
    constructor(template, basis, datePattern) {
        this.template = template;
        this.basis = parse(basis, datePattern, new Date());
    }
}

class CostsFiltersComponent {
    constructor(translation, fb, preferencesService, loaderService) {
        this.translation = translation;
        this.fb = fb;
        this.preferencesService = preferencesService;
        this.update = new EventEmitter();
        this.validations = {
            required: ''
        };
        this.datePattern = '';
        this.submitSubject = new Subject();
        this.loadingWidgetsBusyLoader = loaderService.widgetsLoader;
        this.subjectSubscription = this.submitSubject.pipe(debounceTime(2000), exhaustMap(() => {
            this.submit();
            return of({});
        })).subscribe();
    }
    ngOnInit() {
        this.translation.getTranslations(['Onvio.AccountingCosts.Filters.Errors.Required', 'Onvio.AccountingCosts.BasisInput.DatePattern'])
            .pipe(first())
            .subscribe(([error, date]) => {
            this.validations.required = error;
            this.datePattern = date;
        });
        this.formFilter = this.fb.group({
            calculationTemplate: ['', Validators.required],
            basis: ['', Validators.required]
        });
        this.getPreferences();
    }
    requestSubmit() {
        this.submitSubject.next();
    }
    submit() {
        const form = this.formFilter.value;
        this.loadingWidgetsBusyLoader.show();
        const costsFilters = new AccountingCostsFilters(form.calculationTemplate, form.basis, this.datePattern);
        this.preferencesService.patchFilters({
            selectedBasisDate: form.basis,
            selectedTemplate: costsFilters.template
        }, this.preferenceId);
        this.update.emit(costsFilters);
    }
    i18n(node) {
        return `Onvio.AccountingCosts.Filters.${node}`;
    }
    getPreferences() {
        this.preferencesService.getFilters('costs')
            .subscribe({
            next: (preferences) => {
                const preference = preferences[0];
                if (preference
                    && preference.id
                    && preference.value
                    && preference.value.selectedTemplate
                    && preference.value.selectedBasisDate) {
                    this.preferenceId = preference.id;
                    this.formFilter.patchValue({ calculationTemplate: preference.value.selectedTemplate });
                    this.formFilter.patchValue({ basis: preference.value.selectedBasisDate });
                }
                else {
                    this.createPreference();
                }
            }
        });
    }
    createPreference() {
        this.preferencesService.postFilters('costs')
            .pipe(switchMap(() => {
            this.getPreferences();
            return of({});
        }))
            .subscribe();
    }
    ngOnDestroy() {
        if (this.subjectSubscription) {
            this.subjectSubscription.unsubscribe();
        }
    }
}
CostsFiltersComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CostsFiltersComponent, deps: [{ token: TranslationService }, { token: i2$1.FormBuilder }, { token: AccountingCostsUserPreferencesService }, { token: LoaderService }], target: i0.ɵɵFactoryTarget.Component });
CostsFiltersComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: CostsFiltersComponent, selector: "acc-costs-filters", outputs: { update: "update" }, ngImport: i0, template: "\n<form\n  autocomplete=\"off\"\n  *ngIf=\"!!formFilter\"\n  [formGroup]=\"formFilter\"\n  bfmForm\n  id=\"filtersForm\"\n  name=\"filtersForm\"\n  [validations]=\"validations\"\n  (ngSubmit)=\"requestSubmit()\"\n>\n  <div id=\"dashboard-filters\" class=\"row\">\n    <div class=\"calculation-template-labeled-input\">\n      <acc-calculation-template-combobox\n        name=\"calculation-template\"\n        [control]=\"formFilter.get('calculationTemplate')\"\n      ></acc-calculation-template-combobox>\n    </div>\n    <div class=\"basis-labeled-input\">\n      <acc-basis-input\n        name=\"basis\"\n        [control]=\"formFilter.get('basis')\"\n      ></acc-basis-input>\n    </div>\n    <div class=\"update-button-container\">\n      <button\n        id=\"update-btn\"\n        type=\"submit\"\n        class=\"btn btn-primary\"\n        [disabled]=\"formFilter.invalid\"\n      >\n        {{ i18n(\"Update\") | translate }}\n      </button>\n    </div>\n  </div>\n</form>\n", styles: [".filter-form{border-bottom:1px solid #aeaeae;margin-bottom:25px;padding:0 15px 10px}.row .update-button-container{padding-top:27px}.row .calculation-template-labeled-input{width:370px;padding:0 15px}.row .basis-labeled-input{width:140px;padding:0}\n"], components: [{ type: CalculationTemplateComboboxComponent, selector: "acc-calculation-template-combobox", inputs: ["control"] }, { type: BasisInputComponent, selector: "acc-basis-input", inputs: ["control"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$3.BfmFormDirective, selector: "[bfmForm]", inputs: ["showServerError", "formSubmitted", "resetErrors", "serverErrorContainer", "muteError", "errorContainer", "errorTemplate", "errorContainerTemplate", "resetToDefaultErrorContainerTemplate", "validations", "validateOnBlurOnly", "showFieldLevelErrorContainer", "showErrorIndicator", "instantValidation"], outputs: ["errorHandler"] }, { type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CostsFiltersComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-costs-filters', template: "\n<form\n  autocomplete=\"off\"\n  *ngIf=\"!!formFilter\"\n  [formGroup]=\"formFilter\"\n  bfmForm\n  id=\"filtersForm\"\n  name=\"filtersForm\"\n  [validations]=\"validations\"\n  (ngSubmit)=\"requestSubmit()\"\n>\n  <div id=\"dashboard-filters\" class=\"row\">\n    <div class=\"calculation-template-labeled-input\">\n      <acc-calculation-template-combobox\n        name=\"calculation-template\"\n        [control]=\"formFilter.get('calculationTemplate')\"\n      ></acc-calculation-template-combobox>\n    </div>\n    <div class=\"basis-labeled-input\">\n      <acc-basis-input\n        name=\"basis\"\n        [control]=\"formFilter.get('basis')\"\n      ></acc-basis-input>\n    </div>\n    <div class=\"update-button-container\">\n      <button\n        id=\"update-btn\"\n        type=\"submit\"\n        class=\"btn btn-primary\"\n        [disabled]=\"formFilter.invalid\"\n      >\n        {{ i18n(\"Update\") | translate }}\n      </button>\n    </div>\n  </div>\n</form>\n", styles: [".filter-form{border-bottom:1px solid #aeaeae;margin-bottom:25px;padding:0 15px 10px}.row .update-button-container{padding-top:27px}.row .calculation-template-labeled-input{width:370px;padding:0 15px}.row .basis-labeled-input{width:140px;padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslationService }, { type: i2$1.FormBuilder }, { type: AccountingCostsUserPreferencesService }, { type: LoaderService }]; }, propDecorators: { update: [{
                type: Output
            }] } });

class ViewCalculationFiltersService {
    constructor(userPreferenceService) {
        this.userPreferenceService = userPreferenceService;
    }
    createProfitPreference(basis, template) {
        const value = {
            selectedBasisDate: basis,
            selectedTemplate: template
        };
        return this.userPreferenceService.postPreference('accounting-costs', 'view-calculations', value);
    }
}
ViewCalculationFiltersService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ViewCalculationFiltersService, deps: [{ token: UserPreferenceService }], target: i0.ɵɵFactoryTarget.Injectable });
ViewCalculationFiltersService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ViewCalculationFiltersService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ViewCalculationFiltersService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: UserPreferenceService }]; } });

class ViewCalculationFiltersComponent {
    constructor(translation, fb, viewFiltersService, datePipe, preferencesService) {
        this.translation = translation;
        this.fb = fb;
        this.viewFiltersService = viewFiltersService;
        this.datePipe = datePipe;
        this.preferencesService = preferencesService;
        this.basisField = 'basis';
        this.update = new EventEmitter();
        this.validations = {
            required: ''
        };
        this.datePattern = '';
        this.formFilter = this.fb.group({
            calculationTemplate: ['', Validators.required],
            [this.basisField]: ['', Validators.required]
        });
    }
    set filters(filters) {
        if (!!filters) {
            if (!!filters.basis && !!filters.template) {
                const basis = this.datePipe.transform(filters.basis, 'MM/yyyy');
                const value = {
                    selectedBasisDate: basis,
                    selectedTemplate: filters.template
                };
                this.formFilter.patchValue({
                    basis,
                    calculationTemplate: filters.template
                });
                if (this.preferenceId) {
                    this.preferencesService.patchFilters(value, this.preferenceId);
                }
                else {
                    this.getPreferences(value);
                }
            }
        }
        else {
            this.getPreferences();
        }
    }
    ngOnInit() {
        this.translation.getTranslations(['Onvio.AccountingCosts.Filters.Errors.Required', 'Onvio.AccountingCosts.BasisInput.DatePattern'])
            .pipe(first())
            .subscribe(([error, datePattern]) => {
            this.validations.required = error;
            this.datePattern = datePattern;
        });
    }
    i18n(node) {
        return `Onvio.AccountingCosts.Filters.${node}`;
    }
    submit() {
        const form = this.formFilter.value;
        this.replaceLocationHref();
        this.update.emit(new AccountingCostsFilters(form.calculationTemplate, form.basis, this.datePattern));
    }
    replaceLocationHref() {
        const queryParamsSplit = window.location.href.split('?');
        if (queryParamsSplit.length > 1) {
            const prefix = window.location.href.split('?')[0];
            window.location.href = prefix;
        }
    }
    getPreferences(filters) {
        this.preferencesService.getFilters('view-calculations')
            .subscribe({
            next: (preferences) => {
                const preference = preferences[0];
                if (preference
                    && preference.id
                    && preference.value
                    && preference.value.selectedTemplate
                    && preference.value.selectedBasisDate) {
                    this.preferenceId = preference.id;
                    if (!filters) {
                        this.formFilter.patchValue({
                            calculationTemplate: preference.value.selectedTemplate,
                            basis: preference.value.selectedBasisDate
                        });
                    }
                    else {
                        this.preferencesService.patchFilters(filters, this.preferenceId);
                    }
                }
                else {
                    this.createPreference(filters);
                }
            }
        });
    }
    createPreference(filters) {
        const createObs = !filters ?
            this.preferencesService.postFilters('view-calculations') :
            this.viewFiltersService.createProfitPreference(filters.selectedBasisDate, filters.selectedTemplate);
        createObs.pipe(switchMap(() => {
            this.getPreferences();
            return of({});
        }))
            .subscribe();
    }
}
ViewCalculationFiltersComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ViewCalculationFiltersComponent, deps: [{ token: TranslationService }, { token: i2$1.FormBuilder }, { token: ViewCalculationFiltersService }, { token: i4.DatePipe }, { token: AccountingCostsUserPreferencesService }], target: i0.ɵɵFactoryTarget.Component });
ViewCalculationFiltersComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ViewCalculationFiltersComponent, selector: "acc-view-calculation-filters", inputs: { filters: "filters" }, outputs: { update: "update" }, providers: [DatePipe], ngImport: i0, template: "\n<form\nautocomplete=\"off\"\n*ngIf=\"!!formFilter\"\n[formGroup]=\"formFilter\"\nbfmForm\nid=\"filtersForm\"\nname=\"filtersForm\"\n[validations]=\"validations\"\n(ngSubmit)=\"submit()\"\n>\n<div id=\"dashboard-filters\" class=\"row\">\n  <div class=\"calculation-template-labeled-input\">\n    <acc-calculation-template-combobox\n      name=\"calculation-template\"\n      [control]=\"formFilter.get('calculationTemplate')\"\n    ></acc-calculation-template-combobox>\n  </div>\n  <div class=\"basis-labeled-input\">\n    <acc-basis-input\n      name=\"basis\"\n      [control]=\"formFilter.get('basis')\"\n    ></acc-basis-input>\n  </div>\n  <div>\n    <div class=\"update-button-container\">\n      <button\n        id=\"update-btn\"\n        type=\"submit\"\n        class=\"btn btn-primary\"\n        [disabled]=\"formFilter.invalid\"\n      >\n        {{ i18n(\"Update\") | translate }}\n      </button>\n    </div>\n  </div>\n</div>\n</form>\n\n", styles: [".filter-form{border-bottom:1px solid #aeaeae;margin-bottom:25px;padding:0 15px 10px}.row .update-button-container{padding-top:27px}.row .calculation-template-labeled-input{width:370px;padding:0 15px}.row .basis-labeled-input{width:140px;padding:0}\n"], components: [{ type: CalculationTemplateComboboxComponent, selector: "acc-calculation-template-combobox", inputs: ["control"] }, { type: BasisInputComponent, selector: "acc-basis-input", inputs: ["control"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$3.BfmFormDirective, selector: "[bfmForm]", inputs: ["showServerError", "formSubmitted", "resetErrors", "serverErrorContainer", "muteError", "errorContainer", "errorTemplate", "errorContainerTemplate", "resetToDefaultErrorContainerTemplate", "validations", "validateOnBlurOnly", "showFieldLevelErrorContainer", "showErrorIndicator", "instantValidation"], outputs: ["errorHandler"] }, { type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ViewCalculationFiltersComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-view-calculation-filters', providers: [DatePipe], template: "\n<form\nautocomplete=\"off\"\n*ngIf=\"!!formFilter\"\n[formGroup]=\"formFilter\"\nbfmForm\nid=\"filtersForm\"\nname=\"filtersForm\"\n[validations]=\"validations\"\n(ngSubmit)=\"submit()\"\n>\n<div id=\"dashboard-filters\" class=\"row\">\n  <div class=\"calculation-template-labeled-input\">\n    <acc-calculation-template-combobox\n      name=\"calculation-template\"\n      [control]=\"formFilter.get('calculationTemplate')\"\n    ></acc-calculation-template-combobox>\n  </div>\n  <div class=\"basis-labeled-input\">\n    <acc-basis-input\n      name=\"basis\"\n      [control]=\"formFilter.get('basis')\"\n    ></acc-basis-input>\n  </div>\n  <div>\n    <div class=\"update-button-container\">\n      <button\n        id=\"update-btn\"\n        type=\"submit\"\n        class=\"btn btn-primary\"\n        [disabled]=\"formFilter.invalid\"\n      >\n        {{ i18n(\"Update\") | translate }}\n      </button>\n    </div>\n  </div>\n</div>\n</form>\n\n", styles: [".filter-form{border-bottom:1px solid #aeaeae;margin-bottom:25px;padding:0 15px 10px}.row .update-button-container{padding-top:27px}.row .calculation-template-labeled-input{width:370px;padding:0 15px}.row .basis-labeled-input{width:140px;padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslationService }, { type: i2$1.FormBuilder }, { type: ViewCalculationFiltersService }, { type: i4.DatePipe }, { type: AccountingCostsUserPreferencesService }]; }, propDecorators: { update: [{
                type: Output
            }], filters: [{
                type: Input
            }] } });

class FiltersModule {
}
FiltersModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FiltersModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FiltersModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FiltersModule, declarations: [CostsFiltersComponent,
        CalculationTemplateComboboxComponent,
        BasisInputComponent,
        CalculationFormComponent,
        ViewCalculationFiltersComponent], imports: [CommonModule$1,
        TranslateModule,
        BentoModule,
        BfmModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule, i1$4.NgxMaskModule], exports: [CostsFiltersComponent,
        CalculationFormComponent,
        ViewCalculationFiltersComponent] });
FiltersModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FiltersModule, imports: [[
            CommonModule$1,
            TranslateModule,
            BentoModule,
            BfmModule,
            NgbModule,
            FormsModule,
            ReactiveFormsModule,
            NgxMaskModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FiltersModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CostsFiltersComponent,
                        CalculationTemplateComboboxComponent,
                        BasisInputComponent,
                        CalculationFormComponent,
                        ViewCalculationFiltersComponent
                    ],
                    imports: [
                        CommonModule$1,
                        TranslateModule,
                        BentoModule,
                        BfmModule,
                        NgbModule,
                        FormsModule,
                        ReactiveFormsModule,
                        NgxMaskModule.forChild()
                    ],
                    exports: [
                        CostsFiltersComponent,
                        CalculationFormComponent,
                        ViewCalculationFiltersComponent
                    ]
                }]
        }] });

class RouterModule {
}
RouterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RouterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RouterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RouterModule });
RouterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RouterModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RouterModule, decorators: [{
            type: NgModule
        }] });

class AlertBrowserComponent {
    constructor(activeModal, alertBrowser) {
        this.activeModal = activeModal;
        this.alertBrowser = alertBrowser;
        this.firefoxPng = this.getBase64Mozilla();
        this.chromePng = this.getBase64Chrome();
    }
    close() {
        this.alertBrowser.close();
    }
    i18n(node) {
        return `Onvio.AccountingCosts.AlertBrowser.${node}`;
    }
    getBase64Mozilla() {
        return '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';
    }
    getBase64Chrome() {
        return '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';
    }
}
AlertBrowserComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertBrowserComponent, deps: [{ token: i1$2.NgbActiveModal }, { token: AlertBrowserService }], target: i0.ɵɵFactoryTarget.Component });
AlertBrowserComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: AlertBrowserComponent, selector: "acc-alert-browser", ngImport: i0, template: "<div id=\"alertBrowser\" >\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\"> {{ i18n(\"Title\") | translate }} </h4>\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"close()\">\n           <span aria-hidden=\"true\">&times;</span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <p> {{ i18n(\"Content\") | translate }} </p>\n\n        <div class=\"col\">\n            <p> <img src=\"{{'data:image/jpg;base64,' + chromePng}}\" alt=\"Google Chrome\"> Google Chrome - <a href=\"{{ i18n('ChromeLink') | translate }}\" target=\"_blank\"> {{ i18n(\"Install\") | translate }} </a> </p>\n        </div>\n        <div class=\"col\">\n          <p> <img src=\"{{'data:image/jpg;base64,' + firefoxPng}}\" alt=\"Mozilla Firefox\">  Mozilla Firefox - <a href=\"{{ i18n('FirefoxLink') | translate }}\" target=\"_blank\"> {{ i18n(\"Install\") | translate }} </a> </p>\n        </div>\n    </div>\n</div>\n", styles: ["::ng-deep #alertBrowser .modal-title{font-size:26px;letter-spacing:-.24px}::ng-deep #alertBrowser p{font-size:16px}::ng-deep #alertBrowser .col{width:50%;display:inline-block;padding:0}::ng-deep .ng-bento .modal .modal-dialog .close{margin:0}#alertBrowser .icon-chrome{background-image:url(/src/modules/shared/icons/icon-chrome.png)}::ng-deep\\a0  .ie\\a0.ng-bento\\a0.modal\\a0.modal-dialog\\a0 {position:relative}::ng-deep\\a0  .ie\\a0.modal-content{left:50%;top:50%;position:\\a0 absolute;transform:\\a0translateX(-50%)\\a0translateY(-50%)}\n"], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertBrowserComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-alert-browser', template: "<div id=\"alertBrowser\" >\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\"> {{ i18n(\"Title\") | translate }} </h4>\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"close()\">\n           <span aria-hidden=\"true\">&times;</span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <p> {{ i18n(\"Content\") | translate }} </p>\n\n        <div class=\"col\">\n            <p> <img src=\"{{'data:image/jpg;base64,' + chromePng}}\" alt=\"Google Chrome\"> Google Chrome - <a href=\"{{ i18n('ChromeLink') | translate }}\" target=\"_blank\"> {{ i18n(\"Install\") | translate }} </a> </p>\n        </div>\n        <div class=\"col\">\n          <p> <img src=\"{{'data:image/jpg;base64,' + firefoxPng}}\" alt=\"Mozilla Firefox\">  Mozilla Firefox - <a href=\"{{ i18n('FirefoxLink') | translate }}\" target=\"_blank\"> {{ i18n(\"Install\") | translate }} </a> </p>\n        </div>\n    </div>\n</div>\n", styles: ["::ng-deep #alertBrowser .modal-title{font-size:26px;letter-spacing:-.24px}::ng-deep #alertBrowser p{font-size:16px}::ng-deep #alertBrowser .col{width:50%;display:inline-block;padding:0}::ng-deep .ng-bento .modal .modal-dialog .close{margin:0}#alertBrowser .icon-chrome{background-image:url(/src/modules/shared/icons/icon-chrome.png)}::ng-deep\\a0  .ie\\a0.ng-bento\\a0.modal\\a0.modal-dialog\\a0 {position:relative}::ng-deep\\a0  .ie\\a0.modal-content{left:50%;top:50%;position:\\a0 absolute;transform:\\a0translateX(-50%)\\a0translateY(-50%)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }, { type: AlertBrowserService }]; } });

class AlertBrowserService {
    constructor(modalService, alertService, translate, localStorageService) {
        this.modalService = modalService;
        this.alertService = alertService;
        this.translate = translate;
        this.localStorageService = localStorageService;
        this.BROWSER_SUPORT_STATE = 'BROWSER-SUPORT';
        this.FIREFOX_SUPPORTED_VERSION = 63;
        this.state = {
            unsupported: false
        };
    }
    alert() {
        const info = this.insideI18n('Alert');
        const infoAlert = {
            closeable: false,
            msg: info,
            type: 'warning alert-browser'
        };
        this.alertService.cleanAlerts();
        this.alertService.addAlert(infoAlert);
    }
    open() {
        if (this.validate() && !this.state.unsupported) {
            this.modalReference = this.modalService.open(AlertBrowserComponent, {
                container: '#bentoNGModalContainer',
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            });
            this.state.unsupported = true;
            return this.state.unsupported;
        }
        if (this.state.unsupported) {
            this.alert();
            return false;
        }
    }
    close() {
        this.modalReference.close();
        if (this.validate()) {
            this.alert();
        }
    }
    validate() {
        const isEdge = /edge\//i.test(window.navigator.userAgent);
        const isIE = /msie\s|trident\//i.test(window.navigator.userAgent);
        const isFirefox = /firefox\//i.test(window.navigator.userAgent);
        if (isEdge) {
            return true;
        }
        if (isIE) {
            this.alert();
            return true;
        }
        if (isFirefox) {
            const regex = /(Firefox\/)/;
            const userAgent = window.navigator.userAgent;
            const version = userAgent.split(regex);
            return parseFloat(version[2]) < this.FIREFOX_SUPPORTED_VERSION;
        }
        if (!isEdge && !isFirefox && !isIE) {
            return false;
        }
    }
    insideI18n(node) {
        return this.translate.instant(`Onvio.AccountingCosts.AlertBrowser.${node}`);
    }
    loadState() {
        this.state = this.localStorageService.get(this.BROWSER_SUPORT_STATE);
        if (!this.state) {
            this.resetState();
        }
    }
    saveState() {
        this.localStorageService.set(this.BROWSER_SUPORT_STATE, this.state);
    }
    resetState() {
        this.state = {
            unsupported: false
        };
        this.saveState();
    }
}
AlertBrowserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertBrowserService, deps: [{ token: i1$2.NgbModal }, { token: AlertFixedService }, { token: i1$1.TranslateService }, { token: LocalStorageService }], target: i0.ɵɵFactoryTarget.Injectable });
AlertBrowserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertBrowserService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertBrowserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }, { type: AlertFixedService }, { type: i1$1.TranslateService }, { type: LocalStorageService }]; } });

class DefaultCalculationModelService {
    constructor(http, cookieService) {
        this.http = http;
        this.cookieService = cookieService;
        this.cookieBaseName = 'AccountingCostsDefaultModelSynced';
    }
    syncDefaultModel() {
        const uri = `${API_URL}default-calculation-model/sync`;
        return this.http.post(uri, {});
    }
    requestSync() {
        const companyId = this.cookieService.get('bmTheme');
        if (this.cookieService.get(this.cookieBaseName + companyId) === '') {
            this.syncDefaultModel().subscribe(_ => {
                this.cookieService.set(this.cookieBaseName + companyId, 'true');
            });
        }
    }
}
DefaultCalculationModelService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DefaultCalculationModelService, deps: [{ token: i1.HttpClient }, { token: i2$2.CookieService }], target: i0.ɵɵFactoryTarget.Injectable });
DefaultCalculationModelService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DefaultCalculationModelService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DefaultCalculationModelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2$2.CookieService }]; } });

var CheckboxState;
(function (CheckboxState) {
    CheckboxState[CheckboxState["SELECTED"] = 1] = "SELECTED";
    CheckboxState[CheckboxState["UNSELECTED"] = 2] = "UNSELECTED";
    CheckboxState[CheckboxState["INDETERMINATE"] = 3] = "INDETERMINATE";
})(CheckboxState || (CheckboxState = {}));

class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
    parse(value) {
        if (value) {
            const dateParts = value.trim().split('/');
            if (dateParts.length === 1 && !isNaN(+dateParts[0])) {
                return { year: parseInt(dateParts[0], 10), month: null, day: null };
            }
            else if (dateParts.length === 2 && !isNaN(+dateParts[0]) && !isNaN(+dateParts[1])) {
                return { year: parseInt(dateParts[0], 10), month: parseInt(dateParts[1], 10), day: null };
            }
            else if (dateParts.length === 3
                && !isNaN(+dateParts[0])
                && !isNaN(+dateParts[1])
                && !isNaN(+dateParts[2])) {
                return {
                    year: parseInt(dateParts[0], 10),
                    month: parseInt(dateParts[1], 10),
                    day: parseInt(dateParts[2], 10)
                };
            }
        }
        return null;
    }
    format(date) {
        return date ? `${!isNaN(date.month) ? this.padNumber(date.month) : ''}/${!isNaN(date.day) ? this.padNumber(date.day) : ''}/${date.year}` : '';
    }
    padNumber(value) {
        return `0${value}`.slice(-2);
    }
}
NgbDateCustomParserFormatter.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbDateCustomParserFormatter, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NgbDateCustomParserFormatter.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbDateCustomParserFormatter });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbDateCustomParserFormatter, decorators: [{
            type: Injectable
        }] });

/**
 * Example of a Native Date adapter
 */
class NgbDateNativeAdapter extends NgbDateAdapter {
    fromModel(date) {
        return (date && date.getFullYear) ?
            { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() } : null;
    }
    toModel(date) {
        return date ? new Date(date.year, date.month - 1, date.day) : null;
    }
}
NgbDateNativeAdapter.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbDateNativeAdapter, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NgbDateNativeAdapter.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbDateNativeAdapter });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbDateNativeAdapter, decorators: [{
            type: Injectable
        }] });

class CalculationTemplateService {
    constructor(http) {
        this.http = http;
        this.calculationModelsEndpoint = `${API_URL}calculation-model/`;
    }
    getAllCalculationModels() {
        const urlParams = new HttpParams();
        return this.http.get(this.calculationModelsEndpoint).pipe(map(res => res), catchError(this.handleError('getAllCalculationModels', [])));
    }
    handleError(operation = 'operation', result) {
        return (error) => {
            console.error(error);
            return of(result);
        };
    }
    duplicate(model) {
        const uri = `${this.calculationModelsEndpoint}duplicate`;
        return this.http.post(uri, model);
    }
    delete(id) {
        const uri = `${this.calculationModelsEndpoint}${id}`;
        return this.http.delete(uri);
    }
    getNextTemplate() {
        const uri = `${this.calculationModelsEndpoint}next`;
        return this.http.get(uri);
    }
}
CalculationTemplateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CalculationTemplateService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
CalculationTemplateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CalculationTemplateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CalculationTemplateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class DeleteModalComponent {
    constructor(activeModal, service, loaderService) {
        this.activeModal = activeModal;
        this.service = service;
        this.ids = [];
        this.loadingActionsBusyLoader = loaderService.actionsLoader;
    }
    onKeydownHandler(event) {
        if (event.key === 'Enter') {
            this.delete();
        }
    }
    ngOnInit() {
        const confirmButton = document.querySelector('#remove-button');
        confirmButton.focus();
    }
    i18n(node) {
        return `Onvio.AccountingCosts.${node}`;
    }
    getDeleteRequests(ids) {
        return ids.map(id => {
            return this.service.delete(id)
                .pipe(first());
        });
    }
    delete() {
        this.loadingActionsBusyLoader.show();
        const formatedIds = this.formatIds(this.ids);
        const deleteRequests = this.getDeleteRequests(formatedIds);
        combineLatest(deleteRequests).subscribe({
            next: () => {
                this.activeModal.close('save click');
                this.loadingActionsBusyLoader.hide();
            },
            error: () => {
                this.activeModal.close('save click');
                this.loadingActionsBusyLoader.hide();
            }
        });
    }
    formatIds(ids) {
        return ids.map(id => this.stringToUUID(id));
    }
    stringToUUID(id) {
        const endPosition = [8, 13, 18, 23];
        for (let index = 0; index < 4; index++) {
            id = [id.slice(0, endPosition[index]), '-', id.slice(endPosition[index])].join('');
        }
        return id;
    }
}
DeleteModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DeleteModalComponent, deps: [{ token: i1$2.NgbActiveModal }, { token: CalculationTemplateService }, { token: LoaderService }], target: i0.ɵɵFactoryTarget.Component });
DeleteModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DeleteModalComponent, selector: "acc-modal-content", host: { listeners: { "window:keydown": "onKeydownHandler($event)" } }, ngImport: i0, template: "<div class=\"busy-loader-container\" [bentoBusyLoader]=\"loadingActionsBusyLoader.state\">\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss('Cross click')\">\n    <span aria-hidden=\"true\">&times;</span>\n</button>\n<div class=\"modal-header\">\n  {{ i18n(\"Toolbar.Remove.Modal.Confirm.Title\") | translate }}\n</div>\n  <div class=\"modal-footer\">\n    <button id=\"remove-button\" data-testid=\"confirm-btn\" type=\"button\" class=\"btn btn-primary\" (click)=\"delete()\">\n      {{ i18n(\"Toolbar.Remove\") | translate }}\n    </button>\n    <button data-testid=\"cancel-btn\" type=\"button\" class=\"btn btn-outline-dark\" (click)=\"activeModal.close('Close click')\">\n      {{ i18n(\"Toolbar.Remove.Cancel\") | translate }}\n    </button>\n  </div>\n", styles: [".busy-loader-container ::ng-deep .bento-busyloader-front-blocker{background:0}\n"], directives: [{ type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["size", "showDelay", "hideDelay", "bentoBusyLoader"], outputs: ["show", "hide"] }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i5.BentoFooterTabHelper, selector: "[class=\"modal-footer\"]" }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DeleteModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-modal-content', template: "<div class=\"busy-loader-container\" [bentoBusyLoader]=\"loadingActionsBusyLoader.state\">\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss('Cross click')\">\n    <span aria-hidden=\"true\">&times;</span>\n</button>\n<div class=\"modal-header\">\n  {{ i18n(\"Toolbar.Remove.Modal.Confirm.Title\") | translate }}\n</div>\n  <div class=\"modal-footer\">\n    <button id=\"remove-button\" data-testid=\"confirm-btn\" type=\"button\" class=\"btn btn-primary\" (click)=\"delete()\">\n      {{ i18n(\"Toolbar.Remove\") | translate }}\n    </button>\n    <button data-testid=\"cancel-btn\" type=\"button\" class=\"btn btn-outline-dark\" (click)=\"activeModal.close('Close click')\">\n      {{ i18n(\"Toolbar.Remove.Cancel\") | translate }}\n    </button>\n  </div>\n", styles: [".busy-loader-container ::ng-deep .bento-busyloader-front-blocker{background:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }, { type: CalculationTemplateService }, { type: LoaderService }]; }, propDecorators: { onKeydownHandler: [{
                type: HostListener,
                args: ['window:keydown', ['$event']]
            }] } });

class DuplicateModalComponent {
    constructor(activeModal, translateService, service, translatePipe, formBuild, alertService, loaderService) {
        this.activeModal = activeModal;
        this.translateService = translateService;
        this.service = service;
        this.translatePipe = translatePipe;
        this.formBuild = formBuild;
        this.alertService = alertService;
        this.newName = '';
        this.maxLengthCode = 10;
        this.requiredTemplate = '';
        this.loadingActionsBusyLoader = loaderService.actionsLoader;
    }
    ngOnInit() {
        this.translateService.get(this.i18n('Form.Errors.Required'))
            .subscribe(translate => this.requiredTemplate = translate);
        this.initForm();
    }
    initForm() {
        const code = `${this.newCode}`.toString().substr(0, 10);
        this.duplicateForm = this.formBuild.group({
            id: [this.id],
            code: [code, Validators.required],
            name: [this.newName, Validators.required]
        });
    }
    i18n(node) {
        return `Onvio.AccountingCosts.Toolbar.${node}`;
    }
    save() {
        if (this.duplicateForm.valid) {
            this.loadingActionsBusyLoader.show();
            const newModel = Object.assign({}, this.duplicateForm.value);
            this.service.duplicate(newModel).pipe(first()).subscribe({
                next: () => {
                    this.activeModal.close('save click');
                    this.loadingActionsBusyLoader.hide();
                },
                error: err => {
                    this.translateService.get(this.getErrorMessage(err))
                        .subscribe(res => {
                        this.loadingActionsBusyLoader.hide();
                        this.addError(res);
                    });
                }
            });
        }
        else {
            Object.keys(this.duplicateForm.controls).forEach(key => {
                this.duplicateForm.get(key).markAsDirty();
            });
        }
    }
    showErrorMessage(label) {
        return this.requiredTemplate.replace('{0}', this.translatePipe.transform(label));
    }
    shouldShowError(formControlKey) {
        if (!this.duplicateForm) {
            return false;
        }
        return !this.duplicateForm.controls[formControlKey].valid &&
            !this.duplicateForm.controls[formControlKey].pristine;
    }
    isNumber(value) {
        const regex = new RegExp('^[0-9]*$');
        return regex.test(value);
    }
    onCodeKeypress(event) {
        if (!this.isNumber(event.key)) {
            event.preventDefault();
            return;
        }
        const value = this.duplicateForm.get('code').value;
        this.validateCodeValue(event, value);
    }
    onCodePaste(event) {
        const clipboardData = event.clipboardData.getData('text');
        if (!this.isNumber(clipboardData)) {
            event.preventDefault();
            return;
        }
        const value = this.duplicateForm.get('code').value + clipboardData;
        this.validateCodeValue(event, value);
    }
    validateCodeValue(event, value) {
        if (value.length >= this.maxLengthCode) {
            event.preventDefault();
        }
    }
    addError(msg) {
        this.alertService.addAlert({
            type: 'danger',
            closeable: true,
            timeout: 5000,
            msg
        });
    }
    getErrorMessage(err) {
        if (err && err.error && err.error.errorMessage) {
            const message = err.error.errorMessage;
            switch (message) {
                case ErrorType.NO_CLIENTS: {
                    return this.i18n('Error.NoClients');
                }
                default: {
                    return this.i18n('Error.DuplicatedID');
                }
            }
        }
        return this.i18n('Error.DuplicatedID');
    }
}
DuplicateModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DuplicateModalComponent, deps: [{ token: i1$2.NgbActiveModal }, { token: i1$1.TranslateService }, { token: CalculationTemplateService }, { token: i1$1.TranslatePipe }, { token: i2$1.FormBuilder }, { token: AlertService }, { token: LoaderService }], target: i0.ɵɵFactoryTarget.Component });
DuplicateModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DuplicateModalComponent, selector: "acc-modal-content", inputs: { id: "id", newCode: "newCode", newName: "newName" }, providers: [TranslatePipe], ngImport: i0, template: "<form class=\"busy-loader-container\" [formGroup]=\"duplicateForm\" (submit)=\"save()\" [bentoBusyLoader]=\"loadingActionsBusyLoader.state\">\n  <div class=\"modal-header\">\n    {{ i18n('Duplicate.Modal.Confirm.Title') | translate }}\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-5\">\n      <div class=\"form-group\">\n        <label class=\"bento-label-required\" for=\"id\">\n          {{i18n('Duplicate.Id') | translate}}\n        </label>\n        <input [class.border-danger]=\"shouldShowError('code')\" (paste)=\"onCodePaste($event)\" (keypress)=\"onCodeKeypress($event)\" class=\"bento-input form-control\" id=\"code\" name=\"code\"\n          formControlName=\"code\" required type=\"text\">\n        <div *ngIf=\"shouldShowError('code')\" class=\"bfm-error-message\">\n          <span class=\"ng-star-inserted\">\n            {{ showErrorMessage(i18n('Duplicate.Id')) }}\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-5\">\n      <div class=\"form-group\">\n        <label class=\"bento-label-required\" for=\"name\">\n          {{ i18n('Duplicate.Name') | translate }}\n        </label>\n        <input [class.border-danger]=\"shouldShowError('name')\" class=\"bento-input form-control\" id=\"name\" name=\"name\"\n          formControlName=\"name\" required type=\"text\" maxlength=\"200\" />\n        <div *ngIf=\"shouldShowError('name')\" class=\"bfm-error-message\">\n          <span class=\"ng-star-inserted\">\n            {{ showErrorMessage(i18n('Duplicate.Name')) }}\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button data-testid=\"confirm-btn\" type=\"submit\" class=\"btn btn-primary\">\n      {{ i18n(\"Duplicate.Modal.Confirm\") | translate }}\n    </button>\n    <button data-testid=\"cancel-btn\" type=\"button\" class=\"btn btn-outline-dark\"\n      (click)=\"activeModal.close('Close click')\">\n      {{ i18n(\"Duplicate.Cancel\") | translate }}\n    </button>\n  </div>\n</form>\n", styles: [".busy-loader-container ::ng-deep .bento-busyloader-front-blocker{background:0}\n"], directives: [{ type: i2$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["size", "showDelay", "hideDelay", "bentoBusyLoader"], outputs: ["show", "hide"] }, { type: i2$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i2$1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: i5.BentoFooterTabHelper, selector: "[class=\"modal-footer\"]" }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DuplicateModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-modal-content', providers: [TranslatePipe], template: "<form class=\"busy-loader-container\" [formGroup]=\"duplicateForm\" (submit)=\"save()\" [bentoBusyLoader]=\"loadingActionsBusyLoader.state\">\n  <div class=\"modal-header\">\n    {{ i18n('Duplicate.Modal.Confirm.Title') | translate }}\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-5\">\n      <div class=\"form-group\">\n        <label class=\"bento-label-required\" for=\"id\">\n          {{i18n('Duplicate.Id') | translate}}\n        </label>\n        <input [class.border-danger]=\"shouldShowError('code')\" (paste)=\"onCodePaste($event)\" (keypress)=\"onCodeKeypress($event)\" class=\"bento-input form-control\" id=\"code\" name=\"code\"\n          formControlName=\"code\" required type=\"text\">\n        <div *ngIf=\"shouldShowError('code')\" class=\"bfm-error-message\">\n          <span class=\"ng-star-inserted\">\n            {{ showErrorMessage(i18n('Duplicate.Id')) }}\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-5\">\n      <div class=\"form-group\">\n        <label class=\"bento-label-required\" for=\"name\">\n          {{ i18n('Duplicate.Name') | translate }}\n        </label>\n        <input [class.border-danger]=\"shouldShowError('name')\" class=\"bento-input form-control\" id=\"name\" name=\"name\"\n          formControlName=\"name\" required type=\"text\" maxlength=\"200\" />\n        <div *ngIf=\"shouldShowError('name')\" class=\"bfm-error-message\">\n          <span class=\"ng-star-inserted\">\n            {{ showErrorMessage(i18n('Duplicate.Name')) }}\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button data-testid=\"confirm-btn\" type=\"submit\" class=\"btn btn-primary\">\n      {{ i18n(\"Duplicate.Modal.Confirm\") | translate }}\n    </button>\n    <button data-testid=\"cancel-btn\" type=\"button\" class=\"btn btn-outline-dark\"\n      (click)=\"activeModal.close('Close click')\">\n      {{ i18n(\"Duplicate.Cancel\") | translate }}\n    </button>\n  </div>\n</form>\n", styles: [".busy-loader-container ::ng-deep .bento-busyloader-front-blocker{background:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }, { type: i1$1.TranslateService }, { type: CalculationTemplateService }, { type: i1$1.TranslatePipe }, { type: i2$1.FormBuilder }, { type: AlertService }, { type: LoaderService }]; }, propDecorators: { id: [{
                type: Input
            }], newCode: [{
                type: Input
            }], newName: [{
                type: Input
            }] } });

var FilterType;
(function (FilterType) {
    FilterType[FilterType["NONE"] = 0] = "NONE";
    FilterType[FilterType["CONDITION"] = 1] = "CONDITION";
    FilterType[FilterType["VALUE"] = 2] = "VALUE";
    FilterType[FilterType["CONDITION_AND_VALUE"] = 3] = "CONDITION_AND_VALUE";
})(FilterType || (FilterType = {}));

class ToolbarComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.actions = [];
        this.actionsButtons = [];
        this.filtersHidden = false;
    }
    ngOnInit() {
        this.setActionsButtons();
    }
    ngOnChanges(changes) {
        if (changes.actions) {
            changes.actions.currentValue.forEach((element, index) => {
                if (!!this.actionsButtons[index]) {
                    this.actionsButtons[index].disabled = element.disabled;
                }
            });
            if (!!this.bentoToolbar) {
                this.bentoToolbar.refresh();
            }
        }
    }
    setActionsButtons() {
        let translatedType = '';
        forkJoin([
            this.translateService.get('Onvio.AccountingCosts.Toolbar.Add'),
            this.translateService.get('Onvio.AccountingCosts.Toolbar.Duplicate'),
            this.translateService.get('Onvio.AccountingCosts.Toolbar.Remove'),
            this.translateService.get('Onvio.AccountingCosts.Toolbar.Excluir'),
        ]).pipe(first()).subscribe(([add, duplicate, remove, excluir]) => {
            this.actionsButtons = this.actions.map((_a) => {
                var { type } = _a, config = __rest(_a, ["type"]);
                if (type) {
                    switch (type) {
                        case 'Add':
                            translatedType = add;
                            break;
                        case 'Duplicate':
                            translatedType = duplicate;
                            break;
                        case 'Remove':
                            translatedType = remove;
                            break;
                        case 'Excluir':
                            translatedType = excluir;
                            break;
                    }
                }
                return (Object.assign({ label: translatedType, icon: this.getActionIcon(type), static: true }, config));
            });
        });
    }
    getTranslate(node) {
        return this.translateService.get(this.i18n(node)).toPromise();
    }
    i18n(node) {
        return `Onvio.AccountingCosts.Toolbar.${node}`;
    }
    getActionIcon(type) {
        switch (type) {
            case ActionTypes.ADD:
                return 'bento-icon-add';
            case ActionTypes.DUPLICATE:
                return 'bento-icon-copy';
            case ActionTypes.REMOVE:
                return 'bento-icon-remove';
        }
    }
    getTooltipToggleFilters() {
        return this.filtersHidden ? this.i18n('ShowFilters') : this.i18n('HideFilters');
    }
    handleToggleFilter() {
        this.filtersHidden = !this.filtersHidden;
        if (this.toggleFilter) {
            this.toggleFilter(this.filtersHidden);
        }
    }
}
ToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToolbarComponent, deps: [{ token: i1$1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
ToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ToolbarComponent, selector: "acc-toolbar", inputs: { actions: "actions", toggleFilter: "toggleFilter", columns: "columns" }, viewQueries: [{ propertyName: "bentoToolbar", first: true, predicate: ["toolbar"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"ng-bento\">\n  <bento-toolbar #toolbar *ngIf=\"actionsButtons.length\" class=\"bento-toolbar\" [items]=\"actionsButtons\">\n    <ul class=\"nav navbar-right\" role=\"group\">\n      <li>\n        <button class=\"btn btn-outline-primary btn-icon btn-toggle\" [ngClass]=\"{'active':!filtersHidden}\"\n          placement=\"bottom\" [ngbTooltip]=\"getTooltipToggleFilters() | translate\" (click)=\"handleToggleFilter()\">\n          <i class=\"bento-icon-filter-az\"></i>\n        </button>\n      </li>\n      <li>\n        <div ngbDropdown id=\"dropDown\" autoClose=\"outside\">\n          <button class=\"btn btn-outline-primary btn-icon btn-toggle dropdown-toggle\" ngbDropdownToggle\n            placement=\"bottom\" [ngbTooltip]=\"i18n('ToggleColumns') | translate\">\n            <i class=\"bento-icon-cog\"></i>\n            <i class=\"bento-icon-arrow-down2\"></i>\n          </button>\n          <ul ngbDropdownMenu class=\"dropdown-menu\" aria-labelledby=\"colVisibility\">\n            <li ngbDropdownItem *ngFor=\"let item of columns\" class=\"dropdown-item\">\n              <a (click)=\"item.visible = !item.visible\" *ngIf=\"item.binding !== 'actions'\">\n                <i [ngClass]=\"{'bento-icon-checkbox':!item.visible,'bento-icon-checkbox-filled':item.visible}\"></i>\n                {{ item.header }}\n              </a>\n            </li>\n          </ul>\n        </div>\n      </li>\n    </ul>\n  </bento-toolbar>\n</div>\n", styles: ["::ng-deep .ng-bento ::ng-deep .tooltip.show{border:none;box-shadow:none}::ng-deep .ng-bento .bento-toolbar .navbar-right>li .btn.btn-toggle.active,.ng-bento .bento-toolbar .navbar-list>li .btn.btn-toggle.active{border:1px transparent}:host ::ng-deep .ng-bento .bento-toolbar .navbar-nav .more-button{display:none!important}.ng-bento .bento-toolbar{height:36px}.ng-bento .bento-toolbar .navbar-right{height:31px}.ng-bento .bento-toolbar .navbar-right li .btn{margin:3px 0 0}\n"], components: [{ type: i5.BentoToolbarComponent, selector: "bento-toolbar", inputs: ["items", "moreText"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i1$2.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i1$2.NgbDropdown, selector: "[ngbDropdown]", inputs: ["open", "placement", "container", "autoClose", "display", "dropdownClass"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i1$2.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i5.BentoNgbDropdownAnimationDirective, selector: "[ngbDropdownMenu], bento-megamenu" }, { type: i1$2.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$2.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["disabled"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-toolbar', template: "<div class=\"ng-bento\">\n  <bento-toolbar #toolbar *ngIf=\"actionsButtons.length\" class=\"bento-toolbar\" [items]=\"actionsButtons\">\n    <ul class=\"nav navbar-right\" role=\"group\">\n      <li>\n        <button class=\"btn btn-outline-primary btn-icon btn-toggle\" [ngClass]=\"{'active':!filtersHidden}\"\n          placement=\"bottom\" [ngbTooltip]=\"getTooltipToggleFilters() | translate\" (click)=\"handleToggleFilter()\">\n          <i class=\"bento-icon-filter-az\"></i>\n        </button>\n      </li>\n      <li>\n        <div ngbDropdown id=\"dropDown\" autoClose=\"outside\">\n          <button class=\"btn btn-outline-primary btn-icon btn-toggle dropdown-toggle\" ngbDropdownToggle\n            placement=\"bottom\" [ngbTooltip]=\"i18n('ToggleColumns') | translate\">\n            <i class=\"bento-icon-cog\"></i>\n            <i class=\"bento-icon-arrow-down2\"></i>\n          </button>\n          <ul ngbDropdownMenu class=\"dropdown-menu\" aria-labelledby=\"colVisibility\">\n            <li ngbDropdownItem *ngFor=\"let item of columns\" class=\"dropdown-item\">\n              <a (click)=\"item.visible = !item.visible\" *ngIf=\"item.binding !== 'actions'\">\n                <i [ngClass]=\"{'bento-icon-checkbox':!item.visible,'bento-icon-checkbox-filled':item.visible}\"></i>\n                {{ item.header }}\n              </a>\n            </li>\n          </ul>\n        </div>\n      </li>\n    </ul>\n  </bento-toolbar>\n</div>\n", styles: ["::ng-deep .ng-bento ::ng-deep .tooltip.show{border:none;box-shadow:none}::ng-deep .ng-bento .bento-toolbar .navbar-right>li .btn.btn-toggle.active,.ng-bento .bento-toolbar .navbar-list>li .btn.btn-toggle.active{border:1px transparent}:host ::ng-deep .ng-bento .bento-toolbar .navbar-nav .more-button{display:none!important}.ng-bento .bento-toolbar{height:36px}.ng-bento .bento-toolbar .navbar-right{height:31px}.ng-bento .bento-toolbar .navbar-right li .btn{margin:3px 0 0}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }]; }, propDecorators: { actions: [{
                type: Input
            }], toggleFilter: [{
                type: Input
            }], columns: [{
                type: Input
            }], bentoToolbar: [{
                type: ViewChild,
                args: ['toolbar']
            }] } });

class BentoTableComponent {
    constructor(modalService, routerService, service, translateService, addCostsCalculationTemplateService, dateFormatter, flexGridService, loaderService) {
        this.modalService = modalService;
        this.routerService = routerService;
        this.service = service;
        this.translateService = translateService;
        this.addCostsCalculationTemplateService = addCostsCalculationTemplateService;
        this.dateFormatter = dateFormatter;
        this.flexGridService = flexGridService;
        this.filteredColumns = ['code', 'updatedAt', 'templateName'];
        this.actions = [
            {
                type: ActionTypes.ADD,
                action: () => {
                    this.openNewTemplatePage();
                }
            },
            {
                type: ActionTypes.DUPLICATE,
                action: () => {
                    this.openDuplicateModal();
                },
                disabled: true
            },
            {
                type: ActionTypes.REMOVE,
                action: () => {
                    this.openDeleteModal();
                },
                disabled: true
            }
        ];
        this.columns = [];
        this.columnDefinitionsByBinding = {
            code: new wjcGrid.Column(),
            actions: new wjcGrid.Column(),
            updatedAt: new wjcGrid.Column(),
            templateName: new wjcGrid.Column()
        };
        this.toggleFilterProp = this.toggleFilter.bind(this);
        this.headerCheckBoxMode = CheckboxState.UNSELECTED;
        this.selectBinding = 'selected';
        this.idBinding = 'id';
        this.nextCode = 0;
        this.CODE_COLUMN_WIDTH = 100;
        this.ACTIONS_COLUMN_WIDTH = 80;
        this.UPDATE_AT_COLUMN_WIDTH = 158;
        this.isDefaultSelected = false;
        this.loadingTemplatesBusyLoader = loaderService.templatesLoader;
        this.loadingTemplatesBusyLoader.show();
    }
    updateFlexGridRows(flexGrid) {
        flexGrid = this.flexGridService.updateFlexGridRows(this.flexGrid);
    }
    i18n(node) {
        return `Onvio.AccountingCosts.CalculationTemplate.${node}`;
    }
    // After View Init Handler
    ngOnInit() {
        this.setNextCode();
        this.getCalculationModels();
        this.generateColumnBindings();
        this.flexGrid = this.flexGridService.updateFlexGridRows(this.flexGrid);
        this.toggleFilter(true);
    }
    generateColumnBindings() {
        this.getColumnBindings().subscribe(columns => {
            this.columns = columns;
            this.columnDefinitionsByBinding = this.getColumnDefinitionByBindings(columns);
        });
    }
    getCalculationModels() {
        this.service
            .getAllCalculationModels()
            .pipe(take(1))
            .subscribe(res => {
            const data = (res.items || []).map(item => {
                const calculationModelRow = {
                    id: item.id,
                    code: item.code,
                    selected: false,
                    templateName: item.name,
                    updatedAt: '',
                    isDefaultModel: item.defaultModel
                };
                if (!!item.changed) {
                    this.dateFormatter.formatUtcDate(item.changed)
                        .pipe(take(1))
                        .subscribe(formattedDateTime => {
                        calculationModelRow.updatedAt = formattedDateTime;
                    });
                }
                return calculationModelRow;
            });
            this.data = new wjcCore.CollectionView(data);
            this.loadingTemplatesBusyLoader.hide();
        });
    }
    getColumnBindings() {
        return forkJoin([
            this.translateService.get('Onvio.AccountingCosts.CalculationTemplate.TableHeader.ID'),
            this.translateService.get('Onvio.AccountingCosts.CalculationTemplate.TableHeader.Actions'),
            this.translateService.get('Onvio.AccountingCosts.CalculationTemplate.TableHeader.UpdatedAt'),
            this.translateService.get('Onvio.AccountingCosts.CalculationTemplate.TableHeader.TemplateName')
        ]).pipe(map(([id, actions, updatedAt, templateName]) => {
            return [
                new wjcGrid.Column({
                    header: id,
                    binding: 'code',
                    visible: true,
                    isReadOnly: true,
                    width: this.CODE_COLUMN_WIDTH,
                    format: 'f0'
                }),
                new wjcGrid.Column({
                    header: actions,
                    binding: 'actions',
                    visible: true,
                    isReadOnly: true,
                    width: this.ACTIONS_COLUMN_WIDTH
                }),
                new wjcGrid.Column({
                    header: updatedAt,
                    binding: 'updatedAt',
                    visible: true,
                    isReadOnly: true,
                    width: this.UPDATE_AT_COLUMN_WIDTH
                }),
                new wjcGrid.Column({
                    header: templateName,
                    binding: 'templateName',
                    visible: true,
                    isReadOnly: true,
                    width: '*'
                })
            ];
        }));
    }
    gridInitialized() {
        this.initializeHeaders();
    }
    initializeHeaders() {
        if (this.flexGrid) {
            this.flexGrid.rowHeaders.columns.pop();
            const hc = new wjcGrid.Column();
            this.flexGrid.rowHeaders.columns.push(hc);
        }
    }
    onCheckBoxChange() {
        this.isDefaultSelected = false;
        this.headerCheckBoxMode = CheckboxState.UNSELECTED;
        let count = 0;
        for (let i = 0, ttl = this.flexGrid.rows.length; i < ttl; i++) {
            if (this.flexGrid.rows[i].dataItem[this.selectBinding]) {
                if (this.flexGrid.rows[i].dataItem.isDefaultModel === true) {
                    this.isDefaultSelected = true;
                }
                count++;
                this.flexGrid.rows[i].cssClass = 'row-selected';
            }
            else {
                this.flexGrid.rows[i].cssClass = '';
            }
        }
        if (count === this.flexGrid.rows.length) {
            this.headerCheckBoxMode = CheckboxState.SELECTED;
        }
        else if (count > 0) {
            this.headerCheckBoxMode = CheckboxState.INDETERMINATE;
        }
        this.disableActionButtons(count);
    }
    disableActionButtons(count) {
        this.actions = this.actions.map(item => {
            if (item.type === ActionTypes.DUPLICATE) {
                item.disabled = count !== 1;
            }
            if (item.type === ActionTypes.REMOVE) {
                item.disabled = (count === 0 || this.isDefaultSelected);
            }
            return item;
        });
    }
    isAllSelected() {
        return this.headerCheckBoxMode === CheckboxState.SELECTED;
    }
    isIndeterminate() {
        return this.headerCheckBoxMode === CheckboxState.INDETERMINATE;
    }
    onHeaderCheckBoxChange() {
        let selected = false;
        let count = 0;
        this.isDefaultSelected = true;
        if (this.headerCheckBoxMode !== CheckboxState.SELECTED) {
            this.headerCheckBoxMode = CheckboxState.SELECTED;
            selected = true;
        }
        else {
            this.headerCheckBoxMode = CheckboxState.UNSELECTED;
            selected = false;
        }
        for (let i = 0, ttl = this.flexGrid.rows.length; i < ttl; i++) {
            this.flexGrid.rows[i].dataItem[this.selectBinding] = selected;
            this.flexGrid.rows[i].cssClass = selected ? 'row-selected' : '';
            if (this.flexGrid.rows[i].dataItem[this.selectBinding]) {
                count++;
            }
        }
        this.disableActionButtons(count);
    }
    toggleFilter(filtersHidden) {
        if (this.gridFilter) {
            // iterate through filtered columns
            for (const column of this.columns) {
                // get column
                const gridColumn = this.gridFilter.grid.columns.getColumn(column.binding);
                // get column filter
                const columnFilter = gridColumn ? this.gridFilter.getColumnFilter(gridColumn, true) : {};
                columnFilter.filterType = filtersHidden ? FilterType.NONE : FilterType.CONDITION_AND_VALUE;
            }
            this.gridFilter.grid.refresh();
        }
    }
    openNewTemplatePage() {
        this.addCostsCalculationTemplateService.resetState();
        this.routerService.setRoute(new AddCostsCalculationRoute());
    }
    openDuplicateModal(rowIndex) {
        const modalRef = this.modalService.open(DuplicateModalComponent, {
            container: '#bentoNGModalContainer',
            size: 'lg'
        });
        modalRef.componentInstance.id = !!(rowIndex + 1)
            ? this.getId(rowIndex)
            : this.getSelectedCheckboxByCode();
        modalRef.componentInstance.newCode = this.nextCode;
        modalRef.componentInstance.newName = '';
        modalRef.result.then(result => {
            if (result === 'save click') {
                this.setNextCode();
                this.getCalculationModels();
            }
        });
    }
    openDeleteModal(rowIndex) {
        const modalRef = this.modalService.open(DeleteModalComponent, {
            container: '#bentoNGModalContainer',
            size: 'lg'
        });
        const ids = !!(rowIndex + 1) ? [this.getId(rowIndex)] : this.getSelectedCheckboxes();
        modalRef.componentInstance.ids = ids;
        modalRef.result.then(result => {
            if (result === 'save click') {
                this.disableActionButtons(0);
                this.setNextCode();
                this.getCalculationModels();
            }
        });
    }
    getId(rowIndex) {
        if (!!this.flexGrid &&
            !!this.flexGrid.rows[rowIndex] &&
            !!this.flexGrid.rows[rowIndex].dataItem[this.idBinding]) {
            return this.flexGrid.rows[rowIndex].dataItem[this.idBinding];
        }
    }
    getSelectedCheckboxByCode() {
        for (let i = 0, ttl = this.flexGrid.rows.length; i < ttl; i++) {
            if (this.flexGrid.rows[i].dataItem[this.selectBinding] === true) {
                return this.flexGrid.rows[i].dataItem[this.idBinding];
            }
        }
    }
    getCode(rowIndex) {
        if (!!this.flexGrid &&
            !!this.flexGrid.rows[rowIndex] &&
            !!this.flexGrid.rows[rowIndex].dataItem.code) {
            return this.flexGrid.rows[rowIndex].dataItem.code;
        }
    }
    isDefaultModel(rowIndex) {
        if (!!this.flexGrid &&
            !!this.flexGrid.rows[rowIndex] &&
            !!this.flexGrid.rows[rowIndex].dataItem.isDefaultModel) {
            return this.flexGrid.rows[rowIndex].dataItem.isDefaultModel;
        }
        else {
            return false;
        }
    }
    getSelectedCheckboxes() {
        const selectedIds = this.flexGrid.rows.reduce((ids, row) => {
            const isSelected = !!row.dataItem[this.selectBinding];
            if (isSelected) {
                const id = row.dataItem[this.idBinding];
                return [...ids, id];
            }
            return ids;
        }, []);
        return selectedIds;
    }
    getColumnDefinitionByBindings(columns = []) {
        return columns.reduce((result, item) => {
            result[item.binding] = item;
            return result;
        }, {});
    }
    setNextCode() {
        this.service
            .getNextTemplate()
            .pipe(take(1))
            .subscribe(nextTemplate => {
            this.nextCode = nextTemplate.code;
        });
    }
    edit(rowIndex) {
        if (this.flexGrid.rows[rowIndex].dataItem[this.idBinding]) {
            this.routerService.setRoute(new AddCostsCalculationRoute({
                templateId: this.flexGrid.rows[rowIndex].dataItem[this.idBinding]
            }));
        }
    }
}
BentoTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BentoTableComponent, deps: [{ token: i1$2.NgbModal }, { token: RouterService }, { token: CalculationTemplateService }, { token: i1$1.TranslateService }, { token: AddCostsCalculationTemplateService }, { token: DateFormatterService }, { token: AccountingCostsFlexGridServices }, { token: LoaderService }], target: i0.ɵɵFactoryTarget.Component });
BentoTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: BentoTableComponent, selector: "acc-bento-table", providers: [
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
        { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }
    ], viewQueries: [{ propertyName: "gridFilter", first: true, predicate: ["filter"], descendants: true }, { propertyName: "flexGrid", first: true, predicate: ["flexGrid"], descendants: true, static: true }], ngImport: i0, template: "<acc-toolbar\n  [actions]=\"actions\"\n  [toggleFilter]=\"toggleFilterProp\"\n  [columns]=\"columns\"\n></acc-toolbar>\n<div\n  class=\"busy-loader-container\"\n  [bentoBusyLoader]=\"loadingTemplatesBusyLoader.state\"\n>\n  <wj-flex-grid\n    #flexGrid\n    class=\"bento-flex-grid has-row-hover\"\n    [ngStyle]=\"{\n      height: loadingTemplatesBusyLoader.state ? 'calc(100vh - 250px)' : ''\n    }\"\n    [itemsSource]=\"data\"\n    [stickyHeaders]=\"true\"\n    [showMarquee]=\"false\"\n    [showSort]=\"true\"\n    (initialized)=\"gridInitialized()\"\n    (loadedRows)=\"updateFlexGridRows(flexGrid)\"\n  >\n    <!-- FLEXGRID FILTER -->\n    <wj-flex-grid-filter\n      #filter\n      [filterColumns]=\"filteredColumns\"\n    ></wj-flex-grid-filter>\n    <ng-template wjFlexGridCellTemplate [cellType]=\"'TopLeft'\" let-col=\"col\">\n      <bento-checkbox\n        [ngModel]=\"isAllSelected()\"\n        (change)=\"onHeaderCheckBoxChange()\"\n        [indeterminate]=\"isIndeterminate()\"\n      ></bento-checkbox>\n    </ng-template>\n    <ng-template\n      wjFlexGridCellTemplate\n      [cellType]=\"'RowHeader'\"\n      let-col=\"col\"\n      let-row=\"row\"\n      let-item=\"item\"\n    >\n      <bento-checkbox\n        [ngModel]=\"item.selected\"\n        (change)=\"\n          item.disabled || (item.selected = !item.selected); onCheckBoxChange()\n        \"\n      ></bento-checkbox>\n    </ng-template>\n\n    <wj-flex-grid-column\n      [header]=\"columnDefinitionsByBinding['code'].header\"\n      [binding]=\"columnDefinitionsByBinding['code'].binding\"\n      [visible]=\"columnDefinitionsByBinding['code'].visible\"\n      [isReadOnly]=\"columnDefinitionsByBinding['code'].isReadOnly\"\n      [width]=\"columnDefinitionsByBinding['code'].width\"\n      [format]=\"columnDefinitionsByBinding['code'].format\"\n      [allowResizing]=\"false\"\n      [dataType]=\"2\"\n    >\n      <ng-template wjFlexGridCellTemplate [cellType]=\"'ColumnHeader'\">\n        <div class=\"id-header\">\n          {{ columnDefinitionsByBinding[\"code\"].header }}\n        </div>\n      </ng-template>\n    </wj-flex-grid-column>\n\n    <!-- Actions Column -->\n    <wj-flex-grid-column\n      [header]=\"columnDefinitionsByBinding['actions'].header\"\n      [binding]=\"columnDefinitionsByBinding['actions'].binding\"\n      [visible]=\"columnDefinitionsByBinding['actions'].visible\"\n      [isReadOnly]=\"columnDefinitionsByBinding['actions'].isReadOnly\"\n      [width]=\"columnDefinitionsByBinding['actions'].width\"\n      [minWidth]=\"columnDefinitionsByBinding['actions'].minWidth\"\n      [allowSorting]=\"columnDefinitionsByBinding['actions'].allowSorting\"\n      [allowDragging]=\"columnDefinitionsByBinding['actions'].allowDragging\"\n      [cssClass]=\"'action-column'\"\n      [allowResizing]=\"false\"\n    >\n      <ng-template\n        wjFlexGridCellTemplate\n        [cellType]=\"'Cell'\"\n        let-item=\"item\"\n        let-row=\"row\"\n      >\n        <button\n          class=\"grid-action-icon action-button\"\n          [ngbTooltip]=\"i18n('Actions.Edit') | translate\"\n          [title]=\"i18n('Actions.Edit') | translate\"\n          container=\"body\"\n          (click)=\"edit(row.index)\"\n        >\n          <i class=\"bento-icon-edit\"></i>\n        </button>\n        <button\n          class=\"grid-action-icon action-button\"\n          [ngbTooltip]=\"i18n('Actions.Duplicate') | translate\"\n          [title]=\"i18n('Actions.Duplicate') | translate\"\n          container=\"body\"\n          (click)=\"openDuplicateModal(row.index)\"\n          data-testid=\"duplicate-icon\"\n        >\n          <i class=\"bento-icon-copy\"></i>\n        </button>\n        <button\n          class=\"grid-action-icon action-button\"\n          [ngbTooltip]=\"i18n('Actions.Remove') | translate\"\n          [title]=\"i18n('Actions.Remove') | translate\"\n          container=\"body\"\n          (click)=\"openDeleteModal(row.index)\"\n          data-testid=\"remove-icon\"\n          [disabled]=\"isDefaultModel(row.index)\"\n        >\n          <i class=\"bento-icon-remove\"></i>\n        </button>\n      </ng-template>\n    </wj-flex-grid-column>\n\n    <wj-flex-grid-column\n      [header]=\"columnDefinitionsByBinding['updatedAt'].header\"\n      [binding]=\"columnDefinitionsByBinding['updatedAt'].binding\"\n      [visible]=\"columnDefinitionsByBinding['updatedAt'].visible\"\n      [isReadOnly]=\"columnDefinitionsByBinding['updatedAt'].isReadOnly\"\n      [width]=\"columnDefinitionsByBinding['updatedAt'].width\"\n      [allowResizing]=\"false\"\n    >\n    </wj-flex-grid-column>\n\n    <wj-flex-grid-column\n      [header]=\"columnDefinitionsByBinding['templateName'].header\"\n      [binding]=\"columnDefinitionsByBinding['templateName'].binding\"\n      [visible]=\"columnDefinitionsByBinding['templateName'].visible\"\n      [isReadOnly]=\"columnDefinitionsByBinding['templateName'].isReadOnly\"\n      [width]=\"'*'\"\n    >\n    </wj-flex-grid-column>\n  </wj-flex-grid>\n</div>\n", styles: [".bento-flex-grid{max-height:calc(100vh - 250px)}::ng-deep .bento-flex-grid .wj-header.wj-cell{text-transform:none}::ng-deep .ng-bento ::ng-deep .bento-flex-grid ::ng-deep .wj-header.wj-cell{text-transform:none}::ng-deep .action-column:not(.wj-group){padding-right:10px!important}.wj-control.wj-flexgrid ::ng-deep .wj-cell ::ng-deep .wj-btn.wj-elem-filter{align-items:unset;justify-content:unset}.id-header{position:absolute}.action-button{cursor:pointer;font-size:14px;border:none;background:none;outline:none;padding:0}.action-button[disabled]{cursor:default!important}.action-button[disabled]>i{color:#a5a5ad}@media (min-width: 768px){::ng-deep .ng-bento .modal .modal-dialog.modal-lg .modal-content{width:600px}}\n"], components: [{ type: ToolbarComponent, selector: "acc-toolbar", inputs: ["actions", "toggleFilter", "columns"] }, { type: i2.WjFlexGrid, selector: "wj-flex-grid", inputs: ["wjModelProperty", "isDisabled", "tabOrder", "newRowAtTop", "allowAddNew", "allowDelete", "allowDragging", "allowMerging", "allowResizing", "allowSorting", "allowPinning", "autoScroll", "autoRowHeights", "autoSizeMode", "autoGenerateColumns", "autoSearch", "caseSensitiveSearch", "quickAutoSize", "bigCheckboxes", "childItemsPath", "groupHeaderFormat", "headersVisibility", "showSelectedHeaders", "showMarquee", "showPlaceholders", "itemFormatter", "isReadOnly", "imeEnabled", "mergeManager", "selectionMode", "showGroups", "showSort", "showDropDown", "showAlternatingRows", "showErrors", "alternatingRowStep", "itemValidator", "validateEdits", "treeIndent", "itemsSource", "autoClipboard", "expandSelectionOnCopyPaste", "frozenCells", "frozenRows", "frozenColumns", "cloneFrozenCells", "deferResizing", "sortRowIndex", "editColumnIndex", "stickyHeaders", "preserveSelectedState", "preserveOutlineState", "preserveWhiteSpace", "keyActionTab", "keyActionEnter", "rowHeaderPath", "virtualizationThreshold", "anchorCursor", "lazyRender", "refreshOnEdit", "copyHeaders", "columnGroups", "commitEmptyEdits", "headersFocusability", "ariaLabel", "skipMerged", "pasteEmptyCells", "groupSummaryPosition"], outputs: ["initialized", "gotFocus", "lostFocus", "refreshing", "refreshed", "invalidInput", "beginningEdit", "cellEditEnded", "cellEditEnding", "prepareCellForEdit", "formatItem", "resizingColumn", "resizedColumn", "autoSizingColumn", "autoSizedColumn", "draggingColumn", "draggingColumnOver", "draggedColumn", "sortingColumn", "sortedColumn", "pinningColumn", "pinnedColumn", "resizingRow", "resizedRow", "autoSizingRow", "autoSizedRow", "draggingRow", "draggingRowOver", "draggedRow", "deletingRow", "deletedRow", "loadingRows", "loadedRows", "rowEditStarting", "rowEditStarted", "rowEditEnding", "rowEditEnded", "rowAdded", "groupCollapsedChanging", "groupCollapsedChanged", "columnGroupCollapsedChanging", "columnGroupCollapsedChanged", "itemsSourceChanging", "itemsSourceChanged", "selectionChanging", "selectionChanged", "scrollPositionChanged", "updatingView", "updatedView", "updatingLayout", "updatedLayout", "pasting", "pasted", "pastingCell", "pastedCell", "copying", "copied"] }, { type: i11.WjFlexGridFilter, selector: "wj-flex-grid-filter", inputs: ["wjProperty", "showFilterIcons", "showSortButtons", "defaultFilterType", "filterColumns", "exclusiveValueSearch", "reApplyFilterOnUpdate", "showIncludeSelection"], outputs: ["initialized", "editingFilter", "filterChanging", "filterChanged", "filterApplied"] }, { type: i5.BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }, { type: i2.WjFlexGridColumn, selector: "wj-flex-grid-column", inputs: ["asyncBindings", "wjProperty", "name", "dataMap", "dataType", "binding", "sortMemberPath", "format", "cellTemplate", "header", "width", "maxLength", "minWidth", "maxWidth", "align", "allowDragging", "allowSorting", "allowResizing", "allowMerging", "aggregate", "isReadOnly", "cssClass", "cssClassAll", "isContentHtml", "isSelected", "visible", "wordWrap", "multiLine", "mask", "inputType", "isRequired", "showDropDown", "dataMapEditor", "dropDownCssClass", "quickAutoSize", "editor", "placeholder"], outputs: ["initialized", "isSelectedChange"] }], directives: [{ type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["size", "showDelay", "hideDelay", "bentoBusyLoader"], outputs: ["show", "hide"] }, { type: i4.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i2.WjFlexGridCellTemplate, selector: "[wjFlexGridCellTemplate]", inputs: ["wjFlexGridCellTemplate", "cellOverflow", "valuePaths", "autoSizeRows", "forceFullEdit", "cellType"], exportAs: ["wjFlexGridCellTemplate"] }, { type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i1$2.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BentoTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-bento-table', providers: [
                        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
                        { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }
                    ], template: "<acc-toolbar\n  [actions]=\"actions\"\n  [toggleFilter]=\"toggleFilterProp\"\n  [columns]=\"columns\"\n></acc-toolbar>\n<div\n  class=\"busy-loader-container\"\n  [bentoBusyLoader]=\"loadingTemplatesBusyLoader.state\"\n>\n  <wj-flex-grid\n    #flexGrid\n    class=\"bento-flex-grid has-row-hover\"\n    [ngStyle]=\"{\n      height: loadingTemplatesBusyLoader.state ? 'calc(100vh - 250px)' : ''\n    }\"\n    [itemsSource]=\"data\"\n    [stickyHeaders]=\"true\"\n    [showMarquee]=\"false\"\n    [showSort]=\"true\"\n    (initialized)=\"gridInitialized()\"\n    (loadedRows)=\"updateFlexGridRows(flexGrid)\"\n  >\n    <!-- FLEXGRID FILTER -->\n    <wj-flex-grid-filter\n      #filter\n      [filterColumns]=\"filteredColumns\"\n    ></wj-flex-grid-filter>\n    <ng-template wjFlexGridCellTemplate [cellType]=\"'TopLeft'\" let-col=\"col\">\n      <bento-checkbox\n        [ngModel]=\"isAllSelected()\"\n        (change)=\"onHeaderCheckBoxChange()\"\n        [indeterminate]=\"isIndeterminate()\"\n      ></bento-checkbox>\n    </ng-template>\n    <ng-template\n      wjFlexGridCellTemplate\n      [cellType]=\"'RowHeader'\"\n      let-col=\"col\"\n      let-row=\"row\"\n      let-item=\"item\"\n    >\n      <bento-checkbox\n        [ngModel]=\"item.selected\"\n        (change)=\"\n          item.disabled || (item.selected = !item.selected); onCheckBoxChange()\n        \"\n      ></bento-checkbox>\n    </ng-template>\n\n    <wj-flex-grid-column\n      [header]=\"columnDefinitionsByBinding['code'].header\"\n      [binding]=\"columnDefinitionsByBinding['code'].binding\"\n      [visible]=\"columnDefinitionsByBinding['code'].visible\"\n      [isReadOnly]=\"columnDefinitionsByBinding['code'].isReadOnly\"\n      [width]=\"columnDefinitionsByBinding['code'].width\"\n      [format]=\"columnDefinitionsByBinding['code'].format\"\n      [allowResizing]=\"false\"\n      [dataType]=\"2\"\n    >\n      <ng-template wjFlexGridCellTemplate [cellType]=\"'ColumnHeader'\">\n        <div class=\"id-header\">\n          {{ columnDefinitionsByBinding[\"code\"].header }}\n        </div>\n      </ng-template>\n    </wj-flex-grid-column>\n\n    <!-- Actions Column -->\n    <wj-flex-grid-column\n      [header]=\"columnDefinitionsByBinding['actions'].header\"\n      [binding]=\"columnDefinitionsByBinding['actions'].binding\"\n      [visible]=\"columnDefinitionsByBinding['actions'].visible\"\n      [isReadOnly]=\"columnDefinitionsByBinding['actions'].isReadOnly\"\n      [width]=\"columnDefinitionsByBinding['actions'].width\"\n      [minWidth]=\"columnDefinitionsByBinding['actions'].minWidth\"\n      [allowSorting]=\"columnDefinitionsByBinding['actions'].allowSorting\"\n      [allowDragging]=\"columnDefinitionsByBinding['actions'].allowDragging\"\n      [cssClass]=\"'action-column'\"\n      [allowResizing]=\"false\"\n    >\n      <ng-template\n        wjFlexGridCellTemplate\n        [cellType]=\"'Cell'\"\n        let-item=\"item\"\n        let-row=\"row\"\n      >\n        <button\n          class=\"grid-action-icon action-button\"\n          [ngbTooltip]=\"i18n('Actions.Edit') | translate\"\n          [title]=\"i18n('Actions.Edit') | translate\"\n          container=\"body\"\n          (click)=\"edit(row.index)\"\n        >\n          <i class=\"bento-icon-edit\"></i>\n        </button>\n        <button\n          class=\"grid-action-icon action-button\"\n          [ngbTooltip]=\"i18n('Actions.Duplicate') | translate\"\n          [title]=\"i18n('Actions.Duplicate') | translate\"\n          container=\"body\"\n          (click)=\"openDuplicateModal(row.index)\"\n          data-testid=\"duplicate-icon\"\n        >\n          <i class=\"bento-icon-copy\"></i>\n        </button>\n        <button\n          class=\"grid-action-icon action-button\"\n          [ngbTooltip]=\"i18n('Actions.Remove') | translate\"\n          [title]=\"i18n('Actions.Remove') | translate\"\n          container=\"body\"\n          (click)=\"openDeleteModal(row.index)\"\n          data-testid=\"remove-icon\"\n          [disabled]=\"isDefaultModel(row.index)\"\n        >\n          <i class=\"bento-icon-remove\"></i>\n        </button>\n      </ng-template>\n    </wj-flex-grid-column>\n\n    <wj-flex-grid-column\n      [header]=\"columnDefinitionsByBinding['updatedAt'].header\"\n      [binding]=\"columnDefinitionsByBinding['updatedAt'].binding\"\n      [visible]=\"columnDefinitionsByBinding['updatedAt'].visible\"\n      [isReadOnly]=\"columnDefinitionsByBinding['updatedAt'].isReadOnly\"\n      [width]=\"columnDefinitionsByBinding['updatedAt'].width\"\n      [allowResizing]=\"false\"\n    >\n    </wj-flex-grid-column>\n\n    <wj-flex-grid-column\n      [header]=\"columnDefinitionsByBinding['templateName'].header\"\n      [binding]=\"columnDefinitionsByBinding['templateName'].binding\"\n      [visible]=\"columnDefinitionsByBinding['templateName'].visible\"\n      [isReadOnly]=\"columnDefinitionsByBinding['templateName'].isReadOnly\"\n      [width]=\"'*'\"\n    >\n    </wj-flex-grid-column>\n  </wj-flex-grid>\n</div>\n", styles: [".bento-flex-grid{max-height:calc(100vh - 250px)}::ng-deep .bento-flex-grid .wj-header.wj-cell{text-transform:none}::ng-deep .ng-bento ::ng-deep .bento-flex-grid ::ng-deep .wj-header.wj-cell{text-transform:none}::ng-deep .action-column:not(.wj-group){padding-right:10px!important}.wj-control.wj-flexgrid ::ng-deep .wj-cell ::ng-deep .wj-btn.wj-elem-filter{align-items:unset;justify-content:unset}.id-header{position:absolute}.action-button{cursor:pointer;font-size:14px;border:none;background:none;outline:none;padding:0}.action-button[disabled]{cursor:default!important}.action-button[disabled]>i{color:#a5a5ad}@media (min-width: 768px){::ng-deep .ng-bento .modal .modal-dialog.modal-lg .modal-content{width:600px}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }, { type: RouterService }, { type: CalculationTemplateService }, { type: i1$1.TranslateService }, { type: AddCostsCalculationTemplateService }, { type: DateFormatterService }, { type: AccountingCostsFlexGridServices }, { type: LoaderService }]; }, propDecorators: { gridFilter: [{
                type: ViewChild,
                args: ['filter']
            }], flexGrid: [{
                type: ViewChild,
                args: ['flexGrid', { static: true }]
            }] } });

class CalculationTemplateComponent extends HybridRouterComponent {
    constructor(accountingCostsService, routerService, alertBrowserService, defaultService) {
        super(routerService);
        this.defaultService = defaultService;
        accountingCostsService.setLanguage();
        alertBrowserService.open();
    }
    i18n(node) {
        return `Onvio.AccountingCosts.CalculationTemplate.${node}`;
    }
    ngOnInit() {
        super.ngOnInit();
        this.defaultService.requestSync();
    }
}
CalculationTemplateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CalculationTemplateComponent, deps: [{ token: AccountingCostsService }, { token: RouterService }, { token: AlertBrowserService }, { token: DefaultCalculationModelService }], target: i0.ɵɵFactoryTarget.Component });
CalculationTemplateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: CalculationTemplateComponent, selector: "acc-calculation-template", usesInheritance: true, ngImport: i0, template: "\n<acc-alert></acc-alert>\n<div class=\"ng-bento\">\n  <section class=\"calculation-template\">\n    <acc-alert-fixed></acc-alert-fixed>\n    <h1>{{ i18n(\"Home.PageTitle\") | translate }}</h1>\n    <acc-bento-table></acc-bento-table>\n  </section>\n</div>\n", styles: [".calculation-template{padding:20px 50px}\n"], components: [{ type: AlertComponent, selector: "acc-alert" }, { type: AlertFixedComponent, selector: "acc-alert-fixed" }, { type: BentoTableComponent, selector: "acc-bento-table" }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CalculationTemplateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-calculation-template', template: "\n<acc-alert></acc-alert>\n<div class=\"ng-bento\">\n  <section class=\"calculation-template\">\n    <acc-alert-fixed></acc-alert-fixed>\n    <h1>{{ i18n(\"Home.PageTitle\") | translate }}</h1>\n    <acc-bento-table></acc-bento-table>\n  </section>\n</div>\n", styles: [".calculation-template{padding:20px 50px}\n"] }]
        }], ctorParameters: function () { return [{ type: AccountingCostsService }, { type: RouterService }, { type: AlertBrowserService }, { type: DefaultCalculationModelService }]; } });

class CalculationTemplateModule {
}
CalculationTemplateModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CalculationTemplateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CalculationTemplateModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CalculationTemplateModule, declarations: [CalculationTemplateComponent, BentoTableComponent, ToolbarComponent, DuplicateModalComponent, DeleteModalComponent], imports: [CommonModule$1,
        FiltersModule,
        FormsModule,
        BentoModule,
        TranslateModule,
        NgbModule,
        WjGridModule,
        WjInputModule,
        WjGridFilterModule,
        WjGridGrouppanelModule,
        BentoFlexGridControlModule,
        RouterModule,
        CommonModule,
        ReactiveFormsModule,
        BfmModule], exports: [CalculationTemplateComponent, ToolbarComponent] });
CalculationTemplateModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CalculationTemplateModule, imports: [[
            CommonModule$1,
            FiltersModule,
            FormsModule,
            BentoModule,
            TranslateModule,
            NgbModule,
            WjGridModule,
            WjInputModule,
            WjGridFilterModule,
            WjGridGrouppanelModule,
            BentoFlexGridControlModule,
            RouterModule,
            CommonModule,
            ReactiveFormsModule,
            BfmModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CalculationTemplateModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CalculationTemplateComponent, BentoTableComponent, ToolbarComponent, DuplicateModalComponent, DeleteModalComponent],
                    imports: [
                        CommonModule$1,
                        FiltersModule,
                        FormsModule,
                        BentoModule,
                        TranslateModule,
                        NgbModule,
                        WjGridModule,
                        WjInputModule,
                        WjGridFilterModule,
                        WjGridGrouppanelModule,
                        BentoFlexGridControlModule,
                        RouterModule,
                        CommonModule,
                        ReactiveFormsModule,
                        BfmModule
                    ],
                    exports: [CalculationTemplateComponent, ToolbarComponent]
                }]
        }] });

class ClientsLateralPanelComponent {
    constructor(clientsService, modalService, translateService, loaderService) {
        this.clientsService = clientsService;
        this.modalService = modalService;
        this.translateService = translateService;
        this.loaderService = loaderService;
        this.ITEMS_PER_PAGE = 30;
        this.templateSelectedClients = [];
        this.templateSelectedClientIds = [];
        this.templateSelectedAll = false;
        this.pagingInfo = new PagingInfo(0, 1, this.ITEMS_PER_PAGE);
    }
    ngOnInit() {
        forkJoin([this.translateService.get('Onvio.AccountingCosts.Toolbar.Add'),
            this.translateService.get('Onvio.AccountingCosts.Toolbar.Remove')])
            .subscribe(([add, remove]) => {
            this.actions = [{
                    action: () => this.openModal(),
                    icon: 'bento-icon-add',
                    label: add
                }, {
                    action: () => this.removeClients(),
                    icon: 'bento-icon-remove',
                    label: remove,
                    disabled: true
                }];
        });
        this.isLeftOpened = false;
        this.leftWidth = 550;
    }
    ngOnDestroy() {
        if (this.onScrollSubscription) {
            this.onScrollSubscription.unsubscribe();
        }
        if (this.onSearchSubscription) {
            this.onSearchSubscription.unsubscribe();
        }
    }
    i18n(node) {
        return `Onvio.AccountingCosts.Costs.CostsCalculation.${node}`;
    }
    changeRemoveButtonStatus(isDisabled) {
        const [add, remove] = this.actions;
        this.actions = [Object.assign({}, add), Object.assign(Object.assign({}, remove), { disabled: isDisabled })];
    }
    onLeftOpenedChange(isLeftOpened) {
        return this.isLeftOpened = !isLeftOpened;
    }
    onBindClients(template) {
        if (template && template.clients) {
            this.templateSelectedClientIds = template.clients.map(client => (client.clientId));
            this.reset();
            this.fetchClients();
        }
    }
    onEndOfScroll() {
        if ((this.templateSelectedClients.length < this.totalItems) &&
            this.templateSelectedClientIds &&
            this.templateSelectedClientIds.length > 0 &&
            !this.loaderService.clientsLoader.state) {
            this.fetchClients();
        }
    }
    onSearch(searchFilter) {
        if (!this.loaderService.clientsLoader.state) {
            this.reset();
            this.fetchClients(searchFilter);
        }
    }
    onSelect() {
        this.changeRemoveButtonStatus(this.templateSelectedClients.every(client => !client.state));
        this.templateSelectedAll = false;
    }
    onSelectAll(isAllSelected) {
        this.templateSelectedAll = isAllSelected;
        this.changeRemoveButtonStatus(!isAllSelected);
    }
    removeClients() {
        const idsToRemove = this.templateSelectedClients.filter(client => client.state).map(client => client.id);
        idsToRemove.forEach(id => {
            this.templateSelectedClientIds.splice(this.templateSelectedClientIds.indexOf(id), 1);
        });
        this.changeRemoveButtonStatus(true);
        this.reset();
        this.fetchClients();
    }
    fetchClientsModal(search) {
        this.loaderService.modalClientsLoader.show();
        this.clientsService.findClientsExcluding(this.templateSelectedClientIds, this.modalPagingInfo, { search })
            .pipe(take(1))
            .subscribe(response => {
            const clients = response.items.map(item => (Object.assign(Object.assign({}, item), { state: false })));
            this.modalTotalItems = response.totalItems;
            this.modalPagingInfo.pageIndex++;
            this.modalPagingInfo.startIndex = (this.ITEMS_PER_PAGE * (this.modalPagingInfo.pageIndex - 1)) + 1;
            this.modalRef.componentInstance.clients = [...this.modalRef.componentInstance.clients, ...clients];
            this.modalRef.componentInstance.totalItems = this.modalTotalItems;
            this.loaderService.modalClientsLoader.hide();
        }, err => {
            console.log(err);
            this.loaderService.clientsLoader.hide();
        });
    }
    fetchClients(search) {
        this.loaderService.clientsLoader.show();
        this.clientsService.findClientsPage(this.templateSelectedClientIds, this.pagingInfo, { search })
            .pipe(take(1))
            .subscribe(response => {
            const clients = response.items.map(item => (Object.assign(Object.assign({}, item), { state: false })));
            this.totalItems = response.totalItems;
            this.pagingInfo.pageIndex++;
            this.pagingInfo.startIndex = (this.ITEMS_PER_PAGE * (this.pagingInfo.pageIndex - 1)) + 1;
            this.templateSelectedClients = [...this.templateSelectedClients, ...clients];
            this.loaderService.clientsLoader.hide();
        }, err => {
            console.log(err);
            this.loaderService.clientsLoader.hide();
        });
    }
    openModal() {
        this.resetModal();
        this.modalRef = this.modalService.open(ClientsModalComponent, {
            container: '#bentoNGModalContainer'
        });
        this.onScrollSubscription = this.modalRef.componentInstance.endScrollObs.subscribe(() => {
            if (this.modalRef.componentInstance.clients.length < this.modalTotalItems &&
                !this.loaderService.modalClientsLoader.state) {
                this.fetchClientsModal();
            }
        });
        this.onSearchSubscription = this.modalRef.componentInstance.searchObs.subscribe((search) => {
            if (!this.loaderService.modalClientsLoader.state) {
                this.resetModal();
                this.fetchClientsModal(search);
            }
        });
        this.modalRef.result.then((dataToAdd) => {
            const clientsToAdd = dataToAdd.filter(client => this.templateSelectedClientIds.indexOf(client.id) === -1);
            this.templateSelectedClientIds = [...this.templateSelectedClientIds, ...clientsToAdd.map(client => client.id)];
            this.modalRef = null;
            this.reset();
            this.resetModal();
            this.fetchClients();
        }, () => {
            this.modalRef = null;
            this.resetModal();
        });
        this.fetchClientsModal();
    }
    reset() {
        this.templateSelectedClients = [];
        this.templateSelectedAll = false;
        this.totalItems = 0;
        this.pagingInfo = new PagingInfo(0, 1, this.ITEMS_PER_PAGE);
    }
    resetModal() {
        this.modalPagingInfo = new PagingInfo(0, 1, this.ITEMS_PER_PAGE);
        this.modalTotalItems = 0;
        if (this.modalRef && this.modalRef.componentInstance) {
            this.modalRef.componentInstance.clients = [];
        }
    }
}
ClientsLateralPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientsLateralPanelComponent, deps: [{ token: ClientsService }, { token: i1$2.NgbModal }, { token: i1$1.TranslateService }, { token: LoaderService }], target: i0.ɵɵFactoryTarget.Component });
ClientsLateralPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ClientsLateralPanelComponent, selector: "acc-clients-lateral-panel", ngImport: i0, template: "<div class=\"splitter-container ng-bento\">\n  <bento-splitter-group (leftOpenedChange)=\"onLeftOpenedChange(isLeftOpened)\" [leftOpened]=\"isLeftOpened\"\n    [leftWidth]=\"leftWidth\">\n    <bento-splitter-group-left>\n      <div class=\"splitter-left-content\">\n        <h2>{{ i18n('SelectClients') | translate }}</h2>\n        <div class=\"clients-table\" [bentoBusyLoader]=\"loaderService.clientsLoader.state\">\n          <acc-table-clients \n            class=\"clients-table\" \n            (endScroll)=\"onEndOfScroll()\" \n            (search)=\"onSearch($event)\"\n            (selectAll)=\"onSelectAll($event)\"\n            (select)=\"onSelect()\"\n            [clients]=\"templateSelectedClients\"\n            [actions]=\"actions\"></acc-table-clients>\n        </div>\n      </div>\n    </bento-splitter-group-left>\n    <bento-splitter-group-main>\n      <div class=\"splitter-main-content\">\n        <acc-calculation-form [isLateralOpen]=\"isLeftOpened\" [selectedClientsIds]=\"templateSelectedClientIds\"\n          (selectClients)=\"onLeftOpenedChange(isLeftOpened)\" (bindClients)=\"onBindClients($event)\">\n        </acc-calculation-form>\n      </div>\n    </bento-splitter-group-main>\n  </bento-splitter-group>\n</div>", styles: [".splitter-container{height:calc(100vh - 175px);overflow:hidden}.bento-splitter-group{margin-top:36px;border-left:1px solid #b2b2b8}.splitter-left-content{margin:20px}.splitter-main-content{margin-left:20px}bento-splitter-group ::ng-deep .bento-splitter-group-left>.bento-splitter-group-inner{overflow:hidden}.clients-table ::ng-deep .bento-busyloader-front-blocker{background:0}.clients-table ::ng-deep .ng-bento .wj-content{height:calc(100vh - 260px)}\n"], components: [{ type: i5.BentoSplitterGroupComponent, selector: "bento-splitter-group", inputs: ["resizeStepSize", "leftMaxWidth", "rightMaxWidth", "topMaxHeight", "bottomMaxHeight", "autoResize", "noCollapse", "leftWidth", "leftOpened", "rightWidth", "rightOpened", "topHeight", "topOpened", "bottomHeight", "bottomOpened"], outputs: ["leftWidthChange", "leftOpenedChange", "rightWidthChange", "rightOpenedChange", "topHeightChange", "topOpenedChange", "bottomHeightChange", "bottomOpenedChange"] }, { type: i5.BentoSplitterGroupLeftComponent, selector: "bento-splitter-group-left" }, { type: TableClientsComponent, selector: "acc-table-clients", inputs: ["actions", "clients"], outputs: ["endScroll", "select", "selectAll", "search"] }, { type: i5.BentoSplitterGroupMainComponent, selector: "bento-splitter-group-main" }, { type: CalculationFormComponent, selector: "acc-calculation-form", inputs: ["isLateralOpen", "selectedClientsIds"], outputs: ["selectClients", "bindClients"] }], directives: [{ type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["size", "showDelay", "hideDelay", "bentoBusyLoader"], outputs: ["show", "hide"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientsLateralPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-clients-lateral-panel', template: "<div class=\"splitter-container ng-bento\">\n  <bento-splitter-group (leftOpenedChange)=\"onLeftOpenedChange(isLeftOpened)\" [leftOpened]=\"isLeftOpened\"\n    [leftWidth]=\"leftWidth\">\n    <bento-splitter-group-left>\n      <div class=\"splitter-left-content\">\n        <h2>{{ i18n('SelectClients') | translate }}</h2>\n        <div class=\"clients-table\" [bentoBusyLoader]=\"loaderService.clientsLoader.state\">\n          <acc-table-clients \n            class=\"clients-table\" \n            (endScroll)=\"onEndOfScroll()\" \n            (search)=\"onSearch($event)\"\n            (selectAll)=\"onSelectAll($event)\"\n            (select)=\"onSelect()\"\n            [clients]=\"templateSelectedClients\"\n            [actions]=\"actions\"></acc-table-clients>\n        </div>\n      </div>\n    </bento-splitter-group-left>\n    <bento-splitter-group-main>\n      <div class=\"splitter-main-content\">\n        <acc-calculation-form [isLateralOpen]=\"isLeftOpened\" [selectedClientsIds]=\"templateSelectedClientIds\"\n          (selectClients)=\"onLeftOpenedChange(isLeftOpened)\" (bindClients)=\"onBindClients($event)\">\n        </acc-calculation-form>\n      </div>\n    </bento-splitter-group-main>\n  </bento-splitter-group>\n</div>", styles: [".splitter-container{height:calc(100vh - 175px);overflow:hidden}.bento-splitter-group{margin-top:36px;border-left:1px solid #b2b2b8}.splitter-left-content{margin:20px}.splitter-main-content{margin-left:20px}bento-splitter-group ::ng-deep .bento-splitter-group-left>.bento-splitter-group-inner{overflow:hidden}.clients-table ::ng-deep .bento-busyloader-front-blocker{background:0}.clients-table ::ng-deep .ng-bento .wj-content{height:calc(100vh - 260px)}\n"] }]
        }], ctorParameters: function () { return [{ type: ClientsService }, { type: i1$2.NgbModal }, { type: i1$1.TranslateService }, { type: LoaderService }]; } });

class ColumnHeader {
    constructor(name, value = null) {
        this.name = name;
        this.value = value;
    }
    toString() {
        return this.name;
    }
}

var ProfitMargin;
(function (ProfitMargin) {
    ProfitMargin[ProfitMargin["ALL"] = 0] = "ALL";
    ProfitMargin[ProfitMargin["PAGED"] = 1] = "PAGED";
})(ProfitMargin || (ProfitMargin = {}));

class ProfitSpreadsheetService {
    constructor(http, translate, currencyPipe) {
        this.http = http;
        this.translate = translate;
        this.currencyPipe = currencyPipe;
    }
    formatToLowerCase(str) {
        if (!str) {
            return str;
        }
        const reg = /(.{8})-(.{4})-(.{4})-(.{4})-(.{12})/;
        if (reg.test(str)) {
            return str.toLowerCase();
        }
        const stringMatch = str.match('^(.{8})(.{4})(.{4})(.{4})(.{12})$');
        return `${stringMatch[1]}-${stringMatch[2]}-${stringMatch[3]}-${stringMatch[4]}-${stringMatch[5]}`.toLowerCase();
    }
    formatYearMonth(date) {
        return format(date, 'yyyy-MM');
    }
    getProfitMargin(templateId, periodDate, pagingInfo) {
        let params = new HttpParams();
        const keys = [...Object.keys(pagingInfo || {})];
        keys.forEach(key => {
            if (!!pagingInfo[key] || pagingInfo[key] === 0) {
                params = params.append(key, pagingInfo[key]);
            }
        });
        // tslint:disable-next-line: max-line-length
        const profitMarginEndpoint = `${API_URL}calculation-model-result/calculation-model-id/${this.formatToLowerCase(templateId)}/basis/${this.formatYearMonth(periodDate)}`;
        return this.http
            .get(profitMarginEndpoint, { params })
            .pipe(map(res => {
            return res;
        }));
    }
    toObject(columns = [], { surplus, deficit }) {
        const clientObject = {};
        columns.forEach(column => {
            const cellDataLabel = document.createElement('span');
            const cellDataValue = document.createElement('span');
            cellDataValue.className = 'cellValue';
            if (column.unitType === 'AMOUNT') {
                clientObject[column.columnName] = column.value;
            }
            else {
                cellDataValue.innerHTML = column.value;
                clientObject[column.columnName] = cellDataValue.outerHTML;
            }
        });
        return clientObject;
    }
    convertHtmlSpaceToWhiteSpace(text) {
        return text.replace(/&nbsp;/g, ' ');
    }
    getFormattedTableData(res) {
        return __awaiter(this, void 0, void 0, function* () {
            const surplus = yield this.translate
                .get('Onvio.AccountingCosts.Costs.Spreadsheet.Surplus')
                .toPromise();
            const deficit = yield this.translate
                .get('Onvio.AccountingCosts.Costs.Spreadsheet.Deficit')
                .toPromise();
            return res.map(client => (Object.assign({ name: client.name, cnpj: client.cnpj }, this.toObject(client.columnInfo, { surplus, deficit }))));
        });
    }
    setColumns(res) {
        const columnFinalResult = 'FINAL_RESULT';
        return res.map(response => {
            return response.columnInfo.map(item => {
                if (item.columnType === columnFinalResult) {
                    item = Object.assign(Object.assign({}, item), { cssClass: 'final-result' });
                }
                else {
                    item = Object.assign(Object.assign({}, item), { cssClass: '' });
                }
                return item;
            });
        });
    }
}
ProfitSpreadsheetService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ProfitSpreadsheetService, deps: [{ token: i1.HttpClient }, { token: i1$1.TranslateService }, { token: i4.CurrencyPipe }], target: i0.ɵɵFactoryTarget.Injectable });
ProfitSpreadsheetService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ProfitSpreadsheetService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ProfitSpreadsheetService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i1$1.TranslateService }, { type: i4.CurrencyPipe }]; } });

class ProfitSpreadsheetComponent {
    constructor(alertService, service, translate, flexGridService, cdr, dateFormatterService, loaderService) {
        this.alertService = alertService;
        this.service = service;
        this.translate = translate;
        this.flexGridService = flexGridService;
        this.cdr = cdr;
        this.dateFormatterService = dateFormatterService;
        this.filtersUpdate = new EventEmitter();
        this.data = [];
        this.columnDefinitions = [];
        this.hideAbleColumnDefinitions = [];
        this.toolbarData = [];
        this.pagingInfo = new PagingInfo(0, 1, 25);
        this.updateSubject = new Subject();
        this.gridWidth = 0;
        this.offsetWidth = 0;
        this.totalItems = 0;
        this.lastIndexCalled = 0;
        this.columnsObject = [];
        this.itemsPerPage = 25;
        this.wijmoColummHeader = 2;
        this.loadingScrollBusyLoader = loaderService.scrollLoader;
    }
    set calculationModel(filters) {
        this.columnDefinitions = [];
        this.hideAbleColumnDefinitions = [];
        this.pagingInfo = new PagingInfo(0, 1, this.itemsPerPage);
        this.data = [];
        if (filters && filters.template && filters.basis) {
            this.accountingCostsFilters = filters;
            this.templateId = filters.template.id;
            this.periodDate = filters.basis;
            this.getProfitMargin(filters.template.id, filters.basis).subscribe();
        }
    }
    set filters(filters) {
        this.columnDefinitions = [];
        this.hideAbleColumnDefinitions = [];
        this.pagingInfo = new PagingInfo(0, 1, this.itemsPerPage);
        this.data = [];
        if (filters && filters.template && filters.basis) {
            this.accountingCostsFilters = filters;
            this.templateId = filters.template.id;
            this.periodDate = filters.basis;
            this.getProfitMargin(filters.template.id, filters.basis).subscribe();
        }
    }
    gridInitialized(flex) {
        flex.scrollPositionChanged.addHandler((grid) => {
            if (grid.rows.length >= this.itemsPerPage &&
                this.lastIndexCalled < this.totalItems &&
                grid.viewRange.bottomRow >= grid.rows.length - 1 &&
                this.data.length !== 0) {
                this.onEndScroll();
            }
        });
    }
    getTranslation(key) {
        return this.translate.get(this.i18n(key)).toPromise();
    }
    onFiltersUpdate(event) {
        this.data = [];
        this.loadingScrollBusyLoader.show();
        this.updateSubject.next(event);
    }
    toggleFilter() {
        this.gridFilter.showFilterIcons = !this.gridFilter.showFilterIcons;
        if (this.gridFilter && !this.gridFilter.showFilterIcons) {
            this.gridFilter.clear();
            this.gridFilter.grid.refresh();
        }
    }
    ngOnInit() {
        this.gridFilter.showFilterIcons = false;
        this.setUpTooltips();
        this.flexGrid = this.flexGridService.updateFlexGridRows(this.flexGrid);
        this.addUpdateSubject();
        this.initializeToolbarData();
    }
    setIconTranslation() {
        this.translate.get(this.i18n('Deficit')).subscribe(translation => {
            document
                .querySelectorAll('.i-error.final-result')
                .forEach(item => {
                item.setAttribute('data-before', translation);
            });
        });
        this.translate.get(this.i18n('Surplus')).subscribe(translation => {
            document
                .querySelectorAll('.i-success.final-result')
                .forEach(item => {
                item.setAttribute('data-before', translation);
            });
        });
    }
    addUpdateSubject() {
        this.updateSubject
            .asObservable()
            .pipe(exhaustMap((filters) => interval(2000).pipe(first(), tap(_ => {
            this.setFilter(filters);
        }))))
            .subscribe();
    }
    setFilter(filters) {
        this.filters = filters;
        this.filtersUpdate.emit(filters);
    }
    updateFlexGridRows(flexGrid) {
        flexGrid = this.flexGridService.updateFlexGridRows(this.flexGrid);
    }
    onUpdatedView(flexGrid) {
        this.gridWidth = flexGrid.scrollSize.width;
        if (!!document.getElementById('tab-view-calculation-panel')) {
            this.offsetWidth = document.getElementById('tab-view-calculation-panel').offsetWidth;
        }
        this.cdr.detectChanges();
        this.setIconTranslation();
        this.formatCurrencyAmountHTMLValue();
    }
    exportXls() {
        if (!this.loadingScrollBusyLoader.state) {
            this.loadingScrollBusyLoader.show();
            this.getProfitMargin(this.templateId, this.periodDate, ProfitMargin.ALL).subscribe((canExport) => {
                if (canExport) {
                    setTimeout(() => {
                        wjcGridXlsx.FlexGridXlsxConverter.saveAsync(this.flexGrid, { includeColumnHeaders: true, includeCellStyles: true }, this.formatFileName());
                    });
                }
            });
        }
    }
    initializeToolbarData() {
        this.translate
            .get(this.i18n('Export'))
            .pipe(first())
            .subscribe(label => {
            this.toolbarData = [
                {
                    label,
                    icon: 'bento-icon-exit',
                    action: () => this.exportXls()
                }
            ];
        });
    }
    setUpTooltips() {
        if (!this.toolTip) {
            this.toolTip = new wjcCore.Tooltip();
        }
        this.flexGrid.hostElement.addEventListener('mouseover', (e) => {
            const ht = this.flexGrid.hitTest(e);
            if (ht.cellType === this.wijmoColummHeader &&
                ht.col !== 0 &&
                ht.col !== 1) {
                const tipContent = this.formatFormula(this.hideAbleColumnDefinitions[ht.col].formula) +
                    this.formatColumnType(this.hideAbleColumnDefinitions[ht.col].columnType);
                const cellElement = document.elementFromPoint(e.clientX, e.clientY);
                const cellBounds = wjcCore.Rect.fromBoundingRect(cellElement.getBoundingClientRect());
                this.toolTip.show(this.flexGrid.hostElement, tipContent, cellBounds);
            }
        });
        this.flexGrid.hostElement.addEventListener('mouseout', e => {
            this.toolTip.hide();
        });
    }
    formatColumnType(columnType) {
        const columnItem = document.createElement('span');
        columnItem.className = 'columnType';
        forkJoin([
            this.translate.get(this.i18n('FinalResult')),
            this.translate.get(this.i18n('Revenue')),
            this.translate.get(this.i18n('Expense')),
            this.translate.get(this.i18n('Others'))
        ])
            .pipe(first())
            .subscribe(([finalResult, revenue, expense, others]) => {
            switch (columnType) {
                case 'FINAL_RESULT':
                    columnItem.innerHTML = finalResult;
                    break;
                case 'REVENUE':
                    columnItem.innerHTML = revenue;
                    break;
                case 'EXPENSE':
                    columnItem.innerHTML = expense;
                    break;
                case 'OTHERS':
                    columnItem.innerHTML = others;
                    break;
            }
        });
        return `<hr/>` + columnItem.outerHTML;
    }
    formatFormula(formula) {
        return JSON.parse(formula)
            .map(element => {
            const item = document.createElement('span');
            item.className = 'tooltipColumn';
            switch (element.type.toUpperCase()) {
                case 'LIMITER':
                    item.className += ' operator-limiter';
                    item.innerHTML = element.limiter;
                    break;
                case 'OPERATOR':
                    item.className += ' operator-limiter';
                    item.innerHTML = element.operator;
                    break;
                case 'FIXED':
                    item.className += ' value';
                    item.innerHTML = this.formatValue(element);
                    break;
                case 'COLUMN':
                    item.className += ' column';
                    item.innerHTML = element.nestedColumnName;
                    break;
                case 'ATTRIBUTE':
                case 'COST_ITEM':
                    item.className +=
                        element.origin === 'CUSTOMER' ? ' customer' : ' office';
                    item.innerHTML = element.description;
                    break;
            }
            return item.outerHTML;
        })
            .join(' ');
    }
    getProfitMargin(templateId, periodDate, profitMargin = ProfitMargin.PAGED) {
        const allProfitMargins = profitMargin === ProfitMargin.ALL;
        this.loadingScrollBusyLoader.show();
        let observable;
        if (allProfitMargins) {
            observable = this.service.getProfitMargin(templateId, periodDate);
        }
        else {
            observable = this.service.getProfitMargin(templateId, periodDate, this.pagingInfo);
        }
        return observable.pipe(first(), switchMap((res) => __awaiter(this, void 0, void 0, function* () {
            this.totalItems = res.totalItems;
            if (!allProfitMargins && this.pagingInfo.startIndex === 0) {
                this.setColumns(res.items);
            }
            if (allProfitMargins) {
                this.data = [];
                this.lastIndexCalled = res.totalItems;
            }
            else {
                this.lastIndexCalled = this.pagingInfo.startIndex + this.itemsPerPage;
            }
            const items = yield this.service.getFormattedTableData(res.items);
            items.forEach(tableData => {
                this.data.push(tableData);
            });
            if (!!this.flexGrid && !!this.flexGrid.collectionView) {
                this.flexGrid.collectionView.refresh();
            }
            if (this.data.length === 0) {
                throwError(this.i18n('NotFound'));
            }
            this.loadingScrollBusyLoader.hide();
            return true;
        })), catchError(() => {
            this.translate.get(this.i18n('NotFound'))
                .pipe(first())
                .subscribe(res => this.addError(res));
            this.loadingScrollBusyLoader.hide();
            return of(false);
        }));
    }
    onEndScroll() {
        if (!this.loadingScrollBusyLoader.state) {
            this.pagingInfo.startIndex += this.itemsPerPage;
            this.loadingScrollBusyLoader.show();
            this.getProfitMargin(this.templateId, this.periodDate).subscribe();
        }
    }
    setColumns(res) {
        forkJoin([
            this.translate.get('Onvio.AccountingCosts.Costs.Spreadsheet.Client'),
            this.translate.get('Onvio.AccountingCosts.Costs.Spreadsheet.Inscription')
        ])
            .pipe(first())
            .subscribe(([client, inscription]) => {
            this.columnDefinitions.push({
                binding: 'name',
                header: new ColumnHeader(client),
                width: 350,
                visible: true,
                filterType: 3
            }, {
                binding: 'cnpj',
                header: new ColumnHeader(inscription),
                width: 145,
                visible: true,
                filterType: 3
            });
        });
        this.columnsObject = this.service.setColumns(res);
        this.columnsObject[0].forEach((item, index) => {
            const newColumn = {
                binding: item.columnName,
                header: new ColumnHeader(item.columnName, index),
                width: 300 + item.columnName.length,
                visible: true,
                filterType: 3,
                formula: item.formula,
                unitType: item.unitType,
                align: 'right',
                cssClass: item.cssClass,
                columnType: item.columnType
            };
            this.columnDefinitions.push(newColumn);
        });
        this.hideAbleColumnDefinitions = this.columnDefinitions.slice();
    }
    i18n(node) {
        return `Onvio.AccountingCosts.Costs.Spreadsheet.${node}`;
    }
    getTooltipToggleFilters() {
        return this.gridFilter.showFilterIcons
            ? this.i18n('HideFilters')
            : this.i18n('ShowFilters');
    }
    getTooltipHideShowColumns() {
        return this.i18n('ShowHideColumns');
    }
    addError(msg) {
        this.alertService.addAlert({
            type: 'danger',
            closeable: true,
            timeout: 5000,
            msg
        });
    }
    formatValue(element) {
        if (element.percentage) {
            element.value += '%';
        }
        return element.value;
    }
    formatFileName() {
        const modelName = this.accountingCostsFilters.template.name;
        const date = new Date(this.accountingCostsFilters.basis);
        const formattedDate = this.dateFormatterService.formatYearMonthIso(date);
        return `${modelName.split(' ').join('_')}-${formattedDate}`;
    }
    formatCurrencyAmountHTMLValue() {
        const allValues = document.getElementsByClassName('final-result');
        for (let i = 0; i < allValues.length; i++) {
            const currentText = allValues.item(i).innerHTML;
            if (currentText.includes('(')) {
                allValues.item(i).innerHTML = currentText.replace('(', '- ').replace(')', '');
            }
        }
    }
}
ProfitSpreadsheetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ProfitSpreadsheetComponent, deps: [{ token: AlertService }, { token: ProfitSpreadsheetService }, { token: i1$1.TranslateService }, { token: AccountingCostsFlexGridServices }, { token: i0.ChangeDetectorRef }, { token: DateFormatterService }, { token: LoaderService }], target: i0.ɵɵFactoryTarget.Component });
ProfitSpreadsheetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ProfitSpreadsheetComponent, selector: "acc-profit-spreadsheet", inputs: { calculationModel: "calculationModel", filters: "filters" }, outputs: { filtersUpdate: "filtersUpdate" }, viewQueries: [{ propertyName: "gridFilter", first: true, predicate: ["filter"], descendants: true, static: true }, { propertyName: "flexGrid", first: true, predicate: ["flexGrid"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"view-calculation-content\">\n  <h1>{{ i18n(\"ViewCalculation\") | translate }}</h1>\n  <acc-view-calculation-filters [filters]=\"accountingCostsFilters\" (update)=\"onFiltersUpdate($event)\">\n  </acc-view-calculation-filters>\n\n  <div id=\"table-container\" [ngStyle]=\"{'width': (offsetWidth < gridWidth || data.length === 0 || gridWidth === 0)\n                          ? 'auto'\n                          : 'min-content'}\">\n    <bento-toolbar class=\"bento-toolbar\" [items]=\"toolbarData\">\n      <ul class=\"nav navbar-right\">\n\n        <li>\n          <button class=\"btn btn-outline-primary btn-icon btn-toggle\" [ngClass]=\"{'active':gridFilter.showFilterIcons}\"\n            (click)=\"toggleFilter()\" placement=\"bottom\" [ngbTooltip]=\"getTooltipToggleFilters() | translate\">\n            <i class=\"bento-icon-filter-az\"></i>\n          </button>\n        </li>\n        <li>\n          <div ngbDropdown [autoClose]=\"'outside'\">\n            <button class=\"btn btn-outline-primary btn-icon btn-toggle dropdown-toggle\" ngbDropdownToggle\n              placement=\"bottom\" [ngbTooltip]=\"getTooltipHideShowColumns() | translate\">\n              <i class=\"bento-icon-cog\"></i>\n              <i class=\"bento-icon-arrow-down2\"></i>\n            </button>\n            <ul ngbDropdownMenu class=\"dropdown-menu\">\n              <li *ngFor=\"let item of hideAbleColumnDefinitions\" ngbDropdownItem class=\"dropdown-item\">\n                <a (click)=\"item.visible = !item.visible\">\n                  <i [ngClass]=\"{'bento-icon-checkbox':!item.visible,'bento-icon-checkbox-filled':item.visible}\"></i>\n                  {{ item.header }}</a>\n              </li>\n            </ul>\n          </div>\n        </li>\n      </ul>\n    </bento-toolbar>\n    <div class=\"busy-loader-container\" [bentoBusyLoader]=\"loadingScrollBusyLoader.state\"\n      [ngStyle]=\"{'height': loadingScrollBusyLoader.state ? '63vh' : ''}\">\n\n      <wj-flex-grid #flexGrid class=\"bento-flex-grid has-row-hover\" [itemsSource]=\"data\" [stickyHeaders]=\"true\"\n        [showMarquee]=\"false\" [showSort]=\"true\" (initialized)=\"gridInitialized(flexGrid)\" [frozenColumns]=\"1 && 2\"\n        [autoSizeMode]=\"3\" [deferResizing]=\"true\" [isReadOnly]=\"true\" (loadedRows)=\"updateFlexGridRows(flexGrid)\"\n        (updatedView)=\"onUpdatedView(flexGrid)\">\n\n        <wj-flex-grid-filter #filter></wj-flex-grid-filter>\n\n        <ng-template wjFlexGridCellTemplate [cellType]=\"'RowHeader'\" let-col=\"col\" let-row=\"row\">\n          <div *ngIf=\"col.index === 0\">{{ row.index+1 }}</div>\n        </ng-template>\n\n        <div *ngFor=\"let column of columnDefinitions.reverse()\">\n\n          <wj-flex-grid-column\n            [align]=\"column.align\"\n            [header]=\"column.header\"\n            [binding]=\"column.binding\"\n            [isReadOnly]=\"column.isReadOnly\"\n            [width]=\"column.width\"\n            [visible]=\"column.visible\"\n            [isContentHtml]=\"column.binding !=='name' && 'cnpj'\"\n            [isReadOnly]=\"true\"\n            [format]=\"'cR$'\"\n            [cssClass]=\"column.cssClass\">\n          </wj-flex-grid-column>\n\n        </div>\n      </wj-flex-grid>\n    </div>\n  </div>\n", styles: [".view-calculation-content{margin-top:-20px}.view-calculation-content .bento-toolbar{height:43px!important}.view-calculation-content .bento-toolbar .navbar-right{height:40px}.view-calculation-content .bento-toolbar .navbar-right li{min-height:inherit}.view-calculation-content .bento-toolbar .navbar-right li button{margin:3px 0 0}.bento-flex-grid{height:auto;max-height:63vh}::ng-deep .bento-toolbar{height:36px!important}::ng-deep .wj-tooltip{background-color:#fff;flex-wrap:wrap;border-radius:5px;padding:4px 15px}::ng-deep .wj-tooltip:before{content:none}::ng-deep .wj-tooltip:after{border-top:15px solid #ffffff;border-right:15px solid transparent;border-left:15px solid transparent}::ng-deep .tooltipColumn{padding:2px 5px;border-radius:4px;display:inline-block;color:#fff;margin:5px 2px;text-transform:uppercase;font-size:x-small}::ng-deep .tooltipColumn.office{background-color:#387c2b;color:#fff}::ng-deep .tooltipColumn.customer{background-color:#0072a8;color:#fff}::ng-deep .tooltipColumn.column{background-color:#5d1893;color:#fff}::ng-deep .tooltipColumn.operator-limiter{background-color:#ffb400;color:#000!important}::ng-deep .tooltipColumn.value{background-color:#d4ebf4;color:#000!important}::ng-deep .columnType{color:#666;font-family:Arial,Helvetica,sans-serif;font-size:14px;font-weight:bolder;width:-webkit-fill-available}::ng-deep hr{border-top:1px solid #d5d4d9;margin-bottom:10px;min-inline-size:-webkit-fill-available}::ng-deep .cellDataPositive{background:#387c2b;border-radius:4px;color:#fff;padding:3px;margin:5px}::ng-deep .cellDataNegative{background:#dc0a0a;border-radius:4px;color:#fff;padding:3px;margin:5px}::ng-deep [wj-part=ch]{z-index:0!important;height:36px}:host ::ng-deep [wj-part=tl]{z-index:0!important}:host ::ng-deep [wj-part=rh]{z-index:0!important}::ng-deep .ng-bento .col-md-3{z-index:5}::ng-deep .action-column:not(.wj-group){padding-right:10px!important}.wj-control.wj-flexgrid ::ng-deep .wj-cell ::ng-deep .wj-btn.wj-elem-filter{align-items:unset;justify-content:unset;position:absolute;margin-left:10px}::ng-deep .wj-header .header{position:absolute;width:calc(100% - 10px);height:calc(100% - 10px)}::ng-deep .wj-cells>.wj-row,::ng-deep .wj-marquee{z-index:0!important}:host ::ng-deep .wj-header[class*=wj-filter-].wj-align-right{text-align:right!important}:host ::ng-deep .bento-flex-grid .wj-header.wj-cell.wj-filter-on.wj-align-right,:host ::ng-deep .bento-flex-grid .wj-header.wj-cell.wj-filter-off.wj-align-right{padding:8px 44px 8px 10px!important;display:inline;display:initial}:host ::ng-deep .bento-flex-grid .wj-header.wj-cell.wj-filter-off.wj-align-right .wj-glyph-up,:host ::ng-deep .bento-flex-grid .wj-header.wj-cell.wj-filter-off.wj-align-right .wj-glyph-down{display:inline-block;position:absolute;right:20px;top:35%}::ng-deep .wj-sort-asc{margin:0;padding:8px 44px 8px 10px!important;align-items:center}::ng-deep .wj-sort-desc{margin:0;padding:0 0 0 10px;display:inline;display:initial;align-items:center}.busy-loader-container ::ng-deep .bento-busyloader-front-blocker{background:0}::ng-deep .ng-bento .bento-flex-grid.wj-content .wj-cell.i-success.final-result,::ng-deep .ng-bento .bento-flex-grid.wj-content .wj-cell.i-error.final-result{display:flex;align-items:center;justify-content:space-between}::ng-deep .i-success.final-result:before{background:green}::ng-deep .i-error.final-result:before{background:red}::ng-deep .i-success.final-result:before,::ng-deep .i-error.final-result:before{content:attr(data-before);border-radius:4px;color:#fff;padding:3px;margin-right:10px;width:67px;text-align:center;height:22px;line-height:16px;position:static;position:initial}\n"], components: [{ type: ViewCalculationFiltersComponent, selector: "acc-view-calculation-filters", inputs: ["filters"], outputs: ["update"] }, { type: i5.BentoToolbarComponent, selector: "bento-toolbar", inputs: ["items", "moreText"] }, { type: i2.WjFlexGrid, selector: "wj-flex-grid", inputs: ["wjModelProperty", "isDisabled", "tabOrder", "newRowAtTop", "allowAddNew", "allowDelete", "allowDragging", "allowMerging", "allowResizing", "allowSorting", "allowPinning", "autoScroll", "autoRowHeights", "autoSizeMode", "autoGenerateColumns", "autoSearch", "caseSensitiveSearch", "quickAutoSize", "bigCheckboxes", "childItemsPath", "groupHeaderFormat", "headersVisibility", "showSelectedHeaders", "showMarquee", "showPlaceholders", "itemFormatter", "isReadOnly", "imeEnabled", "mergeManager", "selectionMode", "showGroups", "showSort", "showDropDown", "showAlternatingRows", "showErrors", "alternatingRowStep", "itemValidator", "validateEdits", "treeIndent", "itemsSource", "autoClipboard", "expandSelectionOnCopyPaste", "frozenCells", "frozenRows", "frozenColumns", "cloneFrozenCells", "deferResizing", "sortRowIndex", "editColumnIndex", "stickyHeaders", "preserveSelectedState", "preserveOutlineState", "preserveWhiteSpace", "keyActionTab", "keyActionEnter", "rowHeaderPath", "virtualizationThreshold", "anchorCursor", "lazyRender", "refreshOnEdit", "copyHeaders", "columnGroups", "commitEmptyEdits", "headersFocusability", "ariaLabel", "skipMerged", "pasteEmptyCells", "groupSummaryPosition"], outputs: ["initialized", "gotFocus", "lostFocus", "refreshing", "refreshed", "invalidInput", "beginningEdit", "cellEditEnded", "cellEditEnding", "prepareCellForEdit", "formatItem", "resizingColumn", "resizedColumn", "autoSizingColumn", "autoSizedColumn", "draggingColumn", "draggingColumnOver", "draggedColumn", "sortingColumn", "sortedColumn", "pinningColumn", "pinnedColumn", "resizingRow", "resizedRow", "autoSizingRow", "autoSizedRow", "draggingRow", "draggingRowOver", "draggedRow", "deletingRow", "deletedRow", "loadingRows", "loadedRows", "rowEditStarting", "rowEditStarted", "rowEditEnding", "rowEditEnded", "rowAdded", "groupCollapsedChanging", "groupCollapsedChanged", "columnGroupCollapsedChanging", "columnGroupCollapsedChanged", "itemsSourceChanging", "itemsSourceChanged", "selectionChanging", "selectionChanged", "scrollPositionChanged", "updatingView", "updatedView", "updatingLayout", "updatedLayout", "pasting", "pasted", "pastingCell", "pastedCell", "copying", "copied"] }, { type: i11.WjFlexGridFilter, selector: "wj-flex-grid-filter", inputs: ["wjProperty", "showFilterIcons", "showSortButtons", "defaultFilterType", "filterColumns", "exclusiveValueSearch", "reApplyFilterOnUpdate", "showIncludeSelection"], outputs: ["initialized", "editingFilter", "filterChanging", "filterChanged", "filterApplied"] }, { type: i2.WjFlexGridColumn, selector: "wj-flex-grid-column", inputs: ["asyncBindings", "wjProperty", "name", "dataMap", "dataType", "binding", "sortMemberPath", "format", "cellTemplate", "header", "width", "maxLength", "minWidth", "maxWidth", "align", "allowDragging", "allowSorting", "allowResizing", "allowMerging", "aggregate", "isReadOnly", "cssClass", "cssClassAll", "isContentHtml", "isSelected", "visible", "wordWrap", "multiLine", "mask", "inputType", "isRequired", "showDropDown", "dataMapEditor", "dropDownCssClass", "quickAutoSize", "editor", "placeholder"], outputs: ["initialized", "isSelectedChange"] }], directives: [{ type: i4.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i1$2.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i1$2.NgbDropdown, selector: "[ngbDropdown]", inputs: ["open", "placement", "container", "autoClose", "display", "dropdownClass"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i1$2.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i5.BentoNgbDropdownAnimationDirective, selector: "[ngbDropdownMenu], bento-megamenu" }, { type: i1$2.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$2.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["disabled"] }, { type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["size", "showDelay", "hideDelay", "bentoBusyLoader"], outputs: ["show", "hide"] }, { type: i2.WjFlexGridCellTemplate, selector: "[wjFlexGridCellTemplate]", inputs: ["wjFlexGridCellTemplate", "cellOverflow", "valuePaths", "autoSizeRows", "forceFullEdit", "cellType"], exportAs: ["wjFlexGridCellTemplate"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ProfitSpreadsheetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-profit-spreadsheet', template: "<div class=\"view-calculation-content\">\n  <h1>{{ i18n(\"ViewCalculation\") | translate }}</h1>\n  <acc-view-calculation-filters [filters]=\"accountingCostsFilters\" (update)=\"onFiltersUpdate($event)\">\n  </acc-view-calculation-filters>\n\n  <div id=\"table-container\" [ngStyle]=\"{'width': (offsetWidth < gridWidth || data.length === 0 || gridWidth === 0)\n                          ? 'auto'\n                          : 'min-content'}\">\n    <bento-toolbar class=\"bento-toolbar\" [items]=\"toolbarData\">\n      <ul class=\"nav navbar-right\">\n\n        <li>\n          <button class=\"btn btn-outline-primary btn-icon btn-toggle\" [ngClass]=\"{'active':gridFilter.showFilterIcons}\"\n            (click)=\"toggleFilter()\" placement=\"bottom\" [ngbTooltip]=\"getTooltipToggleFilters() | translate\">\n            <i class=\"bento-icon-filter-az\"></i>\n          </button>\n        </li>\n        <li>\n          <div ngbDropdown [autoClose]=\"'outside'\">\n            <button class=\"btn btn-outline-primary btn-icon btn-toggle dropdown-toggle\" ngbDropdownToggle\n              placement=\"bottom\" [ngbTooltip]=\"getTooltipHideShowColumns() | translate\">\n              <i class=\"bento-icon-cog\"></i>\n              <i class=\"bento-icon-arrow-down2\"></i>\n            </button>\n            <ul ngbDropdownMenu class=\"dropdown-menu\">\n              <li *ngFor=\"let item of hideAbleColumnDefinitions\" ngbDropdownItem class=\"dropdown-item\">\n                <a (click)=\"item.visible = !item.visible\">\n                  <i [ngClass]=\"{'bento-icon-checkbox':!item.visible,'bento-icon-checkbox-filled':item.visible}\"></i>\n                  {{ item.header }}</a>\n              </li>\n            </ul>\n          </div>\n        </li>\n      </ul>\n    </bento-toolbar>\n    <div class=\"busy-loader-container\" [bentoBusyLoader]=\"loadingScrollBusyLoader.state\"\n      [ngStyle]=\"{'height': loadingScrollBusyLoader.state ? '63vh' : ''}\">\n\n      <wj-flex-grid #flexGrid class=\"bento-flex-grid has-row-hover\" [itemsSource]=\"data\" [stickyHeaders]=\"true\"\n        [showMarquee]=\"false\" [showSort]=\"true\" (initialized)=\"gridInitialized(flexGrid)\" [frozenColumns]=\"1 && 2\"\n        [autoSizeMode]=\"3\" [deferResizing]=\"true\" [isReadOnly]=\"true\" (loadedRows)=\"updateFlexGridRows(flexGrid)\"\n        (updatedView)=\"onUpdatedView(flexGrid)\">\n\n        <wj-flex-grid-filter #filter></wj-flex-grid-filter>\n\n        <ng-template wjFlexGridCellTemplate [cellType]=\"'RowHeader'\" let-col=\"col\" let-row=\"row\">\n          <div *ngIf=\"col.index === 0\">{{ row.index+1 }}</div>\n        </ng-template>\n\n        <div *ngFor=\"let column of columnDefinitions.reverse()\">\n\n          <wj-flex-grid-column\n            [align]=\"column.align\"\n            [header]=\"column.header\"\n            [binding]=\"column.binding\"\n            [isReadOnly]=\"column.isReadOnly\"\n            [width]=\"column.width\"\n            [visible]=\"column.visible\"\n            [isContentHtml]=\"column.binding !=='name' && 'cnpj'\"\n            [isReadOnly]=\"true\"\n            [format]=\"'cR$'\"\n            [cssClass]=\"column.cssClass\">\n          </wj-flex-grid-column>\n\n        </div>\n      </wj-flex-grid>\n    </div>\n  </div>\n", styles: [".view-calculation-content{margin-top:-20px}.view-calculation-content .bento-toolbar{height:43px!important}.view-calculation-content .bento-toolbar .navbar-right{height:40px}.view-calculation-content .bento-toolbar .navbar-right li{min-height:inherit}.view-calculation-content .bento-toolbar .navbar-right li button{margin:3px 0 0}.bento-flex-grid{height:auto;max-height:63vh}::ng-deep .bento-toolbar{height:36px!important}::ng-deep .wj-tooltip{background-color:#fff;flex-wrap:wrap;border-radius:5px;padding:4px 15px}::ng-deep .wj-tooltip:before{content:none}::ng-deep .wj-tooltip:after{border-top:15px solid #ffffff;border-right:15px solid transparent;border-left:15px solid transparent}::ng-deep .tooltipColumn{padding:2px 5px;border-radius:4px;display:inline-block;color:#fff;margin:5px 2px;text-transform:uppercase;font-size:x-small}::ng-deep .tooltipColumn.office{background-color:#387c2b;color:#fff}::ng-deep .tooltipColumn.customer{background-color:#0072a8;color:#fff}::ng-deep .tooltipColumn.column{background-color:#5d1893;color:#fff}::ng-deep .tooltipColumn.operator-limiter{background-color:#ffb400;color:#000!important}::ng-deep .tooltipColumn.value{background-color:#d4ebf4;color:#000!important}::ng-deep .columnType{color:#666;font-family:Arial,Helvetica,sans-serif;font-size:14px;font-weight:bolder;width:-webkit-fill-available}::ng-deep hr{border-top:1px solid #d5d4d9;margin-bottom:10px;min-inline-size:-webkit-fill-available}::ng-deep .cellDataPositive{background:#387c2b;border-radius:4px;color:#fff;padding:3px;margin:5px}::ng-deep .cellDataNegative{background:#dc0a0a;border-radius:4px;color:#fff;padding:3px;margin:5px}::ng-deep [wj-part=ch]{z-index:0!important;height:36px}:host ::ng-deep [wj-part=tl]{z-index:0!important}:host ::ng-deep [wj-part=rh]{z-index:0!important}::ng-deep .ng-bento .col-md-3{z-index:5}::ng-deep .action-column:not(.wj-group){padding-right:10px!important}.wj-control.wj-flexgrid ::ng-deep .wj-cell ::ng-deep .wj-btn.wj-elem-filter{align-items:unset;justify-content:unset;position:absolute;margin-left:10px}::ng-deep .wj-header .header{position:absolute;width:calc(100% - 10px);height:calc(100% - 10px)}::ng-deep .wj-cells>.wj-row,::ng-deep .wj-marquee{z-index:0!important}:host ::ng-deep .wj-header[class*=wj-filter-].wj-align-right{text-align:right!important}:host ::ng-deep .bento-flex-grid .wj-header.wj-cell.wj-filter-on.wj-align-right,:host ::ng-deep .bento-flex-grid .wj-header.wj-cell.wj-filter-off.wj-align-right{padding:8px 44px 8px 10px!important;display:inline;display:initial}:host ::ng-deep .bento-flex-grid .wj-header.wj-cell.wj-filter-off.wj-align-right .wj-glyph-up,:host ::ng-deep .bento-flex-grid .wj-header.wj-cell.wj-filter-off.wj-align-right .wj-glyph-down{display:inline-block;position:absolute;right:20px;top:35%}::ng-deep .wj-sort-asc{margin:0;padding:8px 44px 8px 10px!important;align-items:center}::ng-deep .wj-sort-desc{margin:0;padding:0 0 0 10px;display:inline;display:initial;align-items:center}.busy-loader-container ::ng-deep .bento-busyloader-front-blocker{background:0}::ng-deep .ng-bento .bento-flex-grid.wj-content .wj-cell.i-success.final-result,::ng-deep .ng-bento .bento-flex-grid.wj-content .wj-cell.i-error.final-result{display:flex;align-items:center;justify-content:space-between}::ng-deep .i-success.final-result:before{background:green}::ng-deep .i-error.final-result:before{background:red}::ng-deep .i-success.final-result:before,::ng-deep .i-error.final-result:before{content:attr(data-before);border-radius:4px;color:#fff;padding:3px;margin-right:10px;width:67px;text-align:center;height:22px;line-height:16px;position:static;position:initial}\n"] }]
        }], ctorParameters: function () { return [{ type: AlertService }, { type: ProfitSpreadsheetService }, { type: i1$1.TranslateService }, { type: AccountingCostsFlexGridServices }, { type: i0.ChangeDetectorRef }, { type: DateFormatterService }, { type: LoaderService }]; }, propDecorators: { gridFilter: [{
                type: ViewChild,
                args: ['filter', { static: true }]
            }], flexGrid: [{
                type: ViewChild,
                args: ['flexGrid', { static: true }]
            }], filtersUpdate: [{
                type: Output
            }], calculationModel: [{
                type: Input
            }], filters: [{
                type: Input
            }] } });

class ArcGaugeComponent {
    constructor(translate) {
        this.translate = translate;
        this.arcGaugeOptionsObservable = new AsyncSubject();
    }
    ngOnInit() {
        this.arcGaugeOptionsObservable
            .subscribe({
            next: () => this.arcGauge.refresh()
        });
        this.listenToOptions();
    }
    i18n(node) {
        return `Onvio.AccountingCosts.Widgets.${node}`;
    }
    listenToOptions() {
        setTimeout(() => {
            if (this.arcGauge.options) {
                this.arcGaugeOptionsObservable.next(true);
                this.arcGaugeOptionsObservable.complete();
            }
            else {
                this.listenToOptions();
            }
        }, 100);
    }
}
ArcGaugeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ArcGaugeComponent, deps: [{ token: i1$1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
ArcGaugeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ArcGaugeComponent, selector: "acc-arc-gauge", inputs: { data: "data", labelColor: "labelColor", labelPorcent: "labelPorcent", labelEstatus: "labelEstatus" }, viewQueries: [{ propertyName: "arcGauge", first: true, predicate: BentoD3ArcGaugeComponent, descendants: true }], ngImport: i0, template: "<bento-d3-arc-gauge class=\"custom-arc-gauge\" [options]=\"data\">\n  <div class=\"custom-arc-label\" [ngStyle]=\"{ color: labelColor }\">\n    <div class=\"header\">{{ labelPorcent }}%</div>\n    <div class=\"sub-header\">{{ labelEstatus }}</div>\n  </div>\n</bento-d3-arc-gauge>\n", styles: [".custom-arc-gauge{text-align:center;position:relative;margin:auto auto 20px}.custom-arc-gauge .custom-arc-label{position:absolute}@media (min-width: 1000px){.custom-arc-gauge{height:35%;width:100%}.custom-arc-gauge .custom-arc-label{top:20%;text-align:center;width:100%;overflow:hidden}.custom-arc-gauge .custom-arc-label .sub-header{font-size:14px}.custom-arc-gauge .custom-arc-label .header{font-size:32px;width:40%;margin:auto;overflow:hidden}}@media (min-width: 993px) and (max-width: 999px){.custom-arc-gauge{display:inline-flex;height:150px;text-align:center;justify-content:center;width:100%}.custom-arc-gauge .custom-arc-label{width:40%;text-align:center;padding:25px 0 0;font-size:16px}.custom-arc-gauge .custom-arc-label .header{font-size:calc(2em + 1vw)}}@media (max-width: 992px){.custom-arc-gauge{display:inline-flex;height:150px;text-align:center;justify-content:center;width:50%}.custom-arc-gauge .custom-arc-label{width:40%;text-align:center;padding:25px 0 0;font-size:16px}.custom-arc-gauge .custom-arc-label .header{font-size:calc(2em + 1vw)}}\n"], components: [{ type: i2$4.BentoD3ArcGaugeComponent, selector: "bento-d3-arc-gauge", inputs: ["options"] }], directives: [{ type: i4.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ArcGaugeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-arc-gauge', template: "<bento-d3-arc-gauge class=\"custom-arc-gauge\" [options]=\"data\">\n  <div class=\"custom-arc-label\" [ngStyle]=\"{ color: labelColor }\">\n    <div class=\"header\">{{ labelPorcent }}%</div>\n    <div class=\"sub-header\">{{ labelEstatus }}</div>\n  </div>\n</bento-d3-arc-gauge>\n", styles: [".custom-arc-gauge{text-align:center;position:relative;margin:auto auto 20px}.custom-arc-gauge .custom-arc-label{position:absolute}@media (min-width: 1000px){.custom-arc-gauge{height:35%;width:100%}.custom-arc-gauge .custom-arc-label{top:20%;text-align:center;width:100%;overflow:hidden}.custom-arc-gauge .custom-arc-label .sub-header{font-size:14px}.custom-arc-gauge .custom-arc-label .header{font-size:32px;width:40%;margin:auto;overflow:hidden}}@media (min-width: 993px) and (max-width: 999px){.custom-arc-gauge{display:inline-flex;height:150px;text-align:center;justify-content:center;width:100%}.custom-arc-gauge .custom-arc-label{width:40%;text-align:center;padding:25px 0 0;font-size:16px}.custom-arc-gauge .custom-arc-label .header{font-size:calc(2em + 1vw)}}@media (max-width: 992px){.custom-arc-gauge{display:inline-flex;height:150px;text-align:center;justify-content:center;width:50%}.custom-arc-gauge .custom-arc-label{width:40%;text-align:center;padding:25px 0 0;font-size:16px}.custom-arc-gauge .custom-arc-label .header{font-size:calc(2em + 1vw)}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }]; }, propDecorators: { data: [{
                type: Input
            }], labelColor: [{
                type: Input
            }], labelPorcent: [{
                type: Input
            }], labelEstatus: [{
                type: Input
            }], arcGauge: [{
                type: ViewChild,
                args: [BentoD3ArcGaugeComponent]
            }] } });

class ColumnChartComponent {
    constructor() { }
    ngOnInit() { }
}
ColumnChartComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ColumnChartComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ColumnChartComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ColumnChartComponent, selector: "acc-column-chart", inputs: { titleCollumn: "titleCollumn", dataBasic: "dataBasic" }, viewQueries: [{ propertyName: "columnChart", first: true, predicate: BentoD3ColumnChartComponent, descendants: true }], ngImport: i0, template: "<h2 class=\"title\">{{ titleCollumn }}</h2>\n<bento-d3-column-chart [options]=\"dataBasic\"></bento-d3-column-chart>\n", styles: [""], components: [{ type: i2$4.BentoD3ColumnChartComponent, selector: "bento-d3-column-chart", inputs: ["options"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ColumnChartComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-column-chart', template: "<h2 class=\"title\">{{ titleCollumn }}</h2>\n<bento-d3-column-chart [options]=\"dataBasic\"></bento-d3-column-chart>\n", styles: [""] }]
        }], ctorParameters: function () { return []; }, propDecorators: { titleCollumn: [{
                type: Input
            }], dataBasic: [{
                type: Input
            }], columnChart: [{
                type: ViewChild,
                args: [BentoD3ColumnChartComponent]
            }] } });

function formatValue(value) {
    if (!value) {
        return '';
    }
    let fixedValue = value.toFixed(2);
    fixedValue = fixedValue.replace('.', ',');
    const regex = /(\d)(?=(\d{3})+(?!\d))/g;
    return fixedValue.replace(regex, '$1.');
}

class WidgetsService {
    constructor(http) {
        this.http = http;
        this.costsEndpoint = `${API_URL}calculation-model-result/cost`;
        this.revenueEndpoint = `${API_URL}calculation-model-result/revenue`;
        this.revenueCostsClientEndpoint = `${API_URL}calculation-model-result/ranking`;
        this.clientsEndpoint = `${API_URL}calculation-model-result/score`;
    }
    formatYearMonth(date) {
        return format(date, 'yyyy-MM');
    }
    formatToLowerCase(str) {
        const stringMatch = str.match('^(.{8})(.{4})(.{4})(.{4})(.{12})$');
        if (stringMatch) {
            return `${stringMatch[1]}-${stringMatch[2]}-${stringMatch[3]}-${stringMatch[4]}-${stringMatch[5]}`.toLowerCase();
        }
        else {
            return str;
        }
    }
    getCosts(templateId, initialBasisDate, finalBasisDate) {
        const urlParams = new HttpParams()
            .append('initialCompetence', this.formatYearMonth(initialBasisDate))
            .append('finalCompetence', this.formatYearMonth(finalBasisDate))
            .append('calculationModelId', templateId);
        return this.http.get(this.costsEndpoint, { params: urlParams }).pipe(map(res => {
            const amount = [];
            const competence = res.map(element => {
                const parsedDate = parse(element.competence, 'yyyy-MM', new Date());
                amount.push(element.cost);
                return {
                    name: format(parsedDate, 'MM/yy'),
                    y: element.cost
                };
            });
            const response = {
                amount,
                competence
            };
            return response;
        }));
    }
    getRevenue(templateId, initialBasisDate, finalBasisDate) {
        const urlParams = new HttpParams()
            .append('initialCompetence', this.formatYearMonth(initialBasisDate))
            .append('finalCompetence', this.formatYearMonth(finalBasisDate))
            .append('calculationModelId', templateId);
        return this.http.get(this.revenueEndpoint, { params: urlParams }).pipe(map(res => {
            const amount = [];
            const competence = res.map(element => {
                const parsedDate = parse(element.competence, 'yyyy-MM', new Date());
                amount.push(element.revenue);
                return {
                    name: format(parsedDate, 'MM/yy'),
                    y: element.revenue
                };
            });
            const response = {
                amount,
                competence
            };
            return response;
        }));
    }
    getRevenueCosts(templateId, initialBasisDate, finalBasisDate) {
        return forkJoin([
            this.getCosts(templateId, initialBasisDate, finalBasisDate),
            this.getRevenue(templateId, initialBasisDate, finalBasisDate)
        ]).pipe(map(([costs, revenue]) => {
            if (costs && revenue) {
                const competence = revenue.competence
                    .map((item, index) => this.mapDoubleAmmountByCompetence(item, index, costs.competence));
                return {
                    competence
                };
            }
            else {
                return { competence: null };
            }
        }));
    }
    getRevenueCostsPerClient(periodDate, calculationModelId) {
        const urlParams = new HttpParams()
            .append('basis', this.formatYearMonth(periodDate))
            .append('calculationModelId', this.formatToLowerCase(calculationModelId));
        return this.http.get(this.revenueCostsClientEndpoint, { params: urlParams }).pipe(map((res) => {
            return res.sort((a, b) => {
                return b.totalRevenues - a.totalRevenues;
            }).map(item => {
                return {
                    name: item.clientName,
                    data: [item.totalRevenues, item.totalCosts]
                };
            });
        }));
    }
    getTotalClientsInSurplusOrDeficit(basisDate, calculationModelId) {
        const urlParams = new HttpParams()
            .append('basis', this.formatYearMonth(basisDate))
            .append('calculationModelId', this.formatToLowerCase(calculationModelId));
        return this.http.get(this.clientsEndpoint, { params: urlParams }).pipe(map(res => res));
    }
    mapDoubleAmmountByCompetence(item, index, items) {
        return {
            name: item.name,
            data: [item.y, items[index].y]
        };
    }
}
WidgetsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: WidgetsService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
WidgetsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: WidgetsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: WidgetsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class WidgetsComponent {
    constructor(translateService, service, alertService, loaderService) {
        this.translateService = translateService;
        this.service = service;
        this.alertService = alertService;
        this.data = {};
        this.monthsBefore = 5;
        this.navigate = new EventEmitter();
        this.updateSubject = new Subject();
        this.RED = '#dc0a0a';
        this.GREEN = '#387C2B';
        this.loadingWidgetsBusyLoader = loaderService.widgetsLoader;
        this.subjectSubscription = this.updateSubject.pipe(debounceTime(2000), exhaustMap(({ templateId, finalBasisDate }) => {
            this.updateWidgets(templateId, finalBasisDate);
            return of({});
        })).subscribe();
    }
    insideI18n(node) {
        return this.translateService.instant(`Onvio.AccountingCosts.Widgets.${node}`);
    }
    i18n(node) {
        return `Onvio.AccountingCosts.Widgets.${node}`;
    }
    arcGauge(porcent, color) {
        const data = {
            dataLabels: {
                formatter: d => {
                    return '';
                }
            },
            stops: [
                [0.0, color],
                [1.0, color]
            ],
            series: [
                {
                    size: 1,
                    innerSize: 0.8,
                    data: [porcent]
                }
            ]
        };
        return data;
    }
    requestUpdate(templateId, finalBasisDate) {
        this.updateSubject.next({ templateId, finalBasisDate });
    }
    chartSingle(seriesConfig) {
        const options = {
            chart: {
                marginTop: 20,
                marginRight: 60,
                marginBottom: 70,
                marginLeft: 80,
                height: 200
            },
            xAxis: {
                labels: {
                    rotation: -45,
                    style: {
                        fontSize: '13px'
                    }
                },
                title: {
                    text: this.insideI18n('Competence')
                }
            },
            yAxis: {
                title: {
                    text: this.insideI18n('Amount')
                },
                labels: {
                    formatter: this.getYAxisLabelFormatter()
                }
            },
            plotOptions: {
                series: {
                    pointPadding: 0.3
                }
            },
            series: seriesConfig,
            tooltip: {
                formatter: this.nameAndValueFormatter
            }
        };
        return options;
    }
    getYAxisLabelFormatter() {
        return d => d;
    }
    capName(str, cappedNameMaxLength) {
        if (str.length > cappedNameMaxLength) {
            const cappedNameSuffix = '...';
            const nameSubstrLength = Math.max(0, cappedNameMaxLength - cappedNameSuffix.length);
            return str.substr(0, nameSubstrLength) + '...';
        }
        return str;
    }
    chartGrouped(config, colors, xAxisOptions, tooltipFormatter) {
        this.data.categories = [
            this.insideI18n('Revenue'),
            this.insideI18n('Cost')
        ];
        const options = {
            chart: {
                marginTop: 20,
                marginRight: 60,
                marginBottom: 90,
                marginLeft: 80,
                height: 200
            },
            colors,
            xAxis: {
                categories: this.data.categories,
                labels: {
                    formatter: xAxisOptions.labelsFormatter,
                    rotation: xAxisOptions.labelsRotation,
                    style: {
                        fontSize: '11px'
                    }
                },
                title: {
                    text: xAxisOptions.title
                }
            },
            yAxis: {
                title: {
                    text: this.insideI18n('Amount')
                },
                labels: {
                    formatter: d => d
                }
            },
            series: config
        };
        if (tooltipFormatter) {
            options.tooltip = {
                formatter: tooltipFormatter
            };
        }
        return options;
    }
    configSingle(data) {
        const config = [{ data }];
        return config;
    }
    configGrouped(data) {
        const groupedData = data;
        return groupedData;
    }
    set filters(filters) {
        this.selectedFilter = filters;
        if (filters) {
            this.loadingWidgetsBusyLoader.show();
            this.requestUpdate(filters.template.id, filters.basis);
        }
    }
    updateWidgets(templateId, finalBasisDate) {
        this.data = {};
        forkJoin([
            this.getCosts(templateId, finalBasisDate),
            this.getTotalClientsInSurplusOrDeficit(templateId, finalBasisDate),
            this.getRevenue(templateId, finalBasisDate),
            this.getRevenueCosts(templateId, finalBasisDate),
            this.getRevenueCostsPerClient(templateId, finalBasisDate)
        ]).subscribe(() => {
            this.loadingWidgetsBusyLoader.hide();
        }, (err) => {
            this.translateService.get(this.i18n('Error')).subscribe(res => {
                this.addError(res);
            });
            this.data = null;
            this.loadingWidgetsBusyLoader.hide();
        });
    }
    getInitialBasisDate(finalBasisDate) {
        if (!finalBasisDate) {
            return null;
        }
        const finalDate = new Date(finalBasisDate);
        return new Date((finalDate.setMonth(finalDate.getMonth() - this.monthsBefore)));
    }
    getCosts(templateId, finalBasisDate, initialBasisDate = this.getInitialBasisDate(finalBasisDate)) {
        return this.service
            .getCosts(templateId, initialBasisDate, finalBasisDate)
            .pipe(take(1), tap(res => {
            const color = '#0099C4';
            const data = res.competence.map(item => {
                item = {
                    name: item.name,
                    color: `${color}`,
                    y: item.y
                };
                return item;
            });
            this.data = Object.assign(Object.assign({}, this.data), { costs: this.chartSingle(this.configSingle(data)) });
        }));
    }
    getRevenue(templateId, finalBasisDate, initialBasisDate = this.getInitialBasisDate(finalBasisDate)) {
        return this.service
            .getRevenue(templateId, initialBasisDate, finalBasisDate)
            .pipe(take(1), tap(res => {
            const color = '#FFB401';
            let data = {};
            data = res.competence.map(item => {
                item = {
                    name: item.name,
                    color: `${color}`,
                    y: item.y
                };
                return item;
            });
            this.data = Object.assign(Object.assign({}, this.data), { revenue: this.chartSingle(this.configSingle(data)) });
        }));
    }
    getRevenueCosts(templateId, finalBasisDate, initialBasisDate = this.getInitialBasisDate(finalBasisDate)) {
        return this.service
            .getRevenueCosts(templateId, initialBasisDate, finalBasisDate)
            .pipe(tap(res => {
            const colors = ['#FFB401', '#FF8000'];
            this.data = Object.assign(Object.assign({}, this.data), { groupedRevenueCosts: this.chartGrouped(this.configGrouped(res.competence), colors, {
                    title: this.insideI18n('Competence'),
                    labelsRotation: -45,
                    labelsFormatter: (label) => label
                }, this.nameAndValueFormatter) });
        }));
    }
    getRevenueCostsPerClient(calculationModelId, periodDate) {
        return this.service
            .getRevenueCostsPerClient(periodDate, calculationModelId)
            .pipe(tap(res => {
            const colors = ['#397c2c', '#2099c5'];
            this.data = Object.assign(Object.assign({}, this.data), { revenueCostsPerClient: this.chartGrouped(this.configGrouped(res), colors, {
                    title: this.insideI18n('Clients'),
                    labelsRotation: -35,
                    labelsFormatter: (label) => this.capName(label, 15)
                }, this.clientFormatter) });
        }));
    }
    getTotalClientsInSurplusOrDeficit(calculationModelId, periodDate) {
        let porcentDeficit;
        let porcentSuperavit;
        return this.service
            .getTotalClientsInSurplusOrDeficit(periodDate, calculationModelId)
            .pipe(take(1), tap(res => {
            if (res && res.totalCustomers) {
                porcentDeficit = res.deficitCustomers ? (res.deficitCustomers * 100) / res.totalCustomers : 0;
                porcentSuperavit = res.avitCustomers ? (res.avitCustomers * 100) / res.totalCustomers : 0;
            }
            else {
                porcentDeficit = 0;
                porcentSuperavit = 0;
            }
            this.data = Object.assign(Object.assign({}, this.data), { deficit: this.arcGauge(porcentDeficit, this.RED), labelPorcentDeficit: String(Math.round(porcentDeficit)), labelColorDeficit: this.RED, labelColorSuperavit: this.GREEN, superavit: this.arcGauge(porcentSuperavit, this.GREEN), labelPorcentSuperavit: String(Math.round(porcentSuperavit)) });
        }));
    }
    nameAndValueFormatter(obj) {
        return `${obj.name}: ${formatValue(obj.value)}`;
    }
    clientFormatter(obj) {
        return `${obj.groupName}(${obj.name}): ${formatValue(obj.value)}`;
    }
    navigateToDetails() {
        this.navigate.emit(this.selectedFilter);
    }
    addError(msg) {
        this.alertService.addAlert({
            type: 'danger',
            closeable: true,
            timeout: 5000,
            msg
        });
    }
    ngOnDestroy() {
        if (this.subjectSubscription) {
            this.subjectSubscription.unsubscribe();
        }
    }
}
WidgetsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: WidgetsComponent, deps: [{ token: i1$1.TranslateService }, { token: WidgetsService }, { token: AlertService }, { token: LoaderService }], target: i0.ɵɵFactoryTarget.Component });
WidgetsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: WidgetsComponent, selector: "acc-widgets", inputs: { filters: "filters" }, outputs: { navigate: "navigate" }, ngImport: i0, template: "<div class=\"conteiner-widgets\" *ngIf=\"data && !loadingWidgetsBusyLoader.state\">\n  <div class=\"row\">\n    <div class=\"ng-bento col\">\n      <acc-column-chart\n        titleCollumn=\"{{ i18n('Costs') | translate }}\"\n        *ngIf=\"data.costs\"\n        [dataBasic]=\"data.costs\"\n      ></acc-column-chart>\n    </div>\n\n    <div class=\"ng-bento col\">\n      <acc-column-chart\n        titleCollumn=\"{{ i18n('Revenues') | translate }}\"\n        *ngIf=\"data.revenue\"\n        [dataBasic]=\"data.revenue\"\n      ></acc-column-chart>\n    </div>\n\n    <div class=\"ng-bento col\">\n      <div class=\"d-flex justify-content-between\">\n        <h2 class=\"title\">{{i18n('Clients') | translate}}</h2>\n        <span class=\"link\" (click)=\"navigateToDetails()\">{{i18n('Details') | translate}}</span>\n      </div>\n      <acc-arc-gauge\n        *ngIf=\"data.superavit\"\n        [data]=\"data.superavit\"\n        [labelColor]=\"data.labelColorSuperavit\"\n        labelEstatus=\"{{ i18n('Superavit') | translate }}\"\n        [labelPorcent]=\"data.labelPorcentSuperavit\"\n      ></acc-arc-gauge>\n      <acc-arc-gauge\n        *ngIf=\"data.deficit\"\n        [data]=\"data.deficit\"\n        [labelColor]=\"data.labelColorDeficit\"\n        labelEstatus=\"{{ i18n('Deficit') | translate }}\"\n        [labelPorcent]=\"data.labelPorcentDeficit\"\n      ></acc-arc-gauge>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"ng-bento col\">\n      <acc-column-chart\n        titleCollumn=\"{{ i18n('RevenueCosts') | translate }}\"\n        *ngIf=\"data.groupedRevenueCosts\"\n        [dataBasic]=\"data.groupedRevenueCosts\"\n      ></acc-column-chart>\n    </div>\n\n    <div class=\"ng-bento col\">\n      <acc-column-chart\n        titleCollumn=\"{{ i18n('RevenueCostsPerClient') | translate }}\"\n        *ngIf=\"data.revenueCostsPerClient\"\n        [dataBasic]=\"data.revenueCostsPerClient\"\n      ></acc-column-chart>\n    </div>\n\n    <div class=\"ng-bento col noBorder\"></div>\n  </div>\n</div>\n", styles: [".row{display:flex;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.col{flex-basis:0;flex-grow:1;max-width:100%}.conteiner-widgets{overflow-x:hidden}.conteiner-widgets .col{border-width:1px;border-style:solid;border-color:#d5d4d9;margin:0 15px 40px;padding-right:15px;padding-left:15px}.conteiner-widgets .col.noBorder{border:0px solid #fff}@media (max-width: 992px){.conteiner-widgets .col{flex-basis:inherit;flex-flow:row;flex-grow:inherit}}.link{font-size:11px;color:#0072a8}.link:hover{text-decoration:underline;cursor:pointer}\n"], components: [{ type: ColumnChartComponent, selector: "acc-column-chart", inputs: ["titleCollumn", "dataBasic"] }, { type: ArcGaugeComponent, selector: "acc-arc-gauge", inputs: ["data", "labelColor", "labelPorcent", "labelEstatus"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: WidgetsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-widgets', template: "<div class=\"conteiner-widgets\" *ngIf=\"data && !loadingWidgetsBusyLoader.state\">\n  <div class=\"row\">\n    <div class=\"ng-bento col\">\n      <acc-column-chart\n        titleCollumn=\"{{ i18n('Costs') | translate }}\"\n        *ngIf=\"data.costs\"\n        [dataBasic]=\"data.costs\"\n      ></acc-column-chart>\n    </div>\n\n    <div class=\"ng-bento col\">\n      <acc-column-chart\n        titleCollumn=\"{{ i18n('Revenues') | translate }}\"\n        *ngIf=\"data.revenue\"\n        [dataBasic]=\"data.revenue\"\n      ></acc-column-chart>\n    </div>\n\n    <div class=\"ng-bento col\">\n      <div class=\"d-flex justify-content-between\">\n        <h2 class=\"title\">{{i18n('Clients') | translate}}</h2>\n        <span class=\"link\" (click)=\"navigateToDetails()\">{{i18n('Details') | translate}}</span>\n      </div>\n      <acc-arc-gauge\n        *ngIf=\"data.superavit\"\n        [data]=\"data.superavit\"\n        [labelColor]=\"data.labelColorSuperavit\"\n        labelEstatus=\"{{ i18n('Superavit') | translate }}\"\n        [labelPorcent]=\"data.labelPorcentSuperavit\"\n      ></acc-arc-gauge>\n      <acc-arc-gauge\n        *ngIf=\"data.deficit\"\n        [data]=\"data.deficit\"\n        [labelColor]=\"data.labelColorDeficit\"\n        labelEstatus=\"{{ i18n('Deficit') | translate }}\"\n        [labelPorcent]=\"data.labelPorcentDeficit\"\n      ></acc-arc-gauge>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"ng-bento col\">\n      <acc-column-chart\n        titleCollumn=\"{{ i18n('RevenueCosts') | translate }}\"\n        *ngIf=\"data.groupedRevenueCosts\"\n        [dataBasic]=\"data.groupedRevenueCosts\"\n      ></acc-column-chart>\n    </div>\n\n    <div class=\"ng-bento col\">\n      <acc-column-chart\n        titleCollumn=\"{{ i18n('RevenueCostsPerClient') | translate }}\"\n        *ngIf=\"data.revenueCostsPerClient\"\n        [dataBasic]=\"data.revenueCostsPerClient\"\n      ></acc-column-chart>\n    </div>\n\n    <div class=\"ng-bento col noBorder\"></div>\n  </div>\n</div>\n", styles: [".row{display:flex;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.col{flex-basis:0;flex-grow:1;max-width:100%}.conteiner-widgets{overflow-x:hidden}.conteiner-widgets .col{border-width:1px;border-style:solid;border-color:#d5d4d9;margin:0 15px 40px;padding-right:15px;padding-left:15px}.conteiner-widgets .col.noBorder{border:0px solid #fff}@media (max-width: 992px){.conteiner-widgets .col{flex-basis:inherit;flex-flow:row;flex-grow:inherit}}.link{font-size:11px;color:#0072a8}.link:hover{text-decoration:underline;cursor:pointer}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }, { type: WidgetsService }, { type: AlertService }, { type: LoaderService }]; }, propDecorators: { navigate: [{
                type: Output
            }], filters: [{
                type: Input
            }] } });

class WidgetsModule {
}
WidgetsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: WidgetsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
WidgetsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: WidgetsModule, declarations: [WidgetsComponent, ArcGaugeComponent, ColumnChartComponent], imports: [CommonModule$1, BentoModule, BentoD3Module, TranslateModule], exports: [WidgetsComponent] });
WidgetsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: WidgetsModule, imports: [[CommonModule$1, BentoModule, BentoD3Module, TranslateModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: WidgetsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [WidgetsComponent, ArcGaugeComponent, ColumnChartComponent],
                    imports: [CommonModule$1, BentoModule, BentoD3Module, TranslateModule],
                    exports: [WidgetsComponent]
                }]
        }] });

class CostItemsService {
    constructor(http) {
        this.http = http;
    }
    hasCostItem() {
        const uri = `${API_URL}cost-item-result/exists/any`;
        return this.http.get(uri);
    }
}
CostItemsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CostItemsService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
CostItemsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CostItemsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CostItemsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class CostsComponent extends HybridRouterComponent {
    constructor(alertBrowserService, accountingCostsService, routerService, translate, alertService, accountingCostsCalculationTemplateService, loaderService, costItemsService, defaultService) {
        super(routerService);
        this.translate = translate;
        this.alertService = alertService;
        this.accountingCostsCalculationTemplateService = accountingCostsCalculationTemplateService;
        this.costItemsService = costItemsService;
        this.defaultService = defaultService;
        this.isWidgetsLoading = true;
        this.onChangeHash = new Subject();
        this.preventUrlCheck = false;
        this.alertSubject = new Subject();
        accountingCostsService.setLanguage();
        alertBrowserService.open();
        this.loadingWidgetsBusyLoader = loaderService.widgetsLoader;
        /* TODO this.filters should be initialized with the default template and basis
         and be passed  as parameter to the filters component.
         This must be done when the US for loading the default template is implemented. */
    }
    ngOnInit() {
        super.ngOnInit();
        this.setOnHashChanges();
        this.initializeSubject();
        this.verifyCostItemPresence();
        this.defaultService.requestSync();
    }
    onTabChange(tab) {
        if (tab !== 3) {
            const urlSplit = window.location.href.split('?');
            if (urlSplit.length > 1) {
                window.location.href = urlSplit[0];
            }
        }
        this.verifyCostItemPresence();
    }
    verifyCostItemPresence() {
        this.alertSubject.next();
    }
    initializeSubject() {
        const infoAlert = {
            closeable: true,
            template: this.costInfoTemplate,
            type: 'info'
        };
        this.alertSubscription = this.alertSubject
            .pipe(switchMap(_ => this.costItemsService.hasCostItem()))
            .subscribe(res => {
            if (!res && this.alertService.findAlert(this.addedAlert) === -1) {
                this.addedAlert = this.alertService.addAlert(infoAlert);
            }
            else if (res) {
                this.alertService.removeAlert(this.addedAlert);
            }
        });
    }
    ngOnDestroy() {
        if (this.onChangeHashSubscription) {
            this.onChangeHashSubscription.unsubscribe();
        }
        if (this.alertSubscription) {
            this.alertSubscription.unsubscribe();
        }
        this.alertService.cleanAlerts();
    }
    setOnHashChanges() {
        this.onChangeHashSubscription = this.onChangeHash
            .pipe(debounceTime(500), exhaustMap(() => {
            this.checkUrlParams();
            return of();
        }))
            .subscribe();
        window.onhashchange = () => {
            this.onChangeHash.next();
        };
        this.onChangeHash.next();
    }
    onParamUpdate(filters) {
        this.preventUrlCheck = true;
        window.location.href = this.updateUrlParams(filters);
    }
    updateUrlParams(filter) {
        let params = new HttpParams();
        const year = filter.basis.getFullYear();
        const month = `${filter.basis.getMonth() + 1}`.padStart(2, '0');
        const basis = `${year}-${month}`;
        params = params.set('calculationModelId', filter.template.id);
        params = params.set('basis', basis);
        let prefix = window.location.href.split('?')[0];
        prefix = prefix.includes('#') ? prefix : `${prefix}#`;
        return `${prefix}?${params.toString()}`;
    }
    checkUrlParams() {
        if (this.preventUrlCheck) {
            this.preventUrlCheck = false;
            return;
        }
        const calculationModelId = this.getParameterByName('calculationModelId');
        const basis = this.getParameterByName('basis');
        if (!!calculationModelId && !!basis && this.validateDate(basis)) {
            this.accountingCostsCalculationTemplateService
                .get(calculationModelId)
                .subscribe({
                next: result => {
                    this.filters = new AccountingCostsFilters(result, basis, 'yyyy-MM');
                    this.basisDateUrl = basis;
                    this.calculationTemplate = result;
                    this.tab.select(3);
                },
                error: error => {
                    if (this.errorNotFound) {
                        this.addError(this.errorNotFound);
                    }
                    else {
                        this.translate
                            .get(this.i18n('Spreadsheet.NotFound'))
                            .subscribe(res => {
                            this.errorNotFound = res;
                            this.addError(res);
                        });
                    }
                }
            });
        }
        else {
            this.filters = {};
        }
    }
    i18n(node) {
        return `Onvio.AccountingCosts.Costs.${node}`;
    }
    onFiltersUpdate(event) {
        this.widgetsFilters = event;
    }
    onNavigate(calculation) {
        this.tab.select(3);
        this.filters = calculation;
    }
    getParameterByName(name, url) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    validateDate(str) {
        const reg = new RegExp(/([12]\d{3}-(0[1-9]|1[0-2]))/);
        return reg.test(str);
    }
    addError(msg, template) {
        this.alertService.addAlert({
            type: 'danger',
            closeable: true,
            timeout: 5000,
            msg,
            template
        });
    }
}
CostsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CostsComponent, deps: [{ token: AlertBrowserService }, { token: AccountingCostsService }, { token: RouterService }, { token: i1$1.TranslateService }, { token: AlertService }, { token: AccountingCostsCalculationTemplateService }, { token: LoaderService }, { token: CostItemsService }, { token: DefaultCalculationModelService }], target: i0.ɵɵFactoryTarget.Component });
CostsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: CostsComponent, selector: "acc-costs", viewQueries: [{ propertyName: "tab", first: true, predicate: ["myNav"], descendants: true, static: true }, { propertyName: "costInfoTemplate", first: true, predicate: ["costItemInfo"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<acc-alert-fixed></acc-alert-fixed>\n<acc-alert></acc-alert>\n<div class=\"ng-bento\">\n  <div class=\"bento-tabset tabs-top\">\n    <ul ngbNav #myNav=\"ngbNav\" class=\"nav nav-tabs\" (navChange)=\"onTabChange($event.nextId)\">\n      <li [ngbNavItem]=\"1\">\n        <a ngbNavLink>{{ i18n(\"Dashboard\") | translate }}</a>\n        <ng-template ngbNavContent>\n          <acc-costs-filters (update)=\"onFiltersUpdate($event)\"></acc-costs-filters>\n          <div class=\"busy-loader-container\" [bentoBusyLoader]=\"loadingWidgetsBusyLoader.state\"\n            [ngStyle]=\"{'height': loadingWidgetsBusyLoader.state ? 'calc(100vh - 250px)' : ''}\">\n            <acc-widgets *ngIf=\"widgetsFilters\" [filters]=\"widgetsFilters\" (navigate)=\"onNavigate($event)\">\n            </acc-widgets>\n          </div>\n        </ng-template>\n      </li>\n      <li [ngbNavItem]=\"2\"><a ngbNavLink>{{ i18n(\"CostsCalculation\") | translate }}</a>\n        <ng-template ngbNavContent>\n          <acc-clients-lateral-panel></acc-clients-lateral-panel>\n        </ng-template>\n      </li>\n      <li [ngbNavItem]=\"3\"><a ngbNavLink>{{ i18n(\"ViewCalculation\") | translate }}</a>\n        <ng-template ngbNavContent>\n          <acc-profit-spreadsheet [calculationModel]=\"filters\"></acc-profit-spreadsheet>\n        </ng-template>\n      </li>\n    </ul>\n    <div [ngbNavOutlet]=\"myNav\" class=\"tab-content\"></div>\n  </div>\n</div>\n\n<ng-template #costItemInfo>\n  <div>\n    {{ i18n(\"CostItemInfo\") | translate }}\n  </div>\n  <a style=\"color: #005da2\" href=\"https://suporte.dominioatendimento.com/central/faces/solucao.html?codigo=6619\" target=\"_blank\">\n    {{ i18n(\"CostItemInfo.LearnMore\") | translate }}\n  </a>\n</ng-template>\n", components: [{ type: AlertFixedComponent, selector: "acc-alert-fixed" }, { type: AlertComponent, selector: "acc-alert" }, { type: CostsFiltersComponent, selector: "acc-costs-filters", outputs: ["update"] }, { type: WidgetsComponent, selector: "acc-widgets", inputs: ["filters"], outputs: ["navigate"] }, { type: ClientsLateralPanelComponent, selector: "acc-clients-lateral-panel" }, { type: ProfitSpreadsheetComponent, selector: "acc-profit-spreadsheet", inputs: ["calculationModel", "filters"], outputs: ["filtersUpdate"] }, { type: i1$2.NgbNavOutlet, selector: "[ngbNavOutlet]", inputs: ["paneRole", "ngbNavOutlet"] }], directives: [{ type: i1$2.NgbNav, selector: "[ngbNav]", inputs: ["animation", "destroyOnHide", "orientation", "roles", "keyboard", "activeId"], outputs: ["activeIdChange", "shown", "hidden", "navChange"], exportAs: ["ngbNav"] }, { type: i1$2.NgbNavItem, selector: "[ngbNavItem]", inputs: ["disabled", "domId", "destroyOnHide", "ngbNavItem"], outputs: ["shown", "hidden"], exportAs: ["ngbNavItem"] }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$2.NgbNavLink, selector: "a[ngbNavLink]" }, { type: i1$2.NgbNavContent, selector: "ng-template[ngbNavContent]" }, { type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["size", "showDelay", "hideDelay", "bentoBusyLoader"], outputs: ["show", "hide"] }, { type: i4.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CostsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'acc-costs', template: "<acc-alert-fixed></acc-alert-fixed>\n<acc-alert></acc-alert>\n<div class=\"ng-bento\">\n  <div class=\"bento-tabset tabs-top\">\n    <ul ngbNav #myNav=\"ngbNav\" class=\"nav nav-tabs\" (navChange)=\"onTabChange($event.nextId)\">\n      <li [ngbNavItem]=\"1\">\n        <a ngbNavLink>{{ i18n(\"Dashboard\") | translate }}</a>\n        <ng-template ngbNavContent>\n          <acc-costs-filters (update)=\"onFiltersUpdate($event)\"></acc-costs-filters>\n          <div class=\"busy-loader-container\" [bentoBusyLoader]=\"loadingWidgetsBusyLoader.state\"\n            [ngStyle]=\"{'height': loadingWidgetsBusyLoader.state ? 'calc(100vh - 250px)' : ''}\">\n            <acc-widgets *ngIf=\"widgetsFilters\" [filters]=\"widgetsFilters\" (navigate)=\"onNavigate($event)\">\n            </acc-widgets>\n          </div>\n        </ng-template>\n      </li>\n      <li [ngbNavItem]=\"2\"><a ngbNavLink>{{ i18n(\"CostsCalculation\") | translate }}</a>\n        <ng-template ngbNavContent>\n          <acc-clients-lateral-panel></acc-clients-lateral-panel>\n        </ng-template>\n      </li>\n      <li [ngbNavItem]=\"3\"><a ngbNavLink>{{ i18n(\"ViewCalculation\") | translate }}</a>\n        <ng-template ngbNavContent>\n          <acc-profit-spreadsheet [calculationModel]=\"filters\"></acc-profit-spreadsheet>\n        </ng-template>\n      </li>\n    </ul>\n    <div [ngbNavOutlet]=\"myNav\" class=\"tab-content\"></div>\n  </div>\n</div>\n\n<ng-template #costItemInfo>\n  <div>\n    {{ i18n(\"CostItemInfo\") | translate }}\n  </div>\n  <a style=\"color: #005da2\" href=\"https://suporte.dominioatendimento.com/central/faces/solucao.html?codigo=6619\" target=\"_blank\">\n    {{ i18n(\"CostItemInfo.LearnMore\") | translate }}\n  </a>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: AlertBrowserService }, { type: AccountingCostsService }, { type: RouterService }, { type: i1$1.TranslateService }, { type: AlertService }, { type: AccountingCostsCalculationTemplateService }, { type: LoaderService }, { type: CostItemsService }, { type: DefaultCalculationModelService }]; }, propDecorators: { tab: [{
                type: ViewChild,
                args: ['myNav', { static: true }]
            }], costInfoTemplate: [{
                type: ViewChild,
                args: ['costItemInfo', { static: true }]
            }] } });

class CostsModule {
}
CostsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CostsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CostsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CostsModule, declarations: [CostsComponent,
        ClientsLateralPanelComponent,
        ProfitSpreadsheetComponent], imports: [CommonModule$1,
        TranslateModule,
        BentoModule,
        NgbModule,
        FiltersModule,
        WidgetsModule,
        FormsModule,
        WjGridModule,
        WjGridFilterModule,
        CalculationTemplateModule,
        ReactiveFormsModule,
        NgbModalModule,
        BrowserAnimationsModule, i1$5.RouterModule, RouterModule,
        WjGridFilterModule,
        WjGridModule,
        FormsModule,
        WjInputModule,
        WjGridGrouppanelModule,
        BentoFlexGridControlModule,
        SharedModule,
        CommonModule], exports: [CostsComponent] });
CostsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CostsModule, providers: [CurrencyPipe], imports: [[
            CommonModule$1,
            TranslateModule,
            BentoModule,
            NgbModule,
            FiltersModule,
            WidgetsModule,
            FormsModule,
            WjGridModule,
            WjGridFilterModule,
            CalculationTemplateModule,
            ReactiveFormsModule,
            NgbModalModule,
            BrowserAnimationsModule,
            RouterModule$1.forChild([]),
            RouterModule,
            WjGridFilterModule,
            WjGridModule,
            FormsModule,
            WjInputModule,
            WjGridGrouppanelModule,
            BentoFlexGridControlModule,
            SharedModule,
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CostsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CostsComponent,
                        ClientsLateralPanelComponent,
                        ProfitSpreadsheetComponent
                    ],
                    imports: [
                        CommonModule$1,
                        TranslateModule,
                        BentoModule,
                        NgbModule,
                        FiltersModule,
                        WidgetsModule,
                        FormsModule,
                        WjGridModule,
                        WjGridFilterModule,
                        CalculationTemplateModule,
                        ReactiveFormsModule,
                        NgbModalModule,
                        BrowserAnimationsModule,
                        RouterModule$1.forChild([]),
                        RouterModule,
                        WjGridFilterModule,
                        WjGridModule,
                        FormsModule,
                        WjInputModule,
                        WjGridGrouppanelModule,
                        BentoFlexGridControlModule,
                        SharedModule,
                        CommonModule
                    ],
                    exports: [CostsComponent],
                    providers: [CurrencyPipe]
                }]
        }] });

class AccountingCostsModule {
}
AccountingCostsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AccountingCostsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsModule, declarations: [AlertBrowserComponent], imports: [HttpClientModule, i1$1.TranslateModule, CostsModule,
        CalculationTemplateModule,
        AddCostsCalculationTemplateModule], exports: [CostsModule, CalculationTemplateModule] });
AccountingCostsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsModule, providers: [CookieService, fakeBackendProvider], imports: [[
            HttpClientModule,
            TranslateModule.forChild({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient]
                }
            }),
            CostsModule,
            CalculationTemplateModule,
            AddCostsCalculationTemplateModule
        ], CostsModule, CalculationTemplateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AccountingCostsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AlertBrowserComponent],
                    imports: [
                        HttpClientModule,
                        TranslateModule.forChild({
                            loader: {
                                provide: TranslateLoader,
                                useFactory: HttpLoaderFactory,
                                deps: [HttpClient]
                            }
                        }),
                        CostsModule,
                        CalculationTemplateModule,
                        AddCostsCalculationTemplateModule
                    ],
                    providers: [CookieService, fakeBackendProvider],
                    exports: [CostsModule, CalculationTemplateModule]
                }]
        }] });
function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http, '/i18n/');
}

/*
 * Public API Surface of accounting-costs
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccountingCostsModule, AddCostsCalculationTemplateComponent, AddCostsCalculationTemplateModule, CalculationTemplateComponent, CalculationTemplateModule, CostsComponent, CostsModule, HttpLoaderFactory, ToolbarComponent, customCurrencyMaskConfig };
